import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const AuthenticationsFragmentDoc = gql`
    fragment Authentications on User {
  authentications {
    provider_name
    provider_subject
  }
}
    `;
export const MiDocumentsFragmentDoc = gql`
    fragment MIDocuments on MIDocumentSummary {
  archived
  case_ids
  client_ids
  created_at
  date_stored
  delete_reason
  document_id
  document_name
  rendered_mortgage_ids
  rendered_organisation_id
  template_id
  template_type
  type
  verification_count
  placeholder
  url
  signed_copy {
    date_stored
    source_id
    source_type
  }
  source {
    id
    first_name
    last_name
    type
  }
  inference_result {
    owner_names {
      first_name
      last_name
      middle_name
    }
    type
  }
}
    `;
export const SuitabilityReportFieldsFragmentDoc = gql`
    fragment SuitabilityReportFields on Case {
  suitability_report_recommendation_introduction
  recommendation_reason_for_equity_disparity
  recommendation_reason_strategy_for_btl_void_period_coverage
  recommendation_reason_for_affordability
  recommendation_term_reason
  recommendation_reason_term_into_retirement
  recommendation_reason_for_recommendation_term_increase
  recommendation_reason_for_recommendation
  recommendation_reason_for_remortgage_cost_increase
  recommendation_reason_additional_borrowing
  reason_for_further_advance
  recommendation_reason_retirement_interest_only
  debt_consolidation_reason_for_consolidated_debts
  recommendation_reason_help_to_buy_loan_repayment_strategy
  reason_for_recommendation_product_type
  reason_for_recommendation_initial_term
}
    `;
export const CaseTransitionVersionsFragmentDoc = gql`
    fragment CaseTransitionVersions on Case {
  transition_mortgage_versions {
    entity_versions {
      mortgage_id
      version
    }
    transition_to
    created_at
  }
  transition_client_versions {
    entity_versions {
      client_id
      version
    }
    transition_to
    created_at
  }
  transition_property_versions {
    entity_versions {
      property_id
      version
    }
    transition_to
    created_at
  }
  transition_protection_versions {
    entity_versions {
      protection_id
      version
    }
    transition_to
    created_at
  }
}
    `;
export const CaseMortgageProductFragmentDoc = gql`
    fragment CaseMortgageProduct on MortgageProduct {
  id
  product_id
  product_code
  product_name
  lender_code
  lender_reference
  lender_name
  initial_pay_rate
  mortgage_class
  applicant_type_conditions
  full_rate_description
  apr_lenders
  max_ltv_available
  selected_mortgage_club_code
  applicant1_income_multiplier
  applicant2_income_multiplier
  joint_applicant_income_multiplier
  standard_variable_rate
  initial_monthly_payment
  cashback
  cashback_conditions
  valuation_fee
  valuation_fee_conditions
  arrangement_fee
  arrangement_fee_conditions
  booking_fee
  booking_fee_conditions
  higher_lending_charge
  higher_lending_charge_conditions
  free_legal_fees
  free_legal_fee_conditions
  chaps_fee
  fees_payable_on_application
  fees_payable_on_completion
  fees_total
  early_repayment_charge_applies_until
  early_repayment_charge_applies_until_calculated_date
  product_notes
  employed_prob_period
  max_property_valuation
  studio_flat_flag
  proc_fee_code
  proc_fee_fixed
  proc_fee_percentage
  proc_fee_min
  proc_fee_max
  monthly_payment_after_initial_period_plus_1perc
  monthly_payment_after_initial_period_plus_2perc
  monthly_payment_after_initial_period_plus_3perc
  self_build
  shared_ownership
  mortgage_discharge_fee
  deeds_release_fee
  funds_transfer_fee_rule
  capital_rest_period
  help_to_buy_shared_equity
  help_to_buy_mortgage_guarantee
  broker_fee
  broker_fee_conditions
  packager_name
  packager_tel_no
  packager_web_address
  lender_criteria_url
  lender_product_reference
  homebuyers_fee
  homebuyers_fee_conditions
  legal_fee
  legal_fee_conditions
  product_type
  net_proc_fee
  net_proc_fee_fixed
  net_proc_fee_percentage
  net_proc_fee_min
  net_proc_fee_max
  mortgage_discharge_fee_when_to_pay
  product_match_status
  reject_reasons
  max_loan_available
  buy_to_let_rental_income_calculation_rate
  disbursement_fee
  disbursement_fee_conditions
  true_cost_full_term
  initial_monthly_payment_inc_existing_mortgage
  true_cost_full_term_inc_existing_mortgage
  true_cost_initial_period_inc_existing_mortgage
  true_cost_inc_existing_mortgage
  max_overpayment_percent_no_erc
  overpayments_allowed
  underpayments_allowed
  payment_holidays_allowed
  date_last_modified
  optional_partial_repayment
  apply_online
  lender_tel_no
  lender_web_address
  initial_rate_period
  initial_rate_period_months
  repayment_acceptable
  product_availability
  available_to_purchase
  available_to_remortgage
  available_to_ftb
  max_loan
  min_loan
  min_time_in_current_position_months
  min_time_in_continuous_service_months
  min_self_employed_accounts_years
  early_repayment_charge_applies
  early_repayment_charge
  ccj_maximum_number
  ccj_maximum_amount
  arrears_not_in_last_months
  true_cost
  true_cost_over_calculated_period
  true_cost_over_initial_period
  cashback_paid_on
  remort_home_improv_max_ltv
  remort_debt_con_max_ltv
  remort_bus_purpose_max_ltv
  remort_hol_cars_max_ltv
  affordability_calculator
  self_years_avg_income
  flat_over_shop_flag
  flat_over_shop_notes
  flat_over_shop_owner
  flat_over_shop_sep_ent
  flat_over_shop_sep_title
  flat_over_shop_restaurant
  flat_over_shop_retail
  flat_over_shop_fast_food
  flat_over_shop_fast_industry_unit
  flat_max_floors
  flat_max_floors_no_lift
  deeds_release_fee_when_to_pay
  applicant1_minimum_age
  applicant2_minimum_age
  applicant_maximum_age
  freehold_flag
  leasehold_flag
  commonhold_flag
  feudal_flag
  flying_freehold_flag
  flying_freehold_max_percentage
  product_available_date
  product_discontinued_date
  is_offset_product
  is_further_advance
  is_porting
  mortgage_type
  stress_test_payments {
    rate_increment_percent
    initial_monthly_payment
    monthly_payment_after_initial_period
  }
  mortgage_club_proc_fees {
    mortgage_club_code
    mortgage_club_name
    proc_fee_code
    net_proc_fee_percentage
    proc_fee_percentage
  }
  early_repayment_charge_periods {
    erc_charge
    period_fixed_end_date
    period_fixed_length_months
  }
  rate_tiers {
    rate
    rate_type
    period_fixed_length_months
    period_fixed_end_date
    rate_tracked
    discount_rate
  }
  fees {
    amount
    timing
    fee_type
    can_be_added_to_loan
  }
}
    `;
export const SourceResponseFragmentDoc = gql`
    fragment SourceResponse on SourceResponse {
  generated_at
  generated_for
  signature
  products {
    product_code
    mortgage_class
    fees_total
    initial_pay_rate
    initial_rate_period
    initial_monthly_payment
    standard_variable_rate
    early_repayment_charge_applies
    full_rate_description
    true_cost_full_term
    true_cost_over_initial_period
    true_cost_over_calculated_period
  }
  source_details {
    term
    term_unit
    mortgage_type
    loan_required
    expected_valuation
    filter_product_term_period_from_months
    filter_product_term_period_to_months
    mortgage_class_fixed
    mortgage_class_tracker
    mortgage_class_libor_linked
    mortgage_class_discount
    mortgage_class_variable
    mortgage_class_capped
    true_cost_disable_add_fees_payable_to_true_cost_total
    true_cost_disable_add_fees_that_will_be_added_to_loan
    true_cost_disable_deduct_cashback
    true_cost_disable_deduct_refunded_fees
    true_cost_disable_calculate_over_initial_period
    true_cost_calculate_over_no_of_months
    reason_for_mortgage
    payment_method
    part_investment_loan_required_investment_part
    buy_to_let_expected_rental_income_per_month
    buy_to_let_number_of_properties_owned_excluding_own_residence
    buy_to_let_total_borrowing_on_properties_excluding_own_residence
    buy_to_let_number_of_floors
    buy_to_let_number_of_tenants
    buy_to_let_tenant_status
    buy_to_let_corporate_let
    buy_to_let_house_of_multiple_occupancy
    buy_to_let_bedsit
    buy_to_let_bedsit_number_of_rooms
    buy_to_let_limited_company
    buy_to_let_limited_company_spv
    buy_to_let_landlord_status
    buy_to_let_consumer
    buy_to_let_consumer_regulated
    buy_to_let_limited_company_name
    buy_to_let_applicants_are_high_tax_rate_payers
    buy_to_let_allows_top_slicing
    filter_direct
    filter_ccjs_acceptable
    filter_arrears_acceptable
    filter_bankruptcy_acceptable
    filter_defaults_acceptable
    filter_free_legal_fees
    filter_free_lender_fees
    filter_valuation_fee
    filter_guarantors
    filter_is_offset
    filter_overpayments_allowed
    filter_higher_lending_charge
    filter_cashback
    filter_portable
    filter_no_arrangement_fee
    filter_no_booking_fee
    filter_refunded_valuation_fees
    filter_refunded_legal_fees
    filter_ivas_acceptable
    filter_dmps_acceptable
    filter_payday_loans_acceptable
    filter_sort_results_by_column {
      column
      direction
    }
    applicants {
      employment_status
      nationality
    }
  }
}
    `;
export const ArrearsSummaryDetailsFragmentDoc = gql`
    fragment ArrearsSummaryDetails on MortgageArrears {
  current_arrears_balance
  date_arrears_cleared
  max_arrears_in_forty_eight_months
  max_arrears_in_thirty_six_months
  max_arrears_in_twenty_four_months
  max_arrears_in_twelve_months
  max_arrears_in_six_months
  max_arrears_in_three_months
}
    `;
export const CaseMortgagesAndMortgageProductsFragmentDoc = gql`
    fragment CaseMortgagesAndMortgageProducts on Mortgage {
  id
  version
  mortgage_id
  client_ids
  case_ids
  mortgage_start_date
  mortgage_end_date
  application_date
  offer_expiry_date
  early_repayment_charge_amount
  esis_document_id
  first_or_second_charge
  interest_only_amount
  monthly_payment
  mortgage_amount
  mortgage_product_id
  mortgage_account_number
  mortgage_product_source_rank
  raw_results_reference
  mortgage_repaid_date
  initial_rate_end_date
  fees_to_be_added
  outstanding_balance
  outstanding_balance_date
  property_secured_ids
  repayment_amount
  revert_monthly_payment
  status
  term
  term_unit
  assumes_continuing
  dip_status
  acre_dip_id
  dip_details {
    dip_decision_reason
    dip_detail
    dip_timestamp
    manual_verification_at_fma
  }
  provider_dip_reference
  provider_application_reference
  valuation_type
  dip_amount
  lender_proposed
  assumes_continuing
  eor_document_ids
  has_arrears
  payment_status_summary
  property_value
  repayment_vehicle_monthly_contribution
  mortgage_product {
    ...CaseMortgageProduct
  }
  source_response {
    ...SourceResponse
  }
  selected_mortgage_club_code
  calculated_values {
    can_generate_esis
    monthly_payment
    revert_monthly_payment
    total_mortgage_fees
    calculated_gross_proc_fee
    calculated_net_proc_fee
    calculated_club_proc_fees {
      mortgage_club_code
      mortgage_club_name
      proc_fee
      net_proc_fee
    }
    cost_over_initial_term_inc_fees_cashback
    fees {
      amount
      timing
      fee_type
      can_be_added_to_loan
    }
    remaining_term_months
  }
  payment_history {
    date
    age_in_months
    balance
    payment
    payment_status
  }
  arrears_summary {
    ...ArrearsSummaryDetails
  }
  external {
    id
    source {
      id
      name
    }
  }
  document_requirements {
    requirement_id
    source
    source_id
  }
}
    ${CaseMortgageProductFragmentDoc}
${SourceResponseFragmentDoc}
${ArrearsSummaryDetailsFragmentDoc}`;
export const ManualProtectionProductTypeFragmentFragmentDoc = gql`
    fragment ManualProtectionProductTypeFragment on ProductBenefitItem {
  client_ids
  product_type
  product_type_other
  term_years
  term_age
  cover_amount
  cover_amount_frequency
  indexation_type
  indexation_percentage
  payout_type
  cover_amount_depreciation_rate
  cover_amount_life
  cover_amount_cic
  cover_amount_life_or_earlier_cic
  product_type_other_name
  product_add_ons {
    fracture_cover_client_ids
    waiver_of_premium_client_ids
    include_total_permanent_disability
  }
  premium_type
  deferral_period_days
  dual_defer_init_defer
  dual_defer_init_amount
  additional_cover_amount
  additional_deferral_period_days
}
    `;
export const BusinessProtectionProductTypeFragmentFragmentDoc = gql`
    fragment BusinessProtectionProductTypeFragment on ProtectionProductBenefitItem {
  client_ids
  product_type
  product_type_other
  term_years
  cover_amount
  cover_amount_frequency
  cost_amount
  cost_amount_frequency
  units_of_cover
  indexation_type
  indexation_percentage
  payout_type
  cover_amount_depreciation_rate
  cover_amount_life
  cover_amount_cic
  cover_amount_life_or_earlier_cic
  product_add_ons {
    fracture_cover_client_ids
    waiver_of_premium_client_ids
    include_total_permanent_disability
  }
  term_age
  premium_type
  deferral_period
  deferral_period_days
  additional_deferral_period_days
  additional_cover_amount
  dual_defer_init_defer
  dual_defer_init_amount
}
    `;
export const ProtectionProductTypePmiFragmentFragmentDoc = gql`
    fragment ProtectionProductTypePMIFragment on BusinessProtectionPMIProductBenefitItem {
  client_ids
  cover_amount_frequency
  cover_amount
  term_years
  excess_amount
  underwriting_level
}
    `;
export const ProtectionProductTypePrivateMedicalInsuranceFragmentDoc = gql`
    fragment ProtectionProductTypePrivateMedicalInsurance on ProtectionProductBenefitItem {
  client_ids
  product_type
  excess_amount
  underwriting_level
  outpatient_cover
  outpatient_cover_details
  hospital_list
  cancer_cover
  dental_and_optical
  therapies
  physiotherapy
  six_week_option
  travel_international
  private_gp_cover
  mental_health
  additional_notes
  outpatient_full_cover
}
    `;
export const ProtectionProductTypeEmployeeBenefitFragmentDoc = gql`
    fragment ProtectionProductTypeEmployeeBenefit on ProtectionProductBenefitItem {
  client_ids
  additional_notes
}
    `;
export const ProtectionProductBenefitsFragmentFragmentDoc = gql`
    fragment ProtectionProductBenefitsFragment on ProductBenefit {
  product_type_term {
    ...ManualProtectionProductTypeFragment
  }
  product_type_family_income_benefit {
    ...ManualProtectionProductTypeFragment
  }
  product_type_whole_of_life {
    ...ManualProtectionProductTypeFragment
  }
  product_type_income_protection {
    ...ManualProtectionProductTypeFragment
  }
  product_type_core_accident_sickness {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_child_accident_sickness {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_sports_lifestyle {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_specialist_healthcare_cover {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_other {
    ...ManualProtectionProductTypeFragment
  }
  product_type_group_life {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_group_pmi {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_group_asu {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_group_cic {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_group_ip {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_relevant_life {
    ...BusinessProtectionProductTypeFragment
  }
  product_key_man {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_pmi {
    ...ProtectionProductTypePMIFragment
  }
  product_type_shareholder_protection {
    ...BusinessProtectionProductTypeFragment
  }
  product_type_private_medical_insurance {
    ...ProtectionProductTypePrivateMedicalInsurance
  }
  product_type_group_private_medical_insurance {
    ...ProtectionProductTypePrivateMedicalInsurance
  }
  product_type_employee_benefit {
    ...ProtectionProductTypeEmployeeBenefit
  }
  product_type_executive_ip {
    ...BusinessProtectionProductTypeFragment
  }
}
    ${ManualProtectionProductTypeFragmentFragmentDoc}
${BusinessProtectionProductTypeFragmentFragmentDoc}
${ProtectionProductTypePmiFragmentFragmentDoc}
${ProtectionProductTypePrivateMedicalInsuranceFragmentDoc}
${ProtectionProductTypeEmployeeBenefitFragmentDoc}`;
export const ProductsForProtectionFragmentDoc = gql`
    fragment ProductsForProtection on ProtectionProductDetails {
  provider_name
  premium_frequency
  product_name
  recommendation_premium_amount
  underwritten_premium_amount
  product_details
  policy_number
  start_date
  end_date
  cancellation_date
  source_response
  solution_type
  solution_products
  is_employment_benefit
  is_business_protection
  keep_existing_policy
  product_recommendation_justification
  product_benefit_group_id
  status
  client_ids
  case_ids
  org_provider_reference
  external {
    id
    source {
      id
      name
    }
  }
  product_benefits {
    ...ProtectionProductBenefitsFragment
  }
  source {
    integrator_name
    product_reference
    quote_reference
    provider_reference
  }
  commission {
    initial_commission
    initial_commission_end_date
    commission_frequency
    renewal_commission
    renewal_commission_frequency
    renewal_commission_start_date
    renewal_commission_end_date
    description
  }
  documents {
    application_doc_id
    key_facts_doc_id
    illustration_doc_id
    policy_letter_doc_id
    comparison_report_doc_id
    commission_comparison_report_doc_id
  }
  recommended_case {
    case_id
    created_at
  }
  not_proceeding_details {
    reason
    reason_entity
    had_psr_when_declined
  }
}
    ${ProtectionProductBenefitsFragmentFragmentDoc}`;
export const ClientEidvDetailsFragmentDoc = gql`
    fragment ClientEidvDetails on ClientIdVerificationStatus {
  eidvs {
    eidv_check_id
    eidv_check_status
    eidv_check_completed
    eidv_check_requested
    eidv_extended_status
    eidv_signature
    eidv_sanction
    eidv_pep
    eidv_special_interest_person
    eidv_close_associate
    eidv_client_details_hash
    additional_eidv_information {
      description
      data
    }
  }
}
    `;
export const PensionDetailsFragmentDoc = gql`
    fragment PensionDetails on ClientIncome {
  pension {
    provider_phone_number
    pension_type
    reference_number
    provider_name
    provider_address {
      address1
      address2
      address3
      posttown
      county
      postcode
      country
    }
    gross_annual_pension_income
  }
}
    `;
export const ClientIncomeSickPayDetailsFragmentDoc = gql`
    fragment ClientIncomeSickPayDetails on ClientIncomeSickPay {
  sick_pay_type
  sick_pay_amount_monthly
  sick_pay_period_months
  sick_pay_details
  allowances {
    percentage
    duration
    duration_unit
  }
}
    `;
export const ClientEmploymentIncomeFragmentDoc = gql`
    fragment ClientEmploymentIncome on ClientIncome {
  employment {
    employment_type
    employment_basis
    employment_start_date
    employment_end_date
    no_other_recent_employment
    employer_name
    will_contract_be_renewed
    contract_renewal_details
    on_probation
    probation_details
    shareholding_percentage
    employer_address {
      address1
      address2
      address3
      posttown
      county
      postcode
      country
    }
    employer_work_phone
    employer_mobile_phone
    employer_email
    employer_alternate_email
    incomes {
      is_guaranteed
      income_amount
      income_currency
      income_frequency
      income_type
      income_other_type
      income_history
      income_history_last_date
    }
    total_guaranteed_annual
    total_additional_annual
  }
}
    `;
export const ClientSelfEmployedIncomeFragmentDoc = gql`
    fragment ClientSelfEmployedIncome on ClientIncome {
  self_employment {
    has_accountant
    self_employed_basis
    business_start_date
    employed_for_tax_purposes
    net_profits_last_year
    net_profits_two_years_ago
    net_profits_three_years_ago
    taxable_income_last_year
    taxable_income_two_years_ago
    taxable_income_three_years_ago
    shareholding_percentage
    percentage_share_last_year
    percentage_share_two_years_ago
    percentage_share_three_years_ago
    your_role_in_business_end_date
    connected_with_business_since_date
    salary_income_last_year
    salary_income_two_years_ago
    salary_income_three_years_ago
    dividend_income_last_year
    dividend_income_two_years_ago
    dividend_income_three_years_ago
    business_name
    accountant_name
    accountant_work_phone
    accountant_email
    no_of_years_accounts_available
    accountant_address {
      address1
      address2
      address3
      posttown
      county
      postcode
      country
    }
    business_address {
      address1
      address2
      address3
      posttown
      county
      postcode
      country
    }
    construction_industry_scheme
    financial_year_end_date
  }
}
    `;
export const FullAddressFragmentDoc = gql`
    fragment FullAddress on LutherAddress {
  address1
  address2
  address3
  posttown
  county
  postcode
  country
  acre_property_id
  __typename
}
    `;
export const LutherAddressFragmentDoc = gql`
    fragment LutherAddress on LutherAddress {
  address1
  address2
  address3
  posttown
  postcode
  country
  county
  acre_property_id
}
    `;
export const ClientHealthFragmentDoc = gql`
    fragment ClientHealth on Client {
  date_of_birth
  smoker_status
  client_weight
  client_height
  display_weight_unit
  display_height_unit
  health_information {
    medical_appointment_in_last_twelve_months {
      is_applicable
      additional_details
    }
    planned_medical_appointments_or_test_results {
      is_applicable
      additional_details
    }
    current_medication_intake {
      is_applicable
      additional_details
    }
    client_has_no_condition
    high_blood_pressure {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
      systolic
      diastolic
    }
    heart_disease {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    heart_attack {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    heart_valve_replacement {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    diabetes {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
      latest_hba1c_level
    }
    stroke {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    mini_stroke {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    cancer_diagnosis {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    cancer_requiring_surgery {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    parkinson {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    dementia {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    multiple_sclerosis {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    chronic_kidney_failure {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    chronic_respiratory_disease {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    organ_transplant {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    cirrhosis {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    motor_neurone_disease {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    peripheral_vascular_disease {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    hepatitis_c {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    hiv {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
      }
    }
    other_medical_condition {
      is_applicable
      additional_details
    }
    early_retirement_due_to_ill_health {
      is_applicable
      additional_details
    }
    medical_history_additional_details
    anxiety_or_panic {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
        time_taken_off
        prescribed_medication
      }
    }
    bipolar_psychosis_schizophrenia {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
        time_taken_off
        prescribed_medication
      }
    }
    depression {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
        time_taken_off
        prescribed_medication
      }
    }
    other_mental_health_condition {
      has_condition
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
        time_taken_off
        prescribed_medication
      }
    }
    muscle_bone_joint_condition {
      has_condition
      had_physiotherapy_surgery_injections
      condition_details {
        date_of_diagnosis
        current_or_planned_treatments
        additional_details
        time_taken_off
        prescribed_medication
      }
    }
    client_has_no_family_medical_history
    family_heart_attack {
      is_applicable
      additional_details
    }
    family_cardiomyopathy {
      is_applicable
      additional_details
    }
    family_diabetes {
      is_applicable
      additional_details
    }
    family_cancer {
      is_applicable
      additional_details
    }
    family_muscular_dystrophy {
      is_applicable
      additional_details
    }
    family_neurological_disorder {
      is_applicable
      additional_details
    }
    family_kidney_disease {
      is_applicable
      additional_details
    }
    family_other_family_medical_condition {
      is_applicable
      additional_details
    }
    family_medical_history_do_not_know
    family_medical_history_additional_details
    gp_registration_status
    gp_has_access_to_english_medical_records {
      is_applicable
      additional_details
    }
    gp_name
    gp_phone_number
    gp_address {
      ...LutherAddress
    }
    gp_additional_notes
    alcohol_consumption_units_per_week
    alcohol_consumption_gp_referral {
      is_applicable
      additional_details
    }
    has_smoked_in_the_past
    stopped_smoking_date
    cigarettes_consumption {
      is_applicable
      daily_consumption
    }
    vape_consumption {
      is_applicable
      daily_consumption
    }
    rolling_tobacco_consumption {
      is_applicable
      daily_consumption
    }
    other_nicotine_consumption_details {
      is_applicable
      additional_details
    }
    recreational_drug_use {
      is_applicable
      additional_details
    }
    motorbike_for_transport {
      is_applicable
      additional_details
    }
    hazardous_sports_or_hobbies {
      is_applicable
      additional_details
    }
    receives_payment_for_sport_participation {
      is_applicable
      additional_details
    }
  }
}
    ${LutherAddressFragmentDoc}`;
export const ClientRiskReportDetailsFragmentDoc = gql`
    fragment ClientRiskReportDetails on RiskReport {
  created_at
  document_id
  client_hash
  term
  results {
    mortality_over_term
    loss_of_income_over_term
    morbidity_or_mortality_over_term
    morbidity_or_mortality_or_loss_of_income_over_term
  }
}
    `;
export const ClientDetailsFragmentDoc = gql`
    fragment ClientDetails on Client {
  id
  title
  first_name
  middle_name
  last_name
  client_type
  maiden_or_previous_name
  date_of_name_change
  gender
  marital_status
  date_of_birth
  is_natural_person
  opt_out_credit_refresh
  previous_names {
    id
    internalHash
    previous_first_name
    previous_surname
    date_of_name_change
    reason_for_name_change
  }
  limited_company_registration_number
  non_natural_organisation_type
  organisation_name
  organisation_sic
  non_natural {
    number_of_employees
  }
  contact_details_email
  contact_details_home_phone
  contact_details_work_phone
  contact_details_mobile_phone
  net_monthly_income
  outgoings_maintenance_payments
  outgoings_water
  outgoings_communications
  outgoings_mortgage_rent
  outgoings_insurance
  outgoings_investments
  outgoings_council_tax
  outgoings_food
  outgoings_clothing
  outgoings_other_living_costs
  outgoings_entertainment
  outgoings_holidays
  outgoings_sports
  outgoings_pension
  outgoings_car_costs
  outgoings_other_transport_costs
  outgoings_child_care
  outgoings_fuel
  outgoings_ground_rent_service_charge_shared_equity_rent
  outgoings_television_license
  outgoings_household_repairs
  outgoings_additional_details
  outgoings_material_change_details
  has_will
  has_reviewed_will_in_last_five_years
  client_weight
  client_height
  smoker_status
  credit_history_has_ever_surrendered_a_property_or_been_repossessed
  credit_history_has_ever_surrendered_a_property_or_been_repossessed_details
  credit_history_adverse_details_has_client_declared_bankruptcy
  credit_history_adverse_details_has_client_had_default
  credit_history_adverse_details_has_client_had_ccj
  credit_history_adverse_details_has_client_missed_payments
  credit_history_adverse_details_number_of_missed_payments
  credit_history_adverse_details_has_missed_payments_cleared
  credit_history_adverse_details_missed_any_payments_on_commitments_details
  credit_history_have_you_ever_had_an_application_denied_or_refused
  mortgage_application_refused {
    id
    internalHash
    application_refused_date
    application_refused_creditor
    application_refused_type
    application_refused_details
  }
  credit_history_default_events {
    date_registered
    date_satisfied
    amount
    creditor_name
  }
  credit_history_county_court_judgements {
    id
    internalHash
    date_registered
    date_satisfied
    amount
    creditor_name
  }
  credit_history_bankruptcy_events {
    id
    internalHash
    bankruptcy_date
    discharge_date
    court
  }
  credit_history_adverse_details_has_client_had_debt_management_plan
  credit_history_debt_management_plans {
    id
    internalHash
    date_registered
    date_completed
    monthly_payment_amount
    satisfactory_conduct
  }
  credit_history_adverse_details_has_arrears
  credit_history_arrears {
    has_cleared
    amount
    max_number_of_monthly_payments_in_arrears
    type_of_credit
    creditor_name
    date_of_arrear
    date_cleared
  }
  credit_history_adverse_details_has_client_had_iva
  credit_history_individual_voluntary_arrangements {
    id
    internalHash
    date_registered
    date_completed
    monthly_payment_amount
    satisfactory_conduct
  }
  unearned_income {
    id
    internalHash
    type
    amount
    frequency
    other_type
  }
  anticipated_retirement_unearned_income {
    id
    internalHash
    type
    amount
    frequency
    other_type
  }
  employment_status
  amount_of_savings
  country_of_birth
  nationalities
  retirement_age
  national_insurance_number
  agreed_budget
  agreed_monthly_protection_budget
  client_originator
  is_vulnerable
  applicants_are_high_tax_rate_payers
  id_verification_status {
    ...ClientEidvDetails
  }
  deposits {
    id
    internalHash
    amount
    type
    donors {
      id
      version
      details {
        id
        first_name
        last_name
        is_natural_person
        relationships {
          relationship_reference
          relationship_type
          relationship_data_access_permitted
        }
      }
    }
    documents
    document_verifies
    source
    deposit_for
  }
  debts {
    internalHash
    id
    term_in_months
    repayment_frequency
    payment_status_summary
    account_status
    commitment_type
    borrower_type
    amount_outstanding
    monthly_repayment_amount
    name_of_creditor
    final_repayment_date
    repaid_before_mortgage_commences
    to_be_consolidated
    credit_limit
    additional_details
    repaid_each_month
    interest_rate
    reference_account_no
    repayment_amount
    start_date
    end_date
    last_update_date
    payment_history {
      age_in_months
      date
      balance
      payment
      payment_status
    }
    default_event {
      date_registered
      date_satisfied
      balance
    }
    arrears_summary {
      max_arrears_currency
      max_arrears_months
      last_arrears_date
      arrears_cleared_date
    }
    joint_applicant {
      client_id
      debt_id
    }
    equifax_account_number
    equifax_promotional_rate_ind
    revert_rate
    revert_date
    estimated_interest_rates
    early_repayment_percentage
    early_repayment_amount
    average_monthly_repayment_amount
    amount_to_consolidate
    calculated_values {
      months_to_repay
      total_interest
      end_date_discrepancy
      months_to_repay_partial
      average_monthly_repayment_amount
    }
  }
  accounts {
    id
    internalHash
    type
    sort_code
    number
    number_of_months_held
  }
  total_guaranteed_annual
  total_additional_annual
  income_and_employment {
    id
    internalHash
    ...PensionDetails
    date_of_retirement
    is_retired
    pay_rise_expected
    pay_rise_expected_details
    pay_rise_due_in_num_months
    sick_pay {
      ...ClientIncomeSickPayDetails
    }
    pay_rise_new_salary
    income_likely_to_reduce_in_future
    income_likely_to_reduce_in_future_description
    ...ClientEmploymentIncome
    ...ClientSelfEmployedIncome
    standardised_occupation_code
    occupation_title
    abi_industry
    monthly_net_income
    is_current
  }
  anticipated_retirement_income {
    id
    internalHash
    ...PensionDetails
    date_of_retirement
    is_retired
    pay_rise_expected
    pay_rise_expected_details
    pay_rise_due_in_num_months
    sick_pay {
      ...ClientIncomeSickPayDetails
    }
    pay_rise_new_salary
    income_likely_to_reduce_in_future
    income_likely_to_reduce_in_future_description
    ...ClientEmploymentIncome
    ...ClientSelfEmployedIncome
    standardised_occupation_code
    occupation_title
    abi_industry
    monthly_net_income
    is_current
  }
  outgoings {
    outgoings_maintenance_payments
    outgoings_water
    outgoings_communications
    outgoings_mortgage_rent
    outgoings_insurance
    outgoings_investments
    outgoings_council_tax
    outgoings_food
    outgoings_clothing
    outgoings_other_living_costs
    outgoings_entertainment
    outgoings_holidays
    outgoings_sports
    outgoings_pension
    outgoings_car_costs
    outgoings_other_transport_costs
    outgoings_child_care
    outgoings_fuel
    outgoings_ground_rent_service_charge_shared_equity_rent
    outgoings_television_license
    outgoings_household_repairs
    outgoings_additional_details
    outgoings_material_change_details
  }
  addresses {
    id
    internalHash
    address {
      ...FullAddress
    }
    is_current_correspondence
    residential_status
    move_in_date
    move_out_date
    documents
    document_verifies
  }
  relationships {
    relationship_reference
    relationship_type
    relationship_data_access_permitted
  }
  dependants {
    id
    internalHash
    date_of_birth
    relationship
    relationship_other
    name
    title
    dependency_end_date
  }
  credit_report_retrievals {
    retrieval_time
    pdf_document_id
  }
  calculated_values {
    age
    risk_details_hash
  }
  vulnerabilities
  vulnerability_details {
    type
    id
    source
    source_id
    actions {
      id
      response
      action
    }
    modified_at
    created_at
  }
  vulnerability_assessments {
    id
    created_at
    modified_at
    template_id
    provider
    complete
  }
  additional_vulnerabilities_details
  external {
    id
    source {
      id
      name
    }
  }
  client_ext_ids {
    id
    name
  }
  contact_history {
    contact_type
    created_at
    identifier
    third_party_id
  }
  ...ClientHealth
  risk_reports {
    ...ClientRiskReportDetails
  }
}
    ${ClientEidvDetailsFragmentDoc}
${PensionDetailsFragmentDoc}
${ClientIncomeSickPayDetailsFragmentDoc}
${ClientEmploymentIncomeFragmentDoc}
${ClientSelfEmployedIncomeFragmentDoc}
${FullAddressFragmentDoc}
${ClientHealthFragmentDoc}
${ClientRiskReportDetailsFragmentDoc}`;
export const PropertyDetailsFragmentDoc = gql`
    fragment PropertyDetails on PropertyVersion {
  id
  property_id
  version
  details {
    id
    property_id
    acre_property_id
    current_energy_rating
    property_price
    property_valuation
    specified_rebuild_cost
    price
    type
    tenure
    valuation
    flying_freehold_percentage
    leasehold_service_charge
    clear_floor_between_retail
    is_new_build
    property_builder_name
    new_build_discounts_or_incentives_value
    builder_registration_scheme
    year_property_built
    monthly_management_expenses
    wall_type
    roof_type
    intend_to_let_or_run_business
    intend_to_let_or_run_business_description
    property_location
    property_use
    number_of_bedrooms
    number_of_bathrooms
    is_property_ex_local_authority
    is_property_furnished
    monthly_rental_income
    shared_ownership_monthly_rent
    is_shared_ownership
    shared_ownership_type
    shared_ownership_share
    shared_equity_repayment_details
    help_to_buy_loan_amount
    shared_equity_monthly_interest
    shared_ownership_scheme_provider
    right_to_buy_valuation
    is_unencumbered
    is_property_habitable
    sub_type
    is_work_planned_on_property
    work_planned_on_property
    gross_development_value
    cost_of_works
    btl_has_lived
    btl_will_lived
    btl_is_operating_a_business
    is_house_of_multiple_occupancy
    number_of_lettable_rooms
    is_multi_unit_freehold_block
    registered_owners_details
    target_registered_owners_details
    purchase_date
    registered_owners {
      id
      version
      details {
        id
        first_name
        middle_name
        last_name
        is_natural_person
        organisation_name
      }
    }
    occupants {
      tenancy_type
      tenant_type
    }
    address {
      address1
      address2
      address3
      posttown
      county
      postcode
      country
    }
    attributes {
      num_floors_in_block
      num_flats_in_block
      floor_of_flat
      years_left_on_lease
      leasehold_ground_rent
      property_converted_in_last_ten_years
      does_the_property_have_a_lift
      is_property_over_retail
      number_of_kitchens
      number_of_reception_rooms
      has_annex
      property_parking
      solar_panels_on_property
      does_the_property_have_deck_access
    }
    mortgages @include(if: $includeCaseDetailsInProperty) {
      ...CaseMortgagesAndMortgageProducts
    }
    case_status @include(if: $includeCaseDetailsInProperty)
    transition_mortgage_versions @include(if: $includeCaseDetailsInProperty) {
      entity_versions {
        mortgage_id
        version
      }
      transition_to
      created_at
    }
    external {
      id
      source {
        id
        name
      }
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}`;
export const ProtectionDetailsFragmentDoc = gql`
    fragment ProtectionDetails on Protection {
  additional_notes
  any_remaning_shortfalls
  client_advice_limit_details
  client_protection_objectives_circumstances
  death_needs_income_amount
  death_needs_income_term
  death_needs_income_term_justification
  death_needs_lump_sum_amount
  death_needs_lump_sum_term
  death_needs_lump_sum_term_justification
  death_lump_sum_needs_met_by_preexisting
  employee_benefits_shortfall_reasoning
  has_client_accepted_protection_advice
  has_client_accepted_protection_needs
  client_declined_protection_needs_reason
  has_existing_policies
  inheritance_advice_indicator
  length_of_time_payment_without_work
  insistent_client_indicator
  illness_needs_deferrment_period_weeks
  illness_needs_income_amount
  illness_needs_income_term
  illness_needs_met_by_preexisting
  illness_needs_term_justification
  include_employee_benefits_in_shortfall
  has_employee_benefits
  justify_remaining_shortfalls
  income_has_critical_illness_requirement
  income_has_death_requirement
  lump_sum_has_critical_illness_requirement
  lump_sum_has_death_requirement
  death_needs_lump_sum_client_ids
  death_needs_income_client_ids
  death_income_needs_met_by_preexisting
  illness_needs_client_ids
  funeral_needs_client_ids
  funeral_needs_lump_sum_amount
  funeral_needs_justification
  funeral_needs_met_by_preexisting
  recommend_placing_in_trust
  specific_trust_recommendation
  trust_details
  client_confirms_terms_exceeding_retirement_affordable
  client_advice_limit
  suitability_report_recommendation_introduction_protection
  rebroke_decision_advantages_and_disadvantages
  additional_considerations_detail
  additional_budget_details
  death_needs_lump_sum_amount_justification
  death_needs_income_amount_justification
  illness_needs_income_amount_justification
  requirements {
    objectives {
      advice_limit
      advice_limit_details
      protection_objectives_circumstances
    }
    life_and_critical_illness {
      id
      client_ids
      scenario
      existing_policy
      cover_amount
      cover_amount_depreciation_rate
      cover_frequency
      cover_reason
      term_years
      term_age
      term_reason
      benefit_type
    }
    family_income_benefits {
      id
      client_ids
      scenario
      existing_policy
      cover_amount
      cover_frequency
      cover_reason
      term_years
      term_age
      term_reason
    }
    income_protection {
      id
      client_ids
      existing_policy
      deferral_weeks
      cover_amount
      cover_amount_type
      cover_frequency
      cover_reason
      term_years
      term_age
      term_reason
    }
    whole_of_life {
      id
      client_ids
      existing_policy
      cover_amount
      cover_frequency
      cover_reason
    }
    private_medical_insurance {
      id
      client_ids
      existing_policy
      cover_reason
    }
    relevant_life {
      id
      client_ids
      scenario
      existing_policy
      cover_amount
      cover_amount_depreciation_rate
      cover_frequency
      cover_reason
      term_years
      term_age
      term_reason
      benefit_type
    }
    executive_ip {
      id
      client_ids
      existing_policy
      deferral_weeks
      cover_amount
      cover_amount_type
      cover_frequency
      cover_reason
      term_years
      term_age
      term_reason
    }
  }
}
    `;
export const CaseLevelDipResultFragmentDoc = gql`
    fragment CaseLevelDipResult on CaseLevelDipResult {
  acre_dip_id
  amount
  client_ids
  dip_details {
    decisionExpiryDate
    overallDecision
  }
  dip_status
  lender
  provider_application_reference
  provider_case_id
  provider_dip_reference
}
    `;
export const DocumentRequirementDetailsFragmentDoc = gql`
    fragment DocumentRequirementDetails on DocumentRequirementDetails {
  organisation_id
  name
  description
  status
  gi
  protection_types
  exclude_product_transfer
  exclude_no_contact_renewal
  exclude_renewal
  case_types
  document_types
  auto_satisfy {
    document_types
    count
    broker_verification_required
  }
  default_overdue
  per_client
  can_share_with_client
  required_from
  required_by
  apply_to_existing
}
    `;
export const CaseDetailsFragmentDoc = gql`
    fragment CaseDetails on Case {
  id
  owner_user_id
  status
  regulated_by
  has_previously_owned_property
  agreed_monthly_protection_budget
  has_seen_face_to_face
  impersonation_check_performed
  impersonation_check_details
  is_debt_consolidation
  btl_has_lived
  btl_will_lived
  btl_is_operating_a_business
  btl_through_company
  client_ids
  is_introduced
  introducer_id
  introducer_details
  lender_has_proposed_new_product
  last_update
  last_significant_update
  owner_organisation_id
  owner_organisation {
    representative_of
    id
    name
    process_settings {
      use_exchange_case_status
    }
    protection_settings {
      decreasing_term_policy_rate_default_type
      decreasing_term_policy_rate_default_rate
      commission {
        indemnity_required
      }
    }
  }
  owner {
    id
    first_name
    last_name
    organisation_id
    organisation {
      id
      fca_reg_no
      name
      primary_address {
        address1
        address2
        address3
        posttown
        county
        postcode
        country
      }
    }
  }
  miDocuments {
    documents {
      ...MIDocuments
      clients {
        id
        version
        details {
          id
          client_id
          is_natural_person
          first_name
          middle_name
          last_name
          organisation_name
        }
      }
    }
  }
  calculated_values {
    total_additional_borrowing
    total_required_loan_amount
  }
  override_client_eidv_results {
    client_id
    override_result
  }
  preference_interest_only_repayment_strategy
  preference_upper_limit
  preference_fixed_rate
  preference_early_year_discount
  preference_no_early_repayment_charge
  preference_no_tie_in
  preference_fee_to_loan
  preference_vary_repayment_amount
  preference_payment_holiday
  preference_link_finances
  preference_details
  preference_term
  preference_repayment_percentage
  change_of_preference_reason
  preference_cashback
  preference_initial_period_months
  preference_mortgage_class
  preference_mortgage_reason
  preference_free_conveyancing
  preference_free_valuations
  preference_completion_speed_important
  preference_tracker
  preference_overpayment
  preference_target_property_value
  preference_loan_amount
  preference_target_deposit
  preference_target_property
  preference_related_property_sale
  reason_for_further_advance
  shared_budget
  preference_mortgage_loan_amount
  additional_loan_required
  recommendation_reason_additional_borrowing
  preference_reason_for_debt_consolidation
  ...SuitabilityReportFields
  ...CaseTransitionVersions
  additional_loans {
    id
    loan_amount
    loan_purpose
  }
  survey_answers {
    client_id
    modified_at
    completed_at
    answers {
      question_id
      question_version
      five_scale_answer
      ten_scale_answer
      zero_ten_scale_answer
      free_text_answer
      bool_answer
      single_choice_answer
      multiple_choice_answer
    }
  }
  mortgages {
    ...CaseMortgagesAndMortgageProducts
  }
  protection_products {
    protection_id
    created_at
    version
    version_created_at
    details {
      ...ProductsForProtection
    }
  }
  clients {
    id
    version
    details {
      ...ClientDetails
    }
  }
  new_property {
    ...PropertyDetails
  }
  remortgage_property {
    ...PropertyDetails
  }
  flags {
    flag_id
    flag_type
    created_at
    reviews {
      review_passed
      created_at
      reviewer_user_id
      reviewer_private_notes
      reviewer_notes
      review_grade
      reviewed_case_version
    }
  }
  protection {
    ...ProtectionDetails
  }
  third_party_orgs {
    type
    firm_name
    name
    work_phone
    email_address
    id
    address {
      address1
      address2
      address3
      posttown
      county
      postcode
      country
    }
  }
  related_users {
    id
    user_id
    relationship_type
    commission_share_basis_points
  }
  related_cases {
    id
    case_id
    relationship_type
    preference_mortgage_reason
    firm
    advisor
    status
    visible
    property_id
    firm_id
    representative_of
    address {
      address1
      address2
      address3
      posttown
      county
      postcode
      country
    }
  }
  conveyancing_type
  own_solicitor_details {
    firm_name
    contact_name
    email_address
    phone_number
    dx_number
    dx_town
    case_reference
  }
  conveyancing_status
  conveyancing_updates {
    conveyancing_update_id
    type
    source
    property
    date
    created_at
  }
  referrals {
    partner
    referral_type
    status
    third_party_id
    contact_history {
      third_party_id
      clicked_at
      clicks
      contact_type
      created_at
      delivered
      identifier
      opened_at
    }
    referral_source
    referral_source_id
  }
  external {
    id
    source {
      id
      name
    }
  }
  lead_metadata {
    source
    campaign
    content
  }
  fee_option_title
  fees {
    fee_type
    value
  }
  dip_result {
    ...CaseLevelDipResult
  }
  addendum_reasons {
    cover_change_self_identified
    cover_change_system_identified
    additional_details
  }
  document_requirements {
    requirement_id
    source
    source_id
    created_at
    details {
      ...DocumentRequirementDetails
    }
  }
}
    ${MiDocumentsFragmentDoc}
${SuitabilityReportFieldsFragmentDoc}
${CaseTransitionVersionsFragmentDoc}
${CaseMortgagesAndMortgageProductsFragmentDoc}
${ProductsForProtectionFragmentDoc}
${ClientDetailsFragmentDoc}
${PropertyDetailsFragmentDoc}
${ProtectionDetailsFragmentDoc}
${CaseLevelDipResultFragmentDoc}
${DocumentRequirementDetailsFragmentDoc}`;
export const CaseMortgageFeesFragmentDoc = gql`
    fragment CaseMortgageFees on CaseVersion {
  id
  details {
    id
    ...CaseTransitionVersions
    client_ids
    fee_option_title
    fees {
      fee_type
      value
    }
    mortgages {
      id
      version
      esis_document_id
      raw_results_reference
      selected_mortgage_club_code
      calculated_values {
        fees {
          amount
          fee_type
        }
        can_generate_esis
        calculated_gross_proc_fee
        calculated_club_proc_fees {
          mortgage_club_code
          mortgage_club_name
          net_proc_fee
          proc_fee
        }
      }
      mortgage_product {
        id
        fees {
          amount
          fee_type
        }
      }
    }
  }
}
    ${CaseTransitionVersionsFragmentDoc}`;
export const CaseRequirementsFragmentDoc = gql`
    fragment CaseRequirements on CaseVersion {
  id
  details {
    id
    protection {
      requirements {
        objectives {
          advice_limit
          advice_limit_details
          protection_objectives_circumstances
        }
        life_and_critical_illness {
          id
          client_ids
          scenario
          existing_policy
          cover_amount
          cover_frequency
          cover_reason
          term_years
          term_age
          term_reason
          benefit_type
        }
        family_income_benefits {
          id
          client_ids
          scenario
          existing_policy
          cover_amount
          cover_frequency
          cover_reason
          term_years
          term_age
          term_reason
        }
        income_protection {
          id
          client_ids
          existing_policy
          deferral_weeks
          cover_amount
          cover_amount_type
          cover_frequency
          cover_reason
          term_years
          term_age
          term_reason
        }
        whole_of_life {
          id
          client_ids
          existing_policy
          cover_amount
          cover_frequency
          cover_reason
        }
        private_medical_insurance {
          id
          client_ids
          existing_policy
          cover_reason
        }
        relevant_life {
          id
          client_ids
          scenario
          existing_policy
          cover_amount
          cover_amount_depreciation_rate
          cover_frequency
          cover_reason
          term_years
          term_age
          term_reason
          benefit_type
        }
        executive_ip {
          id
          client_ids
          existing_policy
          deferral_weeks
          cover_amount
          cover_amount_type
          cover_frequency
          cover_reason
          term_years
          term_age
          term_reason
        }
      }
    }
  }
}
    `;
export const CaseVersionDetailsFragmentDoc = gql`
    fragment CaseVersionDetails on CaseVersion {
  id
  created_at
  version
  version_created_at
  details {
    id
    status
    introducer_id
    owner_user_id
    regulated_by
    lender_has_proposed_new_product
    has_previously_owned_property
    has_seen_face_to_face
    impersonation_check_performed
    impersonation_check_details
    is_debt_consolidation
    btl_has_lived
    btl_will_lived
    btl_is_operating_a_business
    btl_through_company
    is_introduced
    introducer_details
    client_ids
    calculated_values {
      total_additional_borrowing
      total_required_loan_amount
    }
    override_client_eidv_results {
      client_id
      override_result
    }
    preference_interest_only_repayment_strategy
    preference_upper_limit
    preference_fixed_rate
    preference_early_year_discount
    preference_no_early_repayment_charge
    preference_no_tie_in
    preference_fee_to_loan
    preference_vary_repayment_amount
    preference_payment_holiday
    preference_link_finances
    preference_details
    preference_term
    preference_repayment_percentage
    change_of_preference_reason
    preference_cashback
    preference_initial_period_months
    preference_mortgage_class
    preference_mortgage_reason
    preference_free_conveyancing
    preference_free_valuations
    preference_completion_speed_important
    preference_tracker
    preference_overpayment
    preference_target_property_value
    preference_loan_amount
    preference_target_deposit
    preference_target_property
    preference_related_property_sale
    preference_mortgage_loan_amount
    additional_loan_required
    additional_loans {
      id
      loan_amount
      loan_purpose
    }
    recommendation_reason_additional_borrowing
    preference_reason_for_debt_consolidation
    reason_for_further_advance
    flags {
      flag_id
      flag_type
      created_at
      reviews {
        review_passed
        created_at
        reviewer_user_id
        reviewer_private_notes
        reviewer_notes
        review_grade
        reviewed_case_version
      }
    }
    protection {
      ...ProtectionDetails
    }
    shared_budget
    conveyancing_type
    own_solicitor_details {
      firm_name
      contact_name
      email_address
      phone_number
      dx_number
      dx_town
      case_reference
    }
    conveyancing_status
    conveyancing_updates {
      conveyancing_update_id
      created_at
      date
      property
      source
      type
    }
    referrals {
      referral_type
      partner
      third_party_id
      status
    }
    ...CaseTransitionVersions
    new_property {
      ...PropertyDetails
    }
    remortgage_property {
      ...PropertyDetails
    }
    dip_result {
      ...CaseLevelDipResult
    }
    addendum_reasons {
      cover_change_self_identified
      cover_change_system_identified
      additional_details
    }
    document_requirements {
      requirement_id
      source
      source_id
      created_at
      details {
        ...DocumentRequirementDetails
      }
    }
  }
}
    ${ProtectionDetailsFragmentDoc}
${CaseTransitionVersionsFragmentDoc}
${PropertyDetailsFragmentDoc}
${CaseLevelDipResultFragmentDoc}
${DocumentRequirementDetailsFragmentDoc}`;
export const ClientFactFindInfoFragmentDoc = gql`
    fragment ClientFactFindInfo on Client {
  id
  title
  first_name
  middle_name
  last_name
  maiden_or_previous_name
  date_of_name_change
  gender
  marital_status
  date_of_birth
  is_natural_person
  limited_company_registration_number
  organisation_name
  organisation_sic
  non_natural {
    number_of_employees
  }
  country_of_birth
  nationalities
  retirement_age
  national_insurance_number
  contact_details_email
  contact_details_home_phone
  contact_details_work_phone
  contact_details_mobile_phone
  outgoings_maintenance_payments
  outgoings_water
  outgoings_communications
  outgoings_mortgage_rent
  outgoings_insurance
  outgoings_investments
  outgoings_council_tax
  outgoings_food
  outgoings_clothing
  outgoings_other_living_costs
  outgoings_entertainment
  outgoings_holidays
  outgoings_sports
  outgoings_pension
  outgoings_car_costs
  outgoings_other_transport_costs
  outgoings_child_care
  outgoings_fuel
  outgoings_ground_rent_service_charge_shared_equity_rent
  outgoings_television_license
  outgoings_household_repairs
  outgoings_additional_details
  outgoings_material_change_details
  has_will
  has_reviewed_will_in_last_five_years
  client_weight
  client_height
  smoker_status
  credit_history_has_ever_surrendered_a_property_or_been_repossessed
  credit_history_has_ever_surrendered_a_property_or_been_repossessed_details
  credit_history_adverse_details_has_client_declared_bankruptcy
  credit_history_adverse_details_has_client_had_default
  credit_history_adverse_details_has_client_had_ccj
  credit_history_adverse_details_has_client_missed_payments
  credit_history_adverse_details_number_of_missed_payments
  credit_history_adverse_details_has_missed_payments_cleared
  credit_history_adverse_details_missed_any_payments_on_commitments_details
  credit_history_have_you_ever_had_an_application_denied_or_refused
  mortgage_application_refused {
    id
    internalHash
    application_refused_date
    application_refused_creditor
    application_refused_type
    application_refused_details
  }
  credit_history_default_events {
    date_registered
    date_satisfied
    amount
    creditor_name
  }
  credit_history_county_court_judgements {
    id
    internalHash
    date_registered
    date_satisfied
    amount
    creditor_name
  }
  credit_history_bankruptcy_events {
    id
    internalHash
    bankruptcy_date
    discharge_date
    court
  }
  credit_history_adverse_details_has_client_had_debt_management_plan
  credit_history_debt_management_plans {
    id
    internalHash
    date_registered
    date_completed
    monthly_payment_amount
    satisfactory_conduct
  }
  credit_history_adverse_details_has_arrears
  credit_history_arrears {
    has_cleared
    amount
    max_number_of_monthly_payments_in_arrears
    type_of_credit
    creditor_name
    date_of_arrear
    date_cleared
  }
  credit_history_adverse_details_has_client_had_iva
  credit_history_individual_voluntary_arrangements {
    id
    internalHash
    date_registered
    date_completed
    monthly_payment_amount
    satisfactory_conduct
  }
  unearned_income {
    id
    internalHash
    type
    amount
    frequency
    other_type
  }
  anticipated_retirement_unearned_income {
    id
    internalHash
    type
    amount
    frequency
    other_type
  }
  employment_status
  amount_of_savings
  agreed_budget
  agreed_monthly_protection_budget
  disposable_income
  is_vulnerable
  applicants_are_high_tax_rate_payers
  deposits {
    id
    internalHash
    amount
    type
    donors {
      id
      version
    }
    documents
    document_verifies
    source
    deposit_for
  }
  debts {
    id
    internalHash
    commitment_type
    borrower_type
    amount_outstanding
    monthly_repayment_amount
    name_of_creditor
    final_repayment_date
    repaid_before_mortgage_commences
    to_be_consolidated
    credit_limit
    additional_details
    repaid_each_month
    interest_rate
    default_event {
      date_registered
      date_satisfied
      balance
    }
    arrears_summary {
      max_arrears_currency
      max_arrears_months
      last_arrears_date
      arrears_cleared_date
    }
    joint_applicant {
      client_id
      debt_id
    }
    equifax_account_number
    equifax_promotional_rate_ind
    revert_rate
    revert_date
    estimated_interest_rates
    early_repayment_percentage
    early_repayment_amount
    average_monthly_repayment_amount
    amount_to_consolidate
    calculated_values {
      months_to_repay
      total_interest
      end_date_discrepancy
      months_to_repay_partial
      average_monthly_repayment_amount
    }
  }
  accounts {
    id
    internalHash
    type
    sort_code
    number
    number_of_months_held
  }
  total_guaranteed_annual
  income_and_employment {
    id
    internalHash
    ...PensionDetails
    ...ClientEmploymentIncome
    ...ClientSelfEmployedIncome
    standardised_occupation_code
    sick_pay {
      ...ClientIncomeSickPayDetails
    }
    occupation_title
    monthly_net_income
    is_current
  }
  anticipated_retirement_income {
    id
    internalHash
    ...PensionDetails
    ...ClientEmploymentIncome
    ...ClientSelfEmployedIncome
    standardised_occupation_code
    sick_pay {
      ...ClientIncomeSickPayDetails
    }
    occupation_title
    monthly_net_income
    is_current
  }
  credit_report_retrievals {
    retrieval_time
  }
  contact_history {
    contact_type
    created_at
    identifier
    third_party_id
  }
}
    ${PensionDetailsFragmentDoc}
${ClientEmploymentIncomeFragmentDoc}
${ClientSelfEmployedIncomeFragmentDoc}
${ClientIncomeSickPayDetailsFragmentDoc}`;
export const ClientNamesFragmentDoc = gql`
    fragment ClientNames on Case {
  id
  clients(fromClientPortal: $fromClientPortal) {
    id
    version
    details {
      id
      title
      first_name
      last_name
      is_natural_person
      limited_company_registration_number
      organisation_name
      contact_details_mobile_phone
      contact_details_email
    }
  }
}
    `;
export const ClientRelatedEntityDetailsFragmentDoc = gql`
    fragment ClientRelatedEntityDetails on Client {
  id
  miDocuments {
    documents {
      document_id
      date_stored
      document_name
      file_type
      type
      template_type
      other_type
      archived
      verification_count
      source {
        id
        type
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          is_natural_person
          organisation_name
        }
      }
    }
  }
  cases {
    id
    created_at
    details {
      id
      status
      preference_mortgage_reason
      regulated_by
    }
  }
}
    `;
export const CommissionStructureDetailsFragmentDoc = gql`
    fragment CommissionStructureDetails on CommissionStructure {
  commission_structure_id
  paying_organisation_id
  created_at
  modified_at
  receiving_user_id
  receiving_organisation_id
  regulating_organisation_id
  status
  acre_referral_club
  receiving_organisation {
    id
    name
    general_email
    primary_phone
    primary_address {
      address1
      address2
      address3
      posttown
      postcode
      country
      county
    }
    users {
      id
      first_name
      last_name
    }
  }
  commissions {
    internalHash
    type
    case_types
    revenue_types
    deduction_types
    fixed_value
    percentage
    frequency
    number_of_payments
    payment_due
    user_relation_to_case
    introducer_condition {
      condition
      introducer_company
    }
    related_user_condition {
      condition
      related_user
      related_user_relationship_type
    }
    tier_commission {
      period_id
      all_periods
      thresholds {
        percentage
        from
        to
      }
    }
  }
}
    `;
export const DipDetailsFragmentFragmentDoc = gql`
    fragment dipDetailsFragment on DipDecisionDetails {
  affordabilityDecision {
    decision
    description
    maximumAmount
    minimumTermYears
    decisionBasedOn
    helpingHandDecision
    helpingHandMaximumAmount
    helpingHandMinimumTermMonths
    helpingHandMinimumTermYears
  }
  creditDecision {
    decision
    description
  }
  policyDecision {
    decision
    description
    reasonCodes {
      code
      text
    }
  }
  propertyDecision {
    description
    decision
  }
  bureauDetails {
    bureauName
  }
  reasonCodes {
    code
    text
  }
  proofRequirements {
    applicantNumber
    code
    description
    name
  }
}
    `;
export const DocumentDetailsFragmentDoc = gql`
    fragment DocumentDetails on DocumentEntity {
  document_id
  date_stored
  document_name
  file_type
  type
  template_type
  other_type
  uploaded_by
  source
  archived
  verification_count
  source_client_id
  tags
  owning_clients(include_details: true) {
    id
    version
    details {
      id
      first_name
      last_name
      is_natural_person
      organisation_name
    }
  }
  internalHash
}
    `;
export const FilteredNotesFragmentDoc = gql`
    fragment filteredNotes on Note {
  note_id
  created_at
  modified_at
  title
  priority
  status
  body
  primary_type
  communication_type
  assignee_type
  deadline
  assignee_id
  case_id
  template_id
  event_note {
    event_id
    user_ids
    event_type
    start_time
    end_time
  }
  template {
    title
  }
  case {
    case_id
    case_type
  }
  clients {
    client_id
    first_name
    last_name
    is_natural_person
    organisation_name
  }
  client_id
  property_id
  mortgage_id
  verification_id
  organisation_ids
  created_by
  template_id
}
    `;
export const LedgerDetailsFragmentDoc = gql`
    fragment ledgerDetails on Ledger {
  caseId
  advisorId
  amountDue
  grossFee
  originFeeAmount
  type
  clientIds
  clubId
  dueDate
  settledDate
  isOverdue
  id
  propertyId
  period_id
  protection_policy_number
  protection_quote_reference
  mortgageAccountNumber
  isTier
  tierFrom
  tierTo
  originLedgerId
  status
  period_id
  advisor {
    id
    first_name
    last_name
  }
  payments {
    id
    amount
    date
    status
    external_id
    provider
    redirect_uri
    payee {
      id
      hydrationType
      sourceType
      details {
        ... on ClientVersion {
          id
          version
          details {
            id
            first_name
            last_name
            organisation_name
            is_natural_person
          }
        }
        ... on Organisation {
          id
          organisation_id
          name
        }
        ... on User {
          id
          first_name
          last_name
          role_name
          primary_role_id
        }
      }
    }
  }
  clients {
    id
    version
    details {
      id
      first_name
      last_name
      organisation_name
      is_natural_person
    }
  }
  club {
    id
    name
  }
  property {
    id
    version
    details {
      id
      address {
        address1
        address2
        address3
        postcode
        posttown
        county
        country
      }
    }
  }
  sourceId {
    id
    hydrationType
    sourceType
    details {
      ... on ClientVersion {
        id
        version
        details {
          id
          first_name
          last_name
          organisation_name
          is_natural_person
        }
      }
      ... on Organisation {
        id
        organisation_id
        name
      }
      ... on User {
        id
        first_name
        last_name
        role_name
        primary_role_id
      }
    }
  }
  status
  organisationID
  created_by
}
    `;
export const ManualProtectionProductTypeMetLifeFragmentDoc = gql`
    fragment ManualProtectionProductTypeMetLife on ProtectionProductBenefitItem {
  client_ids
  cost_amount
  cost_amount_frequency
  units_of_cover
}
    `;
export const MortgageCalculatedValuesDetailsFragmentDoc = gql`
    fragment MortgageCalculatedValuesDetails on MortgageCalculatedValues {
  cost_over_initial_term_inc_fees_cashback
  cost_over_full_term_inc_fees_cashback
  fees_at_origination
  cost_over_initial_term_inc_fees
  cost_over_full_term_inc_fees
  cost_over_initial_term_exc_fees
  cost_over_full_term_exc_fees
  total_mortgage_fees
  interest_cost_of_added_fees_full_term
  mortgage_origination_inc_added_fees
  loan_total_premiums_or_insurance_added_to_loan
  monthly_payment
  revert_monthly_payment
  calculated_net_proc_fee
  calculated_gross_proc_fee
  loan_total_fees_added_to_loan
  can_generate_esis
}
    `;
export const MortgageDetailsFragmentDoc = gql`
    fragment MortgageDetails on Mortgage {
  id
  mortgage_id
  version
  status
  term
  term_unit
  outstanding_balance
  outstanding_balance_date
  mortgage_start_date
  mortgage_amount
  interest_only_amount
  repayment_amount
  revert_monthly_payment
  fees_to_be_added
  monthly_payment
  application_date
  lender_proposed
  payment_status_summary
  calculated_values {
    monthly_payment
    revert_monthly_payment
  }
  mortgage_product_id
  mortgage_product {
    id
    mortgage_class
    fees_total
    initial_pay_rate
    initial_rate_period
    initial_rate_period_months
    standard_variable_rate
  }
  assumes_continuing
  eor_document_ids
}
    `;
export const MortgageProductDetailsFragmentDoc = gql`
    fragment MortgageProductDetails on MortgageProduct {
  product_code
  product_name
  lender_code
  lender_reference
  initial_pay_rate
  mortgage_class
  applicant_type_conditions
  full_rate_description
  apr_lenders
  max_ltv_available
  selected_mortgage_club_code
  applicant1_income_multiplier
  applicant2_income_multiplier
  joint_applicant_income_multiplier
  standard_variable_rate
  initial_monthly_payment
  cashback
  cashback_conditions
  valuation_fee
  valuation_fee_conditions
  arrangement_fee
  arrangement_fee_conditions
  booking_fee
  booking_fee_conditions
  higher_lending_charge
  higher_lending_charge_conditions
  free_legal_fees
  free_legal_fee_conditions
  chaps_fee
  fees_payable_on_application
  fees_payable_on_completion
  fees_total
  early_repayment_charge_applies_until
  early_repayment_charge_applies_until_calculated_date
  product_notes
  employed_prob_period
  max_property_valuation
  studio_flat_flag
  proc_fee_code
  proc_fee_fixed
  proc_fee_percentage
  proc_fee_min
  proc_fee_max
  monthly_payment_after_initial_period_plus_1perc
  monthly_payment_after_initial_period_plus_2perc
  monthly_payment_after_initial_period_plus_3perc
  self_build
  shared_ownership
  mortgage_discharge_fee
  deeds_release_fee
  funds_transfer_fee_rule
  capital_rest_period
  help_to_buy_shared_equity
  help_to_buy_mortgage_guarantee
  broker_fee
  broker_fee_conditions
  packager_name
  packager_tel_no
  packager_web_address
  lender_criteria_url
  lender_product_reference
  homebuyers_fee
  homebuyers_fee_conditions
  legal_fee
  legal_fee_conditions
  product_type
  net_proc_fee
  net_proc_fee_fixed
  net_proc_fee_percentage
  net_proc_fee_min
  net_proc_fee_max
  mortgage_discharge_fee_when_to_pay
  product_match_status
  reject_reasons
  max_loan_available
  buy_to_let_rental_income_calculation_rate
  disbursement_fee
  disbursement_fee_conditions
  true_cost_full_term
  initial_monthly_payment_inc_existing_mortgage
  true_cost_full_term_inc_existing_mortgage
  true_cost_initial_period_inc_existing_mortgage
  true_cost_inc_existing_mortgage
  max_overpayment_percent_no_erc
  overpayments_allowed
  underpayments_allowed
  payment_holidays_allowed
  date_last_modified
  optional_partial_repayment
  apply_online
  lender_tel_no
  lender_web_address
  initial_rate_period
  initial_rate_period_months
  repayment_acceptable
  product_availability
  available_to_purchase
  available_to_remortgage
  available_to_ftb
  max_loan
  min_loan
  min_time_in_current_position_months
  min_time_in_continuous_service_months
  min_self_employed_accounts_years
  early_repayment_charge_applies
  early_repayment_charge
  ccj_maximum_number
  ccj_maximum_amount
  arrears_not_in_last_months
  true_cost
  true_cost_over_calculated_period
  true_cost_over_initial_period
  cashback_paid_on
  remort_home_improv_max_ltv
  remort_debt_con_max_ltv
  remort_bus_purpose_max_ltv
  remort_hol_cars_max_ltv
  affordability_calculator
  self_years_avg_income
  flat_over_shop_flag
  flat_over_shop_notes
  flat_over_shop_owner
  flat_over_shop_sep_ent
  flat_over_shop_sep_title
  flat_over_shop_restaurant
  flat_over_shop_retail
  flat_over_shop_fast_food
  flat_over_shop_fast_industry_unit
  flat_max_floors
  flat_max_floors_no_lift
  deeds_release_fee_when_to_pay
  applicant1_minimum_age
  applicant2_minimum_age
  applicant_maximum_age
  freehold_flag
  leasehold_flag
  commonhold_flag
  feudal_flag
  flying_freehold_flag
  flying_freehold_max_percentage
  product_available_date
  product_discontinued_date
  is_offset_product
  is_further_advance
  is_porting
  mortgage_type
  stress_test_payments {
    rate_increment_percent
    initial_monthly_payment
    monthly_payment_after_initial_period
  }
  mortgage_club_proc_fees {
    mortgage_club_code
    mortgage_club_name
    proc_fee_code
    net_proc_fee_percentage
    proc_fee_percentage
  }
  rate_tiers {
    rate
    rate_type
    period_fixed_length_months
    period_fixed_end_date
    rate_tracked
    discount_rate
  }
  exclude_retention
}
    `;
export const OrganisationRmarSettingsFragmentDoc = gql`
    fragment OrganisationRmarSettings on Organisation {
  rmar_settings {
    threshold_conditions {
      id
      close_links {
        notifiable_change_occurred
        fca_notified
      }
      controller {
        notifiable_change_occurred
        fca_notified
      }
      start_date
      end_date
    }
    appointed_representatives_monitoring {
      id
      start_date
      end_date
      subject_to_monitoring
      subject_to_financial_checks
      has_other_monitoring_occurred
    }
  }
}
    `;
export const OrganisationSourcingSettingsFragmentDoc = gql`
    fragment OrganisationSourcingSettings on Organisation {
  sourcing_settings {
    true_cost_add_fees_to_loan_default
    true_cost_add_fees_to_loan_locked
    true_cost_add_permitted_fees_default
    true_cost_add_permitted_fees_locked
    true_cost_add_broker_fees_default
    true_cost_add_broker_fees_locked
    true_cost_add_redemption_fees_default
    true_cost_add_redemption_fees_locked
    true_cost_add_upfront_fees_default
    true_cost_add_upfront_fees_locked
    true_cost_add_erc_default
    true_cost_add_erc_locked
    true_cost_add_hlc_default
    true_cost_add_hlc_locked
    true_cost_exclude_cashback_default
    true_cost_exclude_cashback_locked
    true_cost_exclude_legal_fees_default
    true_cost_exclude_legal_fees_locked
    true_cost_include_racp_default
    true_cost_include_racp_locked
    true_cost_add_broker_fee_to_loan_default
    true_cost_add_broker_fee_to_loan_locked
    require_true_cost_calculation_change_reason
  }
}
    `;
export const ProtectionBenefitsFragmentFragmentDoc = gql`
    fragment ProtectionBenefitsFragment on SolutionProductBenefit {
  product_type_term {
    client_ids
    cover_amount
    cover_amount_depreciation_rate
    cover_amount_life
    cover_amount_cic
    cover_amount_life_or_earlier_cic
    include_low_start
    indexation_percentage
    indexation_type
    payout_type
    premium_frequency
    premium_type
    product_benefit_id
    product_type
    term_years
    term_age
    product_add_ons {
      fracture_cover_client_ids
      waiver_of_premium_client_ids
      include_total_permanent_disability
    }
  }
  product_type_family_income_benefit {
    client_ids
    cover_amount
    cover_amount_depreciation_rate
    cover_amount_life
    cover_amount_cic
    cover_amount_life_or_earlier_cic
    include_low_start
    indexation_percentage
    indexation_type
    payout_type
    premium_frequency
    premium_type
    product_benefit_id
    product_type
    term_years
    term_age
    product_add_ons {
      fracture_cover_client_ids
      waiver_of_premium_client_ids
      include_total_permanent_disability
    }
  }
  product_type_whole_of_life {
    client_ids
    cover_amount
    indexation_percentage
    indexation_type
    premium_type
    product_benefit_id
    product_type
    product_add_ons {
      waiver_of_premium_client_ids
    }
  }
  product_type_income_protection {
    additional_cover_amount
    additional_deferral_period_days
    client_ids
    cover_amount
    deferral_period_days
    include_limited_benefit_payment_period
    indexation_percentage
    indexation_type
    premium_frequency
    premium_type
    product_benefit_id
    product_type
    term_years
    term_age
    age_banded
    limited_payment_plan
    limited_payment_plan_term
  }
  product_type_relevant_life {
    client_ids
    cover_amount
    cover_amount_depreciation_rate
    cover_amount_life
    cover_amount_cic
    cover_amount_life_or_earlier_cic
    include_low_start
    indexation_percentage
    indexation_type
    payout_type
    premium_frequency
    premium_type
    product_benefit_id
    product_type
    term_years
    term_age
    product_add_ons {
      fracture_cover_client_ids
      waiver_of_premium_client_ids
      include_total_permanent_disability
    }
  }
  product_type_executive_ip {
    client_ids
    cover_amount
    cover_amount_type
    deferral_period_days
    indexation_percentage
    indexation_type
    premium_frequency
    premium_type
    product_benefit_id
    product_type
    term_years
    term_age
    employer_funding_options {
      include_employer_ni_contributions
      include_employer_pension_contributions
      employer_pension_contribution_amount
    }
  }
}
    `;
export const UserPermissionsFragmentDoc = gql`
    fragment UserPermissions on User {
  permissions @client {
    gate
    permission_name
    has_permission
    assignee {
      id
    }
    scope {
      id
      type
    }
  }
}
    `;
export const VerificationEntitiesFragmentFragmentDoc = gql`
    fragment VerificationEntitiesFragment on Verification {
  entities {
    id
    type
  }
}
    `;
export const VersionWithChangedFieldsFragmentDoc = gql`
    fragment VersionWithChangedFields on VersionWithChangedFields {
  version
  editor {
    id
    type
  }
  changed_fields
}
    `;
export const PanelManagementFragmentDoc = gql`
    fragment PanelManagement on Organisation {
  panel_management {
    panel
    excluded_lenders
    preferred_clubs
    default_club
    mortgage_advice
    second_charge_advice
    bridging_advice
    commercial_advice
    equity_release_lifetime {
      lifetime_advice
      type
      providers
    }
    protection {
      protection_advice
      refer_specialist
      business_protection_advice
      family_income_advice
      whole_of_life_advice
      type
      providers
      unadvised
    }
    pmi {
      pmi_advice
      type
      providers
    }
    asu {
      asu_advice
      type
      providers
    }
    gi {
      gi_advice
      type
      uinsure_auto_refer
      paymentshield_branch_number
      providers
    }
    fee_configurations {
      club_id
      generations {
        fee_type
        payment_due
      }
      rebate_payment_schedule
      rebate_reference_date
      gross_net_split
      rebate
    }
  }
}
    `;
export const BasicOrganisationDetailsFragmentDoc = gql`
    fragment BasicOrganisationDetails on Organisation {
  id
  organisation_id
  external_id
  name
  organisation_ext_identifier
  complaints_url
  complaints_phone
  complaints_email
  compliance_email
  complaints_address {
    ...FullAddress
  }
  primary_address {
    ...FullAddress
  }
  ...PanelManagement
}
    ${FullAddressFragmentDoc}
${PanelManagementFragmentDoc}`;
export const NoteTemplatesFragmentDoc = gql`
    fragment NoteTemplates on Organisation {
  note_templates {
    id
    title
    body
    disabled
    note_type
    case_types
    default_assignees {
      type
      id
    }
    default_delay_minutes
    default_priority
  }
}
    `;
export const VulnerabilityFragmentDoc = gql`
    fragment vulnerability on VulnerabilityTag {
  id
  actions {
    id
    action
    response
  }
  created_at
  modified_at
  source_id
  type
}
    `;
export const ClientUserBasicInfoFragmentDoc = gql`
    fragment ClientUserBasicInfo on Client {
  id
  first_name
  last_name
}
    `;
export const MortgageProductCpFragmentDoc = gql`
    fragment MortgageProductCp on Mortgage {
  mortgage_productCp {
    id
    product_name
    lender_reference
    lender_name
    rate_tiers {
      rate
      rate_type
      period_fixed_length_months
      period_fixed_end_date
    }
  }
}
    `;
export const MortgageAndProductFragmentDoc = gql`
    fragment MortgageAndProduct on Mortgage {
  id
  version
  mortgage_id
  term
  term_unit
  outstanding_balance
  monthly_payment
  mortgage_start_date
  property_secured_ids
  client_ids
  status
  document_requirements {
    requirement_id
    source
  }
  ...MortgageProductCp @include(if: $includeMortgageProduct)
}
    ${MortgageProductCpFragmentDoc}`;
export const PropertyDetailsCpFragmentDoc = gql`
    fragment PropertyDetailsCp on Property {
  id
  property_id
  acre_property_id
  number_of_bedrooms
  property_valuation
  property_price
  property_type
  wall_type
  roof_type
  current_energy_rating
  attributes {
    property_parking
  }
  is_unencumbered
  is_shared_ownership
  shared_ownership_type
  shared_ownership_share
  help_to_buy_loan_amount
  property_tenure
  property_use
  monthly_rental_income
  monthly_management_expenses
  btl_has_lived
  btl_will_lived
  registered_owners_details
  target_registered_owners_details
  property_location
  mortgagesCp {
    ...MortgageAndProduct
  }
  address {
    address1
    address2
    address3
    posttown
    county
    postcode
    country
  }
}
    ${MortgageAndProductFragmentDoc}`;
export const ClientUserDetailsFragmentDoc = gql`
    fragment ClientUserDetails on Client {
  id
  client_originator
  credit_report_retrievals {
    retrieval_time
    pdf_document_id
  }
  is_natural_person
  organisation_name
  relationships {
    relationship_reference
    relationship_type
    relationship_data_access_permitted
  }
  title
  first_name
  middle_name
  last_name
  previous_names {
    id
    previous_first_name
    previous_surname
    date_of_name_change
    reason_for_name_change
  }
  date_of_birth
  marital_status
  national_insurance_number
  country_of_birth
  nationalities
  gender
  contact_details_email
  contact_details_mobile_phone
  employment_status
  has_will
  has_reviewed_will_in_last_five_years
  retirement_age
  dependants {
    id
    date_of_birth
    relationship
    relationship_other
    name
    title
    dependency_end_date
  }
  vulnerability_assessments {
    id
    complete
    provider
  }
  deposits {
    id
    amount
    type
    deposit_for
    donorsCp {
      id
      details {
        id
        first_name
        last_name
        date_of_birth
        nationalities
        relationships {
          relationship_reference
          relationship_type
          relationship_data_access_permitted
        }
        addresses {
          id
          address {
            ...FullAddress
          }
          is_current_correspondence
        }
      }
    }
  }
  addresses {
    id
    address {
      ...FullAddress
    }
    is_current_correspondence
    residential_status
    move_in_date
    move_out_date
    documents
    document_verifies
  }
  outgoings_maintenance_payments
  outgoings_water
  outgoings_communications
  outgoings_mortgage_rent
  outgoings_insurance
  outgoings_investments
  outgoings_council_tax
  outgoings_food
  outgoings_clothing
  outgoings_other_living_costs
  outgoings_entertainment
  outgoings_holidays
  outgoings_sports
  outgoings_pension
  outgoings_car_costs
  outgoings_other_transport_costs
  outgoings_child_care
  outgoings_fuel
  outgoings_ground_rent_service_charge_shared_equity_rent
  outgoings_television_license
  outgoings_household_repairs
  outgoings_additional_details
  outgoings_material_change_details
  accounts {
    id
    internalHash
    type
    sort_code
    number
    number_of_months_held
  }
  income_and_employment {
    id
    income_likely_to_reduce_in_future_description
    is_retired
    pay_rise_expected
    pay_rise_expected_details
    pay_rise_due_in_num_months
    pay_rise_new_salary
    income_likely_to_reduce_in_future
    standardised_occupation_code
    is_current
    occupation_title
    employment {
      employment_type
      employment_basis
      employment_start_date
      employment_end_date
      no_other_recent_employment
      employer_name
      employer_address {
        address1
        address2
        address3
        posttown
        county
        postcode
        country
      }
      employer_work_phone
      employer_email
      total_guaranteed_annual
      incomes {
        income_amount
        income_type
        income_frequency
        is_guaranteed
      }
    }
    self_employment {
      your_role_in_business_end_date
      has_accountant
      self_employed_basis
      business_start_date
      employed_for_tax_purposes
      net_profits_last_year
      net_profits_two_years_ago
      net_profits_three_years_ago
      taxable_income_last_year
      taxable_income_two_years_ago
      taxable_income_three_years_ago
      percentage_share_last_year
      percentage_share_two_years_ago
      percentage_share_three_years_ago
      salary_income_last_year
      salary_income_two_years_ago
      salary_income_three_years_ago
      dividend_income_last_year
      dividend_income_two_years_ago
      dividend_income_three_years_ago
      shareholding_percentage
      business_name
      accountant_name
      accountant_work_phone
      accountant_email
      no_of_years_accounts_available
      connected_with_business_since_date
      business_address {
        address1
        address2
        address3
        posttown
        county
        postcode
        country
      }
      accountant_address {
        address1
        address2
        address3
        posttown
        county
        postcode
        country
      }
    }
    pension {
      pension_type
      provider_name
      gross_annual_pension_income
    }
  }
  propertiesCp {
    id
    property_id
    details {
      ...PropertyDetailsCp
    }
  }
  opt_out_credit_refresh
}
    ${FullAddressFragmentDoc}
${PropertyDetailsCpFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment Question on ClientVulnerabilityQuestion {
  id
  question
  required
  type
  answer {
    bool_answer
    five_scale_answer
    free_text_answer
    multiple_choice_answer
    question_id
    zero_ten_scale_answer
    single_choice_answer
    question_version
    ten_scale_answer
  }
  answered
  choices
  event_trigger {
    type
    choice_trigger
    gt
    lt
  }
  order
  required
  show_if {
    conditions {
      dependent_question_id
      equals_bool
      greater_than
      equals_choice
      less_than
    }
  }
  topic
  version
  is_numeric
  max
  min
  step
  ticks
  lower_label
  upper_label
}
    `;
export const AddCaseDocument = gql`
    mutation addCase($input: CaseInput!, $fromClientPortal: Boolean, $includeClientNames: Boolean = true, $includeOwners: Boolean = true) {
  addCase(input: $input) {
    id
    created_at
    version_created_at
    details {
      id
      ...CaseTransitionVersions
      status
      owner_user_id
      preference_mortgage_reason
      client_ids
      regulated_by
      ...ClientNames @include(if: $includeClientNames)
      owner @include(if: $includeOwners) {
        id
        first_name
        last_name
      }
      shared_budget
    }
  }
}
    ${CaseTransitionVersionsFragmentDoc}
${ClientNamesFragmentDoc}`;
export type AddCaseMutationFn = Apollo.MutationFunction<AddCaseMutation, AddCaseMutationVariables>;

/**
 * __useAddCaseMutation__
 *
 * To run a mutation, you first call `useAddCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaseMutation, { data, loading, error }] = useAddCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *      fromClientPortal: // value for 'fromClientPortal'
 *      includeClientNames: // value for 'includeClientNames'
 *      includeOwners: // value for 'includeOwners'
 *   },
 * });
 */
export function useAddCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddCaseMutation, AddCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCaseMutation, AddCaseMutationVariables>(AddCaseDocument, options);
      }
export type AddCaseMutationHookResult = ReturnType<typeof useAddCaseMutation>;
export type AddCaseMutationResult = Apollo.MutationResult<AddCaseMutation>;
export type AddCaseMutationOptions = Apollo.BaseMutationOptions<AddCaseMutation, AddCaseMutationVariables>;
export const AddCasePropertyDocument = gql`
    mutation addCaseProperty($input: PropertyInput!, $caseId: ID!, $propertyType: String!, $includeCaseDetailsInProperty: Boolean = true, $includeDirectorsProperties: Boolean = false) {
  addCaseProperty(input: $input, caseId: $caseId, propertyType: $propertyType) {
    id
    details {
      id
      ...CaseTransitionVersions
      change_of_preference_reason
      client_ids
      preference_mortgage_reason
      preference_target_property
      preference_related_property_sale
      new_property {
        ...PropertyDetails
      }
      remortgage_property {
        ...PropertyDetails
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          organisation_name
          is_natural_person
          properties {
            ...PropertyDetails
          }
        }
      }
    }
  }
}
    ${CaseTransitionVersionsFragmentDoc}
${PropertyDetailsFragmentDoc}`;
export type AddCasePropertyMutationFn = Apollo.MutationFunction<AddCasePropertyMutation, AddCasePropertyMutationVariables>;

/**
 * __useAddCasePropertyMutation__
 *
 * To run a mutation, you first call `useAddCasePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCasePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCasePropertyMutation, { data, loading, error }] = useAddCasePropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *      caseId: // value for 'caseId'
 *      propertyType: // value for 'propertyType'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *      includeDirectorsProperties: // value for 'includeDirectorsProperties'
 *   },
 * });
 */
export function useAddCasePropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddCasePropertyMutation, AddCasePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCasePropertyMutation, AddCasePropertyMutationVariables>(AddCasePropertyDocument, options);
      }
export type AddCasePropertyMutationHookResult = ReturnType<typeof useAddCasePropertyMutation>;
export type AddCasePropertyMutationResult = Apollo.MutationResult<AddCasePropertyMutation>;
export type AddCasePropertyMutationOptions = Apollo.BaseMutationOptions<AddCasePropertyMutation, AddCasePropertyMutationVariables>;
export const AddClientDocument = gql`
    mutation addClient($input: ClientInput!) {
  addClient(input: $input) {
    id
    version
    details {
      id
      first_name
      last_name
      title
      date_of_birth
      is_natural_person
      limited_company_registration_number
      non_natural_organisation_type
      non_natural {
        number_of_employees
      }
      organisation_name
      organisation_sic
      smoker_status
      nationalities
      contact_details_email
      contact_details_work_phone
      contact_details_mobile_phone
      addresses {
        id
        internalHash
        address {
          ...FullAddress
        }
        is_current_correspondence
        residential_status
        move_in_date
        move_out_date
      }
    }
  }
}
    ${FullAddressFragmentDoc}`;
export type AddClientMutationFn = Apollo.MutationFunction<AddClientMutation, AddClientMutationVariables>;

/**
 * __useAddClientMutation__
 *
 * To run a mutation, you first call `useAddClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientMutation, { data, loading, error }] = useAddClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddClientMutation(baseOptions?: Apollo.MutationHookOptions<AddClientMutation, AddClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientMutation, AddClientMutationVariables>(AddClientDocument, options);
      }
export type AddClientMutationHookResult = ReturnType<typeof useAddClientMutation>;
export type AddClientMutationResult = Apollo.MutationResult<AddClientMutation>;
export type AddClientMutationOptions = Apollo.BaseMutationOptions<AddClientMutation, AddClientMutationVariables>;
export const AddClientAndUpdateCaseDocument = gql`
    mutation addClientAndUpdateCase($caseId: ID!, $newClientId: ID!) {
  addClientAndUpdateCase(caseId: $caseId, newClientId: $newClientId) {
    id
    version
    details {
      id
      ...ClientDetails
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type AddClientAndUpdateCaseMutationFn = Apollo.MutationFunction<AddClientAndUpdateCaseMutation, AddClientAndUpdateCaseMutationVariables>;

/**
 * __useAddClientAndUpdateCaseMutation__
 *
 * To run a mutation, you first call `useAddClientAndUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientAndUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientAndUpdateCaseMutation, { data, loading, error }] = useAddClientAndUpdateCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      newClientId: // value for 'newClientId'
 *   },
 * });
 */
export function useAddClientAndUpdateCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddClientAndUpdateCaseMutation, AddClientAndUpdateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientAndUpdateCaseMutation, AddClientAndUpdateCaseMutationVariables>(AddClientAndUpdateCaseDocument, options);
      }
export type AddClientAndUpdateCaseMutationHookResult = ReturnType<typeof useAddClientAndUpdateCaseMutation>;
export type AddClientAndUpdateCaseMutationResult = Apollo.MutationResult<AddClientAndUpdateCaseMutation>;
export type AddClientAndUpdateCaseMutationOptions = Apollo.BaseMutationOptions<AddClientAndUpdateCaseMutation, AddClientAndUpdateCaseMutationVariables>;
export const AddCompanyAndUpdateCaseDocument = gql`
    mutation addCompanyAndUpdateCase($caseId: ID!, $organisationId: ID, $input: ClientInput!) {
  addCompanyAndUpdateCase(
    caseId: $caseId
    organisationId: $organisationId
    input: $input
  ) {
    id
    created_at
    version
    version_created_at
    details {
      id
      owner_user_id
      preference_mortgage_reason
      change_of_preference_reason
      status
      regulated_by
      is_debt_consolidation
      has_previously_owned_property
      has_seen_face_to_face
      impersonation_check_performed
      impersonation_check_details
      btl_has_lived
      btl_will_lived
      btl_is_operating_a_business
      btl_through_company
      client_ids
      is_introduced
      introducer_details
      owner {
        id
        organisation {
          id
        }
      }
      clients {
        id
        version
        details {
          id
          ...ClientDetails
        }
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type AddCompanyAndUpdateCaseMutationFn = Apollo.MutationFunction<AddCompanyAndUpdateCaseMutation, AddCompanyAndUpdateCaseMutationVariables>;

/**
 * __useAddCompanyAndUpdateCaseMutation__
 *
 * To run a mutation, you first call `useAddCompanyAndUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyAndUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyAndUpdateCaseMutation, { data, loading, error }] = useAddCompanyAndUpdateCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      organisationId: // value for 'organisationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCompanyAndUpdateCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyAndUpdateCaseMutation, AddCompanyAndUpdateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyAndUpdateCaseMutation, AddCompanyAndUpdateCaseMutationVariables>(AddCompanyAndUpdateCaseDocument, options);
      }
export type AddCompanyAndUpdateCaseMutationHookResult = ReturnType<typeof useAddCompanyAndUpdateCaseMutation>;
export type AddCompanyAndUpdateCaseMutationResult = Apollo.MutationResult<AddCompanyAndUpdateCaseMutation>;
export type AddCompanyAndUpdateCaseMutationOptions = Apollo.BaseMutationOptions<AddCompanyAndUpdateCaseMutation, AddCompanyAndUpdateCaseMutationVariables>;
export const AddExistingPropertyToCaseDocument = gql`
    mutation addExistingPropertyToCase($propertyId: ID!, $caseId: ID!, $propertyType: String!, $includeCaseDetailsInProperty: Boolean = true) {
  addExistingPropertyToCase(
    propertyId: $propertyId
    caseId: $caseId
    propertyType: $propertyType
  ) {
    id
    details {
      id
      ...CaseTransitionVersions
      change_of_preference_reason
      client_ids
      preference_mortgage_reason
      preference_target_property
      preference_related_property_sale
      new_property {
        ...PropertyDetails
      }
      remortgage_property {
        ...PropertyDetails
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          organisation_name
          is_natural_person
          properties {
            ...PropertyDetails
          }
        }
      }
    }
  }
}
    ${CaseTransitionVersionsFragmentDoc}
${PropertyDetailsFragmentDoc}`;
export type AddExistingPropertyToCaseMutationFn = Apollo.MutationFunction<AddExistingPropertyToCaseMutation, AddExistingPropertyToCaseMutationVariables>;

/**
 * __useAddExistingPropertyToCaseMutation__
 *
 * To run a mutation, you first call `useAddExistingPropertyToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddExistingPropertyToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addExistingPropertyToCaseMutation, { data, loading, error }] = useAddExistingPropertyToCaseMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      caseId: // value for 'caseId'
 *      propertyType: // value for 'propertyType'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useAddExistingPropertyToCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddExistingPropertyToCaseMutation, AddExistingPropertyToCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddExistingPropertyToCaseMutation, AddExistingPropertyToCaseMutationVariables>(AddExistingPropertyToCaseDocument, options);
      }
export type AddExistingPropertyToCaseMutationHookResult = ReturnType<typeof useAddExistingPropertyToCaseMutation>;
export type AddExistingPropertyToCaseMutationResult = Apollo.MutationResult<AddExistingPropertyToCaseMutation>;
export type AddExistingPropertyToCaseMutationOptions = Apollo.BaseMutationOptions<AddExistingPropertyToCaseMutation, AddExistingPropertyToCaseMutationVariables>;
export const AddGeneralInsuranceProductCaseDocument = gql`
    mutation addGeneralInsuranceProductCase($input: AddGeneralInsuranceProductCaseRequestInput!) {
  addGeneralInsuranceProductCase(input: $input) {
    case_id
    general_insurance_product_id
  }
}
    `;
export type AddGeneralInsuranceProductCaseMutationFn = Apollo.MutationFunction<AddGeneralInsuranceProductCaseMutation, AddGeneralInsuranceProductCaseMutationVariables>;

/**
 * __useAddGeneralInsuranceProductCaseMutation__
 *
 * To run a mutation, you first call `useAddGeneralInsuranceProductCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGeneralInsuranceProductCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGeneralInsuranceProductCaseMutation, { data, loading, error }] = useAddGeneralInsuranceProductCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddGeneralInsuranceProductCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddGeneralInsuranceProductCaseMutation, AddGeneralInsuranceProductCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddGeneralInsuranceProductCaseMutation, AddGeneralInsuranceProductCaseMutationVariables>(AddGeneralInsuranceProductCaseDocument, options);
      }
export type AddGeneralInsuranceProductCaseMutationHookResult = ReturnType<typeof useAddGeneralInsuranceProductCaseMutation>;
export type AddGeneralInsuranceProductCaseMutationResult = Apollo.MutationResult<AddGeneralInsuranceProductCaseMutation>;
export type AddGeneralInsuranceProductCaseMutationOptions = Apollo.BaseMutationOptions<AddGeneralInsuranceProductCaseMutation, AddGeneralInsuranceProductCaseMutationVariables>;
export const AddManualFlagToCaseDocument = gql`
    mutation addManualFlagToCase($input: AddManualFlagToCaseInput!) {
  addManualFlagToCase(input: $input) {
    case_id
    flag_type
  }
}
    `;
export type AddManualFlagToCaseMutationFn = Apollo.MutationFunction<AddManualFlagToCaseMutation, AddManualFlagToCaseMutationVariables>;

/**
 * __useAddManualFlagToCaseMutation__
 *
 * To run a mutation, you first call `useAddManualFlagToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddManualFlagToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addManualFlagToCaseMutation, { data, loading, error }] = useAddManualFlagToCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddManualFlagToCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddManualFlagToCaseMutation, AddManualFlagToCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddManualFlagToCaseMutation, AddManualFlagToCaseMutationVariables>(AddManualFlagToCaseDocument, options);
      }
export type AddManualFlagToCaseMutationHookResult = ReturnType<typeof useAddManualFlagToCaseMutation>;
export type AddManualFlagToCaseMutationResult = Apollo.MutationResult<AddManualFlagToCaseMutation>;
export type AddManualFlagToCaseMutationOptions = Apollo.BaseMutationOptions<AddManualFlagToCaseMutation, AddManualFlagToCaseMutationVariables>;
export const AddMessageDocument = gql`
    mutation addMessage($input: NoteInput!, $isIntroducerCase: Boolean, $useClientApi: Boolean) {
  addMessage(
    input: $input
    isIntroducerCase: $isIntroducerCase
    useClientApi: $useClientApi
  ) {
    note_id
    created_at
    modified_at
    title
    priority
    status
    body
    primary_type
    deadline
    assignee_id
    case_id
    client_id
    organisation_ids
    created_by
    template_id
  }
}
    `;
export type AddMessageMutationFn = Apollo.MutationFunction<AddMessageMutation, AddMessageMutationVariables>;

/**
 * __useAddMessageMutation__
 *
 * To run a mutation, you first call `useAddMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMessageMutation, { data, loading, error }] = useAddMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isIntroducerCase: // value for 'isIntroducerCase'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useAddMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddMessageMutation, AddMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMessageMutation, AddMessageMutationVariables>(AddMessageDocument, options);
      }
export type AddMessageMutationHookResult = ReturnType<typeof useAddMessageMutation>;
export type AddMessageMutationResult = Apollo.MutationResult<AddMessageMutation>;
export type AddMessageMutationOptions = Apollo.BaseMutationOptions<AddMessageMutation, AddMessageMutationVariables>;
export const AddMortgageToCaseDocument = gql`
    mutation addMortgageToCase($id: ID!, $mortgageId: ID!) {
  addMortgageToCase(id: $id, mortgageId: $mortgageId) {
    case_id
    mortgage_id
  }
}
    `;
export type AddMortgageToCaseMutationFn = Apollo.MutationFunction<AddMortgageToCaseMutation, AddMortgageToCaseMutationVariables>;

/**
 * __useAddMortgageToCaseMutation__
 *
 * To run a mutation, you first call `useAddMortgageToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMortgageToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMortgageToCaseMutation, { data, loading, error }] = useAddMortgageToCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mortgageId: // value for 'mortgageId'
 *   },
 * });
 */
export function useAddMortgageToCaseMutation(baseOptions?: Apollo.MutationHookOptions<AddMortgageToCaseMutation, AddMortgageToCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMortgageToCaseMutation, AddMortgageToCaseMutationVariables>(AddMortgageToCaseDocument, options);
      }
export type AddMortgageToCaseMutationHookResult = ReturnType<typeof useAddMortgageToCaseMutation>;
export type AddMortgageToCaseMutationResult = Apollo.MutationResult<AddMortgageToCaseMutation>;
export type AddMortgageToCaseMutationOptions = Apollo.BaseMutationOptions<AddMortgageToCaseMutation, AddMortgageToCaseMutationVariables>;
export const AddMortgageToProductDocument = gql`
    mutation addMortgageToProduct($input: MortgageAndProductInput!) {
  addMortgageToProduct(input: $input) {
    mortgage_id
    product_id
  }
}
    `;
export type AddMortgageToProductMutationFn = Apollo.MutationFunction<AddMortgageToProductMutation, AddMortgageToProductMutationVariables>;

/**
 * __useAddMortgageToProductMutation__
 *
 * To run a mutation, you first call `useAddMortgageToProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMortgageToProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMortgageToProductMutation, { data, loading, error }] = useAddMortgageToProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMortgageToProductMutation(baseOptions?: Apollo.MutationHookOptions<AddMortgageToProductMutation, AddMortgageToProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMortgageToProductMutation, AddMortgageToProductMutationVariables>(AddMortgageToProductDocument, options);
      }
export type AddMortgageToProductMutationHookResult = ReturnType<typeof useAddMortgageToProductMutation>;
export type AddMortgageToProductMutationResult = Apollo.MutationResult<AddMortgageToProductMutation>;
export type AddMortgageToProductMutationOptions = Apollo.BaseMutationOptions<AddMortgageToProductMutation, AddMortgageToProductMutationVariables>;
export const AddNoteDocument = gql`
    mutation addNote($input: NoteInput!, $isIntroducerCase: Boolean, $useClientApi: Boolean) {
  addNote(
    input: $input
    isIntroducerCase: $isIntroducerCase
    useClientApi: $useClientApi
  ) {
    note_id
    created_at
    modified_at
    title
    priority
    status
    body
    primary_type
    deadline
    assignee_id
    case_id
    client_id
    property_id
    mortgage_id
    verification_id
    organisation_ids
    created_by
    template_id
  }
}
    `;
export type AddNoteMutationFn = Apollo.MutationFunction<AddNoteMutation, AddNoteMutationVariables>;

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isIntroducerCase: // value for 'isIntroducerCase'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteMutation, AddNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteMutation, AddNoteMutationVariables>(AddNoteDocument, options);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult = Apollo.MutationResult<AddNoteMutation>;
export type AddNoteMutationOptions = Apollo.BaseMutationOptions<AddNoteMutation, AddNoteMutationVariables>;
export const AddOrganisationFeesDocument = gql`
    mutation addOrganisationFees($id: ID!, $input: [FeeOptionInput!]!) {
  addOrganisationFees(id: $id, input: $input) {
    id
    standard_fee_options {
      fee_option_title
      fees {
        fee_type
        value
      }
      default
    }
  }
}
    `;
export type AddOrganisationFeesMutationFn = Apollo.MutationFunction<AddOrganisationFeesMutation, AddOrganisationFeesMutationVariables>;

/**
 * __useAddOrganisationFeesMutation__
 *
 * To run a mutation, you first call `useAddOrganisationFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrganisationFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrganisationFeesMutation, { data, loading, error }] = useAddOrganisationFeesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrganisationFeesMutation(baseOptions?: Apollo.MutationHookOptions<AddOrganisationFeesMutation, AddOrganisationFeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOrganisationFeesMutation, AddOrganisationFeesMutationVariables>(AddOrganisationFeesDocument, options);
      }
export type AddOrganisationFeesMutationHookResult = ReturnType<typeof useAddOrganisationFeesMutation>;
export type AddOrganisationFeesMutationResult = Apollo.MutationResult<AddOrganisationFeesMutation>;
export type AddOrganisationFeesMutationOptions = Apollo.BaseMutationOptions<AddOrganisationFeesMutation, AddOrganisationFeesMutationVariables>;
export const AddPropertyDocument = gql`
    mutation addProperty($input: PropertyInput!, $caseId: ID, $reasons: [String!], $propertyType: String, $includeCaseDetailsInProperty: Boolean = false) {
  addProperty(
    input: $input
    caseId: $caseId
    reasons: $reasons
    propertyType: $propertyType
  ) {
    ...PropertyDetails
  }
}
    ${PropertyDetailsFragmentDoc}`;
export type AddPropertyMutationFn = Apollo.MutationFunction<AddPropertyMutation, AddPropertyMutationVariables>;

/**
 * __useAddPropertyMutation__
 *
 * To run a mutation, you first call `useAddPropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertyMutation, { data, loading, error }] = useAddPropertyMutation({
 *   variables: {
 *      input: // value for 'input'
 *      caseId: // value for 'caseId'
 *      reasons: // value for 'reasons'
 *      propertyType: // value for 'propertyType'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useAddPropertyMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertyMutation, AddPropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertyMutation, AddPropertyMutationVariables>(AddPropertyDocument, options);
      }
export type AddPropertyMutationHookResult = ReturnType<typeof useAddPropertyMutation>;
export type AddPropertyMutationResult = Apollo.MutationResult<AddPropertyMutation>;
export type AddPropertyMutationOptions = Apollo.BaseMutationOptions<AddPropertyMutation, AddPropertyMutationVariables>;
export const BulkCreateRemoLeadsDocument = gql`
    mutation bulkCreateRemoLeads($input: BulkCreateRemoLeadsInput!) {
  bulkCreateRemoLeads(input: $input) {
    linked_lead_cases {
      complete_case_id
      lead_case_id
    }
  }
}
    `;
export type BulkCreateRemoLeadsMutationFn = Apollo.MutationFunction<BulkCreateRemoLeadsMutation, BulkCreateRemoLeadsMutationVariables>;

/**
 * __useBulkCreateRemoLeadsMutation__
 *
 * To run a mutation, you first call `useBulkCreateRemoLeadsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateRemoLeadsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateRemoLeadsMutation, { data, loading, error }] = useBulkCreateRemoLeadsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateRemoLeadsMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateRemoLeadsMutation, BulkCreateRemoLeadsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateRemoLeadsMutation, BulkCreateRemoLeadsMutationVariables>(BulkCreateRemoLeadsDocument, options);
      }
export type BulkCreateRemoLeadsMutationHookResult = ReturnType<typeof useBulkCreateRemoLeadsMutation>;
export type BulkCreateRemoLeadsMutationResult = Apollo.MutationResult<BulkCreateRemoLeadsMutation>;
export type BulkCreateRemoLeadsMutationOptions = Apollo.BaseMutationOptions<BulkCreateRemoLeadsMutation, BulkCreateRemoLeadsMutationVariables>;
export const ChangeRelationshipTypeDocument = gql`
    mutation changeRelationshipType($relatedClientId: ID!, $relationshipType: ClientRelationship!, $clientId: ID!, $caseId: ID) {
  changeRelationshipType(
    relatedClientId: $relatedClientId
    relationshipType: $relationshipType
    clientId: $clientId
    caseId: $caseId
  )
}
    `;
export type ChangeRelationshipTypeMutationFn = Apollo.MutationFunction<ChangeRelationshipTypeMutation, ChangeRelationshipTypeMutationVariables>;

/**
 * __useChangeRelationshipTypeMutation__
 *
 * To run a mutation, you first call `useChangeRelationshipTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeRelationshipTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeRelationshipTypeMutation, { data, loading, error }] = useChangeRelationshipTypeMutation({
 *   variables: {
 *      relatedClientId: // value for 'relatedClientId'
 *      relationshipType: // value for 'relationshipType'
 *      clientId: // value for 'clientId'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useChangeRelationshipTypeMutation(baseOptions?: Apollo.MutationHookOptions<ChangeRelationshipTypeMutation, ChangeRelationshipTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeRelationshipTypeMutation, ChangeRelationshipTypeMutationVariables>(ChangeRelationshipTypeDocument, options);
      }
export type ChangeRelationshipTypeMutationHookResult = ReturnType<typeof useChangeRelationshipTypeMutation>;
export type ChangeRelationshipTypeMutationResult = Apollo.MutationResult<ChangeRelationshipTypeMutation>;
export type ChangeRelationshipTypeMutationOptions = Apollo.BaseMutationOptions<ChangeRelationshipTypeMutation, ChangeRelationshipTypeMutationVariables>;
export const ChangeUserEmailDocument = gql`
    mutation changeUserEmail($userId: ID!, $newEmail: String!) {
  changeUserEmail(userId: $userId, newEmail: $newEmail) {
    id
    organisation_id
    first_name
    last_name
    primary_role_id
    role_name
    status
    email_address
    phone_number
    group_ids
  }
}
    `;
export type ChangeUserEmailMutationFn = Apollo.MutationFunction<ChangeUserEmailMutation, ChangeUserEmailMutationVariables>;

/**
 * __useChangeUserEmailMutation__
 *
 * To run a mutation, you first call `useChangeUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserEmailMutation, { data, loading, error }] = useChangeUserEmailMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      newEmail: // value for 'newEmail'
 *   },
 * });
 */
export function useChangeUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserEmailMutation, ChangeUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserEmailMutation, ChangeUserEmailMutationVariables>(ChangeUserEmailDocument, options);
      }
export type ChangeUserEmailMutationHookResult = ReturnType<typeof useChangeUserEmailMutation>;
export type ChangeUserEmailMutationResult = Apollo.MutationResult<ChangeUserEmailMutation>;
export type ChangeUserEmailMutationOptions = Apollo.BaseMutationOptions<ChangeUserEmailMutation, ChangeUserEmailMutationVariables>;
export const CheckMistralDocumentsDocument = gql`
    mutation checkMistralDocuments($input: MistralInput!) {
  checkMistralDocuments(input: $input) {
    document_identifier
    result {
      clients {
        first_name
        last_name
        middle_name
      }
      document {
        confidence_score
        explanation
        type
      }
      suggested_document_name
    }
  }
}
    `;
export type CheckMistralDocumentsMutationFn = Apollo.MutationFunction<CheckMistralDocumentsMutation, CheckMistralDocumentsMutationVariables>;

/**
 * __useCheckMistralDocumentsMutation__
 *
 * To run a mutation, you first call `useCheckMistralDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckMistralDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkMistralDocumentsMutation, { data, loading, error }] = useCheckMistralDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckMistralDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<CheckMistralDocumentsMutation, CheckMistralDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckMistralDocumentsMutation, CheckMistralDocumentsMutationVariables>(CheckMistralDocumentsDocument, options);
      }
export type CheckMistralDocumentsMutationHookResult = ReturnType<typeof useCheckMistralDocumentsMutation>;
export type CheckMistralDocumentsMutationResult = Apollo.MutationResult<CheckMistralDocumentsMutation>;
export type CheckMistralDocumentsMutationOptions = Apollo.BaseMutationOptions<CheckMistralDocumentsMutation, CheckMistralDocumentsMutationVariables>;
export const CreateCalendarEventDocument = gql`
    mutation createCalendarEvent($input: CalendarEventInput!) {
  createCalendarEvent(input: $input) {
    note_id
    created_at
    modified_at
    title
    priority
    status
    body
    primary_type
    deadline
    assignee_id
    case_id
    client_id
    organisation_ids
    created_by
    template_id
  }
}
    `;
export type CreateCalendarEventMutationFn = Apollo.MutationFunction<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;

/**
 * __useCreateCalendarEventMutation__
 *
 * To run a mutation, you first call `useCreateCalendarEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCalendarEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCalendarEventMutation, { data, loading, error }] = useCreateCalendarEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCalendarEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>(CreateCalendarEventDocument, options);
      }
export type CreateCalendarEventMutationHookResult = ReturnType<typeof useCreateCalendarEventMutation>;
export type CreateCalendarEventMutationResult = Apollo.MutationResult<CreateCalendarEventMutation>;
export type CreateCalendarEventMutationOptions = Apollo.BaseMutationOptions<CreateCalendarEventMutation, CreateCalendarEventMutationVariables>;
export const CreateCaseFlagReviewDocument = gql`
    mutation createCaseFlagReview($input: CaseFlagReviewInput!) {
  createCaseFlagReview(input: $input) {
    id
    created_at
    version_created_at
    version
    details {
      id
      status
      flags {
        flag_id
        flag_type
        created_at
        reviews {
          review_passed
          created_at
          reviewer_user_id
          reviewer_private_notes
          reviewer_notes
          review_grade
          reviewed_case_version
          skip_future_reviews
        }
      }
    }
  }
}
    `;
export type CreateCaseFlagReviewMutationFn = Apollo.MutationFunction<CreateCaseFlagReviewMutation, CreateCaseFlagReviewMutationVariables>;

/**
 * __useCreateCaseFlagReviewMutation__
 *
 * To run a mutation, you first call `useCreateCaseFlagReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaseFlagReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaseFlagReviewMutation, { data, loading, error }] = useCreateCaseFlagReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaseFlagReviewMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaseFlagReviewMutation, CreateCaseFlagReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaseFlagReviewMutation, CreateCaseFlagReviewMutationVariables>(CreateCaseFlagReviewDocument, options);
      }
export type CreateCaseFlagReviewMutationHookResult = ReturnType<typeof useCreateCaseFlagReviewMutation>;
export type CreateCaseFlagReviewMutationResult = Apollo.MutationResult<CreateCaseFlagReviewMutation>;
export type CreateCaseFlagReviewMutationOptions = Apollo.BaseMutationOptions<CreateCaseFlagReviewMutation, CreateCaseFlagReviewMutationVariables>;
export const CreateClientOrganisationRelationshipDocument = gql`
    mutation createClientOrganisationRelationship($client_id: String!, $organisation_id_or_ext: String!, $input: ClientOrganisationRelationshipInput!) {
  createClientOrganisationRelationship(
    client_id: $client_id
    organisation_id_or_ext: $organisation_id_or_ext
    input: $input
  ) {
    org_id
    client_id
    relationship_type
  }
}
    `;
export type CreateClientOrganisationRelationshipMutationFn = Apollo.MutationFunction<CreateClientOrganisationRelationshipMutation, CreateClientOrganisationRelationshipMutationVariables>;

/**
 * __useCreateClientOrganisationRelationshipMutation__
 *
 * To run a mutation, you first call `useCreateClientOrganisationRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientOrganisationRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientOrganisationRelationshipMutation, { data, loading, error }] = useCreateClientOrganisationRelationshipMutation({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      organisation_id_or_ext: // value for 'organisation_id_or_ext'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientOrganisationRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientOrganisationRelationshipMutation, CreateClientOrganisationRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientOrganisationRelationshipMutation, CreateClientOrganisationRelationshipMutationVariables>(CreateClientOrganisationRelationshipDocument, options);
      }
export type CreateClientOrganisationRelationshipMutationHookResult = ReturnType<typeof useCreateClientOrganisationRelationshipMutation>;
export type CreateClientOrganisationRelationshipMutationResult = Apollo.MutationResult<CreateClientOrganisationRelationshipMutation>;
export type CreateClientOrganisationRelationshipMutationOptions = Apollo.BaseMutationOptions<CreateClientOrganisationRelationshipMutation, CreateClientOrganisationRelationshipMutationVariables>;
export const CreateCommissionStructureDocument = gql`
    mutation createCommissionStructure($input: CommissionStructureInput!) {
  createCommissionStructure(input: $input) {
    ...CommissionStructureDetails
  }
}
    ${CommissionStructureDetailsFragmentDoc}`;
export type CreateCommissionStructureMutationFn = Apollo.MutationFunction<CreateCommissionStructureMutation, CreateCommissionStructureMutationVariables>;

/**
 * __useCreateCommissionStructureMutation__
 *
 * To run a mutation, you first call `useCreateCommissionStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommissionStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommissionStructureMutation, { data, loading, error }] = useCreateCommissionStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommissionStructureMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommissionStructureMutation, CreateCommissionStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommissionStructureMutation, CreateCommissionStructureMutationVariables>(CreateCommissionStructureDocument, options);
      }
export type CreateCommissionStructureMutationHookResult = ReturnType<typeof useCreateCommissionStructureMutation>;
export type CreateCommissionStructureMutationResult = Apollo.MutationResult<CreateCommissionStructureMutation>;
export type CreateCommissionStructureMutationOptions = Apollo.BaseMutationOptions<CreateCommissionStructureMutation, CreateCommissionStructureMutationVariables>;
export const CreateGeneralInsuranceProductDocument = gql`
    mutation createGeneralInsuranceProduct($input: CreateGeneralInsuranceProductRequestInput!) {
  createGeneralInsuranceProduct(input: $input) {
    general_insurance_product {
      general_insurance_product_id
      client_ids
      case_ids
      property_ids
      details {
        quote_reference
        status
        premium_amount
        premium_frequency
        provider_id
        buildings_cover_level
        contents_cover_level
        type
        provider
        policy_number
        underwriter
        annual_premium
        commission
        excess
        buildings_excess_if_different
        start_date
        end_date
        specified_rebuild_cost
        rental_cover
        includes_accidental_damage
        accidental_damage_premium
        includes_home_emergency_cover
        home_emergency_premium
        includes_legal_cover
        legal_cover_premium
        includes_personal_possessions_cover
        personal_possessions_sum_assured
        personal_possessions_premium
        years_no_claims
        buildings_years_no_claims_if_different
        specified_items {
          type
          description
          value
          include_at_home
          include_away_from_home
        }
      }
    }
  }
}
    `;
export type CreateGeneralInsuranceProductMutationFn = Apollo.MutationFunction<CreateGeneralInsuranceProductMutation, CreateGeneralInsuranceProductMutationVariables>;

/**
 * __useCreateGeneralInsuranceProductMutation__
 *
 * To run a mutation, you first call `useCreateGeneralInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeneralInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeneralInsuranceProductMutation, { data, loading, error }] = useCreateGeneralInsuranceProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGeneralInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateGeneralInsuranceProductMutation, CreateGeneralInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGeneralInsuranceProductMutation, CreateGeneralInsuranceProductMutationVariables>(CreateGeneralInsuranceProductDocument, options);
      }
export type CreateGeneralInsuranceProductMutationHookResult = ReturnType<typeof useCreateGeneralInsuranceProductMutation>;
export type CreateGeneralInsuranceProductMutationResult = Apollo.MutationResult<CreateGeneralInsuranceProductMutation>;
export type CreateGeneralInsuranceProductMutationOptions = Apollo.BaseMutationOptions<CreateGeneralInsuranceProductMutation, CreateGeneralInsuranceProductMutationVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($organisation_id: String, $input: CreateGroupInput) {
  createGroup(organisation_id: $organisation_id, input: $input) {
    group_id
    group_name
    organisation_id
    disabled
    accept_reminders
    users {
      id
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      organisation_id: // value for 'organisation_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const CreateLedgerPaymentDocument = gql`
    mutation createLedgerPayment($input: CreateLedgerInput!) {
  createLedgerPayment(input: $input) {
    id
    amountDue
    dueDate
    grossFee
    isOverdue
    type
    paymentDirection
    isTier
    sourceId {
      id
      sourceType
      hydrationType
    }
    status
  }
}
    `;
export type CreateLedgerPaymentMutationFn = Apollo.MutationFunction<CreateLedgerPaymentMutation, CreateLedgerPaymentMutationVariables>;

/**
 * __useCreateLedgerPaymentMutation__
 *
 * To run a mutation, you first call `useCreateLedgerPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLedgerPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLedgerPaymentMutation, { data, loading, error }] = useCreateLedgerPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLedgerPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateLedgerPaymentMutation, CreateLedgerPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLedgerPaymentMutation, CreateLedgerPaymentMutationVariables>(CreateLedgerPaymentDocument, options);
      }
export type CreateLedgerPaymentMutationHookResult = ReturnType<typeof useCreateLedgerPaymentMutation>;
export type CreateLedgerPaymentMutationResult = Apollo.MutationResult<CreateLedgerPaymentMutation>;
export type CreateLedgerPaymentMutationOptions = Apollo.BaseMutationOptions<CreateLedgerPaymentMutation, CreateLedgerPaymentMutationVariables>;
export const CreateMortgageDocument = gql`
    mutation createMortgage($caseId: ID, $mortgageInput: MortgageInput!, $mortgageProductInput: MortgageProductActualInput!) {
  createMortgage(
    caseId: $caseId
    mortgageInput: $mortgageInput
    mortgageProductInput: $mortgageProductInput
  ) {
    ...CaseMortgagesAndMortgageProducts
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}`;
export type CreateMortgageMutationFn = Apollo.MutationFunction<CreateMortgageMutation, CreateMortgageMutationVariables>;

/**
 * __useCreateMortgageMutation__
 *
 * To run a mutation, you first call `useCreateMortgageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgageMutation, { data, loading, error }] = useCreateMortgageMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      mortgageInput: // value for 'mortgageInput'
 *      mortgageProductInput: // value for 'mortgageProductInput'
 *   },
 * });
 */
export function useCreateMortgageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgageMutation, CreateMortgageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgageMutation, CreateMortgageMutationVariables>(CreateMortgageDocument, options);
      }
export type CreateMortgageMutationHookResult = ReturnType<typeof useCreateMortgageMutation>;
export type CreateMortgageMutationResult = Apollo.MutationResult<CreateMortgageMutation>;
export type CreateMortgageMutationOptions = Apollo.BaseMutationOptions<CreateMortgageMutation, CreateMortgageMutationVariables>;
export const CreateMortgageWithProductAndLinkToCaseDocument = gql`
    mutation createMortgageWithProductAndLinkToCase($input: CreateMortgageWithProductInput!) {
  createMortgageWithProductAndLinkToCase(input: $input) {
    case_id
    mortgage {
      ...CaseMortgagesAndMortgageProducts
    }
    product_details {
      ...CaseMortgageProduct
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}
${CaseMortgageProductFragmentDoc}`;
export type CreateMortgageWithProductAndLinkToCaseMutationFn = Apollo.MutationFunction<CreateMortgageWithProductAndLinkToCaseMutation, CreateMortgageWithProductAndLinkToCaseMutationVariables>;

/**
 * __useCreateMortgageWithProductAndLinkToCaseMutation__
 *
 * To run a mutation, you first call `useCreateMortgageWithProductAndLinkToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMortgageWithProductAndLinkToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMortgageWithProductAndLinkToCaseMutation, { data, loading, error }] = useCreateMortgageWithProductAndLinkToCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMortgageWithProductAndLinkToCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateMortgageWithProductAndLinkToCaseMutation, CreateMortgageWithProductAndLinkToCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMortgageWithProductAndLinkToCaseMutation, CreateMortgageWithProductAndLinkToCaseMutationVariables>(CreateMortgageWithProductAndLinkToCaseDocument, options);
      }
export type CreateMortgageWithProductAndLinkToCaseMutationHookResult = ReturnType<typeof useCreateMortgageWithProductAndLinkToCaseMutation>;
export type CreateMortgageWithProductAndLinkToCaseMutationResult = Apollo.MutationResult<CreateMortgageWithProductAndLinkToCaseMutation>;
export type CreateMortgageWithProductAndLinkToCaseMutationOptions = Apollo.BaseMutationOptions<CreateMortgageWithProductAndLinkToCaseMutation, CreateMortgageWithProductAndLinkToCaseMutationVariables>;
export const CreateOrganisationDocument = gql`
    mutation createOrganisation($input: OrganisationInput!) {
  createOrganisation(input: $input) {
    id
    name
  }
}
    `;
export type CreateOrganisationMutationFn = Apollo.MutationFunction<CreateOrganisationMutation, CreateOrganisationMutationVariables>;

/**
 * __useCreateOrganisationMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationMutation, { data, loading, error }] = useCreateOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationMutation, CreateOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationMutation, CreateOrganisationMutationVariables>(CreateOrganisationDocument, options);
      }
export type CreateOrganisationMutationHookResult = ReturnType<typeof useCreateOrganisationMutation>;
export type CreateOrganisationMutationResult = Apollo.MutationResult<CreateOrganisationMutation>;
export type CreateOrganisationMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationMutation, CreateOrganisationMutationVariables>;
export const CreateOrganisationTemplateDocument = gql`
    mutation createOrganisationTemplate($input: OrganisationTemplateInput!) {
  createOrganisationTemplate(input: $input) {
    id
    template_signature
  }
}
    `;
export type CreateOrganisationTemplateMutationFn = Apollo.MutationFunction<CreateOrganisationTemplateMutation, CreateOrganisationTemplateMutationVariables>;

/**
 * __useCreateOrganisationTemplateMutation__
 *
 * To run a mutation, you first call `useCreateOrganisationTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganisationTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganisationTemplateMutation, { data, loading, error }] = useCreateOrganisationTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganisationTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrganisationTemplateMutation, CreateOrganisationTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrganisationTemplateMutation, CreateOrganisationTemplateMutationVariables>(CreateOrganisationTemplateDocument, options);
      }
export type CreateOrganisationTemplateMutationHookResult = ReturnType<typeof useCreateOrganisationTemplateMutation>;
export type CreateOrganisationTemplateMutationResult = Apollo.MutationResult<CreateOrganisationTemplateMutation>;
export type CreateOrganisationTemplateMutationOptions = Apollo.BaseMutationOptions<CreateOrganisationTemplateMutation, CreateOrganisationTemplateMutationVariables>;
export const CreatePermissionAssignmentDocument = gql`
    mutation createPermissionAssignment($input: PermissionAssignmentInput!) {
  createPermissionAssignment(input: $input) {
    permission_assignments {
      permission_assignment_id
      permission_id
      user_id
      user_scope_id
      group_id
      case_id
      organisation_id
      disabled
    }
  }
}
    `;
export type CreatePermissionAssignmentMutationFn = Apollo.MutationFunction<CreatePermissionAssignmentMutation, CreatePermissionAssignmentMutationVariables>;

/**
 * __useCreatePermissionAssignmentMutation__
 *
 * To run a mutation, you first call `useCreatePermissionAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionAssignmentMutation, { data, loading, error }] = useCreatePermissionAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePermissionAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionAssignmentMutation, CreatePermissionAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionAssignmentMutation, CreatePermissionAssignmentMutationVariables>(CreatePermissionAssignmentDocument, options);
      }
export type CreatePermissionAssignmentMutationHookResult = ReturnType<typeof useCreatePermissionAssignmentMutation>;
export type CreatePermissionAssignmentMutationResult = Apollo.MutationResult<CreatePermissionAssignmentMutation>;
export type CreatePermissionAssignmentMutationOptions = Apollo.BaseMutationOptions<CreatePermissionAssignmentMutation, CreatePermissionAssignmentMutationVariables>;
export const CreatePermissionAssignmentBulkDocument = gql`
    mutation createPermissionAssignmentBulk($input: PermissionAssignmentBulkInput) {
  createPermissionAssignmentBulk(input: $input) {
    permission_assignments {
      permission_assignment_id
      permission_id
      user_id
      user_scope_id
      group_id
      disabled
    }
  }
}
    `;
export type CreatePermissionAssignmentBulkMutationFn = Apollo.MutationFunction<CreatePermissionAssignmentBulkMutation, CreatePermissionAssignmentBulkMutationVariables>;

/**
 * __useCreatePermissionAssignmentBulkMutation__
 *
 * To run a mutation, you first call `useCreatePermissionAssignmentBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePermissionAssignmentBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPermissionAssignmentBulkMutation, { data, loading, error }] = useCreatePermissionAssignmentBulkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePermissionAssignmentBulkMutation(baseOptions?: Apollo.MutationHookOptions<CreatePermissionAssignmentBulkMutation, CreatePermissionAssignmentBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePermissionAssignmentBulkMutation, CreatePermissionAssignmentBulkMutationVariables>(CreatePermissionAssignmentBulkDocument, options);
      }
export type CreatePermissionAssignmentBulkMutationHookResult = ReturnType<typeof useCreatePermissionAssignmentBulkMutation>;
export type CreatePermissionAssignmentBulkMutationResult = Apollo.MutationResult<CreatePermissionAssignmentBulkMutation>;
export type CreatePermissionAssignmentBulkMutationOptions = Apollo.BaseMutationOptions<CreatePermissionAssignmentBulkMutation, CreatePermissionAssignmentBulkMutationVariables>;
export const CreateRecurringPaymentDocument = gql`
    mutation createRecurringPayment($input: CreateRecurringPaymentInput!) {
  createRecurringPayment(input: $input) {
    id
    endDate
    isOverdue
    amount
    recurringAmount
    type
    clubId
    nextPayment
    sourceId {
      id
      sourceType
      hydrationType
    }
    status
  }
}
    `;
export type CreateRecurringPaymentMutationFn = Apollo.MutationFunction<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>;

/**
 * __useCreateRecurringPaymentMutation__
 *
 * To run a mutation, you first call `useCreateRecurringPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurringPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurringPaymentMutation, { data, loading, error }] = useCreateRecurringPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRecurringPaymentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>(CreateRecurringPaymentDocument, options);
      }
export type CreateRecurringPaymentMutationHookResult = ReturnType<typeof useCreateRecurringPaymentMutation>;
export type CreateRecurringPaymentMutationResult = Apollo.MutationResult<CreateRecurringPaymentMutation>;
export type CreateRecurringPaymentMutationOptions = Apollo.BaseMutationOptions<CreateRecurringPaymentMutation, CreateRecurringPaymentMutationVariables>;
export const CreateReferralCaseDocument = gql`
    mutation createReferralCase($input: ReferralCaseInput!) {
  createReferralCase(input: $input) {
    id
    created_at
    version_created_at
    details {
      id
      status
      owner_user_id
      preference_mortgage_reason
      client_ids
      regulated_by
      owner {
        id
        first_name
        last_name
      }
      clients {
        id
        version
        details {
          id
          ...ClientDetails
        }
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type CreateReferralCaseMutationFn = Apollo.MutationFunction<CreateReferralCaseMutation, CreateReferralCaseMutationVariables>;

/**
 * __useCreateReferralCaseMutation__
 *
 * To run a mutation, you first call `useCreateReferralCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferralCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferralCaseMutation, { data, loading, error }] = useCreateReferralCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReferralCaseMutation(baseOptions?: Apollo.MutationHookOptions<CreateReferralCaseMutation, CreateReferralCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReferralCaseMutation, CreateReferralCaseMutationVariables>(CreateReferralCaseDocument, options);
      }
export type CreateReferralCaseMutationHookResult = ReturnType<typeof useCreateReferralCaseMutation>;
export type CreateReferralCaseMutationResult = Apollo.MutationResult<CreateReferralCaseMutation>;
export type CreateReferralCaseMutationOptions = Apollo.BaseMutationOptions<CreateReferralCaseMutation, CreateReferralCaseMutationVariables>;
export const CreateReportProblemDocument = gql`
    mutation createReportProblem($input: ZendeskReportProblemInput!) {
  createReportProblem(input: $input)
}
    `;
export type CreateReportProblemMutationFn = Apollo.MutationFunction<CreateReportProblemMutation, CreateReportProblemMutationVariables>;

/**
 * __useCreateReportProblemMutation__
 *
 * To run a mutation, you first call `useCreateReportProblemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportProblemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportProblemMutation, { data, loading, error }] = useCreateReportProblemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportProblemMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportProblemMutation, CreateReportProblemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportProblemMutation, CreateReportProblemMutationVariables>(CreateReportProblemDocument, options);
      }
export type CreateReportProblemMutationHookResult = ReturnType<typeof useCreateReportProblemMutation>;
export type CreateReportProblemMutationResult = Apollo.MutationResult<CreateReportProblemMutation>;
export type CreateReportProblemMutationOptions = Apollo.BaseMutationOptions<CreateReportProblemMutation, CreateReportProblemMutationVariables>;
export const CreateUserDocument = gql`
    mutation createUser($input: UserInput!) {
  createUser(input: $input) {
    id
    first_name
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteClientAndUpdateCaseDocument = gql`
    mutation deleteClientAndUpdateCase($caseId: ID!, $deleteClientId: ID!) {
  deleteClientAndUpdateCase(caseId: $caseId, deleteClientId: $deleteClientId) {
    id
    version
    details {
      id
      clients {
        id
        version
        details {
          id
          ...ClientDetails
        }
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type DeleteClientAndUpdateCaseMutationFn = Apollo.MutationFunction<DeleteClientAndUpdateCaseMutation, DeleteClientAndUpdateCaseMutationVariables>;

/**
 * __useDeleteClientAndUpdateCaseMutation__
 *
 * To run a mutation, you first call `useDeleteClientAndUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientAndUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientAndUpdateCaseMutation, { data, loading, error }] = useDeleteClientAndUpdateCaseMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      deleteClientId: // value for 'deleteClientId'
 *   },
 * });
 */
export function useDeleteClientAndUpdateCaseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientAndUpdateCaseMutation, DeleteClientAndUpdateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientAndUpdateCaseMutation, DeleteClientAndUpdateCaseMutationVariables>(DeleteClientAndUpdateCaseDocument, options);
      }
export type DeleteClientAndUpdateCaseMutationHookResult = ReturnType<typeof useDeleteClientAndUpdateCaseMutation>;
export type DeleteClientAndUpdateCaseMutationResult = Apollo.MutationResult<DeleteClientAndUpdateCaseMutation>;
export type DeleteClientAndUpdateCaseMutationOptions = Apollo.BaseMutationOptions<DeleteClientAndUpdateCaseMutation, DeleteClientAndUpdateCaseMutationVariables>;
export const DeleteLedgerDocument = gql`
    mutation deleteLedger($id: Int!) {
  deleteLedger(id: $id)
}
    `;
export type DeleteLedgerMutationFn = Apollo.MutationFunction<DeleteLedgerMutation, DeleteLedgerMutationVariables>;

/**
 * __useDeleteLedgerMutation__
 *
 * To run a mutation, you first call `useDeleteLedgerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLedgerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLedgerMutation, { data, loading, error }] = useDeleteLedgerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLedgerMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLedgerMutation, DeleteLedgerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLedgerMutation, DeleteLedgerMutationVariables>(DeleteLedgerDocument, options);
      }
export type DeleteLedgerMutationHookResult = ReturnType<typeof useDeleteLedgerMutation>;
export type DeleteLedgerMutationResult = Apollo.MutationResult<DeleteLedgerMutation>;
export type DeleteLedgerMutationOptions = Apollo.BaseMutationOptions<DeleteLedgerMutation, DeleteLedgerMutationVariables>;
export const DeleteMortgageDocument = gql`
    mutation deleteMortgage($mortgageId: ID!, $caseId: ID!, $isPropertyPortfolio: Boolean) {
  deleteMortgage(
    mortgageId: $mortgageId
    caseId: $caseId
    isPropertyPortfolio: $isPropertyPortfolio
  ) {
    case_id
    mortgage_id
  }
}
    `;
export type DeleteMortgageMutationFn = Apollo.MutationFunction<DeleteMortgageMutation, DeleteMortgageMutationVariables>;

/**
 * __useDeleteMortgageMutation__
 *
 * To run a mutation, you first call `useDeleteMortgageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMortgageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMortgageMutation, { data, loading, error }] = useDeleteMortgageMutation({
 *   variables: {
 *      mortgageId: // value for 'mortgageId'
 *      caseId: // value for 'caseId'
 *      isPropertyPortfolio: // value for 'isPropertyPortfolio'
 *   },
 * });
 */
export function useDeleteMortgageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMortgageMutation, DeleteMortgageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMortgageMutation, DeleteMortgageMutationVariables>(DeleteMortgageDocument, options);
      }
export type DeleteMortgageMutationHookResult = ReturnType<typeof useDeleteMortgageMutation>;
export type DeleteMortgageMutationResult = Apollo.MutationResult<DeleteMortgageMutation>;
export type DeleteMortgageMutationOptions = Apollo.BaseMutationOptions<DeleteMortgageMutation, DeleteMortgageMutationVariables>;
export const DeleteMortgagesDocument = gql`
    mutation deleteMortgages($mortgageIds: [ID!]!, $caseId: ID!, $isPropertyPortfolio: Boolean) {
  deleteMortgages(
    mortgageIds: $mortgageIds
    caseId: $caseId
    isPropertyPortfolio: $isPropertyPortfolio
  ) {
    case_id
    mortgage_id
  }
}
    `;
export type DeleteMortgagesMutationFn = Apollo.MutationFunction<DeleteMortgagesMutation, DeleteMortgagesMutationVariables>;

/**
 * __useDeleteMortgagesMutation__
 *
 * To run a mutation, you first call `useDeleteMortgagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMortgagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMortgagesMutation, { data, loading, error }] = useDeleteMortgagesMutation({
 *   variables: {
 *      mortgageIds: // value for 'mortgageIds'
 *      caseId: // value for 'caseId'
 *      isPropertyPortfolio: // value for 'isPropertyPortfolio'
 *   },
 * });
 */
export function useDeleteMortgagesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMortgagesMutation, DeleteMortgagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMortgagesMutation, DeleteMortgagesMutationVariables>(DeleteMortgagesDocument, options);
      }
export type DeleteMortgagesMutationHookResult = ReturnType<typeof useDeleteMortgagesMutation>;
export type DeleteMortgagesMutationResult = Apollo.MutationResult<DeleteMortgagesMutation>;
export type DeleteMortgagesMutationOptions = Apollo.BaseMutationOptions<DeleteMortgagesMutation, DeleteMortgagesMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation deleteNote($note_id: ID!) {
  deleteNote(note_id: $note_id)
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      note_id: // value for 'note_id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const DeleteCasePropertyDocument = gql`
    mutation deleteCaseProperty($caseId: ID!, $reasons: [String!]!, $propertyId: ID!, $propertyType: String!, $deleteFromClient: Boolean!) {
  deleteCaseProperty(
    caseId: $caseId
    reasons: $reasons
    propertyId: $propertyId
    propertyType: $propertyType
    deleteFromClient: $deleteFromClient
  ) {
    id
  }
}
    `;
export type DeleteCasePropertyMutationFn = Apollo.MutationFunction<DeleteCasePropertyMutation, DeleteCasePropertyMutationVariables>;

/**
 * __useDeleteCasePropertyMutation__
 *
 * To run a mutation, you first call `useDeleteCasePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCasePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCasePropertyMutation, { data, loading, error }] = useDeleteCasePropertyMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      reasons: // value for 'reasons'
 *      propertyId: // value for 'propertyId'
 *      propertyType: // value for 'propertyType'
 *      deleteFromClient: // value for 'deleteFromClient'
 *   },
 * });
 */
export function useDeleteCasePropertyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCasePropertyMutation, DeleteCasePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCasePropertyMutation, DeleteCasePropertyMutationVariables>(DeleteCasePropertyDocument, options);
      }
export type DeleteCasePropertyMutationHookResult = ReturnType<typeof useDeleteCasePropertyMutation>;
export type DeleteCasePropertyMutationResult = Apollo.MutationResult<DeleteCasePropertyMutation>;
export type DeleteCasePropertyMutationOptions = Apollo.BaseMutationOptions<DeleteCasePropertyMutation, DeleteCasePropertyMutationVariables>;
export const DownloadProviderStatementTemplateDocument = gql`
    mutation downloadProviderStatementTemplate($input: DownloadProviderStatementTemplateInput!) {
  downloadProviderStatementTemplate(input: $input) {
    filename
    content_base64
  }
}
    `;
export type DownloadProviderStatementTemplateMutationFn = Apollo.MutationFunction<DownloadProviderStatementTemplateMutation, DownloadProviderStatementTemplateMutationVariables>;

/**
 * __useDownloadProviderStatementTemplateMutation__
 *
 * To run a mutation, you first call `useDownloadProviderStatementTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadProviderStatementTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadProviderStatementTemplateMutation, { data, loading, error }] = useDownloadProviderStatementTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadProviderStatementTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DownloadProviderStatementTemplateMutation, DownloadProviderStatementTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadProviderStatementTemplateMutation, DownloadProviderStatementTemplateMutationVariables>(DownloadProviderStatementTemplateDocument, options);
      }
export type DownloadProviderStatementTemplateMutationHookResult = ReturnType<typeof useDownloadProviderStatementTemplateMutation>;
export type DownloadProviderStatementTemplateMutationResult = Apollo.MutationResult<DownloadProviderStatementTemplateMutation>;
export type DownloadProviderStatementTemplateMutationOptions = Apollo.BaseMutationOptions<DownloadProviderStatementTemplateMutation, DownloadProviderStatementTemplateMutationVariables>;
export const EditLedgerPaymentDocument = gql`
    mutation editLedgerPayment($input: EditLedgerPaymentInput!, $ledgerId: ID!) {
  editLedgerPayment(input: $input, ledgerId: $ledgerId) {
    ...ledgerDetails
  }
}
    ${LedgerDetailsFragmentDoc}`;
export type EditLedgerPaymentMutationFn = Apollo.MutationFunction<EditLedgerPaymentMutation, EditLedgerPaymentMutationVariables>;

/**
 * __useEditLedgerPaymentMutation__
 *
 * To run a mutation, you first call `useEditLedgerPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditLedgerPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editLedgerPaymentMutation, { data, loading, error }] = useEditLedgerPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      ledgerId: // value for 'ledgerId'
 *   },
 * });
 */
export function useEditLedgerPaymentMutation(baseOptions?: Apollo.MutationHookOptions<EditLedgerPaymentMutation, EditLedgerPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditLedgerPaymentMutation, EditLedgerPaymentMutationVariables>(EditLedgerPaymentDocument, options);
      }
export type EditLedgerPaymentMutationHookResult = ReturnType<typeof useEditLedgerPaymentMutation>;
export type EditLedgerPaymentMutationResult = Apollo.MutationResult<EditLedgerPaymentMutation>;
export type EditLedgerPaymentMutationOptions = Apollo.BaseMutationOptions<EditLedgerPaymentMutation, EditLedgerPaymentMutationVariables>;
export const GetAcreDipCertBasedOnAffordabilityDocument = gql`
    mutation getAcreDipCertBasedOnAffordability($case: String!) {
  getAcreDipCertBasedOnAffordability(case: $case)
}
    `;
export type GetAcreDipCertBasedOnAffordabilityMutationFn = Apollo.MutationFunction<GetAcreDipCertBasedOnAffordabilityMutation, GetAcreDipCertBasedOnAffordabilityMutationVariables>;

/**
 * __useGetAcreDipCertBasedOnAffordabilityMutation__
 *
 * To run a mutation, you first call `useGetAcreDipCertBasedOnAffordabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAcreDipCertBasedOnAffordabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAcreDipCertBasedOnAffordabilityMutation, { data, loading, error }] = useGetAcreDipCertBasedOnAffordabilityMutation({
 *   variables: {
 *      case: // value for 'case'
 *   },
 * });
 */
export function useGetAcreDipCertBasedOnAffordabilityMutation(baseOptions?: Apollo.MutationHookOptions<GetAcreDipCertBasedOnAffordabilityMutation, GetAcreDipCertBasedOnAffordabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAcreDipCertBasedOnAffordabilityMutation, GetAcreDipCertBasedOnAffordabilityMutationVariables>(GetAcreDipCertBasedOnAffordabilityDocument, options);
      }
export type GetAcreDipCertBasedOnAffordabilityMutationHookResult = ReturnType<typeof useGetAcreDipCertBasedOnAffordabilityMutation>;
export type GetAcreDipCertBasedOnAffordabilityMutationResult = Apollo.MutationResult<GetAcreDipCertBasedOnAffordabilityMutation>;
export type GetAcreDipCertBasedOnAffordabilityMutationOptions = Apollo.BaseMutationOptions<GetAcreDipCertBasedOnAffordabilityMutation, GetAcreDipCertBasedOnAffordabilityMutationVariables>;
export const GetAcreDipCertBasedOnLenderDipDocument = gql`
    mutation getAcreDipCertBasedOnLenderDip($case: String!, $mortgage: String!) {
  getAcreDipCertBasedOnLenderDip(case: $case, mortgage: $mortgage)
}
    `;
export type GetAcreDipCertBasedOnLenderDipMutationFn = Apollo.MutationFunction<GetAcreDipCertBasedOnLenderDipMutation, GetAcreDipCertBasedOnLenderDipMutationVariables>;

/**
 * __useGetAcreDipCertBasedOnLenderDipMutation__
 *
 * To run a mutation, you first call `useGetAcreDipCertBasedOnLenderDipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAcreDipCertBasedOnLenderDipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAcreDipCertBasedOnLenderDipMutation, { data, loading, error }] = useGetAcreDipCertBasedOnLenderDipMutation({
 *   variables: {
 *      case: // value for 'case'
 *      mortgage: // value for 'mortgage'
 *   },
 * });
 */
export function useGetAcreDipCertBasedOnLenderDipMutation(baseOptions?: Apollo.MutationHookOptions<GetAcreDipCertBasedOnLenderDipMutation, GetAcreDipCertBasedOnLenderDipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAcreDipCertBasedOnLenderDipMutation, GetAcreDipCertBasedOnLenderDipMutationVariables>(GetAcreDipCertBasedOnLenderDipDocument, options);
      }
export type GetAcreDipCertBasedOnLenderDipMutationHookResult = ReturnType<typeof useGetAcreDipCertBasedOnLenderDipMutation>;
export type GetAcreDipCertBasedOnLenderDipMutationResult = Apollo.MutationResult<GetAcreDipCertBasedOnLenderDipMutation>;
export type GetAcreDipCertBasedOnLenderDipMutationOptions = Apollo.BaseMutationOptions<GetAcreDipCertBasedOnLenderDipMutation, GetAcreDipCertBasedOnLenderDipMutationVariables>;
export const GetOauthRedirectLinkDocument = gql`
    query getOauthRedirectLink($input: OauthRedirectInput!) {
  getOauthRedirectLink(input: $input)
}
    `;

/**
 * __useGetOauthRedirectLinkQuery__
 *
 * To run a query within a React component, call `useGetOauthRedirectLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOauthRedirectLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOauthRedirectLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOauthRedirectLinkQuery(baseOptions: Apollo.QueryHookOptions<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables> & ({ variables: GetOauthRedirectLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>(GetOauthRedirectLinkDocument, options);
      }
export function useGetOauthRedirectLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>(GetOauthRedirectLinkDocument, options);
        }
// @ts-ignore
export function useGetOauthRedirectLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>;
export function useGetOauthRedirectLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetOauthRedirectLinkQuery | undefined, GetOauthRedirectLinkQueryVariables>;
export function useGetOauthRedirectLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>(GetOauthRedirectLinkDocument, options);
        }
export type GetOauthRedirectLinkQueryHookResult = ReturnType<typeof useGetOauthRedirectLinkQuery>;
export type GetOauthRedirectLinkLazyQueryHookResult = ReturnType<typeof useGetOauthRedirectLinkLazyQuery>;
export type GetOauthRedirectLinkSuspenseQueryHookResult = ReturnType<typeof useGetOauthRedirectLinkSuspenseQuery>;
export type GetOauthRedirectLinkQueryResult = Apollo.QueryResult<GetOauthRedirectLinkQuery, GetOauthRedirectLinkQueryVariables>;
export const GetRiskReportDocument = gql`
    mutation getRiskReport($input: RiskReportInput!) {
  getRiskReport(input: $input) {
    id
    version
    details {
      id
      risk_reports {
        ...ClientRiskReportDetails
      }
    }
  }
}
    ${ClientRiskReportDetailsFragmentDoc}`;
export type GetRiskReportMutationFn = Apollo.MutationFunction<GetRiskReportMutation, GetRiskReportMutationVariables>;

/**
 * __useGetRiskReportMutation__
 *
 * To run a mutation, you first call `useGetRiskReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetRiskReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getRiskReportMutation, { data, loading, error }] = useGetRiskReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRiskReportMutation(baseOptions?: Apollo.MutationHookOptions<GetRiskReportMutation, GetRiskReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetRiskReportMutation, GetRiskReportMutationVariables>(GetRiskReportDocument, options);
      }
export type GetRiskReportMutationHookResult = ReturnType<typeof useGetRiskReportMutation>;
export type GetRiskReportMutationResult = Apollo.MutationResult<GetRiskReportMutation>;
export type GetRiskReportMutationOptions = Apollo.BaseMutationOptions<GetRiskReportMutation, GetRiskReportMutationVariables>;
export const GoCardlessAuthCallbackDocument = gql`
    mutation goCardlessAuthCallback($input: GoCardlessAuthCallbackInput) {
  goCardlessAuthCallback(input: $input)
}
    `;
export type GoCardlessAuthCallbackMutationFn = Apollo.MutationFunction<GoCardlessAuthCallbackMutation, GoCardlessAuthCallbackMutationVariables>;

/**
 * __useGoCardlessAuthCallbackMutation__
 *
 * To run a mutation, you first call `useGoCardlessAuthCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoCardlessAuthCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [goCardlessAuthCallbackMutation, { data, loading, error }] = useGoCardlessAuthCallbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGoCardlessAuthCallbackMutation(baseOptions?: Apollo.MutationHookOptions<GoCardlessAuthCallbackMutation, GoCardlessAuthCallbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoCardlessAuthCallbackMutation, GoCardlessAuthCallbackMutationVariables>(GoCardlessAuthCallbackDocument, options);
      }
export type GoCardlessAuthCallbackMutationHookResult = ReturnType<typeof useGoCardlessAuthCallbackMutation>;
export type GoCardlessAuthCallbackMutationResult = Apollo.MutationResult<GoCardlessAuthCallbackMutation>;
export type GoCardlessAuthCallbackMutationOptions = Apollo.BaseMutationOptions<GoCardlessAuthCallbackMutation, GoCardlessAuthCallbackMutationVariables>;
export const InitiateGoCardlessPaymentDocument = gql`
    mutation initiateGoCardlessPayment($input: InitiateGoCardlessPaymentInput) {
  initiateGoCardlessPayment(input: $input) {
    id
    redirect_uri
    external_id
    status
    amount
    provider
  }
}
    `;
export type InitiateGoCardlessPaymentMutationFn = Apollo.MutationFunction<InitiateGoCardlessPaymentMutation, InitiateGoCardlessPaymentMutationVariables>;

/**
 * __useInitiateGoCardlessPaymentMutation__
 *
 * To run a mutation, you first call `useInitiateGoCardlessPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateGoCardlessPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateGoCardlessPaymentMutation, { data, loading, error }] = useInitiateGoCardlessPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateGoCardlessPaymentMutation(baseOptions?: Apollo.MutationHookOptions<InitiateGoCardlessPaymentMutation, InitiateGoCardlessPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateGoCardlessPaymentMutation, InitiateGoCardlessPaymentMutationVariables>(InitiateGoCardlessPaymentDocument, options);
      }
export type InitiateGoCardlessPaymentMutationHookResult = ReturnType<typeof useInitiateGoCardlessPaymentMutation>;
export type InitiateGoCardlessPaymentMutationResult = Apollo.MutationResult<InitiateGoCardlessPaymentMutation>;
export type InitiateGoCardlessPaymentMutationOptions = Apollo.BaseMutationOptions<InitiateGoCardlessPaymentMutation, InitiateGoCardlessPaymentMutationVariables>;
export const MarkLedgersPaidDocument = gql`
    mutation MarkLedgersPaid($input: MarkLedgersPaidInput!) {
  markLedgersPaid(input: $input) {
    results {
      ledger_id
      status
      error
    }
  }
}
    `;
export type MarkLedgersPaidMutationFn = Apollo.MutationFunction<MarkLedgersPaidMutation, MarkLedgersPaidMutationVariables>;

/**
 * __useMarkLedgersPaidMutation__
 *
 * To run a mutation, you first call `useMarkLedgersPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkLedgersPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markLedgersPaidMutation, { data, loading, error }] = useMarkLedgersPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkLedgersPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkLedgersPaidMutation, MarkLedgersPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkLedgersPaidMutation, MarkLedgersPaidMutationVariables>(MarkLedgersPaidDocument, options);
      }
export type MarkLedgersPaidMutationHookResult = ReturnType<typeof useMarkLedgersPaidMutation>;
export type MarkLedgersPaidMutationResult = Apollo.MutationResult<MarkLedgersPaidMutation>;
export type MarkLedgersPaidMutationOptions = Apollo.BaseMutationOptions<MarkLedgersPaidMutation, MarkLedgersPaidMutationVariables>;
export const MutatePropertyAndMortgagesDocument = gql`
    mutation mutatePropertyAndMortgages($input: MutatePropertyAndMortgagesInput!, $includeCaseDetailsInProperty: Boolean = false) {
  mutatePropertyAndMortgages(input: $input) {
    property {
      ...PropertyDetails
    }
    createdMortgage {
      ...MortgageDetails
    }
    updatedMortgages {
      ...MortgageDetails
    }
  }
}
    ${PropertyDetailsFragmentDoc}
${MortgageDetailsFragmentDoc}`;
export type MutatePropertyAndMortgagesMutationFn = Apollo.MutationFunction<MutatePropertyAndMortgagesMutation, MutatePropertyAndMortgagesMutationVariables>;

/**
 * __useMutatePropertyAndMortgagesMutation__
 *
 * To run a mutation, you first call `useMutatePropertyAndMortgagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutatePropertyAndMortgagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutatePropertyAndMortgagesMutation, { data, loading, error }] = useMutatePropertyAndMortgagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useMutatePropertyAndMortgagesMutation(baseOptions?: Apollo.MutationHookOptions<MutatePropertyAndMortgagesMutation, MutatePropertyAndMortgagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutatePropertyAndMortgagesMutation, MutatePropertyAndMortgagesMutationVariables>(MutatePropertyAndMortgagesDocument, options);
      }
export type MutatePropertyAndMortgagesMutationHookResult = ReturnType<typeof useMutatePropertyAndMortgagesMutation>;
export type MutatePropertyAndMortgagesMutationResult = Apollo.MutationResult<MutatePropertyAndMortgagesMutation>;
export type MutatePropertyAndMortgagesMutationOptions = Apollo.BaseMutationOptions<MutatePropertyAndMortgagesMutation, MutatePropertyAndMortgagesMutationVariables>;
export const PostBrowserIdDocument = gql`
    mutation postBrowserId($useClientApi: Boolean) {
  postBrowserId(useClientApi: $useClientApi) {
    expected_cookie
  }
}
    `;
export type PostBrowserIdMutationFn = Apollo.MutationFunction<PostBrowserIdMutation, PostBrowserIdMutationVariables>;

/**
 * __usePostBrowserIdMutation__
 *
 * To run a mutation, you first call `usePostBrowserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostBrowserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postBrowserIdMutation, { data, loading, error }] = usePostBrowserIdMutation({
 *   variables: {
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function usePostBrowserIdMutation(baseOptions?: Apollo.MutationHookOptions<PostBrowserIdMutation, PostBrowserIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostBrowserIdMutation, PostBrowserIdMutationVariables>(PostBrowserIdDocument, options);
      }
export type PostBrowserIdMutationHookResult = ReturnType<typeof usePostBrowserIdMutation>;
export type PostBrowserIdMutationResult = Apollo.MutationResult<PostBrowserIdMutation>;
export type PostBrowserIdMutationOptions = Apollo.BaseMutationOptions<PostBrowserIdMutation, PostBrowserIdMutationVariables>;
export const PostClientInvitesDocument = gql`
    mutation postClientInvites($emailInput: [EmailTemplateInput!]!, $templateInput: TemplateInput!, $organisationPrivacyPayloadInput: TemplateInput!, $creditReportPayloadInput: TemplateInput, $shouldSendEmailInvite: Boolean) {
  postClientInvites(
    emailInput: $emailInput
    templateInput: $templateInput
    organisationPrivacyPayloadInput: $organisationPrivacyPayloadInput
    creditReportPayloadInput: $creditReportPayloadInput
    shouldSendEmailInvite: $shouldSendEmailInvite
  ) {
    client_recipient_ids
    document {
      document_id
      internalHash
    }
  }
}
    `;
export type PostClientInvitesMutationFn = Apollo.MutationFunction<PostClientInvitesMutation, PostClientInvitesMutationVariables>;

/**
 * __usePostClientInvitesMutation__
 *
 * To run a mutation, you first call `usePostClientInvitesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostClientInvitesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postClientInvitesMutation, { data, loading, error }] = usePostClientInvitesMutation({
 *   variables: {
 *      emailInput: // value for 'emailInput'
 *      templateInput: // value for 'templateInput'
 *      organisationPrivacyPayloadInput: // value for 'organisationPrivacyPayloadInput'
 *      creditReportPayloadInput: // value for 'creditReportPayloadInput'
 *      shouldSendEmailInvite: // value for 'shouldSendEmailInvite'
 *   },
 * });
 */
export function usePostClientInvitesMutation(baseOptions?: Apollo.MutationHookOptions<PostClientInvitesMutation, PostClientInvitesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostClientInvitesMutation, PostClientInvitesMutationVariables>(PostClientInvitesDocument, options);
      }
export type PostClientInvitesMutationHookResult = ReturnType<typeof usePostClientInvitesMutation>;
export type PostClientInvitesMutationResult = Apollo.MutationResult<PostClientInvitesMutation>;
export type PostClientInvitesMutationOptions = Apollo.BaseMutationOptions<PostClientInvitesMutation, PostClientInvitesMutationVariables>;
export const PostClientInvitesTemplateDocument = gql`
    mutation postClientInvitesTemplate($emailInput: EmailTemplateInput!) {
  postClientInvitesTemplate(emailInput: $emailInput) {
    document {
      document_id
      internalHash
    }
    subject
    client_recipient_ids
  }
}
    `;
export type PostClientInvitesTemplateMutationFn = Apollo.MutationFunction<PostClientInvitesTemplateMutation, PostClientInvitesTemplateMutationVariables>;

/**
 * __usePostClientInvitesTemplateMutation__
 *
 * To run a mutation, you first call `usePostClientInvitesTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostClientInvitesTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postClientInvitesTemplateMutation, { data, loading, error }] = usePostClientInvitesTemplateMutation({
 *   variables: {
 *      emailInput: // value for 'emailInput'
 *   },
 * });
 */
export function usePostClientInvitesTemplateMutation(baseOptions?: Apollo.MutationHookOptions<PostClientInvitesTemplateMutation, PostClientInvitesTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostClientInvitesTemplateMutation, PostClientInvitesTemplateMutationVariables>(PostClientInvitesTemplateDocument, options);
      }
export type PostClientInvitesTemplateMutationHookResult = ReturnType<typeof usePostClientInvitesTemplateMutation>;
export type PostClientInvitesTemplateMutationResult = Apollo.MutationResult<PostClientInvitesTemplateMutation>;
export type PostClientInvitesTemplateMutationOptions = Apollo.BaseMutationOptions<PostClientInvitesTemplateMutation, PostClientInvitesTemplateMutationVariables>;
export const RefreshCreditReportDocument = gql`
    mutation refreshCreditReport($clientId: ID!) {
  refreshCreditReport(clientId: $clientId) {
    status
    reason {
      code
      description
    }
  }
}
    `;
export type RefreshCreditReportMutationFn = Apollo.MutationFunction<RefreshCreditReportMutation, RefreshCreditReportMutationVariables>;

/**
 * __useRefreshCreditReportMutation__
 *
 * To run a mutation, you first call `useRefreshCreditReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCreditReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCreditReportMutation, { data, loading, error }] = useRefreshCreditReportMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useRefreshCreditReportMutation(baseOptions?: Apollo.MutationHookOptions<RefreshCreditReportMutation, RefreshCreditReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshCreditReportMutation, RefreshCreditReportMutationVariables>(RefreshCreditReportDocument, options);
      }
export type RefreshCreditReportMutationHookResult = ReturnType<typeof useRefreshCreditReportMutation>;
export type RefreshCreditReportMutationResult = Apollo.MutationResult<RefreshCreditReportMutation>;
export type RefreshCreditReportMutationOptions = Apollo.BaseMutationOptions<RefreshCreditReportMutation, RefreshCreditReportMutationVariables>;
export const RemoveGeneralInsuranceProductDocument = gql`
    mutation removeGeneralInsuranceProduct($general_insurance_product_id: ID!, $case_id: ID!) {
  removeGeneralInsuranceProduct(
    general_insurance_product_id: $general_insurance_product_id
    case_id: $case_id
  )
}
    `;
export type RemoveGeneralInsuranceProductMutationFn = Apollo.MutationFunction<RemoveGeneralInsuranceProductMutation, RemoveGeneralInsuranceProductMutationVariables>;

/**
 * __useRemoveGeneralInsuranceProductMutation__
 *
 * To run a mutation, you first call `useRemoveGeneralInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGeneralInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGeneralInsuranceProductMutation, { data, loading, error }] = useRemoveGeneralInsuranceProductMutation({
 *   variables: {
 *      general_insurance_product_id: // value for 'general_insurance_product_id'
 *      case_id: // value for 'case_id'
 *   },
 * });
 */
export function useRemoveGeneralInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGeneralInsuranceProductMutation, RemoveGeneralInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGeneralInsuranceProductMutation, RemoveGeneralInsuranceProductMutationVariables>(RemoveGeneralInsuranceProductDocument, options);
      }
export type RemoveGeneralInsuranceProductMutationHookResult = ReturnType<typeof useRemoveGeneralInsuranceProductMutation>;
export type RemoveGeneralInsuranceProductMutationResult = Apollo.MutationResult<RemoveGeneralInsuranceProductMutation>;
export type RemoveGeneralInsuranceProductMutationOptions = Apollo.BaseMutationOptions<RemoveGeneralInsuranceProductMutation, RemoveGeneralInsuranceProductMutationVariables>;
export const RemoveProtectionProductsDocument = gql`
    mutation removeProtectionProducts($protection_ids: [ID!]!, $case_id: ID!) {
  removeProtectionProducts(protection_ids: $protection_ids, case_id: $case_id)
}
    `;
export type RemoveProtectionProductsMutationFn = Apollo.MutationFunction<RemoveProtectionProductsMutation, RemoveProtectionProductsMutationVariables>;

/**
 * __useRemoveProtectionProductsMutation__
 *
 * To run a mutation, you first call `useRemoveProtectionProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProtectionProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProtectionProductsMutation, { data, loading, error }] = useRemoveProtectionProductsMutation({
 *   variables: {
 *      protection_ids: // value for 'protection_ids'
 *      case_id: // value for 'case_id'
 *   },
 * });
 */
export function useRemoveProtectionProductsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProtectionProductsMutation, RemoveProtectionProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProtectionProductsMutation, RemoveProtectionProductsMutationVariables>(RemoveProtectionProductsDocument, options);
      }
export type RemoveProtectionProductsMutationHookResult = ReturnType<typeof useRemoveProtectionProductsMutation>;
export type RemoveProtectionProductsMutationResult = Apollo.MutationResult<RemoveProtectionProductsMutation>;
export type RemoveProtectionProductsMutationOptions = Apollo.BaseMutationOptions<RemoveProtectionProductsMutation, RemoveProtectionProductsMutationVariables>;
export const RenderAndStoreDocumentDocument = gql`
    mutation renderAndStoreDocument($input: RenderAndStoreDocumentInput!) {
  renderAndStoreDocument(input: $input) {
    ...DocumentDetails
    data_base64
    document_signature
    document_name
    source
    type
    template_type
    other_type
    uploaded_by
    owning_client_ids
    rendered_case_ids
  }
}
    ${DocumentDetailsFragmentDoc}`;
export type RenderAndStoreDocumentMutationFn = Apollo.MutationFunction<RenderAndStoreDocumentMutation, RenderAndStoreDocumentMutationVariables>;

/**
 * __useRenderAndStoreDocumentMutation__
 *
 * To run a mutation, you first call `useRenderAndStoreDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderAndStoreDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderAndStoreDocumentMutation, { data, loading, error }] = useRenderAndStoreDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderAndStoreDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RenderAndStoreDocumentMutation, RenderAndStoreDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenderAndStoreDocumentMutation, RenderAndStoreDocumentMutationVariables>(RenderAndStoreDocumentDocument, options);
      }
export type RenderAndStoreDocumentMutationHookResult = ReturnType<typeof useRenderAndStoreDocumentMutation>;
export type RenderAndStoreDocumentMutationResult = Apollo.MutationResult<RenderAndStoreDocumentMutation>;
export type RenderAndStoreDocumentMutationOptions = Apollo.BaseMutationOptions<RenderAndStoreDocumentMutation, RenderAndStoreDocumentMutationVariables>;
export const RenderAndStoreIddDocumentDocument = gql`
    mutation renderAndStoreIddDocument($input: RenderAndStoreDocumentInput!, $caseId: String, $clientIdsAccept: [String!]) {
  renderAndStoreIddDocument(
    input: $input
    caseId: $caseId
    clientIdsAccept: $clientIdsAccept
  ) {
    ...DocumentDetails
    data_base64
    document_signature
    document_name
    source
    type
    template_type
    other_type
    uploaded_by
    owning_client_ids
    rendered_case_ids
  }
}
    ${DocumentDetailsFragmentDoc}`;
export type RenderAndStoreIddDocumentMutationFn = Apollo.MutationFunction<RenderAndStoreIddDocumentMutation, RenderAndStoreIddDocumentMutationVariables>;

/**
 * __useRenderAndStoreIddDocumentMutation__
 *
 * To run a mutation, you first call `useRenderAndStoreIddDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderAndStoreIddDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderAndStoreIddDocumentMutation, { data, loading, error }] = useRenderAndStoreIddDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      caseId: // value for 'caseId'
 *      clientIdsAccept: // value for 'clientIdsAccept'
 *   },
 * });
 */
export function useRenderAndStoreIddDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RenderAndStoreIddDocumentMutation, RenderAndStoreIddDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenderAndStoreIddDocumentMutation, RenderAndStoreIddDocumentMutationVariables>(RenderAndStoreIddDocumentDocument, options);
      }
export type RenderAndStoreIddDocumentMutationHookResult = ReturnType<typeof useRenderAndStoreIddDocumentMutation>;
export type RenderAndStoreIddDocumentMutationResult = Apollo.MutationResult<RenderAndStoreIddDocumentMutation>;
export type RenderAndStoreIddDocumentMutationOptions = Apollo.BaseMutationOptions<RenderAndStoreIddDocumentMutation, RenderAndStoreIddDocumentMutationVariables>;
export const ResetUserMfaDocument = gql`
    mutation resetUserMfa($userId: ID!) {
  resetUserMfa(userId: $userId) {
    success
    user_id
  }
}
    `;
export type ResetUserMfaMutationFn = Apollo.MutationFunction<ResetUserMfaMutation, ResetUserMfaMutationVariables>;

/**
 * __useResetUserMfaMutation__
 *
 * To run a mutation, you first call `useResetUserMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserMfaMutation, { data, loading, error }] = useResetUserMfaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useResetUserMfaMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserMfaMutation, ResetUserMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserMfaMutation, ResetUserMfaMutationVariables>(ResetUserMfaDocument, options);
      }
export type ResetUserMfaMutationHookResult = ReturnType<typeof useResetUserMfaMutation>;
export type ResetUserMfaMutationResult = Apollo.MutationResult<ResetUserMfaMutation>;
export type ResetUserMfaMutationOptions = Apollo.BaseMutationOptions<ResetUserMfaMutation, ResetUserMfaMutationVariables>;
export const RevokeOauthDocument = gql`
    mutation revokeOauth($id: ID!) {
  revokeOauth(id: $id)
}
    `;
export type RevokeOauthMutationFn = Apollo.MutationFunction<RevokeOauthMutation, RevokeOauthMutationVariables>;

/**
 * __useRevokeOauthMutation__
 *
 * To run a mutation, you first call `useRevokeOauthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeOauthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeOauthMutation, { data, loading, error }] = useRevokeOauthMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRevokeOauthMutation(baseOptions?: Apollo.MutationHookOptions<RevokeOauthMutation, RevokeOauthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeOauthMutation, RevokeOauthMutationVariables>(RevokeOauthDocument, options);
      }
export type RevokeOauthMutationHookResult = ReturnType<typeof useRevokeOauthMutation>;
export type RevokeOauthMutationResult = Apollo.MutationResult<RevokeOauthMutation>;
export type RevokeOauthMutationOptions = Apollo.BaseMutationOptions<RevokeOauthMutation, RevokeOauthMutationVariables>;
export const RunIdVerificationDocument = gql`
    mutation runIdVerification($id: ID!) {
  runIdVerification(id: $id)
}
    `;
export type RunIdVerificationMutationFn = Apollo.MutationFunction<RunIdVerificationMutation, RunIdVerificationMutationVariables>;

/**
 * __useRunIdVerificationMutation__
 *
 * To run a mutation, you first call `useRunIdVerificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunIdVerificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runIdVerificationMutation, { data, loading, error }] = useRunIdVerificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRunIdVerificationMutation(baseOptions?: Apollo.MutationHookOptions<RunIdVerificationMutation, RunIdVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunIdVerificationMutation, RunIdVerificationMutationVariables>(RunIdVerificationDocument, options);
      }
export type RunIdVerificationMutationHookResult = ReturnType<typeof useRunIdVerificationMutation>;
export type RunIdVerificationMutationResult = Apollo.MutationResult<RunIdVerificationMutation>;
export type RunIdVerificationMutationOptions = Apollo.BaseMutationOptions<RunIdVerificationMutation, RunIdVerificationMutationVariables>;
export const RunQuotationCreditSearchDocument = gql`
    mutation runQuotationCreditSearch($clientIds: [ID!]!) {
  runQuotationCreditSearch(clientIds: $clientIds)
}
    `;
export type RunQuotationCreditSearchMutationFn = Apollo.MutationFunction<RunQuotationCreditSearchMutation, RunQuotationCreditSearchMutationVariables>;

/**
 * __useRunQuotationCreditSearchMutation__
 *
 * To run a mutation, you first call `useRunQuotationCreditSearchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunQuotationCreditSearchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runQuotationCreditSearchMutation, { data, loading, error }] = useRunQuotationCreditSearchMutation({
 *   variables: {
 *      clientIds: // value for 'clientIds'
 *   },
 * });
 */
export function useRunQuotationCreditSearchMutation(baseOptions?: Apollo.MutationHookOptions<RunQuotationCreditSearchMutation, RunQuotationCreditSearchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunQuotationCreditSearchMutation, RunQuotationCreditSearchMutationVariables>(RunQuotationCreditSearchDocument, options);
      }
export type RunQuotationCreditSearchMutationHookResult = ReturnType<typeof useRunQuotationCreditSearchMutation>;
export type RunQuotationCreditSearchMutationResult = Apollo.MutationResult<RunQuotationCreditSearchMutation>;
export type RunQuotationCreditSearchMutationOptions = Apollo.BaseMutationOptions<RunQuotationCreditSearchMutation, RunQuotationCreditSearchMutationVariables>;
export const SaveBusinessProtectionProductsDocument = gql`
    mutation saveBusinessProtectionProducts($input: BusinessProtectionProductsInput!) {
  saveBusinessProtectionProducts(input: $input) {
    protection_id
    created_at
    version
    version_created_at
    details {
      ...ProductsForProtection
    }
  }
}
    ${ProductsForProtectionFragmentDoc}`;
export type SaveBusinessProtectionProductsMutationFn = Apollo.MutationFunction<SaveBusinessProtectionProductsMutation, SaveBusinessProtectionProductsMutationVariables>;

/**
 * __useSaveBusinessProtectionProductsMutation__
 *
 * To run a mutation, you first call `useSaveBusinessProtectionProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBusinessProtectionProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBusinessProtectionProductsMutation, { data, loading, error }] = useSaveBusinessProtectionProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBusinessProtectionProductsMutation(baseOptions?: Apollo.MutationHookOptions<SaveBusinessProtectionProductsMutation, SaveBusinessProtectionProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBusinessProtectionProductsMutation, SaveBusinessProtectionProductsMutationVariables>(SaveBusinessProtectionProductsDocument, options);
      }
export type SaveBusinessProtectionProductsMutationHookResult = ReturnType<typeof useSaveBusinessProtectionProductsMutation>;
export type SaveBusinessProtectionProductsMutationResult = Apollo.MutationResult<SaveBusinessProtectionProductsMutation>;
export type SaveBusinessProtectionProductsMutationOptions = Apollo.BaseMutationOptions<SaveBusinessProtectionProductsMutation, SaveBusinessProtectionProductsMutationVariables>;
export const SaveMortgageProductToCaseDocument = gql`
    mutation saveMortgageProductToCase($input: MortgageProductToCaseInput!) {
  saveMortgageProductToCase(input: $input) {
    id
    ...CaseMortgagesAndMortgageProducts
    source_response {
      ...SourceResponse
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}
${SourceResponseFragmentDoc}`;
export type SaveMortgageProductToCaseMutationFn = Apollo.MutationFunction<SaveMortgageProductToCaseMutation, SaveMortgageProductToCaseMutationVariables>;

/**
 * __useSaveMortgageProductToCaseMutation__
 *
 * To run a mutation, you first call `useSaveMortgageProductToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMortgageProductToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMortgageProductToCaseMutation, { data, loading, error }] = useSaveMortgageProductToCaseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMortgageProductToCaseMutation(baseOptions?: Apollo.MutationHookOptions<SaveMortgageProductToCaseMutation, SaveMortgageProductToCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveMortgageProductToCaseMutation, SaveMortgageProductToCaseMutationVariables>(SaveMortgageProductToCaseDocument, options);
      }
export type SaveMortgageProductToCaseMutationHookResult = ReturnType<typeof useSaveMortgageProductToCaseMutation>;
export type SaveMortgageProductToCaseMutationResult = Apollo.MutationResult<SaveMortgageProductToCaseMutation>;
export type SaveMortgageProductToCaseMutationOptions = Apollo.BaseMutationOptions<SaveMortgageProductToCaseMutation, SaveMortgageProductToCaseMutationVariables>;
export const SaveProtectionProductsDocument = gql`
    mutation saveProtectionProducts($inputs: [ProtectionProductInput!]!) {
  saveProtectionProducts(inputs: $inputs) {
    protection_id
    created_at
    version
    version_created_at
    details {
      ...ProductsForProtection
    }
  }
}
    ${ProductsForProtectionFragmentDoc}`;
export type SaveProtectionProductsMutationFn = Apollo.MutationFunction<SaveProtectionProductsMutation, SaveProtectionProductsMutationVariables>;

/**
 * __useSaveProtectionProductsMutation__
 *
 * To run a mutation, you first call `useSaveProtectionProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProtectionProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProtectionProductsMutation, { data, loading, error }] = useSaveProtectionProductsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveProtectionProductsMutation(baseOptions?: Apollo.MutationHookOptions<SaveProtectionProductsMutation, SaveProtectionProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProtectionProductsMutation, SaveProtectionProductsMutationVariables>(SaveProtectionProductsDocument, options);
      }
export type SaveProtectionProductsMutationHookResult = ReturnType<typeof useSaveProtectionProductsMutation>;
export type SaveProtectionProductsMutationResult = Apollo.MutationResult<SaveProtectionProductsMutation>;
export type SaveProtectionProductsMutationOptions = Apollo.BaseMutationOptions<SaveProtectionProductsMutation, SaveProtectionProductsMutationVariables>;
export const SaveProtectionProductsToCaseDocument = gql`
    mutation saveProtectionProductsToCase($inputs: SaveToCaseInput!) {
  saveProtectionProductsToCase(inputs: $inputs) {
    product_ids
  }
}
    `;
export type SaveProtectionProductsToCaseMutationFn = Apollo.MutationFunction<SaveProtectionProductsToCaseMutation, SaveProtectionProductsToCaseMutationVariables>;

/**
 * __useSaveProtectionProductsToCaseMutation__
 *
 * To run a mutation, you first call `useSaveProtectionProductsToCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProtectionProductsToCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProtectionProductsToCaseMutation, { data, loading, error }] = useSaveProtectionProductsToCaseMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveProtectionProductsToCaseMutation(baseOptions?: Apollo.MutationHookOptions<SaveProtectionProductsToCaseMutation, SaveProtectionProductsToCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProtectionProductsToCaseMutation, SaveProtectionProductsToCaseMutationVariables>(SaveProtectionProductsToCaseDocument, options);
      }
export type SaveProtectionProductsToCaseMutationHookResult = ReturnType<typeof useSaveProtectionProductsToCaseMutation>;
export type SaveProtectionProductsToCaseMutationResult = Apollo.MutationResult<SaveProtectionProductsToCaseMutation>;
export type SaveProtectionProductsToCaseMutationOptions = Apollo.BaseMutationOptions<SaveProtectionProductsToCaseMutation, SaveProtectionProductsToCaseMutationVariables>;
export const SaveProtectionProductsToCaseV2Document = gql`
    mutation saveProtectionProductsToCaseV2($inputs: SaveToCaseInput!) {
  saveProtectionProductsToCaseV2(inputs: $inputs) {
    product_ids
  }
}
    `;
export type SaveProtectionProductsToCaseV2MutationFn = Apollo.MutationFunction<SaveProtectionProductsToCaseV2Mutation, SaveProtectionProductsToCaseV2MutationVariables>;

/**
 * __useSaveProtectionProductsToCaseV2Mutation__
 *
 * To run a mutation, you first call `useSaveProtectionProductsToCaseV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProtectionProductsToCaseV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProtectionProductsToCaseV2Mutation, { data, loading, error }] = useSaveProtectionProductsToCaseV2Mutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useSaveProtectionProductsToCaseV2Mutation(baseOptions?: Apollo.MutationHookOptions<SaveProtectionProductsToCaseV2Mutation, SaveProtectionProductsToCaseV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveProtectionProductsToCaseV2Mutation, SaveProtectionProductsToCaseV2MutationVariables>(SaveProtectionProductsToCaseV2Document, options);
      }
export type SaveProtectionProductsToCaseV2MutationHookResult = ReturnType<typeof useSaveProtectionProductsToCaseV2Mutation>;
export type SaveProtectionProductsToCaseV2MutationResult = Apollo.MutationResult<SaveProtectionProductsToCaseV2Mutation>;
export type SaveProtectionProductsToCaseV2MutationOptions = Apollo.BaseMutationOptions<SaveProtectionProductsToCaseV2Mutation, SaveProtectionProductsToCaseV2MutationVariables>;
export const SendClientSrNotificationDocument = gql`
    mutation sendClientSrNotification($input: SrNotificationInput!) {
  sendClientSrNotification(input: $input) {
    message
  }
}
    `;
export type SendClientSrNotificationMutationFn = Apollo.MutationFunction<SendClientSrNotificationMutation, SendClientSrNotificationMutationVariables>;

/**
 * __useSendClientSrNotificationMutation__
 *
 * To run a mutation, you first call `useSendClientSrNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendClientSrNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendClientSrNotificationMutation, { data, loading, error }] = useSendClientSrNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendClientSrNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendClientSrNotificationMutation, SendClientSrNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendClientSrNotificationMutation, SendClientSrNotificationMutationVariables>(SendClientSrNotificationDocument, options);
      }
export type SendClientSrNotificationMutationHookResult = ReturnType<typeof useSendClientSrNotificationMutation>;
export type SendClientSrNotificationMutationResult = Apollo.MutationResult<SendClientSrNotificationMutation>;
export type SendClientSrNotificationMutationOptions = Apollo.BaseMutationOptions<SendClientSrNotificationMutation, SendClientSrNotificationMutationVariables>;
export const SendSchedulingInviteDocument = gql`
    mutation sendSchedulingInvite($input: SchedulingInviteInput!) {
  sendSchedulingInvite(input: $input) {
    meeting_title
  }
}
    `;
export type SendSchedulingInviteMutationFn = Apollo.MutationFunction<SendSchedulingInviteMutation, SendSchedulingInviteMutationVariables>;

/**
 * __useSendSchedulingInviteMutation__
 *
 * To run a mutation, you first call `useSendSchedulingInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSchedulingInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSchedulingInviteMutation, { data, loading, error }] = useSendSchedulingInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendSchedulingInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendSchedulingInviteMutation, SendSchedulingInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSchedulingInviteMutation, SendSchedulingInviteMutationVariables>(SendSchedulingInviteDocument, options);
      }
export type SendSchedulingInviteMutationHookResult = ReturnType<typeof useSendSchedulingInviteMutation>;
export type SendSchedulingInviteMutationResult = Apollo.MutationResult<SendSchedulingInviteMutation>;
export type SendSchedulingInviteMutationOptions = Apollo.BaseMutationOptions<SendSchedulingInviteMutation, SendSchedulingInviteMutationVariables>;
export const SetupOrganisationDocument = gql`
    mutation setupOrganisation($input: SetupOrganisationInput!) {
  setupOrganisation(input: $input) {
    id
    name
    primary_address {
      ...FullAddress
    }
    general_email
    primary_phone
    users {
      id
    }
  }
}
    ${FullAddressFragmentDoc}`;
export type SetupOrganisationMutationFn = Apollo.MutationFunction<SetupOrganisationMutation, SetupOrganisationMutationVariables>;

/**
 * __useSetupOrganisationMutation__
 *
 * To run a mutation, you first call `useSetupOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupOrganisationMutation, { data, loading, error }] = useSetupOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<SetupOrganisationMutation, SetupOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupOrganisationMutation, SetupOrganisationMutationVariables>(SetupOrganisationDocument, options);
      }
export type SetupOrganisationMutationHookResult = ReturnType<typeof useSetupOrganisationMutation>;
export type SetupOrganisationMutationResult = Apollo.MutationResult<SetupOrganisationMutation>;
export type SetupOrganisationMutationOptions = Apollo.BaseMutationOptions<SetupOrganisationMutation, SetupOrganisationMutationVariables>;
export const SetupUserDocument = gql`
    mutation setupUser($input: UserInput!) {
  setupUser(input: $input) {
    id
    organisation_id
    first_name
    last_name
    primary_role_id
    role_name
    status
    email_address
    phone_number
    group_ids
  }
}
    `;
export type SetupUserMutationFn = Apollo.MutationFunction<SetupUserMutation, SetupUserMutationVariables>;

/**
 * __useSetupUserMutation__
 *
 * To run a mutation, you first call `useSetupUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupUserMutation, { data, loading, error }] = useSetupUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetupUserMutation(baseOptions?: Apollo.MutationHookOptions<SetupUserMutation, SetupUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupUserMutation, SetupUserMutationVariables>(SetupUserDocument, options);
      }
export type SetupUserMutationHookResult = ReturnType<typeof useSetupUserMutation>;
export type SetupUserMutationResult = Apollo.MutationResult<SetupUserMutation>;
export type SetupUserMutationOptions = Apollo.BaseMutationOptions<SetupUserMutation, SetupUserMutationVariables>;
export const SourceMortgagesDocument = gql`
    mutation sourceMortgages($input: MortgageSourcingInput!) {
  sourceMortgages(input: $input) {
    serialised_data
    generated_at
    generated_for
    signature
    products {
      id
      ...MortgageProductDetails
    }
  }
}
    ${MortgageProductDetailsFragmentDoc}`;
export type SourceMortgagesMutationFn = Apollo.MutationFunction<SourceMortgagesMutation, SourceMortgagesMutationVariables>;

/**
 * __useSourceMortgagesMutation__
 *
 * To run a mutation, you first call `useSourceMortgagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSourceMortgagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sourceMortgagesMutation, { data, loading, error }] = useSourceMortgagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSourceMortgagesMutation(baseOptions?: Apollo.MutationHookOptions<SourceMortgagesMutation, SourceMortgagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SourceMortgagesMutation, SourceMortgagesMutationVariables>(SourceMortgagesDocument, options);
      }
export type SourceMortgagesMutationHookResult = ReturnType<typeof useSourceMortgagesMutation>;
export type SourceMortgagesMutationResult = Apollo.MutationResult<SourceMortgagesMutation>;
export type SourceMortgagesMutationOptions = Apollo.BaseMutationOptions<SourceMortgagesMutation, SourceMortgagesMutationVariables>;
export const SubmitDipDocument = gql`
    mutation submitDip($payloadInput: DipInput!, $queryInput: SubmitDipInput) {
  submitDip(payloadInput: $payloadInput, queryInput: $queryInput) {
    approved_amount
    id
    lender
    provider
    provider_id
    reason
    status
    available_next_steps
    details {
      decisionExpiryDate
      overallDecision
      reprocessInd
      decisionDetails {
        ...dipDetailsFragment
      }
      decisions {
        provider
        resultType
        errorMessages {
          name
          result
        }
      }
    }
  }
}
    ${DipDetailsFragmentFragmentDoc}`;
export type SubmitDipMutationFn = Apollo.MutationFunction<SubmitDipMutation, SubmitDipMutationVariables>;

/**
 * __useSubmitDipMutation__
 *
 * To run a mutation, you first call `useSubmitDipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDipMutation, { data, loading, error }] = useSubmitDipMutation({
 *   variables: {
 *      payloadInput: // value for 'payloadInput'
 *      queryInput: // value for 'queryInput'
 *   },
 * });
 */
export function useSubmitDipMutation(baseOptions?: Apollo.MutationHookOptions<SubmitDipMutation, SubmitDipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitDipMutation, SubmitDipMutationVariables>(SubmitDipDocument, options);
      }
export type SubmitDipMutationHookResult = ReturnType<typeof useSubmitDipMutation>;
export type SubmitDipMutationResult = Apollo.MutationResult<SubmitDipMutation>;
export type SubmitDipMutationOptions = Apollo.BaseMutationOptions<SubmitDipMutation, SubmitDipMutationVariables>;
export const GetDipCertDocument = gql`
    mutation getDipCert($id: ID!, $mortgageId: ID, $case: ID!) {
  getDipCert(id: $id, mortgageId: $mortgageId, case: $case)
}
    `;
export type GetDipCertMutationFn = Apollo.MutationFunction<GetDipCertMutation, GetDipCertMutationVariables>;

/**
 * __useGetDipCertMutation__
 *
 * To run a mutation, you first call `useGetDipCertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetDipCertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getDipCertMutation, { data, loading, error }] = useGetDipCertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mortgageId: // value for 'mortgageId'
 *      case: // value for 'case'
 *   },
 * });
 */
export function useGetDipCertMutation(baseOptions?: Apollo.MutationHookOptions<GetDipCertMutation, GetDipCertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetDipCertMutation, GetDipCertMutationVariables>(GetDipCertDocument, options);
      }
export type GetDipCertMutationHookResult = ReturnType<typeof useGetDipCertMutation>;
export type GetDipCertMutationResult = Apollo.MutationResult<GetDipCertMutation>;
export type GetDipCertMutationOptions = Apollo.BaseMutationOptions<GetDipCertMutation, GetDipCertMutationVariables>;
export const GetDipDocumentDocument = gql`
    mutation getDipDocument($id: ID!, $mortgageId: ID, $case: ID!, $docType: DipDocumentType) {
  getDipDocument(
    id: $id
    mortgageId: $mortgageId
    case: $case
    documentType: $docType
  )
}
    `;
export type GetDipDocumentMutationFn = Apollo.MutationFunction<GetDipDocumentMutation, GetDipDocumentMutationVariables>;

/**
 * __useGetDipDocumentMutation__
 *
 * To run a mutation, you first call `useGetDipDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetDipDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getDipDocumentMutation, { data, loading, error }] = useGetDipDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      mortgageId: // value for 'mortgageId'
 *      case: // value for 'case'
 *      docType: // value for 'docType'
 *   },
 * });
 */
export function useGetDipDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GetDipDocumentMutation, GetDipDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetDipDocumentMutation, GetDipDocumentMutationVariables>(GetDipDocumentDocument, options);
      }
export type GetDipDocumentMutationHookResult = ReturnType<typeof useGetDipDocumentMutation>;
export type GetDipDocumentMutationResult = Apollo.MutationResult<GetDipDocumentMutation>;
export type GetDipDocumentMutationOptions = Apollo.BaseMutationOptions<GetDipDocumentMutation, GetDipDocumentMutationVariables>;
export const DoFmaDocument = gql`
    mutation doFMA($input: FMAInput!) {
  doFMA(input: $input) {
    __typename
    ... on ApplicationResponse {
      id
      approved_amount
      lender
      link
      product_code
      provider
      provider_id
      requirements {
        id
        client
        name
      }
      status
      warnings
    }
    ... on DipApplicationError {
      status
      lender
      errors {
        field
        message
      }
    }
  }
}
    `;
export type DoFmaMutationFn = Apollo.MutationFunction<DoFmaMutation, DoFmaMutationVariables>;

/**
 * __useDoFmaMutation__
 *
 * To run a mutation, you first call `useDoFmaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoFmaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doFmaMutation, { data, loading, error }] = useDoFmaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoFmaMutation(baseOptions?: Apollo.MutationHookOptions<DoFmaMutation, DoFmaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoFmaMutation, DoFmaMutationVariables>(DoFmaDocument, options);
      }
export type DoFmaMutationHookResult = ReturnType<typeof useDoFmaMutation>;
export type DoFmaMutationResult = Apollo.MutationResult<DoFmaMutation>;
export type DoFmaMutationOptions = Apollo.BaseMutationOptions<DoFmaMutation, DoFmaMutationVariables>;
export const SubmitKbaQuestionnaireDocument = gql`
    mutation submitKbaQuestionnaire($userId: ID!, $input: KbaInput!, $useClientApi: Boolean) {
  submitKbaQuestionnaire(
    userId: $userId
    input: $input
    useClientApi: $useClientApi
  ) {
    attempts_remaining
    decision
    second_questionnaire {
      questions {
        id
        text
        header
        choices {
          id
          text
        }
      }
      attempt_id
    }
  }
}
    `;
export type SubmitKbaQuestionnaireMutationFn = Apollo.MutationFunction<SubmitKbaQuestionnaireMutation, SubmitKbaQuestionnaireMutationVariables>;

/**
 * __useSubmitKbaQuestionnaireMutation__
 *
 * To run a mutation, you first call `useSubmitKbaQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitKbaQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitKbaQuestionnaireMutation, { data, loading, error }] = useSubmitKbaQuestionnaireMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useSubmitKbaQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<SubmitKbaQuestionnaireMutation, SubmitKbaQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitKbaQuestionnaireMutation, SubmitKbaQuestionnaireMutationVariables>(SubmitKbaQuestionnaireDocument, options);
      }
export type SubmitKbaQuestionnaireMutationHookResult = ReturnType<typeof useSubmitKbaQuestionnaireMutation>;
export type SubmitKbaQuestionnaireMutationResult = Apollo.MutationResult<SubmitKbaQuestionnaireMutation>;
export type SubmitKbaQuestionnaireMutationOptions = Apollo.BaseMutationOptions<SubmitKbaQuestionnaireMutation, SubmitKbaQuestionnaireMutationVariables>;
export const SubmitLbgDipDocument = gql`
    mutation submitLBGDip($payloadInput: DipInput!, $queryInput: LBGDipInput!) {
  submitLBGDip(payloadInput: $payloadInput, queryInput: $queryInput) {
    id
    approved_amount
    link
    lender
    provider
    provider_id
    status
    available_next_steps
    details {
      applicants {
        applicantNumber
        manualVerificationRequiredAtFma
      }
      decision
      information {
        description
      }
      mortgageId
    }
  }
}
    `;
export type SubmitLbgDipMutationFn = Apollo.MutationFunction<SubmitLbgDipMutation, SubmitLbgDipMutationVariables>;

/**
 * __useSubmitLbgDipMutation__
 *
 * To run a mutation, you first call `useSubmitLbgDipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitLbgDipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitLbgDipMutation, { data, loading, error }] = useSubmitLbgDipMutation({
 *   variables: {
 *      payloadInput: // value for 'payloadInput'
 *      queryInput: // value for 'queryInput'
 *   },
 * });
 */
export function useSubmitLbgDipMutation(baseOptions?: Apollo.MutationHookOptions<SubmitLbgDipMutation, SubmitLbgDipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitLbgDipMutation, SubmitLbgDipMutationVariables>(SubmitLbgDipDocument, options);
      }
export type SubmitLbgDipMutationHookResult = ReturnType<typeof useSubmitLbgDipMutation>;
export type SubmitLbgDipMutationResult = Apollo.MutationResult<SubmitLbgDipMutation>;
export type SubmitLbgDipMutationOptions = Apollo.BaseMutationOptions<SubmitLbgDipMutation, SubmitLbgDipMutationVariables>;
export const SubmitNoPropertyDipDocument = gql`
    mutation submitNoPropertyDip($payloadInput: NoPropertyDipInput!, $queryInput: SubmitDipInput) {
  submitNoPropertyDip(payloadInput: $payloadInput, queryInput: $queryInput) {
    approved_amount
    id
    lender
    provider
    provider_id
    reason
    status
    details {
      decisionExpiryDate
      overallDecision
      reprocessInd
      decisionDetails {
        ...dipDetailsFragment
      }
    }
  }
}
    ${DipDetailsFragmentFragmentDoc}`;
export type SubmitNoPropertyDipMutationFn = Apollo.MutationFunction<SubmitNoPropertyDipMutation, SubmitNoPropertyDipMutationVariables>;

/**
 * __useSubmitNoPropertyDipMutation__
 *
 * To run a mutation, you first call `useSubmitNoPropertyDipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitNoPropertyDipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitNoPropertyDipMutation, { data, loading, error }] = useSubmitNoPropertyDipMutation({
 *   variables: {
 *      payloadInput: // value for 'payloadInput'
 *      queryInput: // value for 'queryInput'
 *   },
 * });
 */
export function useSubmitNoPropertyDipMutation(baseOptions?: Apollo.MutationHookOptions<SubmitNoPropertyDipMutation, SubmitNoPropertyDipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitNoPropertyDipMutation, SubmitNoPropertyDipMutationVariables>(SubmitNoPropertyDipDocument, options);
      }
export type SubmitNoPropertyDipMutationHookResult = ReturnType<typeof useSubmitNoPropertyDipMutation>;
export type SubmitNoPropertyDipMutationResult = Apollo.MutationResult<SubmitNoPropertyDipMutation>;
export type SubmitNoPropertyDipMutationOptions = Apollo.BaseMutationOptions<SubmitNoPropertyDipMutation, SubmitNoPropertyDipMutationVariables>;
export const SyncProtectionDocumentsDocument = gql`
    mutation syncProtectionDocuments($input: SyncProtectionDocumentsInput!) {
  syncProtectionDocuments(input: $input) {
    protection_id
    version
    details {
      documents {
        application_doc_id
        key_facts_doc_id
        illustration_doc_id
        policy_letter_doc_id
        comparison_report_doc_id
        commission_comparison_report_doc_id
      }
    }
  }
}
    `;
export type SyncProtectionDocumentsMutationFn = Apollo.MutationFunction<SyncProtectionDocumentsMutation, SyncProtectionDocumentsMutationVariables>;

/**
 * __useSyncProtectionDocumentsMutation__
 *
 * To run a mutation, you first call `useSyncProtectionDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncProtectionDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncProtectionDocumentsMutation, { data, loading, error }] = useSyncProtectionDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncProtectionDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<SyncProtectionDocumentsMutation, SyncProtectionDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncProtectionDocumentsMutation, SyncProtectionDocumentsMutationVariables>(SyncProtectionDocumentsDocument, options);
      }
export type SyncProtectionDocumentsMutationHookResult = ReturnType<typeof useSyncProtectionDocumentsMutation>;
export type SyncProtectionDocumentsMutationResult = Apollo.MutationResult<SyncProtectionDocumentsMutation>;
export type SyncProtectionDocumentsMutationOptions = Apollo.BaseMutationOptions<SyncProtectionDocumentsMutation, SyncProtectionDocumentsMutationVariables>;
export const SyncProtectionDocumentsV2Document = gql`
    mutation syncProtectionDocumentsV2($input: SyncProtectionDocumentsInput!) {
  syncProtectionDocumentsV2(input: $input) {
    protection_id
    version
    details {
      documents {
        application_doc_id
        key_facts_doc_id
        illustration_doc_id
        policy_letter_doc_id
        comparison_report_doc_id
        commission_comparison_report_doc_id
      }
    }
  }
}
    `;
export type SyncProtectionDocumentsV2MutationFn = Apollo.MutationFunction<SyncProtectionDocumentsV2Mutation, SyncProtectionDocumentsV2MutationVariables>;

/**
 * __useSyncProtectionDocumentsV2Mutation__
 *
 * To run a mutation, you first call `useSyncProtectionDocumentsV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncProtectionDocumentsV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncProtectionDocumentsV2Mutation, { data, loading, error }] = useSyncProtectionDocumentsV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncProtectionDocumentsV2Mutation(baseOptions?: Apollo.MutationHookOptions<SyncProtectionDocumentsV2Mutation, SyncProtectionDocumentsV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncProtectionDocumentsV2Mutation, SyncProtectionDocumentsV2MutationVariables>(SyncProtectionDocumentsV2Document, options);
      }
export type SyncProtectionDocumentsV2MutationHookResult = ReturnType<typeof useSyncProtectionDocumentsV2Mutation>;
export type SyncProtectionDocumentsV2MutationResult = Apollo.MutationResult<SyncProtectionDocumentsV2Mutation>;
export type SyncProtectionDocumentsV2MutationOptions = Apollo.BaseMutationOptions<SyncProtectionDocumentsV2Mutation, SyncProtectionDocumentsV2MutationVariables>;
export const UpdateCaseDocument = gql`
    mutation updateCase($id: ID!, $input: CaseInput!, $includeCaseDetailsInProperty: Boolean = true) {
  updateCase(id: $id, input: $input) {
    ...CaseVersionDetails
  }
}
    ${CaseVersionDetailsFragmentDoc}`;
export type UpdateCaseMutationFn = Apollo.MutationFunction<UpdateCaseMutation, UpdateCaseMutationVariables>;

/**
 * __useUpdateCaseMutation__
 *
 * To run a mutation, you first call `useUpdateCaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseMutation, { data, loading, error }] = useUpdateCaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useUpdateCaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseMutation, UpdateCaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseMutation, UpdateCaseMutationVariables>(UpdateCaseDocument, options);
      }
export type UpdateCaseMutationHookResult = ReturnType<typeof useUpdateCaseMutation>;
export type UpdateCaseMutationResult = Apollo.MutationResult<UpdateCaseMutation>;
export type UpdateCaseMutationOptions = Apollo.BaseMutationOptions<UpdateCaseMutation, UpdateCaseMutationVariables>;
export const UpdateCaseAndAddNoteDocument = gql`
    mutation updateCaseAndAddNote($id: ID!, $noteInput: NoteInput, $isIntroducerCase: Boolean, $useClientApi: Boolean, $includeClientNames: Boolean = true, $caseInput: CaseInput!, $includeCaseDetailsInProperty: Boolean = true) {
  updateCaseAndAddNote(
    id: $id
    noteInput: $noteInput
    caseInput: $caseInput
    isIntroducerCase: $isIntroducerCase
    useClientApi: $useClientApi
    includeCaseDetailsInProperty: $includeCaseDetailsInProperty
  ) {
    case {
      ...CaseVersionDetails
    }
    note {
      note_id
      created_at
      modified_at
      title
      priority
      status
      body
      primary_type
      deadline
      assignee_id
      case_id
      client_id
      property_id
      mortgage_id
      verification_id
      organisation_ids
      created_by
      template_id
    }
  }
}
    ${CaseVersionDetailsFragmentDoc}`;
export type UpdateCaseAndAddNoteMutationFn = Apollo.MutationFunction<UpdateCaseAndAddNoteMutation, UpdateCaseAndAddNoteMutationVariables>;

/**
 * __useUpdateCaseAndAddNoteMutation__
 *
 * To run a mutation, you first call `useUpdateCaseAndAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseAndAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseAndAddNoteMutation, { data, loading, error }] = useUpdateCaseAndAddNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      noteInput: // value for 'noteInput'
 *      isIntroducerCase: // value for 'isIntroducerCase'
 *      useClientApi: // value for 'useClientApi'
 *      includeClientNames: // value for 'includeClientNames'
 *      caseInput: // value for 'caseInput'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useUpdateCaseAndAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseAndAddNoteMutation, UpdateCaseAndAddNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseAndAddNoteMutation, UpdateCaseAndAddNoteMutationVariables>(UpdateCaseAndAddNoteDocument, options);
      }
export type UpdateCaseAndAddNoteMutationHookResult = ReturnType<typeof useUpdateCaseAndAddNoteMutation>;
export type UpdateCaseAndAddNoteMutationResult = Apollo.MutationResult<UpdateCaseAndAddNoteMutation>;
export type UpdateCaseAndAddNoteMutationOptions = Apollo.BaseMutationOptions<UpdateCaseAndAddNoteMutation, UpdateCaseAndAddNoteMutationVariables>;
export const UpdateCaseAssigneesDocument = gql`
    mutation updateCaseAssignees($input: CaseAssigneesInput!) {
  updateCaseAssignees(input: $input) {
    cases {
      case_id
      owner_user_id
      related_users {
        id
        user_id
        relationship_type
        commission_share_basis_points
      }
    }
  }
}
    `;
export type UpdateCaseAssigneesMutationFn = Apollo.MutationFunction<UpdateCaseAssigneesMutation, UpdateCaseAssigneesMutationVariables>;

/**
 * __useUpdateCaseAssigneesMutation__
 *
 * To run a mutation, you first call `useUpdateCaseAssigneesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseAssigneesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseAssigneesMutation, { data, loading, error }] = useUpdateCaseAssigneesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseAssigneesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseAssigneesMutation, UpdateCaseAssigneesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseAssigneesMutation, UpdateCaseAssigneesMutationVariables>(UpdateCaseAssigneesDocument, options);
      }
export type UpdateCaseAssigneesMutationHookResult = ReturnType<typeof useUpdateCaseAssigneesMutation>;
export type UpdateCaseAssigneesMutationResult = Apollo.MutationResult<UpdateCaseAssigneesMutation>;
export type UpdateCaseAssigneesMutationOptions = Apollo.BaseMutationOptions<UpdateCaseAssigneesMutation, UpdateCaseAssigneesMutationVariables>;
export const UpdateCaseFeesDocument = gql`
    mutation updateCaseFees($id: ID!, $input: UpdateCaseFeeInput!) {
  updateCaseFees(id: $id, input: $input) {
    ...CaseMortgageFees
  }
}
    ${CaseMortgageFeesFragmentDoc}`;
export type UpdateCaseFeesMutationFn = Apollo.MutationFunction<UpdateCaseFeesMutation, UpdateCaseFeesMutationVariables>;

/**
 * __useUpdateCaseFeesMutation__
 *
 * To run a mutation, you first call `useUpdateCaseFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseFeesMutation, { data, loading, error }] = useUpdateCaseFeesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseFeesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseFeesMutation, UpdateCaseFeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseFeesMutation, UpdateCaseFeesMutationVariables>(UpdateCaseFeesDocument, options);
      }
export type UpdateCaseFeesMutationHookResult = ReturnType<typeof useUpdateCaseFeesMutation>;
export type UpdateCaseFeesMutationResult = Apollo.MutationResult<UpdateCaseFeesMutation>;
export type UpdateCaseFeesMutationOptions = Apollo.BaseMutationOptions<UpdateCaseFeesMutation, UpdateCaseFeesMutationVariables>;
export const UpdateCaseRequirementsDocument = gql`
    mutation updateCaseRequirements($id: ID!, $input: CaseRequirementsInput!) {
  updateCaseRequirements(id: $id, input: $input) {
    ...CaseRequirements
  }
}
    ${CaseRequirementsFragmentDoc}`;
export type UpdateCaseRequirementsMutationFn = Apollo.MutationFunction<UpdateCaseRequirementsMutation, UpdateCaseRequirementsMutationVariables>;

/**
 * __useUpdateCaseRequirementsMutation__
 *
 * To run a mutation, you first call `useUpdateCaseRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseRequirementsMutation, { data, loading, error }] = useUpdateCaseRequirementsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseRequirementsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseRequirementsMutation, UpdateCaseRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseRequirementsMutation, UpdateCaseRequirementsMutationVariables>(UpdateCaseRequirementsDocument, options);
      }
export type UpdateCaseRequirementsMutationHookResult = ReturnType<typeof useUpdateCaseRequirementsMutation>;
export type UpdateCaseRequirementsMutationResult = Apollo.MutationResult<UpdateCaseRequirementsMutation>;
export type UpdateCaseRequirementsMutationOptions = Apollo.BaseMutationOptions<UpdateCaseRequirementsMutation, UpdateCaseRequirementsMutationVariables>;
export const UpdateCaseStatusDocument = gql`
    mutation updateCaseStatus($id: ID!, $input: CaseUpdateStatusInput!) {
  updateCaseStatus(id: $id, input: $input) {
    verification_collections {
      collection_id
    }
    documents {
      ...DocumentDetails
    }
    case {
      id
      version
      details {
        id
        ...CaseTransitionVersions
        status
        transition_mortgage_versions {
          entity_versions {
            mortgage_id
          }
          transition_to
          created_at
        }
      }
    }
  }
}
    ${DocumentDetailsFragmentDoc}
${CaseTransitionVersionsFragmentDoc}`;
export type UpdateCaseStatusMutationFn = Apollo.MutationFunction<UpdateCaseStatusMutation, UpdateCaseStatusMutationVariables>;

/**
 * __useUpdateCaseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCaseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseStatusMutation, { data, loading, error }] = useUpdateCaseStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseStatusMutation, UpdateCaseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseStatusMutation, UpdateCaseStatusMutationVariables>(UpdateCaseStatusDocument, options);
      }
export type UpdateCaseStatusMutationHookResult = ReturnType<typeof useUpdateCaseStatusMutation>;
export type UpdateCaseStatusMutationResult = Apollo.MutationResult<UpdateCaseStatusMutation>;
export type UpdateCaseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCaseStatusMutation, UpdateCaseStatusMutationVariables>;
export const UpdateCaseSuitabilityDocument = gql`
    mutation updateCaseSuitability($id: ID!, $input: CaseSuitabilityInput!, $includeCaseDetailsInProperty: Boolean = true) {
  updateCaseSuitability(id: $id, input: $input) {
    ...CaseVersionDetails
  }
}
    ${CaseVersionDetailsFragmentDoc}`;
export type UpdateCaseSuitabilityMutationFn = Apollo.MutationFunction<UpdateCaseSuitabilityMutation, UpdateCaseSuitabilityMutationVariables>;

/**
 * __useUpdateCaseSuitabilityMutation__
 *
 * To run a mutation, you first call `useUpdateCaseSuitabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseSuitabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseSuitabilityMutation, { data, loading, error }] = useUpdateCaseSuitabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useUpdateCaseSuitabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseSuitabilityMutation, UpdateCaseSuitabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseSuitabilityMutation, UpdateCaseSuitabilityMutationVariables>(UpdateCaseSuitabilityDocument, options);
      }
export type UpdateCaseSuitabilityMutationHookResult = ReturnType<typeof useUpdateCaseSuitabilityMutation>;
export type UpdateCaseSuitabilityMutationResult = Apollo.MutationResult<UpdateCaseSuitabilityMutation>;
export type UpdateCaseSuitabilityMutationOptions = Apollo.BaseMutationOptions<UpdateCaseSuitabilityMutation, UpdateCaseSuitabilityMutationVariables>;
export const UpdateClientDocument = gql`
    mutation updateClient($id: ID!, $input: ClientInput!) {
  updateClient(id: $id, input: $input) {
    id
    version
    details {
      ...ClientDetails
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateClientAccountsDocument = gql`
    mutation updateClientAccounts($id: ID!, $input: [ClientBankAccountInput!]!) {
  updateClientAccounts(id: $id, input: $input) {
    id
    version
    details {
      id
      accounts {
        id
        internalHash
        type
        sort_code
        number
        number_of_months_held
      }
    }
  }
}
    `;
export type UpdateClientAccountsMutationFn = Apollo.MutationFunction<UpdateClientAccountsMutation, UpdateClientAccountsMutationVariables>;

/**
 * __useUpdateClientAccountsMutation__
 *
 * To run a mutation, you first call `useUpdateClientAccountsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientAccountsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientAccountsMutation, { data, loading, error }] = useUpdateClientAccountsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientAccountsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientAccountsMutation, UpdateClientAccountsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientAccountsMutation, UpdateClientAccountsMutationVariables>(UpdateClientAccountsDocument, options);
      }
export type UpdateClientAccountsMutationHookResult = ReturnType<typeof useUpdateClientAccountsMutation>;
export type UpdateClientAccountsMutationResult = Apollo.MutationResult<UpdateClientAccountsMutation>;
export type UpdateClientAccountsMutationOptions = Apollo.BaseMutationOptions<UpdateClientAccountsMutation, UpdateClientAccountsMutationVariables>;
export const UpdateClientAddressesDocument = gql`
    mutation updateClientAddresses($id: ID!, $input: [ClientAddressInput!]!, $client_ids: [String!], $property_id: String, $useClientApi: Boolean) {
  updateClientAddresses(
    id: $id
    input: $input
    client_ids: $client_ids
    property_id: $property_id
    useClientApi: $useClientApi
  ) {
    id
    version
    details {
      id
      addresses {
        id
        internalHash
        address {
          ...FullAddress
        }
        is_current_correspondence
        residential_status
        move_in_date
        move_out_date
        documents
        document_verifies
      }
    }
  }
}
    ${FullAddressFragmentDoc}`;
export type UpdateClientAddressesMutationFn = Apollo.MutationFunction<UpdateClientAddressesMutation, UpdateClientAddressesMutationVariables>;

/**
 * __useUpdateClientAddressesMutation__
 *
 * To run a mutation, you first call `useUpdateClientAddressesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientAddressesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientAddressesMutation, { data, loading, error }] = useUpdateClientAddressesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      client_ids: // value for 'client_ids'
 *      property_id: // value for 'property_id'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useUpdateClientAddressesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientAddressesMutation, UpdateClientAddressesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientAddressesMutation, UpdateClientAddressesMutationVariables>(UpdateClientAddressesDocument, options);
      }
export type UpdateClientAddressesMutationHookResult = ReturnType<typeof useUpdateClientAddressesMutation>;
export type UpdateClientAddressesMutationResult = Apollo.MutationResult<UpdateClientAddressesMutation>;
export type UpdateClientAddressesMutationOptions = Apollo.BaseMutationOptions<UpdateClientAddressesMutation, UpdateClientAddressesMutationVariables>;
export const UpdateClientArrearsDocument = gql`
    mutation updateClientArrears($id: ID!, $input: ClientInput!) {
  updateClientArrears(id: $id, input: $input) {
    id
    version
    details {
      id
      credit_history_arrears {
        has_cleared
        amount
        max_number_of_monthly_payments_in_arrears
        type_of_credit
        creditor_name
        date_of_arrear
        date_cleared
      }
    }
  }
}
    `;
export type UpdateClientArrearsMutationFn = Apollo.MutationFunction<UpdateClientArrearsMutation, UpdateClientArrearsMutationVariables>;

/**
 * __useUpdateClientArrearsMutation__
 *
 * To run a mutation, you first call `useUpdateClientArrearsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientArrearsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientArrearsMutation, { data, loading, error }] = useUpdateClientArrearsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientArrearsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientArrearsMutation, UpdateClientArrearsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientArrearsMutation, UpdateClientArrearsMutationVariables>(UpdateClientArrearsDocument, options);
      }
export type UpdateClientArrearsMutationHookResult = ReturnType<typeof useUpdateClientArrearsMutation>;
export type UpdateClientArrearsMutationResult = Apollo.MutationResult<UpdateClientArrearsMutation>;
export type UpdateClientArrearsMutationOptions = Apollo.BaseMutationOptions<UpdateClientArrearsMutation, UpdateClientArrearsMutationVariables>;
export const UpdateClientBankruptcyEventsDocument = gql`
    mutation updateClientBankruptcyEvents($id: ID!, $input: ClientInput!) {
  updateClientBankruptcyEvents(id: $id, input: $input) {
    id
    version
    details {
      id
      credit_history_bankruptcy_events {
        id
        internalHash
        bankruptcy_date
        discharge_date
        court
      }
    }
  }
}
    `;
export type UpdateClientBankruptcyEventsMutationFn = Apollo.MutationFunction<UpdateClientBankruptcyEventsMutation, UpdateClientBankruptcyEventsMutationVariables>;

/**
 * __useUpdateClientBankruptcyEventsMutation__
 *
 * To run a mutation, you first call `useUpdateClientBankruptcyEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientBankruptcyEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientBankruptcyEventsMutation, { data, loading, error }] = useUpdateClientBankruptcyEventsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientBankruptcyEventsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientBankruptcyEventsMutation, UpdateClientBankruptcyEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientBankruptcyEventsMutation, UpdateClientBankruptcyEventsMutationVariables>(UpdateClientBankruptcyEventsDocument, options);
      }
export type UpdateClientBankruptcyEventsMutationHookResult = ReturnType<typeof useUpdateClientBankruptcyEventsMutation>;
export type UpdateClientBankruptcyEventsMutationResult = Apollo.MutationResult<UpdateClientBankruptcyEventsMutation>;
export type UpdateClientBankruptcyEventsMutationOptions = Apollo.BaseMutationOptions<UpdateClientBankruptcyEventsMutation, UpdateClientBankruptcyEventsMutationVariables>;
export const UpdateClientCcjsDocument = gql`
    mutation updateClientCcjs($id: ID!, $input: ClientInput!) {
  updateClientCcjs(id: $id, input: $input) {
    id
    version
    details {
      id
      credit_history_county_court_judgements {
        id
        internalHash
        date_registered
        date_satisfied
        amount
        creditor_name
      }
    }
  }
}
    `;
export type UpdateClientCcjsMutationFn = Apollo.MutationFunction<UpdateClientCcjsMutation, UpdateClientCcjsMutationVariables>;

/**
 * __useUpdateClientCcjsMutation__
 *
 * To run a mutation, you first call `useUpdateClientCcjsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCcjsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCcjsMutation, { data, loading, error }] = useUpdateClientCcjsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientCcjsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCcjsMutation, UpdateClientCcjsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCcjsMutation, UpdateClientCcjsMutationVariables>(UpdateClientCcjsDocument, options);
      }
export type UpdateClientCcjsMutationHookResult = ReturnType<typeof useUpdateClientCcjsMutation>;
export type UpdateClientCcjsMutationResult = Apollo.MutationResult<UpdateClientCcjsMutation>;
export type UpdateClientCcjsMutationOptions = Apollo.BaseMutationOptions<UpdateClientCcjsMutation, UpdateClientCcjsMutationVariables>;
export const UpdateClientCreditRefusalsDocument = gql`
    mutation updateClientCreditRefusals($id: ID!, $input: ClientInput!) {
  updateClientCreditRefusals(id: $id, input: $input) {
    id
    version
    details {
      id
      mortgage_application_refused {
        id
        internalHash
        application_refused_date
        application_refused_creditor
        application_refused_type
        application_refused_details
      }
    }
  }
}
    `;
export type UpdateClientCreditRefusalsMutationFn = Apollo.MutationFunction<UpdateClientCreditRefusalsMutation, UpdateClientCreditRefusalsMutationVariables>;

/**
 * __useUpdateClientCreditRefusalsMutation__
 *
 * To run a mutation, you first call `useUpdateClientCreditRefusalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCreditRefusalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCreditRefusalsMutation, { data, loading, error }] = useUpdateClientCreditRefusalsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientCreditRefusalsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCreditRefusalsMutation, UpdateClientCreditRefusalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCreditRefusalsMutation, UpdateClientCreditRefusalsMutationVariables>(UpdateClientCreditRefusalsDocument, options);
      }
export type UpdateClientCreditRefusalsMutationHookResult = ReturnType<typeof useUpdateClientCreditRefusalsMutation>;
export type UpdateClientCreditRefusalsMutationResult = Apollo.MutationResult<UpdateClientCreditRefusalsMutation>;
export type UpdateClientCreditRefusalsMutationOptions = Apollo.BaseMutationOptions<UpdateClientCreditRefusalsMutation, UpdateClientCreditRefusalsMutationVariables>;
export const UpdateClientDebtManagementPlansDocument = gql`
    mutation updateClientDebtManagementPlans($id: ID!, $input: ClientInput!) {
  updateClientDebtManagementPlans(id: $id, input: $input) {
    id
    version
    details {
      id
      credit_history_debt_management_plans {
        id
        internalHash
        date_registered
        date_completed
        monthly_payment_amount
        satisfactory_conduct
      }
    }
  }
}
    `;
export type UpdateClientDebtManagementPlansMutationFn = Apollo.MutationFunction<UpdateClientDebtManagementPlansMutation, UpdateClientDebtManagementPlansMutationVariables>;

/**
 * __useUpdateClientDebtManagementPlansMutation__
 *
 * To run a mutation, you first call `useUpdateClientDebtManagementPlansMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientDebtManagementPlansMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientDebtManagementPlansMutation, { data, loading, error }] = useUpdateClientDebtManagementPlansMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientDebtManagementPlansMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientDebtManagementPlansMutation, UpdateClientDebtManagementPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientDebtManagementPlansMutation, UpdateClientDebtManagementPlansMutationVariables>(UpdateClientDebtManagementPlansDocument, options);
      }
export type UpdateClientDebtManagementPlansMutationHookResult = ReturnType<typeof useUpdateClientDebtManagementPlansMutation>;
export type UpdateClientDebtManagementPlansMutationResult = Apollo.MutationResult<UpdateClientDebtManagementPlansMutation>;
export type UpdateClientDebtManagementPlansMutationOptions = Apollo.BaseMutationOptions<UpdateClientDebtManagementPlansMutation, UpdateClientDebtManagementPlansMutationVariables>;
export const UpdateClientDebtsDocument = gql`
    mutation updateClientDebts($id: ID!, $input: [DebtInput!]!) {
  updateClientDebts(id: $id, input: $input) {
    id
    version
    details {
      id
      debts {
        id
        internalHash
        term_in_months
        repayment_frequency
        payment_status_summary
        account_status
        commitment_type
        borrower_type
        amount_outstanding
        monthly_repayment_amount
        name_of_creditor
        final_repayment_date
        repaid_before_mortgage_commences
        to_be_consolidated
        credit_limit
        additional_details
        repaid_each_month
        interest_rate
        reference_account_no
        repayment_amount
        start_date
        end_date
        last_update_date
        default_event {
          date_registered
          date_satisfied
          balance
        }
        arrears_summary {
          max_arrears_currency
          max_arrears_months
          last_arrears_date
          arrears_cleared_date
        }
        payment_history {
          age_in_months
          date
          balance
          payment
          payment_status
        }
        joint_applicant {
          client_id
          debt_id
        }
        equifax_account_number
        equifax_promotional_rate_ind
        revert_rate
        revert_date
        estimated_interest_rates
        early_repayment_percentage
        early_repayment_amount
        average_monthly_repayment_amount
        amount_to_consolidate
        calculated_values {
          months_to_repay
          total_interest
          end_date_discrepancy
          months_to_repay_partial
          average_monthly_repayment_amount
        }
      }
    }
  }
}
    `;
export type UpdateClientDebtsMutationFn = Apollo.MutationFunction<UpdateClientDebtsMutation, UpdateClientDebtsMutationVariables>;

/**
 * __useUpdateClientDebtsMutation__
 *
 * To run a mutation, you first call `useUpdateClientDebtsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientDebtsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientDebtsMutation, { data, loading, error }] = useUpdateClientDebtsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientDebtsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientDebtsMutation, UpdateClientDebtsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientDebtsMutation, UpdateClientDebtsMutationVariables>(UpdateClientDebtsDocument, options);
      }
export type UpdateClientDebtsMutationHookResult = ReturnType<typeof useUpdateClientDebtsMutation>;
export type UpdateClientDebtsMutationResult = Apollo.MutationResult<UpdateClientDebtsMutation>;
export type UpdateClientDebtsMutationOptions = Apollo.BaseMutationOptions<UpdateClientDebtsMutation, UpdateClientDebtsMutationVariables>;
export const UpdateClientDefaultEventsDocument = gql`
    mutation updateClientDefaultEvents($id: ID!, $input: ClientInput!) {
  updateClientDefaultEvents(id: $id, input: $input) {
    id
    version
    details {
      id
      credit_history_default_events {
        date_registered
        date_satisfied
        amount
        creditor_name
      }
    }
  }
}
    `;
export type UpdateClientDefaultEventsMutationFn = Apollo.MutationFunction<UpdateClientDefaultEventsMutation, UpdateClientDefaultEventsMutationVariables>;

/**
 * __useUpdateClientDefaultEventsMutation__
 *
 * To run a mutation, you first call `useUpdateClientDefaultEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientDefaultEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientDefaultEventsMutation, { data, loading, error }] = useUpdateClientDefaultEventsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientDefaultEventsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientDefaultEventsMutation, UpdateClientDefaultEventsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientDefaultEventsMutation, UpdateClientDefaultEventsMutationVariables>(UpdateClientDefaultEventsDocument, options);
      }
export type UpdateClientDefaultEventsMutationHookResult = ReturnType<typeof useUpdateClientDefaultEventsMutation>;
export type UpdateClientDefaultEventsMutationResult = Apollo.MutationResult<UpdateClientDefaultEventsMutation>;
export type UpdateClientDefaultEventsMutationOptions = Apollo.BaseMutationOptions<UpdateClientDefaultEventsMutation, UpdateClientDefaultEventsMutationVariables>;
export const UpdateClientDependantsDocument = gql`
    mutation updateClientDependants($id: ID!, $input: ClientInput!) {
  updateClient(id: $id, input: $input) {
    id
    version
    details {
      id
      dependants {
        id
        internalHash
        date_of_birth
        relationship
        relationship_other
        name
        title
        dependency_end_date
      }
    }
  }
}
    `;
export type UpdateClientDependantsMutationFn = Apollo.MutationFunction<UpdateClientDependantsMutation, UpdateClientDependantsMutationVariables>;

/**
 * __useUpdateClientDependantsMutation__
 *
 * To run a mutation, you first call `useUpdateClientDependantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientDependantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientDependantsMutation, { data, loading, error }] = useUpdateClientDependantsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientDependantsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientDependantsMutation, UpdateClientDependantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientDependantsMutation, UpdateClientDependantsMutationVariables>(UpdateClientDependantsDocument, options);
      }
export type UpdateClientDependantsMutationHookResult = ReturnType<typeof useUpdateClientDependantsMutation>;
export type UpdateClientDependantsMutationResult = Apollo.MutationResult<UpdateClientDependantsMutation>;
export type UpdateClientDependantsMutationOptions = Apollo.BaseMutationOptions<UpdateClientDependantsMutation, UpdateClientDependantsMutationVariables>;
export const UpdateClientDepositsDocument = gql`
    mutation updateClientDeposits($id: ID!, $input: [DepositInput!]) {
  updateClientDeposits(id: $id, input: $input) {
    id
    version
    details {
      id
      deposits {
        id
        internalHash
        amount
        type
        donors {
          id
          version
        }
        documents
        document_verifies
        source
        deposit_for
      }
    }
  }
}
    `;
export type UpdateClientDepositsMutationFn = Apollo.MutationFunction<UpdateClientDepositsMutation, UpdateClientDepositsMutationVariables>;

/**
 * __useUpdateClientDepositsMutation__
 *
 * To run a mutation, you first call `useUpdateClientDepositsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientDepositsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientDepositsMutation, { data, loading, error }] = useUpdateClientDepositsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientDepositsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientDepositsMutation, UpdateClientDepositsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientDepositsMutation, UpdateClientDepositsMutationVariables>(UpdateClientDepositsDocument, options);
      }
export type UpdateClientDepositsMutationHookResult = ReturnType<typeof useUpdateClientDepositsMutation>;
export type UpdateClientDepositsMutationResult = Apollo.MutationResult<UpdateClientDepositsMutation>;
export type UpdateClientDepositsMutationOptions = Apollo.BaseMutationOptions<UpdateClientDepositsMutation, UpdateClientDepositsMutationVariables>;
export const UpdateClientIncomeDocument = gql`
    mutation updateClientIncome($id: ID!, $input: [ClientIncomeInput!]!) {
  updateClientIncome(id: $id, input: $input) {
    id
    version
    details {
      id
      income_and_employment {
        id
        internalHash
        ...PensionDetails
        date_of_retirement
        is_retired
        pay_rise_expected
        pay_rise_expected_details
        pay_rise_due_in_num_months
        pay_rise_new_salary
        sick_pay {
          ...ClientIncomeSickPayDetails
        }
        income_likely_to_reduce_in_future
        income_likely_to_reduce_in_future_description
        ...ClientEmploymentIncome
        ...ClientSelfEmployedIncome
        standardised_occupation_code
        occupation_title
        is_current
        monthly_net_income
      }
      anticipated_retirement_income {
        id
        internalHash
        ...PensionDetails
        date_of_retirement
        is_retired
        pay_rise_expected
        pay_rise_expected_details
        pay_rise_due_in_num_months
        pay_rise_new_salary
        sick_pay {
          ...ClientIncomeSickPayDetails
        }
        income_likely_to_reduce_in_future
        income_likely_to_reduce_in_future_description
        ...ClientEmploymentIncome
        ...ClientSelfEmployedIncome
        standardised_occupation_code
        occupation_title
        is_current
        monthly_net_income
      }
    }
  }
}
    ${PensionDetailsFragmentDoc}
${ClientIncomeSickPayDetailsFragmentDoc}
${ClientEmploymentIncomeFragmentDoc}
${ClientSelfEmployedIncomeFragmentDoc}`;
export type UpdateClientIncomeMutationFn = Apollo.MutationFunction<UpdateClientIncomeMutation, UpdateClientIncomeMutationVariables>;

/**
 * __useUpdateClientIncomeMutation__
 *
 * To run a mutation, you first call `useUpdateClientIncomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientIncomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientIncomeMutation, { data, loading, error }] = useUpdateClientIncomeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientIncomeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientIncomeMutation, UpdateClientIncomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientIncomeMutation, UpdateClientIncomeMutationVariables>(UpdateClientIncomeDocument, options);
      }
export type UpdateClientIncomeMutationHookResult = ReturnType<typeof useUpdateClientIncomeMutation>;
export type UpdateClientIncomeMutationResult = Apollo.MutationResult<UpdateClientIncomeMutation>;
export type UpdateClientIncomeMutationOptions = Apollo.BaseMutationOptions<UpdateClientIncomeMutation, UpdateClientIncomeMutationVariables>;
export const UpdateClientIvasDocument = gql`
    mutation updateClientIvas($id: ID!, $input: ClientInput!) {
  updateClientIvas(id: $id, input: $input) {
    id
    version
    details {
      id
      credit_history_individual_voluntary_arrangements {
        id
        internalHash
        date_registered
        date_completed
        monthly_payment_amount
        satisfactory_conduct
      }
    }
  }
}
    `;
export type UpdateClientIvasMutationFn = Apollo.MutationFunction<UpdateClientIvasMutation, UpdateClientIvasMutationVariables>;

/**
 * __useUpdateClientIvasMutation__
 *
 * To run a mutation, you first call `useUpdateClientIvasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientIvasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientIvasMutation, { data, loading, error }] = useUpdateClientIvasMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientIvasMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientIvasMutation, UpdateClientIvasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientIvasMutation, UpdateClientIvasMutationVariables>(UpdateClientIvasDocument, options);
      }
export type UpdateClientIvasMutationHookResult = ReturnType<typeof useUpdateClientIvasMutation>;
export type UpdateClientIvasMutationResult = Apollo.MutationResult<UpdateClientIvasMutation>;
export type UpdateClientIvasMutationOptions = Apollo.BaseMutationOptions<UpdateClientIvasMutation, UpdateClientIvasMutationVariables>;
export const UpdateClientOrganisationRelationshipDocument = gql`
    mutation updateClientOrganisationRelationship($client_id: String!, $organisation_id_or_ext: String!, $input: MarketingPreferencesInput!) {
  updateClientOrganisationRelationship(
    client_id: $client_id
    organisation_id_or_ext: $organisation_id_or_ext
    input: $input
  ) {
    org_id
    contact_by_phone
    contact_by_email
    contact_by_text
    contact_by_mail
    third_party_contact_by_phone
    third_party_contact_by_email
    third_party_contact_by_text
    third_party_contact_by_mail
  }
}
    `;
export type UpdateClientOrganisationRelationshipMutationFn = Apollo.MutationFunction<UpdateClientOrganisationRelationshipMutation, UpdateClientOrganisationRelationshipMutationVariables>;

/**
 * __useUpdateClientOrganisationRelationshipMutation__
 *
 * To run a mutation, you first call `useUpdateClientOrganisationRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientOrganisationRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientOrganisationRelationshipMutation, { data, loading, error }] = useUpdateClientOrganisationRelationshipMutation({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      organisation_id_or_ext: // value for 'organisation_id_or_ext'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientOrganisationRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientOrganisationRelationshipMutation, UpdateClientOrganisationRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientOrganisationRelationshipMutation, UpdateClientOrganisationRelationshipMutationVariables>(UpdateClientOrganisationRelationshipDocument, options);
      }
export type UpdateClientOrganisationRelationshipMutationHookResult = ReturnType<typeof useUpdateClientOrganisationRelationshipMutation>;
export type UpdateClientOrganisationRelationshipMutationResult = Apollo.MutationResult<UpdateClientOrganisationRelationshipMutation>;
export type UpdateClientOrganisationRelationshipMutationOptions = Apollo.BaseMutationOptions<UpdateClientOrganisationRelationshipMutation, UpdateClientOrganisationRelationshipMutationVariables>;
export const UpdateClientPreviousNamesDocument = gql`
    mutation updateClientPreviousNames($id: ID!, $input: ClientInput!) {
  updateClientPreviousNames(id: $id, input: $input) {
    id
    version
    details {
      id
      previous_names {
        id
        internalHash
        previous_first_name
        previous_surname
        date_of_name_change
        reason_for_name_change
      }
    }
  }
}
    `;
export type UpdateClientPreviousNamesMutationFn = Apollo.MutationFunction<UpdateClientPreviousNamesMutation, UpdateClientPreviousNamesMutationVariables>;

/**
 * __useUpdateClientPreviousNamesMutation__
 *
 * To run a mutation, you first call `useUpdateClientPreviousNamesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientPreviousNamesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientPreviousNamesMutation, { data, loading, error }] = useUpdateClientPreviousNamesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientPreviousNamesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientPreviousNamesMutation, UpdateClientPreviousNamesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientPreviousNamesMutation, UpdateClientPreviousNamesMutationVariables>(UpdateClientPreviousNamesDocument, options);
      }
export type UpdateClientPreviousNamesMutationHookResult = ReturnType<typeof useUpdateClientPreviousNamesMutation>;
export type UpdateClientPreviousNamesMutationResult = Apollo.MutationResult<UpdateClientPreviousNamesMutation>;
export type UpdateClientPreviousNamesMutationOptions = Apollo.BaseMutationOptions<UpdateClientPreviousNamesMutation, UpdateClientPreviousNamesMutationVariables>;
export const UpdateClientsDocument = gql`
    mutation updateClients($clients: [ClientInput!]!) {
  updateClients(clients: $clients) {
    id
    version
    details {
      id
      ...ClientDetails
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type UpdateClientsMutationFn = Apollo.MutationFunction<UpdateClientsMutation, UpdateClientsMutationVariables>;

/**
 * __useUpdateClientsMutation__
 *
 * To run a mutation, you first call `useUpdateClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientsMutation, { data, loading, error }] = useUpdateClientsMutation({
 *   variables: {
 *      clients: // value for 'clients'
 *   },
 * });
 */
export function useUpdateClientsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientsMutation, UpdateClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientsMutation, UpdateClientsMutationVariables>(UpdateClientsDocument, options);
      }
export type UpdateClientsMutationHookResult = ReturnType<typeof useUpdateClientsMutation>;
export type UpdateClientsMutationResult = Apollo.MutationResult<UpdateClientsMutation>;
export type UpdateClientsMutationOptions = Apollo.BaseMutationOptions<UpdateClientsMutation, UpdateClientsMutationVariables>;
export const UpdateCommissionStructureDocument = gql`
    mutation updateCommissionStructure($id: ID!, $input: CommissionStructureInput!) {
  updateCommissionStructure(id: $id, input: $input) {
    ...CommissionStructureDetails
  }
}
    ${CommissionStructureDetailsFragmentDoc}`;
export type UpdateCommissionStructureMutationFn = Apollo.MutationFunction<UpdateCommissionStructureMutation, UpdateCommissionStructureMutationVariables>;

/**
 * __useUpdateCommissionStructureMutation__
 *
 * To run a mutation, you first call `useUpdateCommissionStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommissionStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommissionStructureMutation, { data, loading, error }] = useUpdateCommissionStructureMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommissionStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommissionStructureMutation, UpdateCommissionStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommissionStructureMutation, UpdateCommissionStructureMutationVariables>(UpdateCommissionStructureDocument, options);
      }
export type UpdateCommissionStructureMutationHookResult = ReturnType<typeof useUpdateCommissionStructureMutation>;
export type UpdateCommissionStructureMutationResult = Apollo.MutationResult<UpdateCommissionStructureMutation>;
export type UpdateCommissionStructureMutationOptions = Apollo.BaseMutationOptions<UpdateCommissionStructureMutation, UpdateCommissionStructureMutationVariables>;
export const UpdateGeneralInsuranceProductDocument = gql`
    mutation updateGeneralInsuranceProduct($id: ID!, $input: CreateGeneralInsuranceProductInput!) {
  updateGeneralInsuranceProduct(id: $id, input: $input) {
    general_insurance_product {
      general_insurance_product_id
      client_ids
      case_ids
      property_ids
      details {
        quote_reference
        status
        premium_amount
        premium_frequency
        provider_id
        buildings_cover_level
        contents_cover_level
        type
        provider
        policy_number
        underwriter
        annual_premium
        commission
        excess
        buildings_excess_if_different
        start_date
        end_date
        specified_rebuild_cost
        rental_cover
        includes_accidental_damage
        accidental_damage_premium
        includes_home_emergency_cover
        home_emergency_premium
        includes_legal_cover
        legal_cover_premium
        includes_personal_possessions_cover
        personal_possessions_sum_assured
        personal_possessions_premium
        years_no_claims
        buildings_years_no_claims_if_different
        specified_items {
          type
          description
          value
          include_at_home
          include_away_from_home
        }
        external {
          id
          source {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type UpdateGeneralInsuranceProductMutationFn = Apollo.MutationFunction<UpdateGeneralInsuranceProductMutation, UpdateGeneralInsuranceProductMutationVariables>;

/**
 * __useUpdateGeneralInsuranceProductMutation__
 *
 * To run a mutation, you first call `useUpdateGeneralInsuranceProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneralInsuranceProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneralInsuranceProductMutation, { data, loading, error }] = useUpdateGeneralInsuranceProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGeneralInsuranceProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneralInsuranceProductMutation, UpdateGeneralInsuranceProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeneralInsuranceProductMutation, UpdateGeneralInsuranceProductMutationVariables>(UpdateGeneralInsuranceProductDocument, options);
      }
export type UpdateGeneralInsuranceProductMutationHookResult = ReturnType<typeof useUpdateGeneralInsuranceProductMutation>;
export type UpdateGeneralInsuranceProductMutationResult = Apollo.MutationResult<UpdateGeneralInsuranceProductMutation>;
export type UpdateGeneralInsuranceProductMutationOptions = Apollo.BaseMutationOptions<UpdateGeneralInsuranceProductMutation, UpdateGeneralInsuranceProductMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($group_id: ID!, $input: UpdateGroupInput) {
  updateGroup(group_id: $group_id, input: $input) {
    group_id
    group_name
    organisation_id
    disabled
    accept_reminders
    users {
      id
    }
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      group_id: // value for 'group_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const UpdateLedgersFullPaymentDocument = gql`
    mutation updateLedgersFullPayment($input: PutLedgersFullPaymentInput!) {
  updateLedgersFullPayment(input: $input) {
    payments {
      amount
      created_at
      created_by
      edited_at
      edited_by
      external_id
      id
      ledger_id
      processor
      received_date
      redirect_uri
      status
    }
  }
}
    `;
export type UpdateLedgersFullPaymentMutationFn = Apollo.MutationFunction<UpdateLedgersFullPaymentMutation, UpdateLedgersFullPaymentMutationVariables>;

/**
 * __useUpdateLedgersFullPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateLedgersFullPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLedgersFullPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLedgersFullPaymentMutation, { data, loading, error }] = useUpdateLedgersFullPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLedgersFullPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLedgersFullPaymentMutation, UpdateLedgersFullPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLedgersFullPaymentMutation, UpdateLedgersFullPaymentMutationVariables>(UpdateLedgersFullPaymentDocument, options);
      }
export type UpdateLedgersFullPaymentMutationHookResult = ReturnType<typeof useUpdateLedgersFullPaymentMutation>;
export type UpdateLedgersFullPaymentMutationResult = Apollo.MutationResult<UpdateLedgersFullPaymentMutation>;
export type UpdateLedgersFullPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateLedgersFullPaymentMutation, UpdateLedgersFullPaymentMutationVariables>;
export const UpdateLedgerPaymentDocument = gql`
    mutation updateLedgerPayment($input: UpdateLedgerInput!, $ledgerId: ID!) {
  updateLedgerPayment(input: $input, ledgerId: $ledgerId) {
    ...ledgerDetails
  }
}
    ${LedgerDetailsFragmentDoc}`;
export type UpdateLedgerPaymentMutationFn = Apollo.MutationFunction<UpdateLedgerPaymentMutation, UpdateLedgerPaymentMutationVariables>;

/**
 * __useUpdateLedgerPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateLedgerPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLedgerPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLedgerPaymentMutation, { data, loading, error }] = useUpdateLedgerPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      ledgerId: // value for 'ledgerId'
 *   },
 * });
 */
export function useUpdateLedgerPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLedgerPaymentMutation, UpdateLedgerPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLedgerPaymentMutation, UpdateLedgerPaymentMutationVariables>(UpdateLedgerPaymentDocument, options);
      }
export type UpdateLedgerPaymentMutationHookResult = ReturnType<typeof useUpdateLedgerPaymentMutation>;
export type UpdateLedgerPaymentMutationResult = Apollo.MutationResult<UpdateLedgerPaymentMutation>;
export type UpdateLedgerPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateLedgerPaymentMutation, UpdateLedgerPaymentMutationVariables>;
export const UpdateMessageDocument = gql`
    mutation updateMessage($note_id: ID!, $input: NoteInput!, $useClientApi: Boolean) {
  updateMessage(note_id: $note_id, input: $input, useClientApi: $useClientApi) {
    note_id
    created_at
    modified_at
    title
    priority
    status
    body
    primary_type
    deadline
    assignee_id
    case_id
    client_id
    organisation_ids
    created_by
    template_id
  }
}
    `;
export type UpdateMessageMutationFn = Apollo.MutationFunction<UpdateMessageMutation, UpdateMessageMutationVariables>;

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      note_id: // value for 'note_id'
 *      input: // value for 'input'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useUpdateMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageMutation, UpdateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageMutation, UpdateMessageMutationVariables>(UpdateMessageDocument, options);
      }
export type UpdateMessageMutationHookResult = ReturnType<typeof useUpdateMessageMutation>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMutation, UpdateMessageMutationVariables>;
export const UpdateMortgageDocument = gql`
    mutation updateMortgage($id: ID!, $input: MortgageInput!) {
  updateMortgage(id: $id, input: $input) {
    ...MortgageDetails
  }
}
    ${MortgageDetailsFragmentDoc}`;
export type UpdateMortgageMutationFn = Apollo.MutationFunction<UpdateMortgageMutation, UpdateMortgageMutationVariables>;

/**
 * __useUpdateMortgageMutation__
 *
 * To run a mutation, you first call `useUpdateMortgageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgageMutation, { data, loading, error }] = useUpdateMortgageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMortgageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgageMutation, UpdateMortgageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgageMutation, UpdateMortgageMutationVariables>(UpdateMortgageDocument, options);
      }
export type UpdateMortgageMutationHookResult = ReturnType<typeof useUpdateMortgageMutation>;
export type UpdateMortgageMutationResult = Apollo.MutationResult<UpdateMortgageMutation>;
export type UpdateMortgageMutationOptions = Apollo.BaseMutationOptions<UpdateMortgageMutation, UpdateMortgageMutationVariables>;
export const UpdateMortgageAndProductDocument = gql`
    mutation updateMortgageAndProduct($input: UpdateMortgageWithProductInput!) {
  updateMortgageAndProduct(input: $input) {
    mortgage_id
    product_id
    mortgage {
      ...CaseMortgagesAndMortgageProducts
    }
    product_details {
      ...CaseMortgageProduct
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}
${CaseMortgageProductFragmentDoc}`;
export type UpdateMortgageAndProductMutationFn = Apollo.MutationFunction<UpdateMortgageAndProductMutation, UpdateMortgageAndProductMutationVariables>;

/**
 * __useUpdateMortgageAndProductMutation__
 *
 * To run a mutation, you first call `useUpdateMortgageAndProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgageAndProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgageAndProductMutation, { data, loading, error }] = useUpdateMortgageAndProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMortgageAndProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgageAndProductMutation, UpdateMortgageAndProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgageAndProductMutation, UpdateMortgageAndProductMutationVariables>(UpdateMortgageAndProductDocument, options);
      }
export type UpdateMortgageAndProductMutationHookResult = ReturnType<typeof useUpdateMortgageAndProductMutation>;
export type UpdateMortgageAndProductMutationResult = Apollo.MutationResult<UpdateMortgageAndProductMutation>;
export type UpdateMortgageAndProductMutationOptions = Apollo.BaseMutationOptions<UpdateMortgageAndProductMutation, UpdateMortgageAndProductMutationVariables>;
export const UpdateMortgageProductDocument = gql`
    mutation updateMortgageProduct($mortgageId: ID!, $mortgageProductId: ID!, $mortgageInput: MortgageInput!, $mortgageProductInput: MortgageProductActualInput!) {
  updateMortgageProduct(
    mortgageId: $mortgageId
    mortgageProductId: $mortgageProductId
    mortgageInput: $mortgageInput
    mortgageProductInput: $mortgageProductInput
  ) {
    ...CaseMortgagesAndMortgageProducts
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}`;
export type UpdateMortgageProductMutationFn = Apollo.MutationFunction<UpdateMortgageProductMutation, UpdateMortgageProductMutationVariables>;

/**
 * __useUpdateMortgageProductMutation__
 *
 * To run a mutation, you first call `useUpdateMortgageProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgageProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgageProductMutation, { data, loading, error }] = useUpdateMortgageProductMutation({
 *   variables: {
 *      mortgageId: // value for 'mortgageId'
 *      mortgageProductId: // value for 'mortgageProductId'
 *      mortgageInput: // value for 'mortgageInput'
 *      mortgageProductInput: // value for 'mortgageProductInput'
 *   },
 * });
 */
export function useUpdateMortgageProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgageProductMutation, UpdateMortgageProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgageProductMutation, UpdateMortgageProductMutationVariables>(UpdateMortgageProductDocument, options);
      }
export type UpdateMortgageProductMutationHookResult = ReturnType<typeof useUpdateMortgageProductMutation>;
export type UpdateMortgageProductMutationResult = Apollo.MutationResult<UpdateMortgageProductMutation>;
export type UpdateMortgageProductMutationOptions = Apollo.BaseMutationOptions<UpdateMortgageProductMutation, UpdateMortgageProductMutationVariables>;
export const UpdateMortgagesDocument = gql`
    mutation updateMortgages($input: [UpdateMortgagesInput!]) {
  updateMortgages(input: $input) {
    id
    version
    status
    term
    term_unit
    outstanding_balance
    outstanding_balance_date
    mortgage_start_date
    mortgage_amount
    interest_only_amount
    repayment_amount
    revert_monthly_payment
    monthly_payment
    application_date
    fees_to_be_added
    lender_proposed
    assumes_continuing
    calculated_values {
      monthly_payment
      revert_monthly_payment
    }
    mortgage_product {
      id
      mortgage_class
      fees_total
      initial_pay_rate
      initial_rate_period
      initial_rate_period_months
      standard_variable_rate
    }
  }
}
    `;
export type UpdateMortgagesMutationFn = Apollo.MutationFunction<UpdateMortgagesMutation, UpdateMortgagesMutationVariables>;

/**
 * __useUpdateMortgagesMutation__
 *
 * To run a mutation, you first call `useUpdateMortgagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgagesMutation, { data, loading, error }] = useUpdateMortgagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMortgagesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgagesMutation, UpdateMortgagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgagesMutation, UpdateMortgagesMutationVariables>(UpdateMortgagesDocument, options);
      }
export type UpdateMortgagesMutationHookResult = ReturnType<typeof useUpdateMortgagesMutation>;
export type UpdateMortgagesMutationResult = Apollo.MutationResult<UpdateMortgagesMutation>;
export type UpdateMortgagesMutationOptions = Apollo.BaseMutationOptions<UpdateMortgagesMutation, UpdateMortgagesMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation updateNote($note_id: ID!, $input: NoteInput!, $useClientApi: Boolean) {
  updateNote(note_id: $note_id, input: $input, useClientApi: $useClientApi) {
    note_id
    created_at
    modified_at
    title
    priority
    status
    body
    primary_type
    deadline
    assignee_id
    assignee_type
    case_id
    case {
      case_id
      case_type
    }
    clients {
      client_id
      first_name
      last_name
      is_natural_person
      organisation_name
    }
    client_id
    property_id
    mortgage_id
    verification_id
    organisation_ids
    created_by
    template_id
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      note_id: // value for 'note_id'
 *      input: // value for 'input'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const UpdateOrganisationDocument = gql`
    mutation updateOrganisation($id: ID!, $input: OrganisationInput!) {
  updateOrganisation(id: $id, input: $input) {
    ...BasicOrganisationDetails
    organisation_legal_form
    organisation_ext_identifier
    joined_acre
    logo
    client_portal_url
    client_portal_settings {
      primary_colour
    }
    fca_reg_no
    type
    administered_by {
      id
      external_id
    }
    bank_account {
      sort_code
      number
    }
    ...OrganisationRmarSettings
    ...OrganisationSourcingSettings
    standard_fee_options {
      fee_option_title
      fees {
        fee_type
        value
      }
      default
    }
    representative_of
    representative_of_org {
      ...BasicOrganisationDetails
      metadata {
        name
        string_value
        bool_value
        user_editable
      }
    }
    status
    website
    primary_phone
    general_email
    metadata {
      name
      string_value
      bool_value
      user_editable
    }
    ...NoteTemplates
    periods_settings {
      periods {
        id
        name
        start_date
        end_date
        disabled
      }
    }
    verification_class {
      enhanced
      optional
      beta
    }
    process_settings {
      use_exchange_case_status
      case_board {
        name
        statuses
      }
      protection_disclaimer {
        generated_by
        signed_by
      }
      template_styles {
        protection_advice_disclaimer
      }
      risk_flagging {
        right_to_buy
        vulnerable
        second_job
        gifted_deposit
        lending_into_retirement
        redemption_penalty
        residential_interest_only
        equity_release
        debt_consolidation
        high_risk_debt_consolidation
        high_commission
        cheapest_product_not_recommended
        advisor_under_review
      }
    }
    lender_metadata {
      porting_pay_on_full_loan_amount
    }
    protection_settings {
      decreasing_term_policy_rate_default_type
      decreasing_term_policy_rate_default_rate
      commission {
        indemnity_required
      }
    }
    referral_settings {
      excluded_referral_partners {
        id
        organisation_id
      }
    }
    accounting {
      vat_registered
      vat_number
      bank_details_sort_code
      bank_details_account_no
    }
  }
}
    ${BasicOrganisationDetailsFragmentDoc}
${OrganisationRmarSettingsFragmentDoc}
${OrganisationSourcingSettingsFragmentDoc}
${NoteTemplatesFragmentDoc}`;
export type UpdateOrganisationMutationFn = Apollo.MutationFunction<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;

/**
 * __useUpdateOrganisationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganisationMutation, { data, loading, error }] = useUpdateOrganisationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>(UpdateOrganisationDocument, options);
      }
export type UpdateOrganisationMutationHookResult = ReturnType<typeof useUpdateOrganisationMutation>;
export type UpdateOrganisationMutationResult = Apollo.MutationResult<UpdateOrganisationMutation>;
export type UpdateOrganisationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganisationMutation, UpdateOrganisationMutationVariables>;
export const UpdatePaymentDocument = gql`
    mutation updatePayment($input: LedgerPaymentInput!, $ledgerId: ID!, $paymentId: ID!) {
  updatePayment(input: $input, ledgerId: $ledgerId, paymentId: $paymentId) {
    id
    status
  }
}
    `;
export type UpdatePaymentMutationFn = Apollo.MutationFunction<UpdatePaymentMutation, UpdatePaymentMutationVariables>;

/**
 * __useUpdatePaymentMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMutation, { data, loading, error }] = useUpdatePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      ledgerId: // value for 'ledgerId'
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function useUpdatePaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument, options);
      }
export type UpdatePaymentMutationHookResult = ReturnType<typeof useUpdatePaymentMutation>;
export type UpdatePaymentMutationResult = Apollo.MutationResult<UpdatePaymentMutation>;
export type UpdatePaymentMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMutation, UpdatePaymentMutationVariables>;
export const UpdatePermissionAssignmentDocument = gql`
    mutation updatePermissionAssignment($id: ID!, $input: PermissionAssignmentInput!) {
  updatePermissionAssignment(id: $id, input: $input) {
    permission_assignments {
      permission_assignment_id
      permission_id
      user_id
      user_scope_id
      group_id
      disabled
    }
  }
}
    `;
export type UpdatePermissionAssignmentMutationFn = Apollo.MutationFunction<UpdatePermissionAssignmentMutation, UpdatePermissionAssignmentMutationVariables>;

/**
 * __useUpdatePermissionAssignmentMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionAssignmentMutation, { data, loading, error }] = useUpdatePermissionAssignmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermissionAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionAssignmentMutation, UpdatePermissionAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionAssignmentMutation, UpdatePermissionAssignmentMutationVariables>(UpdatePermissionAssignmentDocument, options);
      }
export type UpdatePermissionAssignmentMutationHookResult = ReturnType<typeof useUpdatePermissionAssignmentMutation>;
export type UpdatePermissionAssignmentMutationResult = Apollo.MutationResult<UpdatePermissionAssignmentMutation>;
export type UpdatePermissionAssignmentMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionAssignmentMutation, UpdatePermissionAssignmentMutationVariables>;
export const UpdatePermissionAssignmentBulkDocument = gql`
    mutation updatePermissionAssignmentBulk($input: PermissionAssignmentBulkInput) {
  updatePermissionAssignmentBulk(input: $input) {
    permission_assignments {
      permission_assignment_id
      permission_id
      user_id
      user_scope_id
      group_id
      disabled
    }
  }
}
    `;
export type UpdatePermissionAssignmentBulkMutationFn = Apollo.MutationFunction<UpdatePermissionAssignmentBulkMutation, UpdatePermissionAssignmentBulkMutationVariables>;

/**
 * __useUpdatePermissionAssignmentBulkMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionAssignmentBulkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionAssignmentBulkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionAssignmentBulkMutation, { data, loading, error }] = useUpdatePermissionAssignmentBulkMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePermissionAssignmentBulkMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionAssignmentBulkMutation, UpdatePermissionAssignmentBulkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionAssignmentBulkMutation, UpdatePermissionAssignmentBulkMutationVariables>(UpdatePermissionAssignmentBulkDocument, options);
      }
export type UpdatePermissionAssignmentBulkMutationHookResult = ReturnType<typeof useUpdatePermissionAssignmentBulkMutation>;
export type UpdatePermissionAssignmentBulkMutationResult = Apollo.MutationResult<UpdatePermissionAssignmentBulkMutation>;
export type UpdatePermissionAssignmentBulkMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionAssignmentBulkMutation, UpdatePermissionAssignmentBulkMutationVariables>;
export const UpdatePermissionsListDocument = gql`
    mutation updatePermissionsList($assignmentsToCreate: [PermissionAssignmentInput!], $assignmentsToDisable: [PermissionAssignmentInput!], $assignmentsToEnable: [PermissionAssignmentInput!], $userId: String!) {
  updatePermissionsList(
    assignmentsToCreate: $assignmentsToCreate
    assignmentsToDisable: $assignmentsToDisable
    assignmentsToEnable: $assignmentsToEnable
    userId: $userId
  ) {
    permission_assignments {
      permission_assignment_id
      permission_id
      user_id
      user_scope_id
      disabled
    }
  }
}
    `;
export type UpdatePermissionsListMutationFn = Apollo.MutationFunction<UpdatePermissionsListMutation, UpdatePermissionsListMutationVariables>;

/**
 * __useUpdatePermissionsListMutation__
 *
 * To run a mutation, you first call `useUpdatePermissionsListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePermissionsListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePermissionsListMutation, { data, loading, error }] = useUpdatePermissionsListMutation({
 *   variables: {
 *      assignmentsToCreate: // value for 'assignmentsToCreate'
 *      assignmentsToDisable: // value for 'assignmentsToDisable'
 *      assignmentsToEnable: // value for 'assignmentsToEnable'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdatePermissionsListMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePermissionsListMutation, UpdatePermissionsListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePermissionsListMutation, UpdatePermissionsListMutationVariables>(UpdatePermissionsListDocument, options);
      }
export type UpdatePermissionsListMutationHookResult = ReturnType<typeof useUpdatePermissionsListMutation>;
export type UpdatePermissionsListMutationResult = Apollo.MutationResult<UpdatePermissionsListMutation>;
export type UpdatePermissionsListMutationOptions = Apollo.BaseMutationOptions<UpdatePermissionsListMutation, UpdatePermissionsListMutationVariables>;
export const UpdateCasePreferencesDocument = gql`
    mutation updateCasePreferences($id: ID!, $input: CasePreferencesInput!) {
  updateCasePreferences(id: $id, input: $input) {
    id
    details {
      id
      change_of_preference_reason
      preference_interest_only_repayment_strategy
      preference_upper_limit
      preference_fixed_rate
      preference_early_year_discount
      preference_no_early_repayment_charge
      preference_no_tie_in
      preference_fee_to_loan
      preference_vary_repayment_amount
      preference_payment_holiday
      preference_link_finances
      preference_details
      preference_term
      preference_repayment_percentage
      preference_cashback
      preference_mortgage_class
      preference_free_conveyancing
      preference_free_valuations
      preference_initial_period_months
      preference_completion_speed_important
      preference_tracker
      preference_overpayment
    }
  }
}
    `;
export type UpdateCasePreferencesMutationFn = Apollo.MutationFunction<UpdateCasePreferencesMutation, UpdateCasePreferencesMutationVariables>;

/**
 * __useUpdateCasePreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateCasePreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCasePreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCasePreferencesMutation, { data, loading, error }] = useUpdateCasePreferencesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCasePreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCasePreferencesMutation, UpdateCasePreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCasePreferencesMutation, UpdateCasePreferencesMutationVariables>(UpdateCasePreferencesDocument, options);
      }
export type UpdateCasePreferencesMutationHookResult = ReturnType<typeof useUpdateCasePreferencesMutation>;
export type UpdateCasePreferencesMutationResult = Apollo.MutationResult<UpdateCasePreferencesMutation>;
export type UpdateCasePreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateCasePreferencesMutation, UpdateCasePreferencesMutationVariables>;
export const UpdatePropertyDocument = gql`
    mutation updateProperty($propertyId: ID!, $input: PropertyInput!, $includeCaseDetailsInProperty: Boolean = false) {
  updateProperty(propertyId: $propertyId, input: $input) {
    ...PropertyDetails
  }
}
    ${PropertyDetailsFragmentDoc}`;
export type UpdatePropertyMutationFn = Apollo.MutationFunction<UpdatePropertyMutation, UpdatePropertyMutationVariables>;

/**
 * __useUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyMutation, { data, loading, error }] = useUpdatePropertyMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useUpdatePropertyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyMutation, UpdatePropertyMutationVariables>(UpdatePropertyDocument, options);
      }
export type UpdatePropertyMutationHookResult = ReturnType<typeof useUpdatePropertyMutation>;
export type UpdatePropertyMutationResult = Apollo.MutationResult<UpdatePropertyMutation>;
export type UpdatePropertyMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>;
export const UpdateProtectionProductDocument = gql`
    mutation updateProtectionProduct($input: ProtectionProductInput, $protection_id: String!) {
  updateProtectionProduct(input: $input, protection_id: $protection_id) {
    protection_id
    created_at
    version
    version_created_at
    details {
      ...ProductsForProtection
    }
  }
}
    ${ProductsForProtectionFragmentDoc}`;
export type UpdateProtectionProductMutationFn = Apollo.MutationFunction<UpdateProtectionProductMutation, UpdateProtectionProductMutationVariables>;

/**
 * __useUpdateProtectionProductMutation__
 *
 * To run a mutation, you first call `useUpdateProtectionProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProtectionProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProtectionProductMutation, { data, loading, error }] = useUpdateProtectionProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *      protection_id: // value for 'protection_id'
 *   },
 * });
 */
export function useUpdateProtectionProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProtectionProductMutation, UpdateProtectionProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProtectionProductMutation, UpdateProtectionProductMutationVariables>(UpdateProtectionProductDocument, options);
      }
export type UpdateProtectionProductMutationHookResult = ReturnType<typeof useUpdateProtectionProductMutation>;
export type UpdateProtectionProductMutationResult = Apollo.MutationResult<UpdateProtectionProductMutation>;
export type UpdateProtectionProductMutationOptions = Apollo.BaseMutationOptions<UpdateProtectionProductMutation, UpdateProtectionProductMutationVariables>;
export const UpdateRecurringLedgerPaymentDocument = gql`
    mutation updateRecurringLedgerPayment($input: UpdateRecurringLedgerInput!, $ledgerId: ID!) {
  updateRecurringLedgerPayment(input: $input, ledgerId: $ledgerId) {
    id
    endDate
    startDate
    isOverdue
    recurringAmount
    type
    nextPayment
    sourceId {
      id
      sourceType
      hydrationType
    }
    status
  }
}
    `;
export type UpdateRecurringLedgerPaymentMutationFn = Apollo.MutationFunction<UpdateRecurringLedgerPaymentMutation, UpdateRecurringLedgerPaymentMutationVariables>;

/**
 * __useUpdateRecurringLedgerPaymentMutation__
 *
 * To run a mutation, you first call `useUpdateRecurringLedgerPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurringLedgerPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurringLedgerPaymentMutation, { data, loading, error }] = useUpdateRecurringLedgerPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      ledgerId: // value for 'ledgerId'
 *   },
 * });
 */
export function useUpdateRecurringLedgerPaymentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRecurringLedgerPaymentMutation, UpdateRecurringLedgerPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRecurringLedgerPaymentMutation, UpdateRecurringLedgerPaymentMutationVariables>(UpdateRecurringLedgerPaymentDocument, options);
      }
export type UpdateRecurringLedgerPaymentMutationHookResult = ReturnType<typeof useUpdateRecurringLedgerPaymentMutation>;
export type UpdateRecurringLedgerPaymentMutationResult = Apollo.MutationResult<UpdateRecurringLedgerPaymentMutation>;
export type UpdateRecurringLedgerPaymentMutationOptions = Apollo.BaseMutationOptions<UpdateRecurringLedgerPaymentMutation, UpdateRecurringLedgerPaymentMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($userId: ID!, $input: UserInput!) {
  updateUser(userId: $userId, input: $input) {
    id
    first_name
    last_name
    primary_role_id
    role_name
    status
    photo
    first_time_access {
      complete
      features {
        feature
        complete
      }
    }
    group_ids
    organisation_id
    mobile_number
    phone_number
    user_firm_identifier
    email_address
    employment_basis
    part_time_percentage
    training_and_competency {
      mortgage_qualifications
      protection_qualifications
      equity_release_qualifications
    }
    metadata {
      name
      string_value
      bool_value
      int_value
      user_editable
    }
    credentials {
      username
      password
      provider
      metadata {
        IRESS_USER_CODE
      }
    }
    agency_codes {
      provider_id
      agency_code
    }
    ...Authentications
  }
}
    ${AuthenticationsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUserStatusDocument = gql`
    mutation updateUserStatus($userId: ID!, $status: Boolean!) {
  updateUserStatus(userId: $userId, status: $status) {
    id
    first_name
    last_name
    primary_role_id
    role_name
    status
  }
}
    `;
export type UpdateUserStatusMutationFn = Apollo.MutationFunction<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;

/**
 * __useUpdateUserStatusMutation__
 *
 * To run a mutation, you first call `useUpdateUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserStatusMutation, { data, loading, error }] = useUpdateUserStatusMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>(UpdateUserStatusDocument, options);
      }
export type UpdateUserStatusMutationHookResult = ReturnType<typeof useUpdateUserStatusMutation>;
export type UpdateUserStatusMutationResult = Apollo.MutationResult<UpdateUserStatusMutation>;
export type UpdateUserStatusMutationOptions = Apollo.BaseMutationOptions<UpdateUserStatusMutation, UpdateUserStatusMutationVariables>;
export const UploadDocumentDocument = gql`
    mutation uploadDocument($input: DocumentUploadInput!, $verifyOnUpload: Boolean) {
  uploadDocument(input: $input, verifyOnUpload: $verifyOnUpload) {
    document_id
    internalHash
    type
    template_type
    other_type
    source
    archived
    file_type
    document_name
    date_stored
    source_user_id
    source_client_id
    case_ids
    owning_client_ids
    verification_count
    uploaded_by
    document_signature
    owning_clients(include_details: true) {
      id
      version
      details {
        id
        first_name
        last_name
        is_natural_person
        organisation_name
      }
    }
  }
}
    `;
export type UploadDocumentMutationFn = Apollo.MutationFunction<UploadDocumentMutation, UploadDocumentMutationVariables>;

/**
 * __useUploadDocumentMutation__
 *
 * To run a mutation, you first call `useUploadDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentMutation, { data, loading, error }] = useUploadDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      verifyOnUpload: // value for 'verifyOnUpload'
 *   },
 * });
 */
export function useUploadDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentMutation, UploadDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentMutation, UploadDocumentMutationVariables>(UploadDocumentDocument, options);
      }
export type UploadDocumentMutationHookResult = ReturnType<typeof useUploadDocumentMutation>;
export type UploadDocumentMutationResult = Apollo.MutationResult<UploadDocumentMutation>;
export type UploadDocumentMutationOptions = Apollo.BaseMutationOptions<UploadDocumentMutation, UploadDocumentMutationVariables>;
export const UploadDocumentClassificationDocument = gql`
    mutation uploadDocumentClassification($input: ClassificationUploadDocumentInput!, $verifyOnUpload: Boolean) {
  uploadDocumentClassification(input: $input, verifyOnUpload: $verifyOnUpload) {
    document {
      documentId
      caseIds
      dataBase64
      fileType
      inferenceResult {
        owner_names {
          first_name
          last_name
          middle_name
        }
        type
      }
    }
    retry_with_base64
  }
}
    `;
export type UploadDocumentClassificationMutationFn = Apollo.MutationFunction<UploadDocumentClassificationMutation, UploadDocumentClassificationMutationVariables>;

/**
 * __useUploadDocumentClassificationMutation__
 *
 * To run a mutation, you first call `useUploadDocumentClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentClassificationMutation, { data, loading, error }] = useUploadDocumentClassificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      verifyOnUpload: // value for 'verifyOnUpload'
 *   },
 * });
 */
export function useUploadDocumentClassificationMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentClassificationMutation, UploadDocumentClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentClassificationMutation, UploadDocumentClassificationMutationVariables>(UploadDocumentClassificationDocument, options);
      }
export type UploadDocumentClassificationMutationHookResult = ReturnType<typeof useUploadDocumentClassificationMutation>;
export type UploadDocumentClassificationMutationResult = Apollo.MutationResult<UploadDocumentClassificationMutation>;
export type UploadDocumentClassificationMutationOptions = Apollo.BaseMutationOptions<UploadDocumentClassificationMutation, UploadDocumentClassificationMutationVariables>;
export const UploadProviderStatementDocument = gql`
    mutation uploadProviderStatement($input: UploadProviderStatementInput!) {
  uploadProviderStatement(input: $input) {
    statement_id
    filename
    total_error {
      expected
      got
      message
    }
    cell_errors {
      cell
      row
      column
      field
      message
    }
  }
}
    `;
export type UploadProviderStatementMutationFn = Apollo.MutationFunction<UploadProviderStatementMutation, UploadProviderStatementMutationVariables>;

/**
 * __useUploadProviderStatementMutation__
 *
 * To run a mutation, you first call `useUploadProviderStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadProviderStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadProviderStatementMutation, { data, loading, error }] = useUploadProviderStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadProviderStatementMutation(baseOptions?: Apollo.MutationHookOptions<UploadProviderStatementMutation, UploadProviderStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadProviderStatementMutation, UploadProviderStatementMutationVariables>(UploadProviderStatementDocument, options);
      }
export type UploadProviderStatementMutationHookResult = ReturnType<typeof useUploadProviderStatementMutation>;
export type UploadProviderStatementMutationResult = Apollo.MutationResult<UploadProviderStatementMutation>;
export type UploadProviderStatementMutationOptions = Apollo.BaseMutationOptions<UploadProviderStatementMutation, UploadProviderStatementMutationVariables>;
export const UploadSignedCopyDocument = gql`
    mutation uploadSignedCopy($documentId: ID!, $input: UploadSignedCopyInput!) {
  uploadSignedCopy(documentId: $documentId, input: $input) {
    document_id
    internalHash
    type
    file_type
    document_name
    date_stored
    document_signature
    case_ids
    owning_client_ids
    verification_count
  }
}
    `;
export type UploadSignedCopyMutationFn = Apollo.MutationFunction<UploadSignedCopyMutation, UploadSignedCopyMutationVariables>;

/**
 * __useUploadSignedCopyMutation__
 *
 * To run a mutation, you first call `useUploadSignedCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSignedCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSignedCopyMutation, { data, loading, error }] = useUploadSignedCopyMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadSignedCopyMutation(baseOptions?: Apollo.MutationHookOptions<UploadSignedCopyMutation, UploadSignedCopyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSignedCopyMutation, UploadSignedCopyMutationVariables>(UploadSignedCopyDocument, options);
      }
export type UploadSignedCopyMutationHookResult = ReturnType<typeof useUploadSignedCopyMutation>;
export type UploadSignedCopyMutationResult = Apollo.MutationResult<UploadSignedCopyMutation>;
export type UploadSignedCopyMutationOptions = Apollo.BaseMutationOptions<UploadSignedCopyMutation, UploadSignedCopyMutationVariables>;
export const UpsertCompanyDocument = gql`
    mutation upsertCompany($company: CHCompanyInput!, $user_id: String!, $organisation_id: String!) {
  upsertCompany(
    company: $company
    user_id: $user_id
    organisation_id: $organisation_id
  ) {
    id
    version
    details {
      ...ClientDetails
    }
  }
}
    ${ClientDetailsFragmentDoc}`;
export type UpsertCompanyMutationFn = Apollo.MutationFunction<UpsertCompanyMutation, UpsertCompanyMutationVariables>;

/**
 * __useUpsertCompanyMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyMutation, { data, loading, error }] = useUpsertCompanyMutation({
 *   variables: {
 *      company: // value for 'company'
 *      user_id: // value for 'user_id'
 *      organisation_id: // value for 'organisation_id'
 *   },
 * });
 */
export function useUpsertCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyMutation, UpsertCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyMutation, UpsertCompanyMutationVariables>(UpsertCompanyDocument, options);
      }
export type UpsertCompanyMutationHookResult = ReturnType<typeof useUpsertCompanyMutation>;
export type UpsertCompanyMutationResult = Apollo.MutationResult<UpsertCompanyMutation>;
export type UpsertCompanyMutationOptions = Apollo.BaseMutationOptions<UpsertCompanyMutation, UpsertCompanyMutationVariables>;
export const UpsertCompanyAndDirectorsDocument = gql`
    mutation upsertCompanyAndDirectors($company: CHCompanyInput!, $user_id: String!, $organisation_id: String!) {
  upsertCompanyAndDirectors(
    company: $company
    user_id: $user_id
    organisation_id: $organisation_id
  ) {
    id
    version
    details {
      id
      ...ClientDetails
      miDocuments {
        documents {
          ...MIDocuments
        }
      }
      cases {
        id
        created_at
        details {
          id
          status
          preference_mortgage_reason
          regulated_by
        }
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}
${MiDocumentsFragmentDoc}`;
export type UpsertCompanyAndDirectorsMutationFn = Apollo.MutationFunction<UpsertCompanyAndDirectorsMutation, UpsertCompanyAndDirectorsMutationVariables>;

/**
 * __useUpsertCompanyAndDirectorsMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyAndDirectorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyAndDirectorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyAndDirectorsMutation, { data, loading, error }] = useUpsertCompanyAndDirectorsMutation({
 *   variables: {
 *      company: // value for 'company'
 *      user_id: // value for 'user_id'
 *      organisation_id: // value for 'organisation_id'
 *   },
 * });
 */
export function useUpsertCompanyAndDirectorsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyAndDirectorsMutation, UpsertCompanyAndDirectorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyAndDirectorsMutation, UpsertCompanyAndDirectorsMutationVariables>(UpsertCompanyAndDirectorsDocument, options);
      }
export type UpsertCompanyAndDirectorsMutationHookResult = ReturnType<typeof useUpsertCompanyAndDirectorsMutation>;
export type UpsertCompanyAndDirectorsMutationResult = Apollo.MutationResult<UpsertCompanyAndDirectorsMutation>;
export type UpsertCompanyAndDirectorsMutationOptions = Apollo.BaseMutationOptions<UpsertCompanyAndDirectorsMutation, UpsertCompanyAndDirectorsMutationVariables>;
export const VerifyDocumentDocument = gql`
    mutation verifyDocument($input: DocumentVerificationInput!, $extendedFingerprint: Boolean) {
  verifyDocument(input: $input, extendedFingerprint: $extendedFingerprint) {
    id
  }
}
    `;
export type VerifyDocumentMutationFn = Apollo.MutationFunction<VerifyDocumentMutation, VerifyDocumentMutationVariables>;

/**
 * __useVerifyDocumentMutation__
 *
 * To run a mutation, you first call `useVerifyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyDocumentMutation, { data, loading, error }] = useVerifyDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      extendedFingerprint: // value for 'extendedFingerprint'
 *   },
 * });
 */
export function useVerifyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<VerifyDocumentMutation, VerifyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyDocumentMutation, VerifyDocumentMutationVariables>(VerifyDocumentDocument, options);
      }
export type VerifyDocumentMutationHookResult = ReturnType<typeof useVerifyDocumentMutation>;
export type VerifyDocumentMutationResult = Apollo.MutationResult<VerifyDocumentMutation>;
export type VerifyDocumentMutationOptions = Apollo.BaseMutationOptions<VerifyDocumentMutation, VerifyDocumentMutationVariables>;
export const VerifyDocumentsDocument = gql`
    mutation verifyDocuments($input: [DocumentVerificationInput!]!) {
  verifyDocuments(input: $input) {
    id
  }
}
    `;
export type VerifyDocumentsMutationFn = Apollo.MutationFunction<VerifyDocumentsMutation, VerifyDocumentsMutationVariables>;

/**
 * __useVerifyDocumentsMutation__
 *
 * To run a mutation, you first call `useVerifyDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyDocumentsMutation, { data, loading, error }] = useVerifyDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<VerifyDocumentsMutation, VerifyDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyDocumentsMutation, VerifyDocumentsMutationVariables>(VerifyDocumentsDocument, options);
      }
export type VerifyDocumentsMutationHookResult = ReturnType<typeof useVerifyDocumentsMutation>;
export type VerifyDocumentsMutationResult = Apollo.MutationResult<VerifyDocumentsMutation>;
export type VerifyDocumentsMutationOptions = Apollo.BaseMutationOptions<VerifyDocumentsMutation, VerifyDocumentsMutationVariables>;
export const WriteOffLedgerDocument = gql`
    mutation writeOffLedger($input: UpdateLedgerInput!, $ledgerId: Int!) {
  writeOffLedger(input: $input, ledgerId: $ledgerId) {
    ...ledgerDetails
  }
}
    ${LedgerDetailsFragmentDoc}`;
export type WriteOffLedgerMutationFn = Apollo.MutationFunction<WriteOffLedgerMutation, WriteOffLedgerMutationVariables>;

/**
 * __useWriteOffLedgerMutation__
 *
 * To run a mutation, you first call `useWriteOffLedgerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWriteOffLedgerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [writeOffLedgerMutation, { data, loading, error }] = useWriteOffLedgerMutation({
 *   variables: {
 *      input: // value for 'input'
 *      ledgerId: // value for 'ledgerId'
 *   },
 * });
 */
export function useWriteOffLedgerMutation(baseOptions?: Apollo.MutationHookOptions<WriteOffLedgerMutation, WriteOffLedgerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WriteOffLedgerMutation, WriteOffLedgerMutationVariables>(WriteOffLedgerDocument, options);
      }
export type WriteOffLedgerMutationHookResult = ReturnType<typeof useWriteOffLedgerMutation>;
export type WriteOffLedgerMutationResult = Apollo.MutationResult<WriteOffLedgerMutation>;
export type WriteOffLedgerMutationOptions = Apollo.BaseMutationOptions<WriteOffLedgerMutation, WriteOffLedgerMutationVariables>;
export const GetCaseDetailsDocument = gql`
    query getCaseDetails($id: ID!) {
  case(id: $id) {
    id
    details {
      id
      ...CaseTransitionVersions
      preference_mortgage_reason
      preference_target_property_value
      preference_target_deposit
      preference_loan_amount
      clients {
        id
        version
        details {
          ...ClientDetails
        }
      }
      introducer_id
      is_introduced
      introducer_details
      preference_interest_only_repayment_strategy
      preference_upper_limit
      preference_fixed_rate
      preference_early_year_discount
      preference_no_early_repayment_charge
      preference_no_tie_in
      preference_fee_to_loan
      preference_vary_repayment_amount
      preference_payment_holiday
      preference_link_finances
      preference_details
      preference_term
      preference_repayment_percentage
      change_of_preference_reason
      preference_cashback
      preference_initial_period_months
      preference_mortgage_class
      preference_free_conveyancing
      preference_free_valuations
      preference_completion_speed_important
      preference_tracker
      preference_overpayment
      preference_target_property_value
      preference_loan_amount
      preference_target_deposit
      preference_target_property
      preference_related_property_sale
      has_seen_face_to_face
      impersonation_check_performed
      impersonation_check_details
      shared_budget
      preference_mortgage_loan_amount
      additional_loan_required
      additional_loans {
        id
        loan_amount
        loan_purpose
      }
      conveyancing_type
      own_solicitor_details {
        firm_name
        contact_name
        email_address
        phone_number
        dx_number
        dx_town
        case_reference
      }
      conveyancing_status
      referrals {
        partner
        referral_type
        status
        third_party_id
        contact_history {
          third_party_id
          clicked_at
          clicks
          contact_type
          created_at
          delivered
          identifier
        }
      }
    }
  }
}
    ${CaseTransitionVersionsFragmentDoc}
${ClientDetailsFragmentDoc}`;

/**
 * __useGetCaseDetailsQuery__
 *
 * To run a query within a React component, call `useGetCaseDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables> & ({ variables: GetCaseDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>(GetCaseDetailsDocument, options);
      }
export function useGetCaseDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>(GetCaseDetailsDocument, options);
        }
// @ts-ignore
export function useGetCaseDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>;
export function useGetCaseDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseDetailsQuery | undefined, GetCaseDetailsQueryVariables>;
export function useGetCaseDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>(GetCaseDetailsDocument, options);
        }
export type GetCaseDetailsQueryHookResult = ReturnType<typeof useGetCaseDetailsQuery>;
export type GetCaseDetailsLazyQueryHookResult = ReturnType<typeof useGetCaseDetailsLazyQuery>;
export type GetCaseDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCaseDetailsSuspenseQuery>;
export type GetCaseDetailsQueryResult = Apollo.QueryResult<GetCaseDetailsQuery, GetCaseDetailsQueryVariables>;
export const GetCaseRelatedCasesDocument = gql`
    query getCaseRelatedCases($id: ID!, $includeCaseDetailsInProperty: Boolean = true) {
  case(id: $id) {
    id
    details {
      id
      owner_user_id
      status
      preference_mortgage_reason
      new_property {
        ...PropertyDetails
      }
      mortgages {
        ...CaseMortgagesAndMortgageProducts
      }
      calculated_values {
        total_additional_borrowing
        total_required_loan_amount
      }
    }
  }
}
    ${PropertyDetailsFragmentDoc}
${CaseMortgagesAndMortgageProductsFragmentDoc}`;

/**
 * __useGetCaseRelatedCasesQuery__
 *
 * To run a query within a React component, call `useGetCaseRelatedCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseRelatedCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseRelatedCasesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useGetCaseRelatedCasesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables> & ({ variables: GetCaseRelatedCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>(GetCaseRelatedCasesDocument, options);
      }
export function useGetCaseRelatedCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>(GetCaseRelatedCasesDocument, options);
        }
// @ts-ignore
export function useGetCaseRelatedCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>;
export function useGetCaseRelatedCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseRelatedCasesQuery | undefined, GetCaseRelatedCasesQueryVariables>;
export function useGetCaseRelatedCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>(GetCaseRelatedCasesDocument, options);
        }
export type GetCaseRelatedCasesQueryHookResult = ReturnType<typeof useGetCaseRelatedCasesQuery>;
export type GetCaseRelatedCasesLazyQueryHookResult = ReturnType<typeof useGetCaseRelatedCasesLazyQuery>;
export type GetCaseRelatedCasesSuspenseQueryHookResult = ReturnType<typeof useGetCaseRelatedCasesSuspenseQuery>;
export type GetCaseRelatedCasesQueryResult = Apollo.QueryResult<GetCaseRelatedCasesQuery, GetCaseRelatedCasesQueryVariables>;
export const ApplyForDipDocument = gql`
    query applyForDip($id: ID!, $mortgageId: ID!, $reservation: Boolean) {
  applyForDip(id: $id, mortgageId: $mortgageId, reservation: $reservation) {
    url
    message
  }
}
    `;

/**
 * __useApplyForDipQuery__
 *
 * To run a query within a React component, call `useApplyForDipQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplyForDipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplyForDipQuery({
 *   variables: {
 *      id: // value for 'id'
 *      mortgageId: // value for 'mortgageId'
 *      reservation: // value for 'reservation'
 *   },
 * });
 */
export function useApplyForDipQuery(baseOptions: Apollo.QueryHookOptions<ApplyForDipQuery, ApplyForDipQueryVariables> & ({ variables: ApplyForDipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplyForDipQuery, ApplyForDipQueryVariables>(ApplyForDipDocument, options);
      }
export function useApplyForDipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplyForDipQuery, ApplyForDipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplyForDipQuery, ApplyForDipQueryVariables>(ApplyForDipDocument, options);
        }
// @ts-ignore
export function useApplyForDipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ApplyForDipQuery, ApplyForDipQueryVariables>): Apollo.UseSuspenseQueryResult<ApplyForDipQuery, ApplyForDipQueryVariables>;
export function useApplyForDipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplyForDipQuery, ApplyForDipQueryVariables>): Apollo.UseSuspenseQueryResult<ApplyForDipQuery | undefined, ApplyForDipQueryVariables>;
export function useApplyForDipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApplyForDipQuery, ApplyForDipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApplyForDipQuery, ApplyForDipQueryVariables>(ApplyForDipDocument, options);
        }
export type ApplyForDipQueryHookResult = ReturnType<typeof useApplyForDipQuery>;
export type ApplyForDipLazyQueryHookResult = ReturnType<typeof useApplyForDipLazyQuery>;
export type ApplyForDipSuspenseQueryHookResult = ReturnType<typeof useApplyForDipSuspenseQuery>;
export type ApplyForDipQueryResult = Apollo.QueryResult<ApplyForDipQuery, ApplyForDipQueryVariables>;
export const CanDoDipDocument = gql`
    query canDoDip($input: DipInput!) {
  canDoDip(input: $input) {
    dip_available
    permanent
    reason
    additional_fields_required
    mortgage_id
    supports_dip_certificate
    messages
  }
}
    `;

/**
 * __useCanDoDipQuery__
 *
 * To run a query within a React component, call `useCanDoDipQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanDoDipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanDoDipQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCanDoDipQuery(baseOptions: Apollo.QueryHookOptions<CanDoDipQuery, CanDoDipQueryVariables> & ({ variables: CanDoDipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanDoDipQuery, CanDoDipQueryVariables>(CanDoDipDocument, options);
      }
export function useCanDoDipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanDoDipQuery, CanDoDipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanDoDipQuery, CanDoDipQueryVariables>(CanDoDipDocument, options);
        }
// @ts-ignore
export function useCanDoDipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CanDoDipQuery, CanDoDipQueryVariables>): Apollo.UseSuspenseQueryResult<CanDoDipQuery, CanDoDipQueryVariables>;
export function useCanDoDipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanDoDipQuery, CanDoDipQueryVariables>): Apollo.UseSuspenseQueryResult<CanDoDipQuery | undefined, CanDoDipQueryVariables>;
export function useCanDoDipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanDoDipQuery, CanDoDipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanDoDipQuery, CanDoDipQueryVariables>(CanDoDipDocument, options);
        }
export type CanDoDipQueryHookResult = ReturnType<typeof useCanDoDipQuery>;
export type CanDoDipLazyQueryHookResult = ReturnType<typeof useCanDoDipLazyQuery>;
export type CanDoDipSuspenseQueryHookResult = ReturnType<typeof useCanDoDipSuspenseQuery>;
export type CanDoDipQueryResult = Apollo.QueryResult<CanDoDipQuery, CanDoDipQueryVariables>;
export const CanDoDipNoPropertyDocument = gql`
    query canDoDipNoProperty($input: NoPropertyDipInput!) {
  canDoDipNoProperty(input: $input) {
    messages
    additional_fields_required
    dip_available
    mortgage_id
    permanent
    reason
    supports_dip_certificate
  }
}
    `;

/**
 * __useCanDoDipNoPropertyQuery__
 *
 * To run a query within a React component, call `useCanDoDipNoPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanDoDipNoPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanDoDipNoPropertyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCanDoDipNoPropertyQuery(baseOptions: Apollo.QueryHookOptions<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables> & ({ variables: CanDoDipNoPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>(CanDoDipNoPropertyDocument, options);
      }
export function useCanDoDipNoPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>(CanDoDipNoPropertyDocument, options);
        }
// @ts-ignore
export function useCanDoDipNoPropertySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>): Apollo.UseSuspenseQueryResult<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>;
export function useCanDoDipNoPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>): Apollo.UseSuspenseQueryResult<CanDoDipNoPropertyQuery | undefined, CanDoDipNoPropertyQueryVariables>;
export function useCanDoDipNoPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>(CanDoDipNoPropertyDocument, options);
        }
export type CanDoDipNoPropertyQueryHookResult = ReturnType<typeof useCanDoDipNoPropertyQuery>;
export type CanDoDipNoPropertyLazyQueryHookResult = ReturnType<typeof useCanDoDipNoPropertyLazyQuery>;
export type CanDoDipNoPropertySuspenseQueryHookResult = ReturnType<typeof useCanDoDipNoPropertySuspenseQuery>;
export type CanDoDipNoPropertyQueryResult = Apollo.QueryResult<CanDoDipNoPropertyQuery, CanDoDipNoPropertyQueryVariables>;
export const CancellationReasonDocument = gql`
    query cancellationReason($body: ReportsCaseStatsFilterInput!) {
  reportsCancellationReason(body: $body) {
    grouped_totals {
      group_id
      results {
        cancellation_reason
        count
        value
      }
    }
    totals {
      cancellation_reason
      count
      value
    }
  }
  getCancellationReasonReport @client {
    id
    view_by
    NO_RESPONSE {
      value
      count
    }
    CLIENT_DECLINED_PRODUCT {
      value
      count
    }
    NO_PRODUCT_AVAILABLE {
      value
      count
    }
    INCORRECT_CONTACT_DETAILS {
      value
      count
    }
    CLIENT_NO_LONGER_REQUIRES_PRODUCT {
      value
      count
    }
    CLIENT_OBTAINED_PRODUCT_ELSEWHERE {
      value
      count
    }
    OTHER {
      value
      count
    }
    TOTAL {
      value
      count
    }
  }
}
    `;

/**
 * __useCancellationReasonQuery__
 *
 * To run a query within a React component, call `useCancellationReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancellationReasonQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCancellationReasonQuery(baseOptions: Apollo.QueryHookOptions<CancellationReasonQuery, CancellationReasonQueryVariables> & ({ variables: CancellationReasonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancellationReasonQuery, CancellationReasonQueryVariables>(CancellationReasonDocument, options);
      }
export function useCancellationReasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancellationReasonQuery, CancellationReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancellationReasonQuery, CancellationReasonQueryVariables>(CancellationReasonDocument, options);
        }
// @ts-ignore
export function useCancellationReasonSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CancellationReasonQuery, CancellationReasonQueryVariables>): Apollo.UseSuspenseQueryResult<CancellationReasonQuery, CancellationReasonQueryVariables>;
export function useCancellationReasonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CancellationReasonQuery, CancellationReasonQueryVariables>): Apollo.UseSuspenseQueryResult<CancellationReasonQuery | undefined, CancellationReasonQueryVariables>;
export function useCancellationReasonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CancellationReasonQuery, CancellationReasonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CancellationReasonQuery, CancellationReasonQueryVariables>(CancellationReasonDocument, options);
        }
export type CancellationReasonQueryHookResult = ReturnType<typeof useCancellationReasonQuery>;
export type CancellationReasonLazyQueryHookResult = ReturnType<typeof useCancellationReasonLazyQuery>;
export type CancellationReasonSuspenseQueryHookResult = ReturnType<typeof useCancellationReasonSuspenseQuery>;
export type CancellationReasonQueryResult = Apollo.QueryResult<CancellationReasonQuery, CancellationReasonQueryVariables>;
export const CancellationReasonTotalsDocument = gql`
    query cancellationReasonTotals($body: ReportsCaseStatsFilterInput!) {
  getCancellationReasonTotals(body: $body) @client {
    NO_RESPONSE {
      value
      count
    }
    CLIENT_DECLINED_PRODUCT {
      value
      count
    }
    NO_PRODUCT_AVAILABLE {
      value
      count
    }
    INCORRECT_CONTACT_DETAILS {
      value
      count
    }
    CLIENT_NO_LONGER_REQUIRES_PRODUCT {
      value
      count
    }
    CLIENT_OBTAINED_PRODUCT_ELSEWHERE {
      value
      count
    }
    OTHER {
      value
      count
    }
    TOTAL {
      value
      count
    }
  }
}
    `;

/**
 * __useCancellationReasonTotalsQuery__
 *
 * To run a query within a React component, call `useCancellationReasonTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationReasonTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancellationReasonTotalsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCancellationReasonTotalsQuery(baseOptions: Apollo.QueryHookOptions<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables> & ({ variables: CancellationReasonTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>(CancellationReasonTotalsDocument, options);
      }
export function useCancellationReasonTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>(CancellationReasonTotalsDocument, options);
        }
// @ts-ignore
export function useCancellationReasonTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>;
export function useCancellationReasonTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<CancellationReasonTotalsQuery | undefined, CancellationReasonTotalsQueryVariables>;
export function useCancellationReasonTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>(CancellationReasonTotalsDocument, options);
        }
export type CancellationReasonTotalsQueryHookResult = ReturnType<typeof useCancellationReasonTotalsQuery>;
export type CancellationReasonTotalsLazyQueryHookResult = ReturnType<typeof useCancellationReasonTotalsLazyQuery>;
export type CancellationReasonTotalsSuspenseQueryHookResult = ReturnType<typeof useCancellationReasonTotalsSuspenseQuery>;
export type CancellationReasonTotalsQueryResult = Apollo.QueryResult<CancellationReasonTotalsQuery, CancellationReasonTotalsQueryVariables>;
export const CaseWaterfallDocument = gql`
    query caseWaterfall($body: ReportsCaseStatsFilterInput!) {
  reportsCaseWaterfall(body: $body) {
    grouped_results {
      group_id
      results {
        case_status
        count
        value
      }
    }
    totals {
      case_status
      count
      value
    }
  }
  getCaseWaterfallReport @client {
    id
    view_by
    LEAD {
      value
      count
    }
    PRE_RECOMMENDATION {
      value
      count
    }
    PRE_APPLICATION {
      value
      count
    }
    APPLICATION_SUBMITTED {
      value
      count
    }
    AWAITING_VALUATION {
      value
      count
    }
    AWAITING_OFFER {
      value
      count
    }
    OFFER_RECEIVED {
      value
      count
    }
    EXCHANGE {
      value
      count
    }
  }
}
    `;

/**
 * __useCaseWaterfallQuery__
 *
 * To run a query within a React component, call `useCaseWaterfallQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseWaterfallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseWaterfallQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCaseWaterfallQuery(baseOptions: Apollo.QueryHookOptions<CaseWaterfallQuery, CaseWaterfallQueryVariables> & ({ variables: CaseWaterfallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseWaterfallQuery, CaseWaterfallQueryVariables>(CaseWaterfallDocument, options);
      }
export function useCaseWaterfallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseWaterfallQuery, CaseWaterfallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseWaterfallQuery, CaseWaterfallQueryVariables>(CaseWaterfallDocument, options);
        }
// @ts-ignore
export function useCaseWaterfallSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaseWaterfallQuery, CaseWaterfallQueryVariables>): Apollo.UseSuspenseQueryResult<CaseWaterfallQuery, CaseWaterfallQueryVariables>;
export function useCaseWaterfallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseWaterfallQuery, CaseWaterfallQueryVariables>): Apollo.UseSuspenseQueryResult<CaseWaterfallQuery | undefined, CaseWaterfallQueryVariables>;
export function useCaseWaterfallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseWaterfallQuery, CaseWaterfallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaseWaterfallQuery, CaseWaterfallQueryVariables>(CaseWaterfallDocument, options);
        }
export type CaseWaterfallQueryHookResult = ReturnType<typeof useCaseWaterfallQuery>;
export type CaseWaterfallLazyQueryHookResult = ReturnType<typeof useCaseWaterfallLazyQuery>;
export type CaseWaterfallSuspenseQueryHookResult = ReturnType<typeof useCaseWaterfallSuspenseQuery>;
export type CaseWaterfallQueryResult = Apollo.QueryResult<CaseWaterfallQuery, CaseWaterfallQueryVariables>;
export const CaseWaterfallTotalsDocument = gql`
    query caseWaterfallTotals($body: ReportsCaseStatsFilterInput!) {
  getCaseWaterfallTotals(body: $body) @client {
    LEAD {
      value
      count
    }
    PRE_RECOMMENDATION {
      value
      count
    }
    PRE_APPLICATION {
      value
      count
    }
    APPLICATION_SUBMITTED {
      value
      count
    }
    AWAITING_VALUATION {
      value
      count
    }
    AWAITING_OFFER {
      value
      count
    }
    OFFER_RECEIVED {
      value
      count
    }
    EXCHANGE {
      value
      count
    }
  }
}
    `;

/**
 * __useCaseWaterfallTotalsQuery__
 *
 * To run a query within a React component, call `useCaseWaterfallTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseWaterfallTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseWaterfallTotalsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCaseWaterfallTotalsQuery(baseOptions: Apollo.QueryHookOptions<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables> & ({ variables: CaseWaterfallTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>(CaseWaterfallTotalsDocument, options);
      }
export function useCaseWaterfallTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>(CaseWaterfallTotalsDocument, options);
        }
// @ts-ignore
export function useCaseWaterfallTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>;
export function useCaseWaterfallTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<CaseWaterfallTotalsQuery | undefined, CaseWaterfallTotalsQueryVariables>;
export function useCaseWaterfallTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>(CaseWaterfallTotalsDocument, options);
        }
export type CaseWaterfallTotalsQueryHookResult = ReturnType<typeof useCaseWaterfallTotalsQuery>;
export type CaseWaterfallTotalsLazyQueryHookResult = ReturnType<typeof useCaseWaterfallTotalsLazyQuery>;
export type CaseWaterfallTotalsSuspenseQueryHookResult = ReturnType<typeof useCaseWaterfallTotalsSuspenseQuery>;
export type CaseWaterfallTotalsQueryResult = Apollo.QueryResult<CaseWaterfallTotalsQuery, CaseWaterfallTotalsQueryVariables>;
export const CheckClientDocument = gql`
    query checkClient($client_id: String!, $phone_number: String, $email_address: String) {
  clientExistsWithEmailOrPhone(
    client_id: $client_id
    phone_number: $phone_number
    email_address: $email_address
  ) {
    found
  }
}
    `;

/**
 * __useCheckClientQuery__
 *
 * To run a query within a React component, call `useCheckClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckClientQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      phone_number: // value for 'phone_number'
 *      email_address: // value for 'email_address'
 *   },
 * });
 */
export function useCheckClientQuery(baseOptions: Apollo.QueryHookOptions<CheckClientQuery, CheckClientQueryVariables> & ({ variables: CheckClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckClientQuery, CheckClientQueryVariables>(CheckClientDocument, options);
      }
export function useCheckClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckClientQuery, CheckClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckClientQuery, CheckClientQueryVariables>(CheckClientDocument, options);
        }
// @ts-ignore
export function useCheckClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckClientQuery, CheckClientQueryVariables>): Apollo.UseSuspenseQueryResult<CheckClientQuery, CheckClientQueryVariables>;
export function useCheckClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckClientQuery, CheckClientQueryVariables>): Apollo.UseSuspenseQueryResult<CheckClientQuery | undefined, CheckClientQueryVariables>;
export function useCheckClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckClientQuery, CheckClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckClientQuery, CheckClientQueryVariables>(CheckClientDocument, options);
        }
export type CheckClientQueryHookResult = ReturnType<typeof useCheckClientQuery>;
export type CheckClientLazyQueryHookResult = ReturnType<typeof useCheckClientLazyQuery>;
export type CheckClientSuspenseQueryHookResult = ReturnType<typeof useCheckClientSuspenseQuery>;
export type CheckClientQueryResult = Apollo.QueryResult<CheckClientQuery, CheckClientQueryVariables>;
export const CheckUserExistsDocument = gql`
    query checkUserExists($email: String!) {
  userExistsWithEmail(email: $email) {
    email
    exists
  }
}
    `;

/**
 * __useCheckUserExistsQuery__
 *
 * To run a query within a React component, call `useCheckUserExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckUserExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckUserExistsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckUserExistsQuery(baseOptions: Apollo.QueryHookOptions<CheckUserExistsQuery, CheckUserExistsQueryVariables> & ({ variables: CheckUserExistsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckUserExistsQuery, CheckUserExistsQueryVariables>(CheckUserExistsDocument, options);
      }
export function useCheckUserExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckUserExistsQuery, CheckUserExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckUserExistsQuery, CheckUserExistsQueryVariables>(CheckUserExistsDocument, options);
        }
// @ts-ignore
export function useCheckUserExistsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckUserExistsQuery, CheckUserExistsQueryVariables>): Apollo.UseSuspenseQueryResult<CheckUserExistsQuery, CheckUserExistsQueryVariables>;
export function useCheckUserExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckUserExistsQuery, CheckUserExistsQueryVariables>): Apollo.UseSuspenseQueryResult<CheckUserExistsQuery | undefined, CheckUserExistsQueryVariables>;
export function useCheckUserExistsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckUserExistsQuery, CheckUserExistsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckUserExistsQuery, CheckUserExistsQueryVariables>(CheckUserExistsDocument, options);
        }
export type CheckUserExistsQueryHookResult = ReturnType<typeof useCheckUserExistsQuery>;
export type CheckUserExistsLazyQueryHookResult = ReturnType<typeof useCheckUserExistsLazyQuery>;
export type CheckUserExistsSuspenseQueryHookResult = ReturnType<typeof useCheckUserExistsSuspenseQuery>;
export type CheckUserExistsQueryResult = Apollo.QueryResult<CheckUserExistsQuery, CheckUserExistsQueryVariables>;
export const GetCompanyAutocompleteDocument = gql`
    query getCompanyAutocomplete($input: String!) {
  companyAutocomplete(input: $input) {
    entries {
      companyNumber
      name
    }
  }
}
    `;

/**
 * __useGetCompanyAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetCompanyAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAutocompleteQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCompanyAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables> & ({ variables: GetCompanyAutocompleteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>(GetCompanyAutocompleteDocument, options);
      }
export function useGetCompanyAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>(GetCompanyAutocompleteDocument, options);
        }
// @ts-ignore
export function useGetCompanyAutocompleteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>;
export function useGetCompanyAutocompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyAutocompleteQuery | undefined, GetCompanyAutocompleteQueryVariables>;
export function useGetCompanyAutocompleteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>(GetCompanyAutocompleteDocument, options);
        }
export type GetCompanyAutocompleteQueryHookResult = ReturnType<typeof useGetCompanyAutocompleteQuery>;
export type GetCompanyAutocompleteLazyQueryHookResult = ReturnType<typeof useGetCompanyAutocompleteLazyQuery>;
export type GetCompanyAutocompleteSuspenseQueryHookResult = ReturnType<typeof useGetCompanyAutocompleteSuspenseQuery>;
export type GetCompanyAutocompleteQueryResult = Apollo.QueryResult<GetCompanyAutocompleteQuery, GetCompanyAutocompleteQueryVariables>;
export const GetCompanyDetailDocument = gql`
    query getCompanyDetail($companyId: String!) {
  getCompanyDetail(companyId: $companyId) {
    address {
      city
      line1
      line2
      postCode
      country
    }
    companyNumber
    nonNaturalOrganisationType
    directors {
      citizenship
      dateOfBirth
      firstNames
      lastName
      role
      address {
        city
        line1
        line2
        postCode
        country
      }
    }
    name
    status
    telephone
    sicCode
  }
}
    `;

/**
 * __useGetCompanyDetailQuery__
 *
 * To run a query within a React component, call `useGetCompanyDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyDetailQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyDetailQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyDetailQuery, GetCompanyDetailQueryVariables> & ({ variables: GetCompanyDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>(GetCompanyDetailDocument, options);
      }
export function useGetCompanyDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>(GetCompanyDetailDocument, options);
        }
// @ts-ignore
export function useGetCompanyDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>;
export function useGetCompanyDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetCompanyDetailQuery | undefined, GetCompanyDetailQueryVariables>;
export function useGetCompanyDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>(GetCompanyDetailDocument, options);
        }
export type GetCompanyDetailQueryHookResult = ReturnType<typeof useGetCompanyDetailQuery>;
export type GetCompanyDetailLazyQueryHookResult = ReturnType<typeof useGetCompanyDetailLazyQuery>;
export type GetCompanyDetailSuspenseQueryHookResult = ReturnType<typeof useGetCompanyDetailSuspenseQuery>;
export type GetCompanyDetailQueryResult = Apollo.QueryResult<GetCompanyDetailQuery, GetCompanyDetailQueryVariables>;
export const CurrentPipelineDocument = gql`
    query currentPipeline($body: ReportsCaseStatsFilterInput!) {
  reportsCurrentPipeline(body: $body) {
    grouped_results {
      group_id
      results {
        case_status
        count
        value
      }
    }
    totals {
      case_status
      count
      value
    }
  }
  getCurrentPipelineReport @client {
    id
    view_by
    LEAD {
      value
      count
    }
    PRE_RECOMMENDATION {
      value
      count
    }
    PRE_APPLICATION {
      value
      count
    }
    APPLICATION_SUBMITTED {
      value
      count
    }
    AWAITING_VALUATION {
      value
      count
    }
    AWAITING_OFFER {
      value
      count
    }
    OFFER_RECEIVED {
      value
      count
    }
    EXCHANGE {
      value
      count
    }
  }
}
    `;

/**
 * __useCurrentPipelineQuery__
 *
 * To run a query within a React component, call `useCurrentPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPipelineQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCurrentPipelineQuery(baseOptions: Apollo.QueryHookOptions<CurrentPipelineQuery, CurrentPipelineQueryVariables> & ({ variables: CurrentPipelineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentPipelineQuery, CurrentPipelineQueryVariables>(CurrentPipelineDocument, options);
      }
export function useCurrentPipelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentPipelineQuery, CurrentPipelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentPipelineQuery, CurrentPipelineQueryVariables>(CurrentPipelineDocument, options);
        }
// @ts-ignore
export function useCurrentPipelineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentPipelineQuery, CurrentPipelineQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPipelineQuery, CurrentPipelineQueryVariables>;
export function useCurrentPipelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPipelineQuery, CurrentPipelineQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPipelineQuery | undefined, CurrentPipelineQueryVariables>;
export function useCurrentPipelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPipelineQuery, CurrentPipelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentPipelineQuery, CurrentPipelineQueryVariables>(CurrentPipelineDocument, options);
        }
export type CurrentPipelineQueryHookResult = ReturnType<typeof useCurrentPipelineQuery>;
export type CurrentPipelineLazyQueryHookResult = ReturnType<typeof useCurrentPipelineLazyQuery>;
export type CurrentPipelineSuspenseQueryHookResult = ReturnType<typeof useCurrentPipelineSuspenseQuery>;
export type CurrentPipelineQueryResult = Apollo.QueryResult<CurrentPipelineQuery, CurrentPipelineQueryVariables>;
export const CurrentPipelineTotalsDocument = gql`
    query currentPipelineTotals($body: ReportsCaseStatsFilterInput!) {
  getCurrentPipelineTotals(body: $body) @client {
    LEAD {
      value
      count
    }
    PRE_RECOMMENDATION {
      value
      count
    }
    PRE_APPLICATION {
      value
      count
    }
    APPLICATION_SUBMITTED {
      value
      count
    }
    AWAITING_VALUATION {
      value
      count
    }
    AWAITING_OFFER {
      value
      count
    }
    OFFER_RECEIVED {
      value
      count
    }
    EXCHANGE {
      value
      count
    }
  }
}
    `;

/**
 * __useCurrentPipelineTotalsQuery__
 *
 * To run a query within a React component, call `useCurrentPipelineTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPipelineTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPipelineTotalsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCurrentPipelineTotalsQuery(baseOptions: Apollo.QueryHookOptions<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables> & ({ variables: CurrentPipelineTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>(CurrentPipelineTotalsDocument, options);
      }
export function useCurrentPipelineTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>(CurrentPipelineTotalsDocument, options);
        }
// @ts-ignore
export function useCurrentPipelineTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>;
export function useCurrentPipelineTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPipelineTotalsQuery | undefined, CurrentPipelineTotalsQueryVariables>;
export function useCurrentPipelineTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>(CurrentPipelineTotalsDocument, options);
        }
export type CurrentPipelineTotalsQueryHookResult = ReturnType<typeof useCurrentPipelineTotalsQuery>;
export type CurrentPipelineTotalsLazyQueryHookResult = ReturnType<typeof useCurrentPipelineTotalsLazyQuery>;
export type CurrentPipelineTotalsSuspenseQueryHookResult = ReturnType<typeof useCurrentPipelineTotalsSuspenseQuery>;
export type CurrentPipelineTotalsQueryResult = Apollo.QueryResult<CurrentPipelineTotalsQuery, CurrentPipelineTotalsQueryVariables>;
export const DashboardsFiltersDiscoveryDocument = gql`
    query dashboardsFiltersDiscovery {
  dashboardsFiltersDiscovery {
    filters {
      display_name
      param_name
      type
      values {
        count
        default
        display
        value
      }
    }
  }
}
    `;

/**
 * __useDashboardsFiltersDiscoveryQuery__
 *
 * To run a query within a React component, call `useDashboardsFiltersDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardsFiltersDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardsFiltersDiscoveryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardsFiltersDiscoveryQuery(baseOptions?: Apollo.QueryHookOptions<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>(DashboardsFiltersDiscoveryDocument, options);
      }
export function useDashboardsFiltersDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>(DashboardsFiltersDiscoveryDocument, options);
        }
// @ts-ignore
export function useDashboardsFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>;
export function useDashboardsFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<DashboardsFiltersDiscoveryQuery | undefined, DashboardsFiltersDiscoveryQueryVariables>;
export function useDashboardsFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>(DashboardsFiltersDiscoveryDocument, options);
        }
export type DashboardsFiltersDiscoveryQueryHookResult = ReturnType<typeof useDashboardsFiltersDiscoveryQuery>;
export type DashboardsFiltersDiscoveryLazyQueryHookResult = ReturnType<typeof useDashboardsFiltersDiscoveryLazyQuery>;
export type DashboardsFiltersDiscoverySuspenseQueryHookResult = ReturnType<typeof useDashboardsFiltersDiscoverySuspenseQuery>;
export type DashboardsFiltersDiscoveryQueryResult = Apollo.QueryResult<DashboardsFiltersDiscoveryQuery, DashboardsFiltersDiscoveryQueryVariables>;
export const FmaFieldsDocument = gql`
    query fmaFields($mortgageID: ID!, $caseID: ID!) {
  fmaFields(mortgageId: $mortgageID, caseId: $caseID) {
    __typename
    ... on DipApplicationError {
      errors {
        message
        field
      }
      lender
      status
    }
    ... on FMAFieldsResponse {
      additional_fields_required
      reason
      permanent
      messages
      dip_available
      mortgage_id
    }
  }
}
    `;

/**
 * __useFmaFieldsQuery__
 *
 * To run a query within a React component, call `useFmaFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFmaFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFmaFieldsQuery({
 *   variables: {
 *      mortgageID: // value for 'mortgageID'
 *      caseID: // value for 'caseID'
 *   },
 * });
 */
export function useFmaFieldsQuery(baseOptions: Apollo.QueryHookOptions<FmaFieldsQuery, FmaFieldsQueryVariables> & ({ variables: FmaFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FmaFieldsQuery, FmaFieldsQueryVariables>(FmaFieldsDocument, options);
      }
export function useFmaFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FmaFieldsQuery, FmaFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FmaFieldsQuery, FmaFieldsQueryVariables>(FmaFieldsDocument, options);
        }
// @ts-ignore
export function useFmaFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FmaFieldsQuery, FmaFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<FmaFieldsQuery, FmaFieldsQueryVariables>;
export function useFmaFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FmaFieldsQuery, FmaFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<FmaFieldsQuery | undefined, FmaFieldsQueryVariables>;
export function useFmaFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FmaFieldsQuery, FmaFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FmaFieldsQuery, FmaFieldsQueryVariables>(FmaFieldsDocument, options);
        }
export type FmaFieldsQueryHookResult = ReturnType<typeof useFmaFieldsQuery>;
export type FmaFieldsLazyQueryHookResult = ReturnType<typeof useFmaFieldsLazyQuery>;
export type FmaFieldsSuspenseQueryHookResult = ReturnType<typeof useFmaFieldsSuspenseQuery>;
export type FmaFieldsQueryResult = Apollo.QueryResult<FmaFieldsQuery, FmaFieldsQueryVariables>;
export const CheckGeneralInsuranceQuotesExistDocument = gql`
    query checkGeneralInsuranceQuotesExist($case_id: ID!, $quote_ids: [ID!]!) {
  checkGeneralInsuranceQuotesExist(case_id: $case_id, quote_ids: $quote_ids)
}
    `;

/**
 * __useCheckGeneralInsuranceQuotesExistQuery__
 *
 * To run a query within a React component, call `useCheckGeneralInsuranceQuotesExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckGeneralInsuranceQuotesExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckGeneralInsuranceQuotesExistQuery({
 *   variables: {
 *      case_id: // value for 'case_id'
 *      quote_ids: // value for 'quote_ids'
 *   },
 * });
 */
export function useCheckGeneralInsuranceQuotesExistQuery(baseOptions: Apollo.QueryHookOptions<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables> & ({ variables: CheckGeneralInsuranceQuotesExistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>(CheckGeneralInsuranceQuotesExistDocument, options);
      }
export function useCheckGeneralInsuranceQuotesExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>(CheckGeneralInsuranceQuotesExistDocument, options);
        }
// @ts-ignore
export function useCheckGeneralInsuranceQuotesExistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>): Apollo.UseSuspenseQueryResult<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>;
export function useCheckGeneralInsuranceQuotesExistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>): Apollo.UseSuspenseQueryResult<CheckGeneralInsuranceQuotesExistQuery | undefined, CheckGeneralInsuranceQuotesExistQueryVariables>;
export function useCheckGeneralInsuranceQuotesExistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>(CheckGeneralInsuranceQuotesExistDocument, options);
        }
export type CheckGeneralInsuranceQuotesExistQueryHookResult = ReturnType<typeof useCheckGeneralInsuranceQuotesExistQuery>;
export type CheckGeneralInsuranceQuotesExistLazyQueryHookResult = ReturnType<typeof useCheckGeneralInsuranceQuotesExistLazyQuery>;
export type CheckGeneralInsuranceQuotesExistSuspenseQueryHookResult = ReturnType<typeof useCheckGeneralInsuranceQuotesExistSuspenseQuery>;
export type CheckGeneralInsuranceQuotesExistQueryResult = Apollo.QueryResult<CheckGeneralInsuranceQuotesExistQuery, CheckGeneralInsuranceQuotesExistQueryVariables>;
export const GeneralInsuranceProductsDocument = gql`
    query generalInsuranceProducts($input: GetGeneralInsuranceProductsInput, $useClientApi: Boolean = false) {
  generalInsuranceProducts(input: $input, useClientApi: $useClientApi) {
    general_insurance_products {
      general_insurance_product_id
      client_ids
      case_ids
      property_ids
      details {
        underwriter
        provider
        type
        annual_premium
        end_date
        quote_reference
        status
        premium_amount
        premium_frequency
        provider_id
        buildings_cover_level
        contents_cover_level
        type
        provider
        policy_number
        underwriter
        annual_premium
        commission
        excess
        buildings_excess_if_different
        start_date
        end_date
        specified_rebuild_cost
        rental_cover
        includes_accidental_damage
        accidental_damage_premium
        includes_home_emergency_cover
        home_emergency_premium
        includes_legal_cover
        legal_cover_premium
        includes_personal_possessions_cover
        personal_possessions_sum_assured
        personal_possessions_premium
        years_no_claims
        buildings_years_no_claims_if_different
        specified_items {
          type
          description
          value
          include_at_home
          include_away_from_home
        }
        external {
          id
          source {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGeneralInsuranceProductsQuery__
 *
 * To run a query within a React component, call `useGeneralInsuranceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeneralInsuranceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeneralInsuranceProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useGeneralInsuranceProductsQuery(baseOptions?: Apollo.QueryHookOptions<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>(GeneralInsuranceProductsDocument, options);
      }
export function useGeneralInsuranceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>(GeneralInsuranceProductsDocument, options);
        }
// @ts-ignore
export function useGeneralInsuranceProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>;
export function useGeneralInsuranceProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GeneralInsuranceProductsQuery | undefined, GeneralInsuranceProductsQueryVariables>;
export function useGeneralInsuranceProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>(GeneralInsuranceProductsDocument, options);
        }
export type GeneralInsuranceProductsQueryHookResult = ReturnType<typeof useGeneralInsuranceProductsQuery>;
export type GeneralInsuranceProductsLazyQueryHookResult = ReturnType<typeof useGeneralInsuranceProductsLazyQuery>;
export type GeneralInsuranceProductsSuspenseQueryHookResult = ReturnType<typeof useGeneralInsuranceProductsSuspenseQuery>;
export type GeneralInsuranceProductsQueryResult = Apollo.QueryResult<GeneralInsuranceProductsQuery, GeneralInsuranceProductsQueryVariables>;
export const GetGeneralInsuranceQuoteDocument = gql`
    query getGeneralInsuranceQuote($case_id: String!, $quote_id: ID!) {
  generalInsuranceQuote(case_id: $case_id, quote_id: $quote_id) {
    quote {
      quote_id
      external_system
      external_system_quote_uri
      policy_reference
      details {
        quote_stage
        product_price_annual
        product_price_monthly
        product_tier
        insurer_name
        product_name
        status
        assumptions {
          is_first_time_buyer
          unapproved_mortgage_application
          permanently_occupied
          subsidence
          convictions
          insurance_declines
          flooding
          unoccupied_sixty_days
          business_purposes
          number_of_adults
          number_of_children
          number_of_bathrooms
          wall_construction
          roof_construction
          window_locks_fitted
          contents_items_to_specify
          external_door_locks
          alarm_type
          property_unoccupied
        }
        cover_details {
          buildings_cover_level
          contents_cover_level
          excess_buildings
          excess_contents
          accidental_damage_buildings
          accidental_damage_contents
          home_emergency_cover_premium
        }
        warnings
      }
    }
  }
}
    `;

/**
 * __useGetGeneralInsuranceQuoteQuery__
 *
 * To run a query within a React component, call `useGetGeneralInsuranceQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralInsuranceQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralInsuranceQuoteQuery({
 *   variables: {
 *      case_id: // value for 'case_id'
 *      quote_id: // value for 'quote_id'
 *   },
 * });
 */
export function useGetGeneralInsuranceQuoteQuery(baseOptions: Apollo.QueryHookOptions<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables> & ({ variables: GetGeneralInsuranceQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>(GetGeneralInsuranceQuoteDocument, options);
      }
export function useGetGeneralInsuranceQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>(GetGeneralInsuranceQuoteDocument, options);
        }
// @ts-ignore
export function useGetGeneralInsuranceQuoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>;
export function useGetGeneralInsuranceQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralInsuranceQuoteQuery | undefined, GetGeneralInsuranceQuoteQueryVariables>;
export function useGetGeneralInsuranceQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>(GetGeneralInsuranceQuoteDocument, options);
        }
export type GetGeneralInsuranceQuoteQueryHookResult = ReturnType<typeof useGetGeneralInsuranceQuoteQuery>;
export type GetGeneralInsuranceQuoteLazyQueryHookResult = ReturnType<typeof useGetGeneralInsuranceQuoteLazyQuery>;
export type GetGeneralInsuranceQuoteSuspenseQueryHookResult = ReturnType<typeof useGetGeneralInsuranceQuoteSuspenseQuery>;
export type GetGeneralInsuranceQuoteQueryResult = Apollo.QueryResult<GetGeneralInsuranceQuoteQuery, GetGeneralInsuranceQuoteQueryVariables>;
export const GetGeneralInsuranceQuotesDocument = gql`
    query getGeneralInsuranceQuotes($input: GeneralInsuranceInput) {
  generalInsuranceQuotes(input: $input) {
    excludes_panels {
      incorrect_credentials
      missing_credentials
      name
      no_valid_quotes_returned
      quote_not_requested
      server_error
      timeout
      message
    }
    quotes {
      quote_id
      external_system
      external_system_quote_uri
      policy_reference
      details {
        quote_stage
        product_price_annual
        product_price_monthly
        product_tier
        insurer_name
        product_name
        status
        assumptions {
          is_first_time_buyer
          unapproved_mortgage_application
          permanently_occupied
          subsidence
          convictions
          insurance_declines
          flooding
          unoccupied_sixty_days
          business_purposes
          number_of_adults
          number_of_children
          number_of_bathrooms
          wall_construction
          roof_construction
          window_locks_fitted
          contents_items_to_specify
          external_door_locks
          alarm_type
          property_unoccupied
        }
        cover_details {
          buildings_cover_level
          contents_cover_level
          excess_buildings
          excess_contents
          accidental_damage_buildings
          accidental_damage_contents
          home_emergency_cover_premium
          legal_expenses
          personal_possessions_total_amount
        }
        warnings
      }
    }
  }
}
    `;

/**
 * __useGetGeneralInsuranceQuotesQuery__
 *
 * To run a query within a React component, call `useGetGeneralInsuranceQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralInsuranceQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralInsuranceQuotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGeneralInsuranceQuotesQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>(GetGeneralInsuranceQuotesDocument, options);
      }
export function useGetGeneralInsuranceQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>(GetGeneralInsuranceQuotesDocument, options);
        }
// @ts-ignore
export function useGetGeneralInsuranceQuotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>;
export function useGetGeneralInsuranceQuotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetGeneralInsuranceQuotesQuery | undefined, GetGeneralInsuranceQuotesQueryVariables>;
export function useGetGeneralInsuranceQuotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>(GetGeneralInsuranceQuotesDocument, options);
        }
export type GetGeneralInsuranceQuotesQueryHookResult = ReturnType<typeof useGetGeneralInsuranceQuotesQuery>;
export type GetGeneralInsuranceQuotesLazyQueryHookResult = ReturnType<typeof useGetGeneralInsuranceQuotesLazyQuery>;
export type GetGeneralInsuranceQuotesSuspenseQueryHookResult = ReturnType<typeof useGetGeneralInsuranceQuotesSuspenseQuery>;
export type GetGeneralInsuranceQuotesQueryResult = Apollo.QueryResult<GetGeneralInsuranceQuotesQuery, GetGeneralInsuranceQuotesQueryVariables>;
export const IsGeneralInsuranceAuthValidDocument = gql`
    query isGeneralInsuranceAuthValid($input: GeneralInsuranceAuthCreds!) {
  isGeneralInsuranceAuthValid(input: $input)
}
    `;

/**
 * __useIsGeneralInsuranceAuthValidQuery__
 *
 * To run a query within a React component, call `useIsGeneralInsuranceAuthValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsGeneralInsuranceAuthValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsGeneralInsuranceAuthValidQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsGeneralInsuranceAuthValidQuery(baseOptions: Apollo.QueryHookOptions<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables> & ({ variables: IsGeneralInsuranceAuthValidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>(IsGeneralInsuranceAuthValidDocument, options);
      }
export function useIsGeneralInsuranceAuthValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>(IsGeneralInsuranceAuthValidDocument, options);
        }
// @ts-ignore
export function useIsGeneralInsuranceAuthValidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>): Apollo.UseSuspenseQueryResult<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>;
export function useIsGeneralInsuranceAuthValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>): Apollo.UseSuspenseQueryResult<IsGeneralInsuranceAuthValidQuery | undefined, IsGeneralInsuranceAuthValidQueryVariables>;
export function useIsGeneralInsuranceAuthValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>(IsGeneralInsuranceAuthValidDocument, options);
        }
export type IsGeneralInsuranceAuthValidQueryHookResult = ReturnType<typeof useIsGeneralInsuranceAuthValidQuery>;
export type IsGeneralInsuranceAuthValidLazyQueryHookResult = ReturnType<typeof useIsGeneralInsuranceAuthValidLazyQuery>;
export type IsGeneralInsuranceAuthValidSuspenseQueryHookResult = ReturnType<typeof useIsGeneralInsuranceAuthValidSuspenseQuery>;
export type IsGeneralInsuranceAuthValidQueryResult = Apollo.QueryResult<IsGeneralInsuranceAuthValidQuery, IsGeneralInsuranceAuthValidQueryVariables>;
export const GetArOrganisationsMiDocument = gql`
    query getAROrganisationsMi($id: ID!, $includeUsers: Boolean = false, $include_disabled_users: Boolean = false, $bookmark: Int, $page_size: Int) {
  organisation(id: $id, includeUsers: $includeUsers) {
    id
    arOrganisationsMi(
      include_disabled_users: $include_disabled_users
      bookmark: $bookmark
      page_size: $page_size
    ) {
      organisations {
        organisation_id
        name
        general_email
        primary_phone
        primary_postcode
        primary_posttown
        users @include(if: $includeUsers) {
          user_id
          first_name
          last_name
          primary_role_id
        }
      }
      next_page {
        bookmark
      }
      filters {
        all_users
        bookmark
        include_disabled_orgs
        include_disabled_users
        org_id
        page_size
        primary_role_ids
        representative_of
      }
    }
  }
}
    `;

/**
 * __useGetArOrganisationsMiQuery__
 *
 * To run a query within a React component, call `useGetArOrganisationsMiQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArOrganisationsMiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArOrganisationsMiQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeUsers: // value for 'includeUsers'
 *      include_disabled_users: // value for 'include_disabled_users'
 *      bookmark: // value for 'bookmark'
 *      page_size: // value for 'page_size'
 *   },
 * });
 */
export function useGetArOrganisationsMiQuery(baseOptions: Apollo.QueryHookOptions<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables> & ({ variables: GetArOrganisationsMiQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>(GetArOrganisationsMiDocument, options);
      }
export function useGetArOrganisationsMiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>(GetArOrganisationsMiDocument, options);
        }
// @ts-ignore
export function useGetArOrganisationsMiSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>): Apollo.UseSuspenseQueryResult<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>;
export function useGetArOrganisationsMiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>): Apollo.UseSuspenseQueryResult<GetArOrganisationsMiQuery | undefined, GetArOrganisationsMiQueryVariables>;
export function useGetArOrganisationsMiSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>(GetArOrganisationsMiDocument, options);
        }
export type GetArOrganisationsMiQueryHookResult = ReturnType<typeof useGetArOrganisationsMiQuery>;
export type GetArOrganisationsMiLazyQueryHookResult = ReturnType<typeof useGetArOrganisationsMiLazyQuery>;
export type GetArOrganisationsMiSuspenseQueryHookResult = ReturnType<typeof useGetArOrganisationsMiSuspenseQuery>;
export type GetArOrganisationsMiQueryResult = Apollo.QueryResult<GetArOrganisationsMiQuery, GetArOrganisationsMiQueryVariables>;
export const GetAcreFirmListDocument = gql`
    query getAcreFirmList($filter: MiOrganisationsInput) {
  getFirmList(filter: $filter) {
    filters {
      bookmark
      start_date
      end_date
      general_emails_exclude
      metadata
      org_ids
      org_ids_exclude
      types
      page_size
    }
    next_page {
      bookmark
    }
    organisations {
      general_email
      name
      organisation_id
      primary_postcode
      primary_posttown
      primary_phone
      type
    }
  }
}
    `;

/**
 * __useGetAcreFirmListQuery__
 *
 * To run a query within a React component, call `useGetAcreFirmListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAcreFirmListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAcreFirmListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAcreFirmListQuery(baseOptions?: Apollo.QueryHookOptions<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>(GetAcreFirmListDocument, options);
      }
export function useGetAcreFirmListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>(GetAcreFirmListDocument, options);
        }
// @ts-ignore
export function useGetAcreFirmListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>;
export function useGetAcreFirmListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAcreFirmListQuery | undefined, GetAcreFirmListQueryVariables>;
export function useGetAcreFirmListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>(GetAcreFirmListDocument, options);
        }
export type GetAcreFirmListQueryHookResult = ReturnType<typeof useGetAcreFirmListQuery>;
export type GetAcreFirmListLazyQueryHookResult = ReturnType<typeof useGetAcreFirmListLazyQuery>;
export type GetAcreFirmListSuspenseQueryHookResult = ReturnType<typeof useGetAcreFirmListSuspenseQuery>;
export type GetAcreFirmListQueryResult = Apollo.QueryResult<GetAcreFirmListQuery, GetAcreFirmListQueryVariables>;
export const GetAddressLookupDocument = gql`
    query getAddressLookup($searchFragment: String!, $id: ID!) {
  addressLookup(searchFragment: $searchFragment, id: $id) {
    line_1
    line_2
    line_3
    town
    postcode
    country
    county
    field_updates {
      property_tenure
      property_type
      property_sub_type
      price_paid
      year_built
      property_location
      bedrooms
      floor_number
      storeys
      current_energy_rating
    }
    property_id
  }
}
    `;

/**
 * __useGetAddressLookupQuery__
 *
 * To run a query within a React component, call `useGetAddressLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressLookupQuery({
 *   variables: {
 *      searchFragment: // value for 'searchFragment'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAddressLookupQuery(baseOptions: Apollo.QueryHookOptions<GetAddressLookupQuery, GetAddressLookupQueryVariables> & ({ variables: GetAddressLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressLookupQuery, GetAddressLookupQueryVariables>(GetAddressLookupDocument, options);
      }
export function useGetAddressLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressLookupQuery, GetAddressLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressLookupQuery, GetAddressLookupQueryVariables>(GetAddressLookupDocument, options);
        }
// @ts-ignore
export function useGetAddressLookupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddressLookupQuery, GetAddressLookupQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupQuery, GetAddressLookupQueryVariables>;
export function useGetAddressLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupQuery, GetAddressLookupQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupQuery | undefined, GetAddressLookupQueryVariables>;
export function useGetAddressLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupQuery, GetAddressLookupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressLookupQuery, GetAddressLookupQueryVariables>(GetAddressLookupDocument, options);
        }
export type GetAddressLookupQueryHookResult = ReturnType<typeof useGetAddressLookupQuery>;
export type GetAddressLookupLazyQueryHookResult = ReturnType<typeof useGetAddressLookupLazyQuery>;
export type GetAddressLookupSuspenseQueryHookResult = ReturnType<typeof useGetAddressLookupSuspenseQuery>;
export type GetAddressLookupQueryResult = Apollo.QueryResult<GetAddressLookupQuery, GetAddressLookupQueryVariables>;
export const GetAddressLookupCpDocument = gql`
    query getAddressLookupCP($searchFragment: String!, $id: ID!) {
  addressLookupCP(searchFragment: $searchFragment, id: $id) {
    line_1
    line_2
    line_3
    town
    postcode
    country
    county
    field_updates {
      property_tenure
      property_type
      property_sub_type
      price_paid
      year_built
      property_location
      bedrooms
      floor_number
      storeys
    }
    property_id
  }
}
    `;

/**
 * __useGetAddressLookupCpQuery__
 *
 * To run a query within a React component, call `useGetAddressLookupCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressLookupCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressLookupCpQuery({
 *   variables: {
 *      searchFragment: // value for 'searchFragment'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAddressLookupCpQuery(baseOptions: Apollo.QueryHookOptions<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables> & ({ variables: GetAddressLookupCpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>(GetAddressLookupCpDocument, options);
      }
export function useGetAddressLookupCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>(GetAddressLookupCpDocument, options);
        }
// @ts-ignore
export function useGetAddressLookupCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>;
export function useGetAddressLookupCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupCpQuery | undefined, GetAddressLookupCpQueryVariables>;
export function useGetAddressLookupCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>(GetAddressLookupCpDocument, options);
        }
export type GetAddressLookupCpQueryHookResult = ReturnType<typeof useGetAddressLookupCpQuery>;
export type GetAddressLookupCpLazyQueryHookResult = ReturnType<typeof useGetAddressLookupCpLazyQuery>;
export type GetAddressLookupCpSuspenseQueryHookResult = ReturnType<typeof useGetAddressLookupCpSuspenseQuery>;
export type GetAddressLookupCpQueryResult = Apollo.QueryResult<GetAddressLookupCpQuery, GetAddressLookupCpQueryVariables>;
export const GetAddressLookupListDocument = gql`
    query getAddressLookupList($searchFragment: String!, $pathFilter: String!) {
  addressLookupList(searchFragment: $searchFragment, pathFilter: $pathFilter) {
    id
    count
    summary
    location
  }
}
    `;

/**
 * __useGetAddressLookupListQuery__
 *
 * To run a query within a React component, call `useGetAddressLookupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressLookupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressLookupListQuery({
 *   variables: {
 *      searchFragment: // value for 'searchFragment'
 *      pathFilter: // value for 'pathFilter'
 *   },
 * });
 */
export function useGetAddressLookupListQuery(baseOptions: Apollo.QueryHookOptions<GetAddressLookupListQuery, GetAddressLookupListQueryVariables> & ({ variables: GetAddressLookupListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>(GetAddressLookupListDocument, options);
      }
export function useGetAddressLookupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>(GetAddressLookupListDocument, options);
        }
// @ts-ignore
export function useGetAddressLookupListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>;
export function useGetAddressLookupListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupListQuery | undefined, GetAddressLookupListQueryVariables>;
export function useGetAddressLookupListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>(GetAddressLookupListDocument, options);
        }
export type GetAddressLookupListQueryHookResult = ReturnType<typeof useGetAddressLookupListQuery>;
export type GetAddressLookupListLazyQueryHookResult = ReturnType<typeof useGetAddressLookupListLazyQuery>;
export type GetAddressLookupListSuspenseQueryHookResult = ReturnType<typeof useGetAddressLookupListSuspenseQuery>;
export type GetAddressLookupListQueryResult = Apollo.QueryResult<GetAddressLookupListQuery, GetAddressLookupListQueryVariables>;
export const GetAddressLookupListCpDocument = gql`
    query getAddressLookupListCP($searchFragment: String!, $pathFilter: String!) {
  addressLookupListCP(searchFragment: $searchFragment, pathFilter: $pathFilter) {
    id
    count
    summary
    location
  }
}
    `;

/**
 * __useGetAddressLookupListCpQuery__
 *
 * To run a query within a React component, call `useGetAddressLookupListCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressLookupListCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressLookupListCpQuery({
 *   variables: {
 *      searchFragment: // value for 'searchFragment'
 *      pathFilter: // value for 'pathFilter'
 *   },
 * });
 */
export function useGetAddressLookupListCpQuery(baseOptions: Apollo.QueryHookOptions<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables> & ({ variables: GetAddressLookupListCpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>(GetAddressLookupListCpDocument, options);
      }
export function useGetAddressLookupListCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>(GetAddressLookupListCpDocument, options);
        }
// @ts-ignore
export function useGetAddressLookupListCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>;
export function useGetAddressLookupListCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupListCpQuery | undefined, GetAddressLookupListCpQueryVariables>;
export function useGetAddressLookupListCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>(GetAddressLookupListCpDocument, options);
        }
export type GetAddressLookupListCpQueryHookResult = ReturnType<typeof useGetAddressLookupListCpQuery>;
export type GetAddressLookupListCpLazyQueryHookResult = ReturnType<typeof useGetAddressLookupListCpLazyQuery>;
export type GetAddressLookupListCpSuspenseQueryHookResult = ReturnType<typeof useGetAddressLookupListCpSuspenseQuery>;
export type GetAddressLookupListCpQueryResult = Apollo.QueryResult<GetAddressLookupListCpQuery, GetAddressLookupListCpQueryVariables>;
export const GetAddressLookupSummaryDocument = gql`
    query getAddressLookupSummary($searchFragment: String!) {
  addressLookupSummary(searchFragment: $searchFragment) {
    id
    count
    summary
    location
  }
}
    `;

/**
 * __useGetAddressLookupSummaryQuery__
 *
 * To run a query within a React component, call `useGetAddressLookupSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressLookupSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressLookupSummaryQuery({
 *   variables: {
 *      searchFragment: // value for 'searchFragment'
 *   },
 * });
 */
export function useGetAddressLookupSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables> & ({ variables: GetAddressLookupSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>(GetAddressLookupSummaryDocument, options);
      }
export function useGetAddressLookupSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>(GetAddressLookupSummaryDocument, options);
        }
// @ts-ignore
export function useGetAddressLookupSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>;
export function useGetAddressLookupSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupSummaryQuery | undefined, GetAddressLookupSummaryQueryVariables>;
export function useGetAddressLookupSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>(GetAddressLookupSummaryDocument, options);
        }
export type GetAddressLookupSummaryQueryHookResult = ReturnType<typeof useGetAddressLookupSummaryQuery>;
export type GetAddressLookupSummaryLazyQueryHookResult = ReturnType<typeof useGetAddressLookupSummaryLazyQuery>;
export type GetAddressLookupSummarySuspenseQueryHookResult = ReturnType<typeof useGetAddressLookupSummarySuspenseQuery>;
export type GetAddressLookupSummaryQueryResult = Apollo.QueryResult<GetAddressLookupSummaryQuery, GetAddressLookupSummaryQueryVariables>;
export const GetAddressLookupSummaryCpDocument = gql`
    query getAddressLookupSummaryCP($searchFragment: String!) {
  addressLookupSummaryCP(searchFragment: $searchFragment) {
    id
    count
    summary
    location
  }
}
    `;

/**
 * __useGetAddressLookupSummaryCpQuery__
 *
 * To run a query within a React component, call `useGetAddressLookupSummaryCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressLookupSummaryCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressLookupSummaryCpQuery({
 *   variables: {
 *      searchFragment: // value for 'searchFragment'
 *   },
 * });
 */
export function useGetAddressLookupSummaryCpQuery(baseOptions: Apollo.QueryHookOptions<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables> & ({ variables: GetAddressLookupSummaryCpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>(GetAddressLookupSummaryCpDocument, options);
      }
export function useGetAddressLookupSummaryCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>(GetAddressLookupSummaryCpDocument, options);
        }
// @ts-ignore
export function useGetAddressLookupSummaryCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>;
export function useGetAddressLookupSummaryCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetAddressLookupSummaryCpQuery | undefined, GetAddressLookupSummaryCpQueryVariables>;
export function useGetAddressLookupSummaryCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>(GetAddressLookupSummaryCpDocument, options);
        }
export type GetAddressLookupSummaryCpQueryHookResult = ReturnType<typeof useGetAddressLookupSummaryCpQuery>;
export type GetAddressLookupSummaryCpLazyQueryHookResult = ReturnType<typeof useGetAddressLookupSummaryCpLazyQuery>;
export type GetAddressLookupSummaryCpSuspenseQueryHookResult = ReturnType<typeof useGetAddressLookupSummaryCpSuspenseQuery>;
export type GetAddressLookupSummaryCpQueryResult = Apollo.QueryResult<GetAddressLookupSummaryCpQuery, GetAddressLookupSummaryCpQueryVariables>;
export const GetAllCasesDocument = gql`
    query getAllCases($params: GetCaseRequestInput!) {
  allCases(params: $params) {
    cases {
      id
      created_at
      version_created_at
      details {
        id
        owner_user_id
        preference_mortgage_reason
        status
        clients {
          id
          version
          details {
            id
            first_name
            last_name
            is_natural_person
            organisation_name
            organisation_sic
            non_natural {
              number_of_employees
            }
            contact_details_email
            contact_details_work_phone
            contact_details_mobile_phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllCasesQuery__
 *
 * To run a query within a React component, call `useGetAllCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCasesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetAllCasesQuery(baseOptions: Apollo.QueryHookOptions<GetAllCasesQuery, GetAllCasesQueryVariables> & ({ variables: GetAllCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCasesQuery, GetAllCasesQueryVariables>(GetAllCasesDocument, options);
      }
export function useGetAllCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCasesQuery, GetAllCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCasesQuery, GetAllCasesQueryVariables>(GetAllCasesDocument, options);
        }
// @ts-ignore
export function useGetAllCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllCasesQuery, GetAllCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCasesQuery, GetAllCasesQueryVariables>;
export function useGetAllCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCasesQuery, GetAllCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllCasesQuery | undefined, GetAllCasesQueryVariables>;
export function useGetAllCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllCasesQuery, GetAllCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllCasesQuery, GetAllCasesQueryVariables>(GetAllCasesDocument, options);
        }
export type GetAllCasesQueryHookResult = ReturnType<typeof useGetAllCasesQuery>;
export type GetAllCasesLazyQueryHookResult = ReturnType<typeof useGetAllCasesLazyQuery>;
export type GetAllCasesSuspenseQueryHookResult = ReturnType<typeof useGetAllCasesSuspenseQuery>;
export type GetAllCasesQueryResult = Apollo.QueryResult<GetAllCasesQuery, GetAllCasesQueryVariables>;
export const GetAllClientCasesDocument = gql`
    query getAllClientCases($clientId: ID!, $fromClientPortal: Boolean, $deniedAccess: Boolean, $includeDeniedCases: Boolean = false, $includeClientNames: Boolean = true, $includeProperty: Boolean = false, $includeClientsUser: Boolean = false, $includeDocuments: Boolean = false, $includeOwnerOrganisation: Boolean = false, $onlyIncludeClientsBasicInfo: Boolean = false, $includeMortgageProduct: Boolean = false) {
  allClientCases(
    clientId: $clientId
    fromClientPortal: $fromClientPortal
    deniedAccess: $deniedAccess
    includeDeniedCases: $includeDeniedCases
  ) {
    id
    created_at
    version
    version_created_at
    details {
      id
      status
      owner_user_id
      preference_mortgage_reason
      preference_target_property
      preference_related_property_sale
      preference_loan_amount
      client_ids
      regulated_by
      owner_organisation(fromClientPortal: $fromClientPortal) @include(if: $includeOwnerOrganisation) {
        id
        client_portal_settings {
          primary_colour
        }
      }
      ...ClientNames @include(if: $includeClientNames)
      calculated_values {
        total_required_loan_amount
        total_additional_borrowing
        current_totals {
          total_outstanding_balances
        }
      }
      clientsUser(showBasicInfo: $onlyIncludeClientsBasicInfo) @include(if: $includeClientsUser) {
        id
        details {
          ...ClientUserDetails @skip(if: $onlyIncludeClientsBasicInfo)
          ...ClientUserBasicInfo @include(if: $onlyIncludeClientsBasicInfo)
        }
      }
      new_property_cp @include(if: $includeProperty) {
        id
        property_id
        details {
          ...PropertyDetailsCp
        }
      }
      remortgage_property_cp @include(if: $includeProperty) {
        id
        property_id
        details {
          ...PropertyDetailsCp
        }
      }
      protection {
        has_client_accepted_protection_advice
        has_client_accepted_protection_needs
        client_declined_protection_needs_reason
        requirements {
          life_and_critical_illness {
            id
          }
          family_income_benefits {
            id
          }
          income_protection {
            id
          }
          whole_of_life {
            id
          }
          private_medical_insurance {
            id
          }
        }
      }
      referrals {
        partner
        referral_type
        status
        third_party_id
        contact_history {
          third_party_id
          clicked_at
          clicks
          contact_type
          created_at
          delivered
          identifier
          opened_at
        }
      }
      miDocuments(fromClientPortal: $fromClientPortal) @include(if: $includeDocuments) {
        documents {
          ...MIDocuments
        }
      }
    }
  }
}
    ${ClientNamesFragmentDoc}
${ClientUserDetailsFragmentDoc}
${ClientUserBasicInfoFragmentDoc}
${PropertyDetailsCpFragmentDoc}
${MiDocumentsFragmentDoc}`;

/**
 * __useGetAllClientCasesQuery__
 *
 * To run a query within a React component, call `useGetAllClientCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllClientCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllClientCasesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      fromClientPortal: // value for 'fromClientPortal'
 *      deniedAccess: // value for 'deniedAccess'
 *      includeDeniedCases: // value for 'includeDeniedCases'
 *      includeClientNames: // value for 'includeClientNames'
 *      includeProperty: // value for 'includeProperty'
 *      includeClientsUser: // value for 'includeClientsUser'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeOwnerOrganisation: // value for 'includeOwnerOrganisation'
 *      onlyIncludeClientsBasicInfo: // value for 'onlyIncludeClientsBasicInfo'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetAllClientCasesQuery(baseOptions: Apollo.QueryHookOptions<GetAllClientCasesQuery, GetAllClientCasesQueryVariables> & ({ variables: GetAllClientCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>(GetAllClientCasesDocument, options);
      }
export function useGetAllClientCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>(GetAllClientCasesDocument, options);
        }
// @ts-ignore
export function useGetAllClientCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>;
export function useGetAllClientCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllClientCasesQuery | undefined, GetAllClientCasesQueryVariables>;
export function useGetAllClientCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>(GetAllClientCasesDocument, options);
        }
export type GetAllClientCasesQueryHookResult = ReturnType<typeof useGetAllClientCasesQuery>;
export type GetAllClientCasesLazyQueryHookResult = ReturnType<typeof useGetAllClientCasesLazyQuery>;
export type GetAllClientCasesSuspenseQueryHookResult = ReturnType<typeof useGetAllClientCasesSuspenseQuery>;
export type GetAllClientCasesQueryResult = Apollo.QueryResult<GetAllClientCasesQuery, GetAllClientCasesQueryVariables>;
export const GetARsAndAccessToIntroducersDocument = gql`
    query getARsAndAccessToIntroducers($filters: MiOrganisationInput, $introducerId: ID!, $includeUsers: Boolean = false) {
  miOrganisations(filters: $filters) {
    organisations {
      organisation_id
      name
      general_email
      primary_phone
      primary_postcode
      primary_posttown
      users @include(if: $includeUsers) {
        user_id
        first_name
        last_name
        primary_role_id
      }
    }
    next_page {
      bookmark
    }
    filters {
      all_users
      bookmark
      include_disabled_orgs
      include_disabled_users
      org_id
      page_size
      primary_role_ids
      representative_of
    }
  }
  getCommissionStructures(
    input: {filter_receiving_organisation_id: $introducerId}
  ) {
    commission_structures {
      commission_structure_id
      status
      paying_organisation_id
      receiving_organisation_id
    }
  }
}
    `;

/**
 * __useGetARsAndAccessToIntroducersQuery__
 *
 * To run a query within a React component, call `useGetARsAndAccessToIntroducersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetARsAndAccessToIntroducersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetARsAndAccessToIntroducersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      introducerId: // value for 'introducerId'
 *      includeUsers: // value for 'includeUsers'
 *   },
 * });
 */
export function useGetARsAndAccessToIntroducersQuery(baseOptions: Apollo.QueryHookOptions<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables> & ({ variables: GetARsAndAccessToIntroducersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>(GetARsAndAccessToIntroducersDocument, options);
      }
export function useGetARsAndAccessToIntroducersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>(GetARsAndAccessToIntroducersDocument, options);
        }
// @ts-ignore
export function useGetARsAndAccessToIntroducersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>): Apollo.UseSuspenseQueryResult<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>;
export function useGetARsAndAccessToIntroducersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>): Apollo.UseSuspenseQueryResult<GetARsAndAccessToIntroducersQuery | undefined, GetARsAndAccessToIntroducersQueryVariables>;
export function useGetARsAndAccessToIntroducersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>(GetARsAndAccessToIntroducersDocument, options);
        }
export type GetARsAndAccessToIntroducersQueryHookResult = ReturnType<typeof useGetARsAndAccessToIntroducersQuery>;
export type GetARsAndAccessToIntroducersLazyQueryHookResult = ReturnType<typeof useGetARsAndAccessToIntroducersLazyQuery>;
export type GetARsAndAccessToIntroducersSuspenseQueryHookResult = ReturnType<typeof useGetARsAndAccessToIntroducersSuspenseQuery>;
export type GetARsAndAccessToIntroducersQueryResult = Apollo.QueryResult<GetARsAndAccessToIntroducersQuery, GetARsAndAccessToIntroducersQueryVariables>;
export const GetAuthUrlsDocument = gql`
    query getAuthUrls($email: String!) {
  authUrls(email: $email) {
    email
    urls
  }
}
    `;

/**
 * __useGetAuthUrlsQuery__
 *
 * To run a query within a React component, call `useGetAuthUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthUrlsQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetAuthUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetAuthUrlsQuery, GetAuthUrlsQueryVariables> & ({ variables: GetAuthUrlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>(GetAuthUrlsDocument, options);
      }
export function useGetAuthUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>(GetAuthUrlsDocument, options);
        }
// @ts-ignore
export function useGetAuthUrlsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>;
export function useGetAuthUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAuthUrlsQuery | undefined, GetAuthUrlsQueryVariables>;
export function useGetAuthUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>(GetAuthUrlsDocument, options);
        }
export type GetAuthUrlsQueryHookResult = ReturnType<typeof useGetAuthUrlsQuery>;
export type GetAuthUrlsLazyQueryHookResult = ReturnType<typeof useGetAuthUrlsLazyQuery>;
export type GetAuthUrlsSuspenseQueryHookResult = ReturnType<typeof useGetAuthUrlsSuspenseQuery>;
export type GetAuthUrlsQueryResult = Apollo.QueryResult<GetAuthUrlsQuery, GetAuthUrlsQueryVariables>;
export const GetBrokersEulaDocument = gql`
    query getBrokersEula($brokerClientId: ID!) {
  brokersEula(brokerClientId: $brokerClientId) {
    document_id
    internalHash
    document_name
    type
    template_type
    verification_count
    data_base64
    file_type
    document_signature
  }
}
    `;

/**
 * __useGetBrokersEulaQuery__
 *
 * To run a query within a React component, call `useGetBrokersEulaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBrokersEulaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBrokersEulaQuery({
 *   variables: {
 *      brokerClientId: // value for 'brokerClientId'
 *   },
 * });
 */
export function useGetBrokersEulaQuery(baseOptions: Apollo.QueryHookOptions<GetBrokersEulaQuery, GetBrokersEulaQueryVariables> & ({ variables: GetBrokersEulaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>(GetBrokersEulaDocument, options);
      }
export function useGetBrokersEulaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>(GetBrokersEulaDocument, options);
        }
// @ts-ignore
export function useGetBrokersEulaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>): Apollo.UseSuspenseQueryResult<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>;
export function useGetBrokersEulaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>): Apollo.UseSuspenseQueryResult<GetBrokersEulaQuery | undefined, GetBrokersEulaQueryVariables>;
export function useGetBrokersEulaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>(GetBrokersEulaDocument, options);
        }
export type GetBrokersEulaQueryHookResult = ReturnType<typeof useGetBrokersEulaQuery>;
export type GetBrokersEulaLazyQueryHookResult = ReturnType<typeof useGetBrokersEulaLazyQuery>;
export type GetBrokersEulaSuspenseQueryHookResult = ReturnType<typeof useGetBrokersEulaSuspenseQuery>;
export type GetBrokersEulaQueryResult = Apollo.QueryResult<GetBrokersEulaQuery, GetBrokersEulaQueryVariables>;
export const GetCaseDocument = gql`
    query getCase($id: ID!, $includeCaseDetailsInProperty: Boolean = true, $show_verifications_pass: Boolean, $show_documents: Boolean = true, $hydrate_related_cases: Boolean = true) {
  case(id: $id, hydrate_related_cases: $hydrate_related_cases) {
    id
    created_at
    version
    version_created_at
    details {
      ...CaseDetails
      miDocuments {
        documents {
          ...MIDocuments
        }
      }
    }
  }
}
    ${CaseDetailsFragmentDoc}
${MiDocumentsFragmentDoc}`;

/**
 * __useGetCaseQuery__
 *
 * To run a query within a React component, call `useGetCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *      show_verifications_pass: // value for 'show_verifications_pass'
 *      show_documents: // value for 'show_documents'
 *      hydrate_related_cases: // value for 'hydrate_related_cases'
 *   },
 * });
 */
export function useGetCaseQuery(baseOptions: Apollo.QueryHookOptions<GetCaseQuery, GetCaseQueryVariables> & ({ variables: GetCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseQuery, GetCaseQueryVariables>(GetCaseDocument, options);
      }
export function useGetCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseQuery, GetCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseQuery, GetCaseQueryVariables>(GetCaseDocument, options);
        }
// @ts-ignore
export function useGetCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseQuery, GetCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseQuery, GetCaseQueryVariables>;
export function useGetCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseQuery, GetCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseQuery | undefined, GetCaseQueryVariables>;
export function useGetCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseQuery, GetCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseQuery, GetCaseQueryVariables>(GetCaseDocument, options);
        }
export type GetCaseQueryHookResult = ReturnType<typeof useGetCaseQuery>;
export type GetCaseLazyQueryHookResult = ReturnType<typeof useGetCaseLazyQuery>;
export type GetCaseSuspenseQueryHookResult = ReturnType<typeof useGetCaseSuspenseQuery>;
export type GetCaseQueryResult = Apollo.QueryResult<GetCaseQuery, GetCaseQueryVariables>;
export const GetCaseAndClientsMiDocumentsSummariesDocument = gql`
    query getCaseAndClientsMIDocumentsSummaries($case_id: String!, $client_ids: [String!]!) {
  caseAndClientsMIDocumentsSummaries(case_id: $case_id, client_ids: $client_ids) {
    documents {
      ...MIDocuments
      clients {
        id
        version
        details {
          id
          client_id
          is_natural_person
          first_name
          middle_name
          last_name
          organisation_name
        }
      }
    }
  }
}
    ${MiDocumentsFragmentDoc}`;

/**
 * __useGetCaseAndClientsMiDocumentsSummariesQuery__
 *
 * To run a query within a React component, call `useGetCaseAndClientsMiDocumentsSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseAndClientsMiDocumentsSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseAndClientsMiDocumentsSummariesQuery({
 *   variables: {
 *      case_id: // value for 'case_id'
 *      client_ids: // value for 'client_ids'
 *   },
 * });
 */
export function useGetCaseAndClientsMiDocumentsSummariesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables> & ({ variables: GetCaseAndClientsMiDocumentsSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>(GetCaseAndClientsMiDocumentsSummariesDocument, options);
      }
export function useGetCaseAndClientsMiDocumentsSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>(GetCaseAndClientsMiDocumentsSummariesDocument, options);
        }
// @ts-ignore
export function useGetCaseAndClientsMiDocumentsSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>;
export function useGetCaseAndClientsMiDocumentsSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseAndClientsMiDocumentsSummariesQuery | undefined, GetCaseAndClientsMiDocumentsSummariesQueryVariables>;
export function useGetCaseAndClientsMiDocumentsSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>(GetCaseAndClientsMiDocumentsSummariesDocument, options);
        }
export type GetCaseAndClientsMiDocumentsSummariesQueryHookResult = ReturnType<typeof useGetCaseAndClientsMiDocumentsSummariesQuery>;
export type GetCaseAndClientsMiDocumentsSummariesLazyQueryHookResult = ReturnType<typeof useGetCaseAndClientsMiDocumentsSummariesLazyQuery>;
export type GetCaseAndClientsMiDocumentsSummariesSuspenseQueryHookResult = ReturnType<typeof useGetCaseAndClientsMiDocumentsSummariesSuspenseQuery>;
export type GetCaseAndClientsMiDocumentsSummariesQueryResult = Apollo.QueryResult<GetCaseAndClientsMiDocumentsSummariesQuery, GetCaseAndClientsMiDocumentsSummariesQueryVariables>;
export const GetCaseByVersionDocument = gql`
    query getCaseByVersion($id: ID!, $version: Int!, $show_history: Int, $includeCaseDetailsInProperty: Boolean = false, $show_verifications_pass: Boolean, $show_documents: Boolean = true) {
  caseVersion(id: $id, version: $version, show_history: $show_history) {
    id
    created_at
    version
    version_created_at
    details {
      ...CaseDetails
    }
    versions {
      ...VersionWithChangedFields
    }
  }
}
    ${CaseDetailsFragmentDoc}
${VersionWithChangedFieldsFragmentDoc}`;

/**
 * __useGetCaseByVersionQuery__
 *
 * To run a query within a React component, call `useGetCaseByVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseByVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseByVersionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *      show_history: // value for 'show_history'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *      show_verifications_pass: // value for 'show_verifications_pass'
 *      show_documents: // value for 'show_documents'
 *   },
 * });
 */
export function useGetCaseByVersionQuery(baseOptions: Apollo.QueryHookOptions<GetCaseByVersionQuery, GetCaseByVersionQueryVariables> & ({ variables: GetCaseByVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>(GetCaseByVersionDocument, options);
      }
export function useGetCaseByVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>(GetCaseByVersionDocument, options);
        }
// @ts-ignore
export function useGetCaseByVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>;
export function useGetCaseByVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseByVersionQuery | undefined, GetCaseByVersionQueryVariables>;
export function useGetCaseByVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>(GetCaseByVersionDocument, options);
        }
export type GetCaseByVersionQueryHookResult = ReturnType<typeof useGetCaseByVersionQuery>;
export type GetCaseByVersionLazyQueryHookResult = ReturnType<typeof useGetCaseByVersionLazyQuery>;
export type GetCaseByVersionSuspenseQueryHookResult = ReturnType<typeof useGetCaseByVersionSuspenseQuery>;
export type GetCaseByVersionQueryResult = Apollo.QueryResult<GetCaseByVersionQuery, GetCaseByVersionQueryVariables>;
export const GetCaseClientMortgagesDocument = gql`
    query getCaseClientMortgages($id: ID!) {
  case(id: $id) {
    id
    details {
      id
      mortgages {
        ...CaseMortgagesAndMortgageProducts
      }
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}`;

/**
 * __useGetCaseClientMortgagesQuery__
 *
 * To run a query within a React component, call `useGetCaseClientMortgagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseClientMortgagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseClientMortgagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseClientMortgagesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables> & ({ variables: GetCaseClientMortgagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>(GetCaseClientMortgagesDocument, options);
      }
export function useGetCaseClientMortgagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>(GetCaseClientMortgagesDocument, options);
        }
// @ts-ignore
export function useGetCaseClientMortgagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>;
export function useGetCaseClientMortgagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseClientMortgagesQuery | undefined, GetCaseClientMortgagesQueryVariables>;
export function useGetCaseClientMortgagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>(GetCaseClientMortgagesDocument, options);
        }
export type GetCaseClientMortgagesQueryHookResult = ReturnType<typeof useGetCaseClientMortgagesQuery>;
export type GetCaseClientMortgagesLazyQueryHookResult = ReturnType<typeof useGetCaseClientMortgagesLazyQuery>;
export type GetCaseClientMortgagesSuspenseQueryHookResult = ReturnType<typeof useGetCaseClientMortgagesSuspenseQuery>;
export type GetCaseClientMortgagesQueryResult = Apollo.QueryResult<GetCaseClientMortgagesQuery, GetCaseClientMortgagesQueryVariables>;
export const GetCaseClientsDocument = gql`
    query getCaseClients($id: ID!) {
  case(id: $id) {
    id
    details {
      id
      ...CaseTransitionVersions
      clients {
        id
        version
        details {
          id
          ...ClientDetails
        }
      }
    }
  }
}
    ${CaseTransitionVersionsFragmentDoc}
${ClientDetailsFragmentDoc}`;

/**
 * __useGetCaseClientsQuery__
 *
 * To run a query within a React component, call `useGetCaseClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseClientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseClientsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseClientsQuery, GetCaseClientsQueryVariables> & ({ variables: GetCaseClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseClientsQuery, GetCaseClientsQueryVariables>(GetCaseClientsDocument, options);
      }
export function useGetCaseClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseClientsQuery, GetCaseClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseClientsQuery, GetCaseClientsQueryVariables>(GetCaseClientsDocument, options);
        }
// @ts-ignore
export function useGetCaseClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseClientsQuery, GetCaseClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseClientsQuery, GetCaseClientsQueryVariables>;
export function useGetCaseClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseClientsQuery, GetCaseClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseClientsQuery | undefined, GetCaseClientsQueryVariables>;
export function useGetCaseClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseClientsQuery, GetCaseClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseClientsQuery, GetCaseClientsQueryVariables>(GetCaseClientsDocument, options);
        }
export type GetCaseClientsQueryHookResult = ReturnType<typeof useGetCaseClientsQuery>;
export type GetCaseClientsLazyQueryHookResult = ReturnType<typeof useGetCaseClientsLazyQuery>;
export type GetCaseClientsSuspenseQueryHookResult = ReturnType<typeof useGetCaseClientsSuspenseQuery>;
export type GetCaseClientsQueryResult = Apollo.QueryResult<GetCaseClientsQuery, GetCaseClientsQueryVariables>;
export const GetCaseDocumentDetailsDocument = gql`
    query getCaseDocumentDetails($docId: ID!, $params: GetDocumentParams) {
  documentDetails(docId: $docId, params: $params) {
    document_id
    internalHash
    type
    rendered_mortgage_ids
    case_ids
    cases {
      id
      details {
        id
        mortgages {
          id
          version
          status
        }
      }
    }
    template {
      id
      name
    }
    mortgageStatus(id: $docId) @client
  }
}
    `;

/**
 * __useGetCaseDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetCaseDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCaseDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables> & ({ variables: GetCaseDocumentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>(GetCaseDocumentDetailsDocument, options);
      }
export function useGetCaseDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>(GetCaseDocumentDetailsDocument, options);
        }
// @ts-ignore
export function useGetCaseDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>;
export function useGetCaseDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseDocumentDetailsQuery | undefined, GetCaseDocumentDetailsQueryVariables>;
export function useGetCaseDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>(GetCaseDocumentDetailsDocument, options);
        }
export type GetCaseDocumentDetailsQueryHookResult = ReturnType<typeof useGetCaseDocumentDetailsQuery>;
export type GetCaseDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetCaseDocumentDetailsLazyQuery>;
export type GetCaseDocumentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCaseDocumentDetailsSuspenseQuery>;
export type GetCaseDocumentDetailsQueryResult = Apollo.QueryResult<GetCaseDocumentDetailsQuery, GetCaseDocumentDetailsQueryVariables>;
export const GetCaseDocumentsDocument = gql`
    query getCaseDocuments($id: ID!) {
  case(id: $id) {
    id
    version
    details {
      id
      miDocuments {
        documents {
          ...MIDocuments
          clients {
            id
            version
            details {
              id
              client_id
              is_natural_person
              first_name
              middle_name
              last_name
              organisation_name
            }
          }
        }
      }
    }
  }
}
    ${MiDocumentsFragmentDoc}`;

/**
 * __useGetCaseDocumentsQuery__
 *
 * To run a query within a React component, call `useGetCaseDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables> & ({ variables: GetCaseDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>(GetCaseDocumentsDocument, options);
      }
export function useGetCaseDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>(GetCaseDocumentsDocument, options);
        }
// @ts-ignore
export function useGetCaseDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>;
export function useGetCaseDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseDocumentsQuery | undefined, GetCaseDocumentsQueryVariables>;
export function useGetCaseDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>(GetCaseDocumentsDocument, options);
        }
export type GetCaseDocumentsQueryHookResult = ReturnType<typeof useGetCaseDocumentsQuery>;
export type GetCaseDocumentsLazyQueryHookResult = ReturnType<typeof useGetCaseDocumentsLazyQuery>;
export type GetCaseDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetCaseDocumentsSuspenseQuery>;
export type GetCaseDocumentsQueryResult = Apollo.QueryResult<GetCaseDocumentsQuery, GetCaseDocumentsQueryVariables>;
export const GetCaseFeeScenarioDocument = gql`
    query getCaseFeeScenario($id: ID!) {
  case(id: $id) {
    id
    created_at
    version
    version_created_at
    details {
      id
      fee_option_title
      fees {
        fee_type
        value
      }
    }
  }
}
    `;

/**
 * __useGetCaseFeeScenarioQuery__
 *
 * To run a query within a React component, call `useGetCaseFeeScenarioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseFeeScenarioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseFeeScenarioQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseFeeScenarioQuery(baseOptions: Apollo.QueryHookOptions<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables> & ({ variables: GetCaseFeeScenarioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>(GetCaseFeeScenarioDocument, options);
      }
export function useGetCaseFeeScenarioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>(GetCaseFeeScenarioDocument, options);
        }
// @ts-ignore
export function useGetCaseFeeScenarioSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>;
export function useGetCaseFeeScenarioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseFeeScenarioQuery | undefined, GetCaseFeeScenarioQueryVariables>;
export function useGetCaseFeeScenarioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>(GetCaseFeeScenarioDocument, options);
        }
export type GetCaseFeeScenarioQueryHookResult = ReturnType<typeof useGetCaseFeeScenarioQuery>;
export type GetCaseFeeScenarioLazyQueryHookResult = ReturnType<typeof useGetCaseFeeScenarioLazyQuery>;
export type GetCaseFeeScenarioSuspenseQueryHookResult = ReturnType<typeof useGetCaseFeeScenarioSuspenseQuery>;
export type GetCaseFeeScenarioQueryResult = Apollo.QueryResult<GetCaseFeeScenarioQuery, GetCaseFeeScenarioQueryVariables>;
export const GetCaseFeesDocument = gql`
    query getCaseFees($id: ID!) {
  case(id: $id) {
    id
    created_at
    version
    version_created_at
    details {
      id
      fee_option_title
      fees {
        fee_type
        value
      }
    }
  }
}
    `;

/**
 * __useGetCaseFeesQuery__
 *
 * To run a query within a React component, call `useGetCaseFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseFeesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseFeesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseFeesQuery, GetCaseFeesQueryVariables> & ({ variables: GetCaseFeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseFeesQuery, GetCaseFeesQueryVariables>(GetCaseFeesDocument, options);
      }
export function useGetCaseFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseFeesQuery, GetCaseFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseFeesQuery, GetCaseFeesQueryVariables>(GetCaseFeesDocument, options);
        }
// @ts-ignore
export function useGetCaseFeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseFeesQuery, GetCaseFeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseFeesQuery, GetCaseFeesQueryVariables>;
export function useGetCaseFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseFeesQuery, GetCaseFeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseFeesQuery | undefined, GetCaseFeesQueryVariables>;
export function useGetCaseFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseFeesQuery, GetCaseFeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseFeesQuery, GetCaseFeesQueryVariables>(GetCaseFeesDocument, options);
        }
export type GetCaseFeesQueryHookResult = ReturnType<typeof useGetCaseFeesQuery>;
export type GetCaseFeesLazyQueryHookResult = ReturnType<typeof useGetCaseFeesLazyQuery>;
export type GetCaseFeesSuspenseQueryHookResult = ReturnType<typeof useGetCaseFeesSuspenseQuery>;
export type GetCaseFeesQueryResult = Apollo.QueryResult<GetCaseFeesQuery, GetCaseFeesQueryVariables>;
export const GetCaseListDocument = gql`
    query getCaseList($organisationId: ID!, $params: GetCaseRequestInput, $fromClientPortal: Boolean) {
  casesResponse(organisationId: $organisationId, params: $params) {
    cases {
      id
      created_at
      version_created_at
      details {
        id
        status
        owner_user_id
        predicted_revenue
        preference_mortgage_reason
        preference_loan_amount
        ...ClientNames
        owner {
          id
          first_name
          last_name
        }
      }
    }
    next_page {
      bookmark
    }
  }
}
    ${ClientNamesFragmentDoc}`;

/**
 * __useGetCaseListQuery__
 *
 * To run a query within a React component, call `useGetCaseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseListQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      params: // value for 'params'
 *      fromClientPortal: // value for 'fromClientPortal'
 *   },
 * });
 */
export function useGetCaseListQuery(baseOptions: Apollo.QueryHookOptions<GetCaseListQuery, GetCaseListQueryVariables> & ({ variables: GetCaseListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseListQuery, GetCaseListQueryVariables>(GetCaseListDocument, options);
      }
export function useGetCaseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseListQuery, GetCaseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseListQuery, GetCaseListQueryVariables>(GetCaseListDocument, options);
        }
// @ts-ignore
export function useGetCaseListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseListQuery, GetCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseListQuery, GetCaseListQueryVariables>;
export function useGetCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseListQuery, GetCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseListQuery | undefined, GetCaseListQueryVariables>;
export function useGetCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseListQuery, GetCaseListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseListQuery, GetCaseListQueryVariables>(GetCaseListDocument, options);
        }
export type GetCaseListQueryHookResult = ReturnType<typeof useGetCaseListQuery>;
export type GetCaseListLazyQueryHookResult = ReturnType<typeof useGetCaseListLazyQuery>;
export type GetCaseListSuspenseQueryHookResult = ReturnType<typeof useGetCaseListSuspenseQuery>;
export type GetCaseListQueryResult = Apollo.QueryResult<GetCaseListQuery, GetCaseListQueryVariables>;
export const GetCaseListWithMortgagesDocument = gql`
    query getCaseListWithMortgages($organisationId: ID!, $params: GetCaseRequestInput, $fromClientPortal: Boolean) {
  casesResponse(organisationId: $organisationId, params: $params) {
    cases {
      id
      created_at
      version_created_at
      details {
        id
        status
        owner_user_id
        preference_mortgage_reason
        preference_target_property
        mortgages {
          ...CaseMortgagesAndMortgageProducts
        }
        new_property {
          id
          version
          details {
            address {
              address1
              address2
              address3
              postcode
              posttown
              county
              country
            }
          }
        }
        preference_loan_amount
        ...ClientNames
        owner {
          id
          first_name
          last_name
        }
      }
    }
    next_page {
      bookmark
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}
${ClientNamesFragmentDoc}`;

/**
 * __useGetCaseListWithMortgagesQuery__
 *
 * To run a query within a React component, call `useGetCaseListWithMortgagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseListWithMortgagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseListWithMortgagesQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      params: // value for 'params'
 *      fromClientPortal: // value for 'fromClientPortal'
 *   },
 * });
 */
export function useGetCaseListWithMortgagesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables> & ({ variables: GetCaseListWithMortgagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>(GetCaseListWithMortgagesDocument, options);
      }
export function useGetCaseListWithMortgagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>(GetCaseListWithMortgagesDocument, options);
        }
// @ts-ignore
export function useGetCaseListWithMortgagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>;
export function useGetCaseListWithMortgagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseListWithMortgagesQuery | undefined, GetCaseListWithMortgagesQueryVariables>;
export function useGetCaseListWithMortgagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>(GetCaseListWithMortgagesDocument, options);
        }
export type GetCaseListWithMortgagesQueryHookResult = ReturnType<typeof useGetCaseListWithMortgagesQuery>;
export type GetCaseListWithMortgagesLazyQueryHookResult = ReturnType<typeof useGetCaseListWithMortgagesLazyQuery>;
export type GetCaseListWithMortgagesSuspenseQueryHookResult = ReturnType<typeof useGetCaseListWithMortgagesSuspenseQuery>;
export type GetCaseListWithMortgagesQueryResult = Apollo.QueryResult<GetCaseListWithMortgagesQuery, GetCaseListWithMortgagesQueryVariables>;
export const GetCaseMiDocumentCategoriesDocument = gql`
    query getCaseMiDocumentCategories($id: ID!, $filters: MIDocumentTotalsFiltersInput) {
  case(id: $id) {
    id
    details {
      id
      document_totals(filters: $filters) {
        group_id
        count
      }
      document_categories(id: $id, filters: $filters) @client {
        categoryId
        title
        count
      }
    }
  }
}
    `;

/**
 * __useGetCaseMiDocumentCategoriesQuery__
 *
 * To run a query within a React component, call `useGetCaseMiDocumentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseMiDocumentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseMiDocumentCategoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCaseMiDocumentCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables> & ({ variables: GetCaseMiDocumentCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>(GetCaseMiDocumentCategoriesDocument, options);
      }
export function useGetCaseMiDocumentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>(GetCaseMiDocumentCategoriesDocument, options);
        }
// @ts-ignore
export function useGetCaseMiDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>;
export function useGetCaseMiDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseMiDocumentCategoriesQuery | undefined, GetCaseMiDocumentCategoriesQueryVariables>;
export function useGetCaseMiDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>(GetCaseMiDocumentCategoriesDocument, options);
        }
export type GetCaseMiDocumentCategoriesQueryHookResult = ReturnType<typeof useGetCaseMiDocumentCategoriesQuery>;
export type GetCaseMiDocumentCategoriesLazyQueryHookResult = ReturnType<typeof useGetCaseMiDocumentCategoriesLazyQuery>;
export type GetCaseMiDocumentCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetCaseMiDocumentCategoriesSuspenseQuery>;
export type GetCaseMiDocumentCategoriesQueryResult = Apollo.QueryResult<GetCaseMiDocumentCategoriesQuery, GetCaseMiDocumentCategoriesQueryVariables>;
export const GetCaseMiDocumentsDocument = gql`
    query getCaseMiDocuments($id: ID!, $filters: MIDocumentSummaryFiltersInput) {
  case(id: $id, filters: $filters) {
    id
    version
    details {
      id
      miDocuments(filters: $filters) {
        filters {
          bookmark
          page_size
        }
        next_page {
          bookmark
        }
        documents {
          ...MIDocuments
          clients {
            id
            version
            details {
              id
              client_id
              is_natural_person
              first_name
              middle_name
              last_name
              organisation_name
            }
          }
        }
      }
    }
  }
}
    ${MiDocumentsFragmentDoc}`;

/**
 * __useGetCaseMiDocumentsQuery__
 *
 * To run a query within a React component, call `useGetCaseMiDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseMiDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseMiDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetCaseMiDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables> & ({ variables: GetCaseMiDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>(GetCaseMiDocumentsDocument, options);
      }
export function useGetCaseMiDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>(GetCaseMiDocumentsDocument, options);
        }
// @ts-ignore
export function useGetCaseMiDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>;
export function useGetCaseMiDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseMiDocumentsQuery | undefined, GetCaseMiDocumentsQueryVariables>;
export function useGetCaseMiDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>(GetCaseMiDocumentsDocument, options);
        }
export type GetCaseMiDocumentsQueryHookResult = ReturnType<typeof useGetCaseMiDocumentsQuery>;
export type GetCaseMiDocumentsLazyQueryHookResult = ReturnType<typeof useGetCaseMiDocumentsLazyQuery>;
export type GetCaseMiDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetCaseMiDocumentsSuspenseQuery>;
export type GetCaseMiDocumentsQueryResult = Apollo.QueryResult<GetCaseMiDocumentsQuery, GetCaseMiDocumentsQueryVariables>;
export const GetCaseOverviewDetailsDocument = gql`
    query getCaseOverviewDetails($id: ID!, $fromClientPortal: Boolean) {
  case(id: $id) {
    id
    created_at
    version_created_at
    version
    details {
      id
      status
      owner_user_id
      client_ids
      owner {
        id
        first_name
        last_name
      }
      preference_loan_amount
      preference_mortgage_reason
      change_of_preference_reason
      regulated_by
      miDocuments {
        documents {
          ...MIDocuments
          clients {
            id
            version
            details {
              id
              client_id
              is_natural_person
              first_name
              middle_name
              last_name
              organisation_name
            }
          }
        }
      }
      ...ClientNames
      preference_details
      preference_target_property
      preference_target_deposit
      preference_target_property_value
      new_property {
        id
        version
        details {
          id
          type
          year_property_built
          number_of_bedrooms
          number_of_bathrooms
          address {
            address1
            address2
            address3
            posttown
            postcode
            country
            county
          }
        }
      }
      remortgage_property {
        id
        version
        details {
          id
          type
          year_property_built
          number_of_bedrooms
          number_of_bathrooms
          address {
            address1
            address2
            address3
            posttown
            postcode
            country
            county
          }
        }
      }
      flags {
        flag_id
        flag_type
        created_at
        reviews {
          review_passed
          created_at
          reviewer_user_id
          reviewer_private_notes
          reviewer_notes
          review_grade
          reviewed_case_version
        }
      }
    }
  }
}
    ${MiDocumentsFragmentDoc}
${ClientNamesFragmentDoc}`;

/**
 * __useGetCaseOverviewDetailsQuery__
 *
 * To run a query within a React component, call `useGetCaseOverviewDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseOverviewDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseOverviewDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fromClientPortal: // value for 'fromClientPortal'
 *   },
 * });
 */
export function useGetCaseOverviewDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables> & ({ variables: GetCaseOverviewDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>(GetCaseOverviewDetailsDocument, options);
      }
export function useGetCaseOverviewDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>(GetCaseOverviewDetailsDocument, options);
        }
// @ts-ignore
export function useGetCaseOverviewDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>;
export function useGetCaseOverviewDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseOverviewDetailsQuery | undefined, GetCaseOverviewDetailsQueryVariables>;
export function useGetCaseOverviewDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>(GetCaseOverviewDetailsDocument, options);
        }
export type GetCaseOverviewDetailsQueryHookResult = ReturnType<typeof useGetCaseOverviewDetailsQuery>;
export type GetCaseOverviewDetailsLazyQueryHookResult = ReturnType<typeof useGetCaseOverviewDetailsLazyQuery>;
export type GetCaseOverviewDetailsSuspenseQueryHookResult = ReturnType<typeof useGetCaseOverviewDetailsSuspenseQuery>;
export type GetCaseOverviewDetailsQueryResult = Apollo.QueryResult<GetCaseOverviewDetailsQuery, GetCaseOverviewDetailsQueryVariables>;
export const GetCaseOwnersDocument = gql`
    query getCaseOwners($organisationId: ID!, $filterOut: CaseOwnerUserRoles) {
  caseOwners(organisationId: $organisationId, filterOut: $filterOut) {
    id
    first_name
    last_name
    primary_role_id
    organisation_id
    status
  }
}
    `;

/**
 * __useGetCaseOwnersQuery__
 *
 * To run a query within a React component, call `useGetCaseOwnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseOwnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseOwnersQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      filterOut: // value for 'filterOut'
 *   },
 * });
 */
export function useGetCaseOwnersQuery(baseOptions: Apollo.QueryHookOptions<GetCaseOwnersQuery, GetCaseOwnersQueryVariables> & ({ variables: GetCaseOwnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>(GetCaseOwnersDocument, options);
      }
export function useGetCaseOwnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>(GetCaseOwnersDocument, options);
        }
// @ts-ignore
export function useGetCaseOwnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>;
export function useGetCaseOwnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseOwnersQuery | undefined, GetCaseOwnersQueryVariables>;
export function useGetCaseOwnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>(GetCaseOwnersDocument, options);
        }
export type GetCaseOwnersQueryHookResult = ReturnType<typeof useGetCaseOwnersQuery>;
export type GetCaseOwnersLazyQueryHookResult = ReturnType<typeof useGetCaseOwnersLazyQuery>;
export type GetCaseOwnersSuspenseQueryHookResult = ReturnType<typeof useGetCaseOwnersSuspenseQuery>;
export type GetCaseOwnersQueryResult = Apollo.QueryResult<GetCaseOwnersQuery, GetCaseOwnersQueryVariables>;
export const GetCasePreferencesDocument = gql`
    query getCasePreferences($id: ID!) {
  case(id: $id) {
    id
    details {
      id
      change_of_preference_reason
      preference_interest_only_repayment_strategy
      preference_upper_limit
      preference_fixed_rate
      preference_early_year_discount
      preference_no_early_repayment_charge
      preference_no_tie_in
      preference_fee_to_loan
      preference_vary_repayment_amount
      preference_payment_holiday
      preference_link_finances
      preference_details
      preference_term
      preference_repayment_percentage
      preference_cashback
      preference_initial_period_months
      preference_mortgage_class
      preference_free_conveyancing
      preference_free_valuations
      preference_completion_speed_important
      preference_tracker
      preference_overpayment
      preference_target_property_value
    }
  }
}
    `;

/**
 * __useGetCasePreferencesQuery__
 *
 * To run a query within a React component, call `useGetCasePreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasePreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasePreferencesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCasePreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetCasePreferencesQuery, GetCasePreferencesQueryVariables> & ({ variables: GetCasePreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>(GetCasePreferencesDocument, options);
      }
export function useGetCasePreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>(GetCasePreferencesDocument, options);
        }
// @ts-ignore
export function useGetCasePreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>;
export function useGetCasePreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasePreferencesQuery | undefined, GetCasePreferencesQueryVariables>;
export function useGetCasePreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>(GetCasePreferencesDocument, options);
        }
export type GetCasePreferencesQueryHookResult = ReturnType<typeof useGetCasePreferencesQuery>;
export type GetCasePreferencesLazyQueryHookResult = ReturnType<typeof useGetCasePreferencesLazyQuery>;
export type GetCasePreferencesSuspenseQueryHookResult = ReturnType<typeof useGetCasePreferencesSuspenseQuery>;
export type GetCasePreferencesQueryResult = Apollo.QueryResult<GetCasePreferencesQuery, GetCasePreferencesQueryVariables>;
export const GetCasePropertiesDocument = gql`
    query getCaseProperties($id: ID!, $includeCaseDetailsInProperty: Boolean = true, $includeDirectorsProperties: Boolean = false, $includeSourceResponse: Boolean = false) {
  case(id: $id, include_source_response: $includeSourceResponse) {
    id
    details {
      id
      ...CaseTransitionVersions
      change_of_preference_reason
      client_ids
      preference_mortgage_reason
      preference_target_property
      preference_related_property_sale
      new_property {
        ...PropertyDetails
      }
      remortgage_property {
        ...PropertyDetails
      }
      property_portfolio(includeDirectorsProperties: $includeDirectorsProperties) {
        ...PropertyDetails
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          organisation_name
          is_natural_person
        }
      }
    }
  }
}
    ${CaseTransitionVersionsFragmentDoc}
${PropertyDetailsFragmentDoc}`;

/**
 * __useGetCasePropertiesQuery__
 *
 * To run a query within a React component, call `useGetCasePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasePropertiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *      includeDirectorsProperties: // value for 'includeDirectorsProperties'
 *      includeSourceResponse: // value for 'includeSourceResponse'
 *   },
 * });
 */
export function useGetCasePropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetCasePropertiesQuery, GetCasePropertiesQueryVariables> & ({ variables: GetCasePropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>(GetCasePropertiesDocument, options);
      }
export function useGetCasePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>(GetCasePropertiesDocument, options);
        }
// @ts-ignore
export function useGetCasePropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>;
export function useGetCasePropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasePropertiesQuery | undefined, GetCasePropertiesQueryVariables>;
export function useGetCasePropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>(GetCasePropertiesDocument, options);
        }
export type GetCasePropertiesQueryHookResult = ReturnType<typeof useGetCasePropertiesQuery>;
export type GetCasePropertiesLazyQueryHookResult = ReturnType<typeof useGetCasePropertiesLazyQuery>;
export type GetCasePropertiesSuspenseQueryHookResult = ReturnType<typeof useGetCasePropertiesSuspenseQuery>;
export type GetCasePropertiesQueryResult = Apollo.QueryResult<GetCasePropertiesQuery, GetCasePropertiesQueryVariables>;
export const GetCaseReferralListDocument = gql`
    query getCaseReferralList($input: GetCaseReferralListFilterInput!) {
  getCaseReferralList(input: $input) {
    stats {
      count
    }
    cases {
      advisor_name
      advisor_id
      case_id
      lender_id
      case_status
      case_type
      last_editor_type
      recent_client_doc
      client_ids
      created_at
      introducer_id
      related_users {
        id
        user_id
        relationship_type
      }
      modified_at
      mortgage_amount
      flags
      organisation_name
      transition_at
      offer_date
      exchange_date
      recommendation_date
      review_date
      submitted_date
      completed_date
      first_offer_date
      first_exchange_date
      first_recommendation_date
      first_review_date
      first_submitted_date
      first_completed_date
      regulated_by_name
      logged_in_to_client_portal
      credit_report_done
      meeting_booked
      org_id
      org_ids
      predicted_revenue
      property_id
      address {
        address1
        address2
        address3
        postcode
        posttown
        county
        country
      }
      advisor {
        id
        first_name
        last_name
      }
      lender {
        name
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          is_natural_person
          organisation_name
        }
      }
      introducer {
        id
        name
      }
      notes {
        assignee_id
        communication_type
        deadline
        primary_type
        priority
        status
        title
        template_id
      }
    }
    next_page {
      bookmark
    }
  }
}
    `;

/**
 * __useGetCaseReferralListQuery__
 *
 * To run a query within a React component, call `useGetCaseReferralListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseReferralListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseReferralListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCaseReferralListQuery(baseOptions: Apollo.QueryHookOptions<GetCaseReferralListQuery, GetCaseReferralListQueryVariables> & ({ variables: GetCaseReferralListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>(GetCaseReferralListDocument, options);
      }
export function useGetCaseReferralListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>(GetCaseReferralListDocument, options);
        }
// @ts-ignore
export function useGetCaseReferralListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>;
export function useGetCaseReferralListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseReferralListQuery | undefined, GetCaseReferralListQueryVariables>;
export function useGetCaseReferralListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>(GetCaseReferralListDocument, options);
        }
export type GetCaseReferralListQueryHookResult = ReturnType<typeof useGetCaseReferralListQuery>;
export type GetCaseReferralListLazyQueryHookResult = ReturnType<typeof useGetCaseReferralListLazyQuery>;
export type GetCaseReferralListSuspenseQueryHookResult = ReturnType<typeof useGetCaseReferralListSuspenseQuery>;
export type GetCaseReferralListQueryResult = Apollo.QueryResult<GetCaseReferralListQuery, GetCaseReferralListQueryVariables>;
export const GetCaseSearchResultsDocument = gql`
    query getCaseSearchResults($searchFragment: String!, $bookmark: Int) {
  caseSearch(searchFragment: $searchFragment, bookmark: $bookmark) {
    total_results
    link
    bookmark
    results {
      id
      doctype
      regulating_org_id
      regulating_org_name
      owning_user_id
      owning_org_id
      owning_org_name
      created_at
      modified_at
      client_ids
      case_status
      case_reason
      address {
        address1
        country
        post_town
        postcode
      }
      Clients {
        address1
        address2
        address3
        created_at
        credit_report_done
        doctype
        email
        first_name
        id
        is_natural_person
        last_name
        logged_in_to_client_portal
        modified_at
        organisation_name
        phone_number
        postcode
        town
      }
      GeneralInsurance {
        created_at
        doctype
        id
        modified_at
        policy_number
        status
      }
      Mortgages {
        assumes_continuing
        created_at
        doctype
        fees_added_to_loan
        first_or_second_charge
        id
        initial_payment
        initial_rate
        initial_rate_end_date
        initial_rate_type
        initial_term_days
        lender
        lender_id
        modified_at
        mortgage_account_number
        mortgage_amount
        mortgage_status
        mortgage_type
        offer_expiry_date
        part_and_part_amount
        proc_fee
        property_id
        repaid_date
        repayment_method
        revert_payment
        revert_rate
        source_rank
        start_date
        term_months
      }
      Protection {
        benefit
        case_id
        client_id
        created_at
        doctype
        end_date
        id
        initial_commission
        initial_commission_frequency
        initial_end_date
        modified_at
        policy_number
        product_name
        provider
        renewal_commission
        renewal_commission_frequency
        renewal_end
        renewal_start
        solution_type
        start_date
        status
      }
    }
  }
}
    `;

/**
 * __useGetCaseSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetCaseSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseSearchResultsQuery({
 *   variables: {
 *      searchFragment: // value for 'searchFragment'
 *      bookmark: // value for 'bookmark'
 *   },
 * });
 */
export function useGetCaseSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables> & ({ variables: GetCaseSearchResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>(GetCaseSearchResultsDocument, options);
      }
export function useGetCaseSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>(GetCaseSearchResultsDocument, options);
        }
// @ts-ignore
export function useGetCaseSearchResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>;
export function useGetCaseSearchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseSearchResultsQuery | undefined, GetCaseSearchResultsQueryVariables>;
export function useGetCaseSearchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>(GetCaseSearchResultsDocument, options);
        }
export type GetCaseSearchResultsQueryHookResult = ReturnType<typeof useGetCaseSearchResultsQuery>;
export type GetCaseSearchResultsLazyQueryHookResult = ReturnType<typeof useGetCaseSearchResultsLazyQuery>;
export type GetCaseSearchResultsSuspenseQueryHookResult = ReturnType<typeof useGetCaseSearchResultsSuspenseQuery>;
export type GetCaseSearchResultsQueryResult = Apollo.QueryResult<GetCaseSearchResultsQuery, GetCaseSearchResultsQueryVariables>;
export const GetCaseSuitabilityDocument = gql`
    query getCaseSuitability($id: ID!) {
  case(id: $id) {
    id
    created_at
    version_created_at
    details {
      id
      change_of_preference_reason
      recommendation_term_reason
      recommendation_reason_for_affordability
      recommendation_reason_for_recommendation
      reason_for_recommendation_product_type
      reason_for_recommendation_initial_term
      recommendation_reason_for_remortgage_cost_increase
      recommendation_reason_for_recommendation_term_increase
      recommendation_reason_term_into_retirement
      recommendation_reason_additional_borrowing
      debt_consolidation_alternative_options
      debt_consolidation_reason_for_consolidated_debts
      suitability_report_recommendation_introduction
      recommendation_reason_strategy_for_btl_void_period_coverage
      recommendation_reason_help_to_buy_loan_repayment_strategy
      recommendation_reason_retirement_interest_only
      preference_details
      preference_interest_only_repayment_strategy
      pay_rise_expected_details
      recommendation_reason_for_further_advance
      recommendation_reason_entitlement_to_state_benefits
      recommendation_strategy_for_payment_erc
      recommendation_reason_for_equity_disparity
      shared_equity_repayment_details
      mortgages {
        id
        version
        status
        mortgage_product_select_reason
      }
    }
  }
}
    `;

/**
 * __useGetCaseSuitabilityQuery__
 *
 * To run a query within a React component, call `useGetCaseSuitabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseSuitabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseSuitabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseSuitabilityQuery(baseOptions: Apollo.QueryHookOptions<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables> & ({ variables: GetCaseSuitabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>(GetCaseSuitabilityDocument, options);
      }
export function useGetCaseSuitabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>(GetCaseSuitabilityDocument, options);
        }
// @ts-ignore
export function useGetCaseSuitabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>;
export function useGetCaseSuitabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseSuitabilityQuery | undefined, GetCaseSuitabilityQueryVariables>;
export function useGetCaseSuitabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>(GetCaseSuitabilityDocument, options);
        }
export type GetCaseSuitabilityQueryHookResult = ReturnType<typeof useGetCaseSuitabilityQuery>;
export type GetCaseSuitabilityLazyQueryHookResult = ReturnType<typeof useGetCaseSuitabilityLazyQuery>;
export type GetCaseSuitabilitySuspenseQueryHookResult = ReturnType<typeof useGetCaseSuitabilitySuspenseQuery>;
export type GetCaseSuitabilityQueryResult = Apollo.QueryResult<GetCaseSuitabilityQuery, GetCaseSuitabilityQueryVariables>;
export const GetCaseVerificationsDocument = gql`
    query getCaseVerifications($id: ID!, $show_pass: Boolean, $show_documents: Boolean = true) {
  case(id: $id, show_pass: $show_pass, show_documents: $show_documents) {
    id
    version
    details {
      id
      status
      owner_user_id
      verifications(show_pass: $show_pass, show_documents: $show_documents) {
        will_need_review
        verification_collections {
          collection_id
          name
          passed
          version
          outstanding_optional
          required_for_future_transition
          required_for_next_transition
          verifications {
            ...VerificationEntitiesFragment
            verification_id
            name
            passed
            explanation
            case_id
            client_id
            mortgage_id
            product_id
            property_id
            failed_fields
            flag
            iterable_id
            optional
            auto_satisfy {
              document_types
              count
              satisfied_document_ids
            }
          }
        }
      }
    }
  }
}
    ${VerificationEntitiesFragmentFragmentDoc}`;

/**
 * __useGetCaseVerificationsQuery__
 *
 * To run a query within a React component, call `useGetCaseVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseVerificationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      show_pass: // value for 'show_pass'
 *      show_documents: // value for 'show_documents'
 *   },
 * });
 */
export function useGetCaseVerificationsQuery(baseOptions: Apollo.QueryHookOptions<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables> & ({ variables: GetCaseVerificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>(GetCaseVerificationsDocument, options);
      }
export function useGetCaseVerificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>(GetCaseVerificationsDocument, options);
        }
// @ts-ignore
export function useGetCaseVerificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>;
export function useGetCaseVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseVerificationsQuery | undefined, GetCaseVerificationsQueryVariables>;
export function useGetCaseVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>(GetCaseVerificationsDocument, options);
        }
export type GetCaseVerificationsQueryHookResult = ReturnType<typeof useGetCaseVerificationsQuery>;
export type GetCaseVerificationsLazyQueryHookResult = ReturnType<typeof useGetCaseVerificationsLazyQuery>;
export type GetCaseVerificationsSuspenseQueryHookResult = ReturnType<typeof useGetCaseVerificationsSuspenseQuery>;
export type GetCaseVerificationsQueryResult = Apollo.QueryResult<GetCaseVerificationsQuery, GetCaseVerificationsQueryVariables>;
export const GetCaseVersionsTimelineDocument = gql`
    query getCaseVersionsTimeline($id: ID!) {
  caseVersionsTimeline(id: $id) {
    timeline {
      editor {
        id
        type
      }
      editor_name
      case_id
      status
      version_from
      version_to
      show_history
      transitioned_at
      property_versions {
        id
        version_from
        version_to
        show_history
      }
      client_versions {
        id
        version_from
        version_to
        show_history
      }
      mortgage_versions {
        id
        version_from
        version_to
        show_history
      }
    }
  }
}
    `;

/**
 * __useGetCaseVersionsTimelineQuery__
 *
 * To run a query within a React component, call `useGetCaseVersionsTimelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseVersionsTimelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseVersionsTimelineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseVersionsTimelineQuery(baseOptions: Apollo.QueryHookOptions<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables> & ({ variables: GetCaseVersionsTimelineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>(GetCaseVersionsTimelineDocument, options);
      }
export function useGetCaseVersionsTimelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>(GetCaseVersionsTimelineDocument, options);
        }
// @ts-ignore
export function useGetCaseVersionsTimelineSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>;
export function useGetCaseVersionsTimelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseVersionsTimelineQuery | undefined, GetCaseVersionsTimelineQueryVariables>;
export function useGetCaseVersionsTimelineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>(GetCaseVersionsTimelineDocument, options);
        }
export type GetCaseVersionsTimelineQueryHookResult = ReturnType<typeof useGetCaseVersionsTimelineQuery>;
export type GetCaseVersionsTimelineLazyQueryHookResult = ReturnType<typeof useGetCaseVersionsTimelineLazyQuery>;
export type GetCaseVersionsTimelineSuspenseQueryHookResult = ReturnType<typeof useGetCaseVersionsTimelineSuspenseQuery>;
export type GetCaseVersionsTimelineQueryResult = Apollo.QueryResult<GetCaseVersionsTimelineQuery, GetCaseVersionsTimelineQueryVariables>;
export const GetCasesDocument = gql`
    query getCases($ids: [ID!]!) {
  cases(ids: $ids) {
    id
    created_at
    version
    version_created_at
    details {
      id
      preference_mortgage_reason
      status
      clients {
        id
        version
        details {
          id
          ...ClientDetails
        }
      }
      related_users {
        commission_share_basis_points
        id
        relationship_type
        user_id
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}`;

/**
 * __useGetCasesQuery__
 *
 * To run a query within a React component, call `useGetCasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCasesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetCasesQuery(baseOptions: Apollo.QueryHookOptions<GetCasesQuery, GetCasesQueryVariables> & ({ variables: GetCasesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCasesQuery, GetCasesQueryVariables>(GetCasesDocument, options);
      }
export function useGetCasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCasesQuery, GetCasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCasesQuery, GetCasesQueryVariables>(GetCasesDocument, options);
        }
// @ts-ignore
export function useGetCasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCasesQuery, GetCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasesQuery, GetCasesQueryVariables>;
export function useGetCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasesQuery, GetCasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCasesQuery | undefined, GetCasesQueryVariables>;
export function useGetCasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCasesQuery, GetCasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCasesQuery, GetCasesQueryVariables>(GetCasesDocument, options);
        }
export type GetCasesQueryHookResult = ReturnType<typeof useGetCasesQuery>;
export type GetCasesLazyQueryHookResult = ReturnType<typeof useGetCasesLazyQuery>;
export type GetCasesSuspenseQueryHookResult = ReturnType<typeof useGetCasesSuspenseQuery>;
export type GetCasesQueryResult = Apollo.QueryResult<GetCasesQuery, GetCasesQueryVariables>;
export const GetClientByVersionDocument = gql`
    query getClientByVersion($id: ID!, $version: Int!, $show_history: Int) {
  clientVersion(id: $id, version: $version, show_history: $show_history) {
    id
    created_at
    version
    version_created_at
    details {
      id
      ...ClientDetails
      miDocuments {
        documents {
          ...MIDocuments
          clients {
            id
            version
            details {
              id
              client_id
              is_natural_person
              first_name
              middle_name
              last_name
              organisation_name
            }
          }
        }
      }
    }
    versions {
      ...VersionWithChangedFields
    }
  }
}
    ${ClientDetailsFragmentDoc}
${MiDocumentsFragmentDoc}
${VersionWithChangedFieldsFragmentDoc}`;

/**
 * __useGetClientByVersionQuery__
 *
 * To run a query within a React component, call `useGetClientByVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientByVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientByVersionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *      show_history: // value for 'show_history'
 *   },
 * });
 */
export function useGetClientByVersionQuery(baseOptions: Apollo.QueryHookOptions<GetClientByVersionQuery, GetClientByVersionQueryVariables> & ({ variables: GetClientByVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientByVersionQuery, GetClientByVersionQueryVariables>(GetClientByVersionDocument, options);
      }
export function useGetClientByVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientByVersionQuery, GetClientByVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientByVersionQuery, GetClientByVersionQueryVariables>(GetClientByVersionDocument, options);
        }
// @ts-ignore
export function useGetClientByVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientByVersionQuery, GetClientByVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientByVersionQuery, GetClientByVersionQueryVariables>;
export function useGetClientByVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientByVersionQuery, GetClientByVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientByVersionQuery | undefined, GetClientByVersionQueryVariables>;
export function useGetClientByVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientByVersionQuery, GetClientByVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientByVersionQuery, GetClientByVersionQueryVariables>(GetClientByVersionDocument, options);
        }
export type GetClientByVersionQueryHookResult = ReturnType<typeof useGetClientByVersionQuery>;
export type GetClientByVersionLazyQueryHookResult = ReturnType<typeof useGetClientByVersionLazyQuery>;
export type GetClientByVersionSuspenseQueryHookResult = ReturnType<typeof useGetClientByVersionSuspenseQuery>;
export type GetClientByVersionQueryResult = Apollo.QueryResult<GetClientByVersionQuery, GetClientByVersionQueryVariables>;
export const GetClientCaseListDocument = gql`
    query getClientCaseList($clientId: ID!, $fromClientPortal: Boolean, $includeClientNames: Boolean = true, $includeProperty: Boolean = false, $includeCRMProperty: Boolean = false, $includeCaseDetailsInProperty: Boolean = false, $includeMortgageProduct: Boolean = false) {
  clientCases(clientId: $clientId, fromClientPortal: $fromClientPortal) {
    id
    created_at
    version
    version_created_at
    details {
      id
      status
      owner_user_id
      preference_mortgage_reason
      client_ids
      regulated_by
      ...ClientNames @include(if: $includeClientNames)
      new_property_cp @include(if: $includeProperty) {
        id
        property_id
        details {
          ...PropertyDetailsCp
        }
      }
      new_property @include(if: $includeCRMProperty) {
        ...PropertyDetails
      }
    }
  }
}
    ${ClientNamesFragmentDoc}
${PropertyDetailsCpFragmentDoc}
${PropertyDetailsFragmentDoc}`;

/**
 * __useGetClientCaseListQuery__
 *
 * To run a query within a React component, call `useGetClientCaseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCaseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCaseListQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      fromClientPortal: // value for 'fromClientPortal'
 *      includeClientNames: // value for 'includeClientNames'
 *      includeProperty: // value for 'includeProperty'
 *      includeCRMProperty: // value for 'includeCRMProperty'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetClientCaseListQuery(baseOptions: Apollo.QueryHookOptions<GetClientCaseListQuery, GetClientCaseListQueryVariables> & ({ variables: GetClientCaseListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCaseListQuery, GetClientCaseListQueryVariables>(GetClientCaseListDocument, options);
      }
export function useGetClientCaseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCaseListQuery, GetClientCaseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCaseListQuery, GetClientCaseListQueryVariables>(GetClientCaseListDocument, options);
        }
// @ts-ignore
export function useGetClientCaseListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientCaseListQuery, GetClientCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientCaseListQuery, GetClientCaseListQueryVariables>;
export function useGetClientCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientCaseListQuery, GetClientCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientCaseListQuery | undefined, GetClientCaseListQueryVariables>;
export function useGetClientCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientCaseListQuery, GetClientCaseListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientCaseListQuery, GetClientCaseListQueryVariables>(GetClientCaseListDocument, options);
        }
export type GetClientCaseListQueryHookResult = ReturnType<typeof useGetClientCaseListQuery>;
export type GetClientCaseListLazyQueryHookResult = ReturnType<typeof useGetClientCaseListLazyQuery>;
export type GetClientCaseListSuspenseQueryHookResult = ReturnType<typeof useGetClientCaseListSuspenseQuery>;
export type GetClientCaseListQueryResult = Apollo.QueryResult<GetClientCaseListQuery, GetClientCaseListQueryVariables>;
export const GetClientCreditIddsDocument = gql`
    query getClientCreditIdds($ids: [ID!]!) {
  clients(ids: $ids) {
    id
    version
    details {
      id
      credit_idd {
        document_id
        internalHash
        document_signature
        data_base64
        verifications {
          verification_id
        }
      }
    }
  }
}
    `;

/**
 * __useGetClientCreditIddsQuery__
 *
 * To run a query within a React component, call `useGetClientCreditIddsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCreditIddsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCreditIddsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetClientCreditIddsQuery(baseOptions: Apollo.QueryHookOptions<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables> & ({ variables: GetClientCreditIddsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>(GetClientCreditIddsDocument, options);
      }
export function useGetClientCreditIddsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>(GetClientCreditIddsDocument, options);
        }
// @ts-ignore
export function useGetClientCreditIddsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>;
export function useGetClientCreditIddsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientCreditIddsQuery | undefined, GetClientCreditIddsQueryVariables>;
export function useGetClientCreditIddsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>(GetClientCreditIddsDocument, options);
        }
export type GetClientCreditIddsQueryHookResult = ReturnType<typeof useGetClientCreditIddsQuery>;
export type GetClientCreditIddsLazyQueryHookResult = ReturnType<typeof useGetClientCreditIddsLazyQuery>;
export type GetClientCreditIddsSuspenseQueryHookResult = ReturnType<typeof useGetClientCreditIddsSuspenseQuery>;
export type GetClientCreditIddsQueryResult = Apollo.QueryResult<GetClientCreditIddsQuery, GetClientCreditIddsQueryVariables>;
export const GetClientDocumentsDocument = gql`
    query getClientDocuments($id: ID!, $filters: MIDocumentSummaryFiltersInput) {
  client(id: $id, filters: $filters) {
    id
    version
    details {
      id
      miDocuments(filters: $filters) {
        filters {
          bookmark
          page_size
        }
        next_page {
          bookmark
        }
        documents {
          ...MIDocuments
        }
      }
    }
  }
}
    ${MiDocumentsFragmentDoc}`;

/**
 * __useGetClientDocumentsQuery__
 *
 * To run a query within a React component, call `useGetClientDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClientDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetClientDocumentsQuery, GetClientDocumentsQueryVariables> & ({ variables: GetClientDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>(GetClientDocumentsDocument, options);
      }
export function useGetClientDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>(GetClientDocumentsDocument, options);
        }
// @ts-ignore
export function useGetClientDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>;
export function useGetClientDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientDocumentsQuery | undefined, GetClientDocumentsQueryVariables>;
export function useGetClientDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>(GetClientDocumentsDocument, options);
        }
export type GetClientDocumentsQueryHookResult = ReturnType<typeof useGetClientDocumentsQuery>;
export type GetClientDocumentsLazyQueryHookResult = ReturnType<typeof useGetClientDocumentsLazyQuery>;
export type GetClientDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetClientDocumentsSuspenseQuery>;
export type GetClientDocumentsQueryResult = Apollo.QueryResult<GetClientDocumentsQuery, GetClientDocumentsQueryVariables>;
export const GetClientHealthDocument = gql`
    query getClientHealth($id: ID!, $version: Int) {
  client(id: $id, version: $version) {
    id
    version
    details {
      id
      ...ClientHealth
    }
  }
}
    ${ClientHealthFragmentDoc}`;

/**
 * __useGetClientHealthQuery__
 *
 * To run a query within a React component, call `useGetClientHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientHealthQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetClientHealthQuery(baseOptions: Apollo.QueryHookOptions<GetClientHealthQuery, GetClientHealthQueryVariables> & ({ variables: GetClientHealthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientHealthQuery, GetClientHealthQueryVariables>(GetClientHealthDocument, options);
      }
export function useGetClientHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientHealthQuery, GetClientHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientHealthQuery, GetClientHealthQueryVariables>(GetClientHealthDocument, options);
        }
// @ts-ignore
export function useGetClientHealthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientHealthQuery, GetClientHealthQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientHealthQuery, GetClientHealthQueryVariables>;
export function useGetClientHealthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientHealthQuery, GetClientHealthQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientHealthQuery | undefined, GetClientHealthQueryVariables>;
export function useGetClientHealthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientHealthQuery, GetClientHealthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientHealthQuery, GetClientHealthQueryVariables>(GetClientHealthDocument, options);
        }
export type GetClientHealthQueryHookResult = ReturnType<typeof useGetClientHealthQuery>;
export type GetClientHealthLazyQueryHookResult = ReturnType<typeof useGetClientHealthLazyQuery>;
export type GetClientHealthSuspenseQueryHookResult = ReturnType<typeof useGetClientHealthSuspenseQuery>;
export type GetClientHealthQueryResult = Apollo.QueryResult<GetClientHealthQuery, GetClientHealthQueryVariables>;
export const GetClientMiDocumentCategoriesDocument = gql`
    query getClientMiDocumentCategories($id: ID!, $version: Int!, $filters: MIDocumentTotalsFiltersInput) {
  client(id: $id, version: $version) {
    id
    version
    details {
      id
      cases {
        id
        version
        created_at
        details {
          id
          preference_mortgage_reason
          new_property {
            id
            version
            details {
              id
              address {
                address1
              }
            }
          }
        }
      }
      document_totals(filters: $filters) {
        group_id
        count
      }
      document_categories(id: $id, version: $version, filters: $filters) @client {
        categoryId
        title
        subTitle
        count
      }
    }
  }
}
    `;

/**
 * __useGetClientMiDocumentCategoriesQuery__
 *
 * To run a query within a React component, call `useGetClientMiDocumentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientMiDocumentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientMiDocumentCategoriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClientMiDocumentCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables> & ({ variables: GetClientMiDocumentCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>(GetClientMiDocumentCategoriesDocument, options);
      }
export function useGetClientMiDocumentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>(GetClientMiDocumentCategoriesDocument, options);
        }
// @ts-ignore
export function useGetClientMiDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>;
export function useGetClientMiDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientMiDocumentCategoriesQuery | undefined, GetClientMiDocumentCategoriesQueryVariables>;
export function useGetClientMiDocumentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>(GetClientMiDocumentCategoriesDocument, options);
        }
export type GetClientMiDocumentCategoriesQueryHookResult = ReturnType<typeof useGetClientMiDocumentCategoriesQuery>;
export type GetClientMiDocumentCategoriesLazyQueryHookResult = ReturnType<typeof useGetClientMiDocumentCategoriesLazyQuery>;
export type GetClientMiDocumentCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetClientMiDocumentCategoriesSuspenseQuery>;
export type GetClientMiDocumentCategoriesQueryResult = Apollo.QueryResult<GetClientMiDocumentCategoriesQuery, GetClientMiDocumentCategoriesQueryVariables>;
export const GetClientMiDocumentsDocument = gql`
    query getClientMiDocuments($id: ID!, $filters: MIDocumentSummaryFiltersInput) {
  client(id: $id, filters: $filters) {
    id
    version
    details {
      id
      miDocuments(filters: $filters) {
        filters {
          bookmark
          page_size
        }
        next_page {
          bookmark
        }
        documents {
          ...MIDocuments
        }
      }
    }
  }
}
    ${MiDocumentsFragmentDoc}`;

/**
 * __useGetClientMiDocumentsQuery__
 *
 * To run a query within a React component, call `useGetClientMiDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientMiDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientMiDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClientMiDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables> & ({ variables: GetClientMiDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>(GetClientMiDocumentsDocument, options);
      }
export function useGetClientMiDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>(GetClientMiDocumentsDocument, options);
        }
// @ts-ignore
export function useGetClientMiDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>;
export function useGetClientMiDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientMiDocumentsQuery | undefined, GetClientMiDocumentsQueryVariables>;
export function useGetClientMiDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>(GetClientMiDocumentsDocument, options);
        }
export type GetClientMiDocumentsQueryHookResult = ReturnType<typeof useGetClientMiDocumentsQuery>;
export type GetClientMiDocumentsLazyQueryHookResult = ReturnType<typeof useGetClientMiDocumentsLazyQuery>;
export type GetClientMiDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetClientMiDocumentsSuspenseQuery>;
export type GetClientMiDocumentsQueryResult = Apollo.QueryResult<GetClientMiDocumentsQuery, GetClientMiDocumentsQueryVariables>;
export const GetClientMortgagesDocument = gql`
    query getClientMortgages($id: ID!, $version: Int) {
  client(id: $id, version: $version) {
    id
    version
    details {
      id
      mortgages {
        ...CaseMortgagesAndMortgageProducts
      }
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}`;

/**
 * __useGetClientMortgagesQuery__
 *
 * To run a query within a React component, call `useGetClientMortgagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientMortgagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientMortgagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetClientMortgagesQuery(baseOptions: Apollo.QueryHookOptions<GetClientMortgagesQuery, GetClientMortgagesQueryVariables> & ({ variables: GetClientMortgagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>(GetClientMortgagesDocument, options);
      }
export function useGetClientMortgagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>(GetClientMortgagesDocument, options);
        }
// @ts-ignore
export function useGetClientMortgagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>;
export function useGetClientMortgagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientMortgagesQuery | undefined, GetClientMortgagesQueryVariables>;
export function useGetClientMortgagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>(GetClientMortgagesDocument, options);
        }
export type GetClientMortgagesQueryHookResult = ReturnType<typeof useGetClientMortgagesQuery>;
export type GetClientMortgagesLazyQueryHookResult = ReturnType<typeof useGetClientMortgagesLazyQuery>;
export type GetClientMortgagesSuspenseQueryHookResult = ReturnType<typeof useGetClientMortgagesSuspenseQuery>;
export type GetClientMortgagesQueryResult = Apollo.QueryResult<GetClientMortgagesQuery, GetClientMortgagesQueryVariables>;
export const GetClientNameDocument = gql`
    query getClientName($id: ID!, $version: Int) {
  client(id: $id, version: $version) {
    id
    version
    details {
      id
      ...ClientDetails
    }
  }
}
    ${ClientDetailsFragmentDoc}`;

/**
 * __useGetClientNameQuery__
 *
 * To run a query within a React component, call `useGetClientNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetClientNameQuery(baseOptions: Apollo.QueryHookOptions<GetClientNameQuery, GetClientNameQueryVariables> & ({ variables: GetClientNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientNameQuery, GetClientNameQueryVariables>(GetClientNameDocument, options);
      }
export function useGetClientNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientNameQuery, GetClientNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientNameQuery, GetClientNameQueryVariables>(GetClientNameDocument, options);
        }
// @ts-ignore
export function useGetClientNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientNameQuery, GetClientNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientNameQuery, GetClientNameQueryVariables>;
export function useGetClientNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientNameQuery, GetClientNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientNameQuery | undefined, GetClientNameQueryVariables>;
export function useGetClientNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientNameQuery, GetClientNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientNameQuery, GetClientNameQueryVariables>(GetClientNameDocument, options);
        }
export type GetClientNameQueryHookResult = ReturnType<typeof useGetClientNameQuery>;
export type GetClientNameLazyQueryHookResult = ReturnType<typeof useGetClientNameLazyQuery>;
export type GetClientNameSuspenseQueryHookResult = ReturnType<typeof useGetClientNameSuspenseQuery>;
export type GetClientNameQueryResult = Apollo.QueryResult<GetClientNameQuery, GetClientNameQueryVariables>;
export const GetClientOrganisationRelationshipDocument = gql`
    query getClientOrganisationRelationship($client_id: String!, $organisation_id_or_ext: String) {
  clientOrganisationRelationship(
    client_id: $client_id
    organisation_id_or_ext: $organisation_id_or_ext
  ) {
    org_id
    client_id
    relationship_type
  }
}
    `;

/**
 * __useGetClientOrganisationRelationshipQuery__
 *
 * To run a query within a React component, call `useGetClientOrganisationRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrganisationRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrganisationRelationshipQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *      organisation_id_or_ext: // value for 'organisation_id_or_ext'
 *   },
 * });
 */
export function useGetClientOrganisationRelationshipQuery(baseOptions: Apollo.QueryHookOptions<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables> & ({ variables: GetClientOrganisationRelationshipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>(GetClientOrganisationRelationshipDocument, options);
      }
export function useGetClientOrganisationRelationshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>(GetClientOrganisationRelationshipDocument, options);
        }
// @ts-ignore
export function useGetClientOrganisationRelationshipSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>;
export function useGetClientOrganisationRelationshipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientOrganisationRelationshipQuery | undefined, GetClientOrganisationRelationshipQueryVariables>;
export function useGetClientOrganisationRelationshipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>(GetClientOrganisationRelationshipDocument, options);
        }
export type GetClientOrganisationRelationshipQueryHookResult = ReturnType<typeof useGetClientOrganisationRelationshipQuery>;
export type GetClientOrganisationRelationshipLazyQueryHookResult = ReturnType<typeof useGetClientOrganisationRelationshipLazyQuery>;
export type GetClientOrganisationRelationshipSuspenseQueryHookResult = ReturnType<typeof useGetClientOrganisationRelationshipSuspenseQuery>;
export type GetClientOrganisationRelationshipQueryResult = Apollo.QueryResult<GetClientOrganisationRelationshipQuery, GetClientOrganisationRelationshipQueryVariables>;
export const GetClientOrganisationRelationshipsDocument = gql`
    query getClientOrganisationRelationships($client_id: String!) {
  clientOrganisationRelationships(client_id: $client_id) {
    org_id
    contact_by_phone
    contact_by_email
    contact_by_text
    contact_by_mail
    third_party_contact_by_phone
    third_party_contact_by_email
    third_party_contact_by_text
    third_party_contact_by_mail
  }
}
    `;

/**
 * __useGetClientOrganisationRelationshipsQuery__
 *
 * To run a query within a React component, call `useGetClientOrganisationRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOrganisationRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOrganisationRelationshipsQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *   },
 * });
 */
export function useGetClientOrganisationRelationshipsQuery(baseOptions: Apollo.QueryHookOptions<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables> & ({ variables: GetClientOrganisationRelationshipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>(GetClientOrganisationRelationshipsDocument, options);
      }
export function useGetClientOrganisationRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>(GetClientOrganisationRelationshipsDocument, options);
        }
// @ts-ignore
export function useGetClientOrganisationRelationshipsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>;
export function useGetClientOrganisationRelationshipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientOrganisationRelationshipsQuery | undefined, GetClientOrganisationRelationshipsQueryVariables>;
export function useGetClientOrganisationRelationshipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>(GetClientOrganisationRelationshipsDocument, options);
        }
export type GetClientOrganisationRelationshipsQueryHookResult = ReturnType<typeof useGetClientOrganisationRelationshipsQuery>;
export type GetClientOrganisationRelationshipsLazyQueryHookResult = ReturnType<typeof useGetClientOrganisationRelationshipsLazyQuery>;
export type GetClientOrganisationRelationshipsSuspenseQueryHookResult = ReturnType<typeof useGetClientOrganisationRelationshipsSuspenseQuery>;
export type GetClientOrganisationRelationshipsQueryResult = Apollo.QueryResult<GetClientOrganisationRelationshipsQuery, GetClientOrganisationRelationshipsQueryVariables>;
export const GetClientProfileDocument = gql`
    query getClientProfile($id: ID!, $version: Int) {
  client(id: $id, version: $version) {
    id
    version
    details {
      id
      ...ClientDetails
      miDocuments {
        documents {
          ...MIDocuments
        }
      }
      cases {
        id
        created_at
        details {
          id
          status
          preference_mortgage_reason
          regulated_by
        }
      }
      mortgages {
        ...CaseMortgagesAndMortgageProducts
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}
${MiDocumentsFragmentDoc}
${CaseMortgagesAndMortgageProductsFragmentDoc}`;

/**
 * __useGetClientProfileQuery__
 *
 * To run a query within a React component, call `useGetClientProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetClientProfileQuery(baseOptions: Apollo.QueryHookOptions<GetClientProfileQuery, GetClientProfileQueryVariables> & ({ variables: GetClientProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientProfileQuery, GetClientProfileQueryVariables>(GetClientProfileDocument, options);
      }
export function useGetClientProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientProfileQuery, GetClientProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientProfileQuery, GetClientProfileQueryVariables>(GetClientProfileDocument, options);
        }
// @ts-ignore
export function useGetClientProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientProfileQuery, GetClientProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientProfileQuery, GetClientProfileQueryVariables>;
export function useGetClientProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientProfileQuery, GetClientProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientProfileQuery | undefined, GetClientProfileQueryVariables>;
export function useGetClientProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientProfileQuery, GetClientProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientProfileQuery, GetClientProfileQueryVariables>(GetClientProfileDocument, options);
        }
export type GetClientProfileQueryHookResult = ReturnType<typeof useGetClientProfileQuery>;
export type GetClientProfileLazyQueryHookResult = ReturnType<typeof useGetClientProfileLazyQuery>;
export type GetClientProfileSuspenseQueryHookResult = ReturnType<typeof useGetClientProfileSuspenseQuery>;
export type GetClientProfileQueryResult = Apollo.QueryResult<GetClientProfileQuery, GetClientProfileQueryVariables>;
export const GetClientPropertiesDocument = gql`
    query getClientProperties($id: ID!, $includeCaseDetailsInProperty: Boolean = false, $includeDirectorsProperties: Boolean = false) {
  client(id: $id) {
    id
    version
    details {
      id
      cases {
        id
        details {
          id
          preference_mortgage_reason
        }
      }
      properties(includeDirectorsProperties: $includeDirectorsProperties) {
        ...PropertyDetails
      }
    }
  }
}
    ${PropertyDetailsFragmentDoc}`;

/**
 * __useGetClientPropertiesQuery__
 *
 * To run a query within a React component, call `useGetClientPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPropertiesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *      includeDirectorsProperties: // value for 'includeDirectorsProperties'
 *   },
 * });
 */
export function useGetClientPropertiesQuery(baseOptions: Apollo.QueryHookOptions<GetClientPropertiesQuery, GetClientPropertiesQueryVariables> & ({ variables: GetClientPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>(GetClientPropertiesDocument, options);
      }
export function useGetClientPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>(GetClientPropertiesDocument, options);
        }
// @ts-ignore
export function useGetClientPropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>;
export function useGetClientPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientPropertiesQuery | undefined, GetClientPropertiesQueryVariables>;
export function useGetClientPropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>(GetClientPropertiesDocument, options);
        }
export type GetClientPropertiesQueryHookResult = ReturnType<typeof useGetClientPropertiesQuery>;
export type GetClientPropertiesLazyQueryHookResult = ReturnType<typeof useGetClientPropertiesLazyQuery>;
export type GetClientPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetClientPropertiesSuspenseQuery>;
export type GetClientPropertiesQueryResult = Apollo.QueryResult<GetClientPropertiesQuery, GetClientPropertiesQueryVariables>;
export const GetClientProtectedFieldsDocument = gql`
    query getClientProtectedFields($id: ID!, $protectedFields: [String!], $date_of_birth: Boolean = false, $maiden_or_previous_name: Boolean = false, $accounts: Boolean = false, $sort_code: Boolean = false, $number: Boolean = false, $previous_names: Boolean = false, $previous_first_name: Boolean = false, $previous_surname: Boolean = false) {
  clientProtectedFields(
    id: $id
    protectedFields: $protectedFields
    date_of_birth: $date_of_birth
    maiden_or_previous_name: $maiden_or_previous_name
    accounts: $accounts
    sort_code: $sort_code
    number: $number
    previous_names: $previous_names
    previous_first_name: $previous_first_name
    previous_surname: $previous_surname
  ) {
    id
    details {
      id
      maiden_or_previous_name @include(if: $maiden_or_previous_name)
      date_of_birth @include(if: $date_of_birth)
      accounts @include(if: $accounts) {
        sort_code @include(if: $sort_code)
        number @include(if: $number)
      }
      previous_names {
        id
        internalHash
        previous_first_name
        previous_surname
      }
    }
  }
}
    `;

/**
 * __useGetClientProtectedFieldsQuery__
 *
 * To run a query within a React component, call `useGetClientProtectedFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientProtectedFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientProtectedFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      protectedFields: // value for 'protectedFields'
 *      date_of_birth: // value for 'date_of_birth'
 *      maiden_or_previous_name: // value for 'maiden_or_previous_name'
 *      accounts: // value for 'accounts'
 *      sort_code: // value for 'sort_code'
 *      number: // value for 'number'
 *      previous_names: // value for 'previous_names'
 *      previous_first_name: // value for 'previous_first_name'
 *      previous_surname: // value for 'previous_surname'
 *   },
 * });
 */
export function useGetClientProtectedFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables> & ({ variables: GetClientProtectedFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>(GetClientProtectedFieldsDocument, options);
      }
export function useGetClientProtectedFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>(GetClientProtectedFieldsDocument, options);
        }
// @ts-ignore
export function useGetClientProtectedFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>;
export function useGetClientProtectedFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientProtectedFieldsQuery | undefined, GetClientProtectedFieldsQueryVariables>;
export function useGetClientProtectedFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>(GetClientProtectedFieldsDocument, options);
        }
export type GetClientProtectedFieldsQueryHookResult = ReturnType<typeof useGetClientProtectedFieldsQuery>;
export type GetClientProtectedFieldsLazyQueryHookResult = ReturnType<typeof useGetClientProtectedFieldsLazyQuery>;
export type GetClientProtectedFieldsSuspenseQueryHookResult = ReturnType<typeof useGetClientProtectedFieldsSuspenseQuery>;
export type GetClientProtectedFieldsQueryResult = Apollo.QueryResult<GetClientProtectedFieldsQuery, GetClientProtectedFieldsQueryVariables>;
export const GetClientSummariesDocument = gql`
    query getClientSummaries($client_details: Boolean, $show_protected: [String!], $show_summary: Boolean, $client_ids: [String!], $filter_organisation_id: String, $filter_email_address: String, $filter_client_ext_ids: [String!], $filter_order_reverse: Boolean, $bookmark: String, $page_size: Int) {
  clientList(
    client_details: $client_details
    show_protected: $show_protected
    show_summary: $show_summary
    client_ids: $client_ids
    filter_organisation_id: $filter_organisation_id
    filter_email_address: $filter_email_address
    filter_client_ext_ids: $filter_client_ext_ids
    filter_order_reverse: $filter_order_reverse
    bookmark: $bookmark
    page_size: $page_size
  ) {
    clients {
      id
      version
      details {
        id
        first_name
        middle_name
        last_name
        contact_details_email
        contact_details_mobile_phone
        is_natural_person
        organisation_name
        non_natural {
          number_of_employees
        }
      }
    }
    next_page {
      bookmark
    }
  }
}
    `;

/**
 * __useGetClientSummariesQuery__
 *
 * To run a query within a React component, call `useGetClientSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSummariesQuery({
 *   variables: {
 *      client_details: // value for 'client_details'
 *      show_protected: // value for 'show_protected'
 *      show_summary: // value for 'show_summary'
 *      client_ids: // value for 'client_ids'
 *      filter_organisation_id: // value for 'filter_organisation_id'
 *      filter_email_address: // value for 'filter_email_address'
 *      filter_client_ext_ids: // value for 'filter_client_ext_ids'
 *      filter_order_reverse: // value for 'filter_order_reverse'
 *      bookmark: // value for 'bookmark'
 *      page_size: // value for 'page_size'
 *   },
 * });
 */
export function useGetClientSummariesQuery(baseOptions?: Apollo.QueryHookOptions<GetClientSummariesQuery, GetClientSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientSummariesQuery, GetClientSummariesQueryVariables>(GetClientSummariesDocument, options);
      }
export function useGetClientSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientSummariesQuery, GetClientSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientSummariesQuery, GetClientSummariesQueryVariables>(GetClientSummariesDocument, options);
        }
// @ts-ignore
export function useGetClientSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientSummariesQuery, GetClientSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientSummariesQuery, GetClientSummariesQueryVariables>;
export function useGetClientSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientSummariesQuery, GetClientSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientSummariesQuery | undefined, GetClientSummariesQueryVariables>;
export function useGetClientSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientSummariesQuery, GetClientSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientSummariesQuery, GetClientSummariesQueryVariables>(GetClientSummariesDocument, options);
        }
export type GetClientSummariesQueryHookResult = ReturnType<typeof useGetClientSummariesQuery>;
export type GetClientSummariesLazyQueryHookResult = ReturnType<typeof useGetClientSummariesLazyQuery>;
export type GetClientSummariesSuspenseQueryHookResult = ReturnType<typeof useGetClientSummariesSuspenseQuery>;
export type GetClientSummariesQueryResult = Apollo.QueryResult<GetClientSummariesQuery, GetClientSummariesQueryVariables>;
export const GetClientVerificationsDocument = gql`
    query getClientVerifications($id: ID!, $show_pass: Boolean, $useClientApi: Boolean) {
  clientVerifications(id: $id, show_pass: $show_pass, useClientApi: $useClientApi) {
    verification_collections {
      collection_id
      name
      passed
      version
      outstanding_optional
      required_for_future_transition
      required_for_next_transition
      verifications {
        ...VerificationEntitiesFragment
        verification_id
        name
        passed
        explanation
        case_id
        client_id
        mortgage_id
        product_id
        property_id
        failed_fields
        flag
        iterable_id
        result_justification
      }
    }
  }
}
    ${VerificationEntitiesFragmentFragmentDoc}`;

/**
 * __useGetClientVerificationsQuery__
 *
 * To run a query within a React component, call `useGetClientVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientVerificationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      show_pass: // value for 'show_pass'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useGetClientVerificationsQuery(baseOptions: Apollo.QueryHookOptions<GetClientVerificationsQuery, GetClientVerificationsQueryVariables> & ({ variables: GetClientVerificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>(GetClientVerificationsDocument, options);
      }
export function useGetClientVerificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>(GetClientVerificationsDocument, options);
        }
// @ts-ignore
export function useGetClientVerificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>;
export function useGetClientVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientVerificationsQuery | undefined, GetClientVerificationsQueryVariables>;
export function useGetClientVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>(GetClientVerificationsDocument, options);
        }
export type GetClientVerificationsQueryHookResult = ReturnType<typeof useGetClientVerificationsQuery>;
export type GetClientVerificationsLazyQueryHookResult = ReturnType<typeof useGetClientVerificationsLazyQuery>;
export type GetClientVerificationsSuspenseQueryHookResult = ReturnType<typeof useGetClientVerificationsSuspenseQuery>;
export type GetClientVerificationsQueryResult = Apollo.QueryResult<GetClientVerificationsQuery, GetClientVerificationsQueryVariables>;
export const GetClientsDocument = gql`
    query getClients($ids: [ID!], $organisationId: ID, $includeMiDocuments: Boolean = true) {
  clients(ids: $ids, organisationId: $organisationId) {
    id
    version
    details {
      id
      ...ClientDetails
      miDocuments @include(if: $includeMiDocuments) {
        documents {
          ...MIDocuments
        }
      }
      cases {
        id
        created_at
        details {
          id
          status
          preference_mortgage_reason
          regulated_by
          owner_organisation_id
          owner_user_id
          client_ids
        }
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}
${MiDocumentsFragmentDoc}`;

/**
 * __useGetClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      organisationId: // value for 'organisationId'
 *      includeMiDocuments: // value for 'includeMiDocuments'
 *   },
 * });
 */
export function useGetClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
      }
export function useGetClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
// @ts-ignore
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsQuery, GetClientsQueryVariables>;
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsQuery | undefined, GetClientsQueryVariables>;
export function useGetClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsQuery, GetClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsQuery, GetClientsQueryVariables>(GetClientsDocument, options);
        }
export type GetClientsQueryHookResult = ReturnType<typeof useGetClientsQuery>;
export type GetClientsLazyQueryHookResult = ReturnType<typeof useGetClientsLazyQuery>;
export type GetClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsSuspenseQuery>;
export type GetClientsQueryResult = Apollo.QueryResult<GetClientsQuery, GetClientsQueryVariables>;
export const GetClientsRelatedClientsDocument = gql`
    query getClientsRelatedClients($ids: [ID!], $relationshipTypes: [ClientRelationship!], $fromClientPortal: Boolean = false) {
  clients(ids: $ids) {
    id
    version
    details {
      id
      relatedClients(
        relationshipTypes: $relationshipTypes
        fromClientPortal: $fromClientPortal
      ) {
        id
        version
        details {
          id
          first_name
          last_name
          date_of_birth
          nationalities
          relationships {
            relationship_reference
            relationship_type
            relationship_data_access_permitted
          }
          addresses {
            id
            internalHash
            address {
              ...FullAddress
            }
            is_current_correspondence
          }
        }
      }
    }
  }
}
    ${FullAddressFragmentDoc}`;

/**
 * __useGetClientsRelatedClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsRelatedClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsRelatedClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsRelatedClientsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      relationshipTypes: // value for 'relationshipTypes'
 *      fromClientPortal: // value for 'fromClientPortal'
 *   },
 * });
 */
export function useGetClientsRelatedClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>(GetClientsRelatedClientsDocument, options);
      }
export function useGetClientsRelatedClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>(GetClientsRelatedClientsDocument, options);
        }
// @ts-ignore
export function useGetClientsRelatedClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>;
export function useGetClientsRelatedClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsRelatedClientsQuery | undefined, GetClientsRelatedClientsQueryVariables>;
export function useGetClientsRelatedClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>(GetClientsRelatedClientsDocument, options);
        }
export type GetClientsRelatedClientsQueryHookResult = ReturnType<typeof useGetClientsRelatedClientsQuery>;
export type GetClientsRelatedClientsLazyQueryHookResult = ReturnType<typeof useGetClientsRelatedClientsLazyQuery>;
export type GetClientsRelatedClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsRelatedClientsSuspenseQuery>;
export type GetClientsRelatedClientsQueryResult = Apollo.QueryResult<GetClientsRelatedClientsQuery, GetClientsRelatedClientsQueryVariables>;
export const GetClubNamesDocument = gql`
    query getClubNames {
  clubNames {
    id
    name
  }
}
    `;

/**
 * __useGetClubNamesQuery__
 *
 * To run a query within a React component, call `useGetClubNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClubNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetClubNamesQuery, GetClubNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubNamesQuery, GetClubNamesQueryVariables>(GetClubNamesDocument, options);
      }
export function useGetClubNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubNamesQuery, GetClubNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubNamesQuery, GetClubNamesQueryVariables>(GetClubNamesDocument, options);
        }
// @ts-ignore
export function useGetClubNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClubNamesQuery, GetClubNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClubNamesQuery, GetClubNamesQueryVariables>;
export function useGetClubNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubNamesQuery, GetClubNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClubNamesQuery | undefined, GetClubNamesQueryVariables>;
export function useGetClubNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubNamesQuery, GetClubNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubNamesQuery, GetClubNamesQueryVariables>(GetClubNamesDocument, options);
        }
export type GetClubNamesQueryHookResult = ReturnType<typeof useGetClubNamesQuery>;
export type GetClubNamesLazyQueryHookResult = ReturnType<typeof useGetClubNamesLazyQuery>;
export type GetClubNamesSuspenseQueryHookResult = ReturnType<typeof useGetClubNamesSuspenseQuery>;
export type GetClubNamesQueryResult = Apollo.QueryResult<GetClubNamesQuery, GetClubNamesQueryVariables>;
export const GetCommissionStructuresDocument = gql`
    query getCommissionStructures($input: CommissionStructureRequestInput!, $includePayingOrg: Boolean = false) {
  getCommissionStructures(input: $input, includePayingOrg: $includePayingOrg) {
    commission_structures {
      ...CommissionStructureDetails
      paying_organisation @include(if: $includePayingOrg) {
        id
        organisation_id
        name
      }
    }
    next_page {
      bookmark
      page_size
    }
  }
}
    ${CommissionStructureDetailsFragmentDoc}`;

/**
 * __useGetCommissionStructuresQuery__
 *
 * To run a query within a React component, call `useGetCommissionStructuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionStructuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionStructuresQuery({
 *   variables: {
 *      input: // value for 'input'
 *      includePayingOrg: // value for 'includePayingOrg'
 *   },
 * });
 */
export function useGetCommissionStructuresQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables> & ({ variables: GetCommissionStructuresQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>(GetCommissionStructuresDocument, options);
      }
export function useGetCommissionStructuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>(GetCommissionStructuresDocument, options);
        }
// @ts-ignore
export function useGetCommissionStructuresSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>;
export function useGetCommissionStructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommissionStructuresQuery | undefined, GetCommissionStructuresQueryVariables>;
export function useGetCommissionStructuresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>(GetCommissionStructuresDocument, options);
        }
export type GetCommissionStructuresQueryHookResult = ReturnType<typeof useGetCommissionStructuresQuery>;
export type GetCommissionStructuresLazyQueryHookResult = ReturnType<typeof useGetCommissionStructuresLazyQuery>;
export type GetCommissionStructuresSuspenseQueryHookResult = ReturnType<typeof useGetCommissionStructuresSuspenseQuery>;
export type GetCommissionStructuresQueryResult = Apollo.QueryResult<GetCommissionStructuresQuery, GetCommissionStructuresQueryVariables>;
export const GetCaseComplianceListDocument = gql`
    query getCaseComplianceList($organisationId: ID!, $params: GetCaseRequestInput, $fromClientPortal: Boolean) {
  complianceCases(organisationId: $organisationId, params: $params) {
    cases {
      id
      created_at
      version_created_at
      details {
        id
        status
        owner {
          id
          first_name
          last_name
          organisation {
            id
            name
          }
        }
        preference_mortgage_reason
        ...ClientNames
        flags {
          flag_type
        }
      }
    }
    organisation_name
    next_page {
      bookmark
    }
  }
}
    ${ClientNamesFragmentDoc}`;

/**
 * __useGetCaseComplianceListQuery__
 *
 * To run a query within a React component, call `useGetCaseComplianceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseComplianceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseComplianceListQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      params: // value for 'params'
 *      fromClientPortal: // value for 'fromClientPortal'
 *   },
 * });
 */
export function useGetCaseComplianceListQuery(baseOptions: Apollo.QueryHookOptions<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables> & ({ variables: GetCaseComplianceListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>(GetCaseComplianceListDocument, options);
      }
export function useGetCaseComplianceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>(GetCaseComplianceListDocument, options);
        }
// @ts-ignore
export function useGetCaseComplianceListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>;
export function useGetCaseComplianceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseComplianceListQuery | undefined, GetCaseComplianceListQueryVariables>;
export function useGetCaseComplianceListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>(GetCaseComplianceListDocument, options);
        }
export type GetCaseComplianceListQueryHookResult = ReturnType<typeof useGetCaseComplianceListQuery>;
export type GetCaseComplianceListLazyQueryHookResult = ReturnType<typeof useGetCaseComplianceListLazyQuery>;
export type GetCaseComplianceListSuspenseQueryHookResult = ReturnType<typeof useGetCaseComplianceListSuspenseQuery>;
export type GetCaseComplianceListQueryResult = Apollo.QueryResult<GetCaseComplianceListQuery, GetCaseComplianceListQueryVariables>;
export const GetConsumerDutyResultsDocument = gql`
    query getConsumerDutyResults($body: SurveyResultsInput!) {
  consumerDutyResults(body: $body) {
    filters {
      advisor_ids
      bookmark
      case_completion_end_date
      case_completion_start_date
      case_submission_end_date
      case_submission_start_date
      case_types
      network_id
      order
      order_by
      order_by_question_id
      organisation_id
      page_size
    }
    next_page {
      bookmark
    }
    survey_results {
      advisor_id
      advisor_name
      case_completion_date
      case_id
      case_submission_date
      case_type
      client_id
      client_name
      network_id
      org_id
      completed_at
      modified_at
      question_answers {
        answer {
          bool_answer
          five_scale_answer
          free_text_answer
          multiple_choice_answer
          single_choice_answer
          ten_scale_answer
          zero_ten_scale_answer
        }
        question {
          id
          topic
          order
          question
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetConsumerDutyResultsQuery__
 *
 * To run a query within a React component, call `useGetConsumerDutyResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConsumerDutyResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConsumerDutyResultsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useGetConsumerDutyResultsQuery(baseOptions: Apollo.QueryHookOptions<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables> & ({ variables: GetConsumerDutyResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>(GetConsumerDutyResultsDocument, options);
      }
export function useGetConsumerDutyResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>(GetConsumerDutyResultsDocument, options);
        }
// @ts-ignore
export function useGetConsumerDutyResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>;
export function useGetConsumerDutyResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetConsumerDutyResultsQuery | undefined, GetConsumerDutyResultsQueryVariables>;
export function useGetConsumerDutyResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>(GetConsumerDutyResultsDocument, options);
        }
export type GetConsumerDutyResultsQueryHookResult = ReturnType<typeof useGetConsumerDutyResultsQuery>;
export type GetConsumerDutyResultsLazyQueryHookResult = ReturnType<typeof useGetConsumerDutyResultsLazyQuery>;
export type GetConsumerDutyResultsSuspenseQueryHookResult = ReturnType<typeof useGetConsumerDutyResultsSuspenseQuery>;
export type GetConsumerDutyResultsQueryResult = Apollo.QueryResult<GetConsumerDutyResultsQuery, GetConsumerDutyResultsQueryVariables>;
export const GetCpUpdatesDocument = gql`
    query getCpUpdates($case_id: ID!) {
  cpUpdates(case_id: $case_id) {
    cp_changes {
      clients {
        entity_id
        editor_id
        editor_type
        field
        version_from
        version_to
        change_type
        current
        differences
        previous
      }
      mortgages {
        entity_id
        editor_id
        editor_type
        field
        version_from
        version_to
        change_type
        current
        differences
        previous
      }
      properties {
        entity_id
        editor_id
        editor_type
        field
        version_from
        version_to
        change_type
        current
        differences
        previous
      }
      documents {
        entity_id
        editor_id
        editor_type
        type
        document_name
        date_stored
      }
    }
  }
}
    `;

/**
 * __useGetCpUpdatesQuery__
 *
 * To run a query within a React component, call `useGetCpUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCpUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCpUpdatesQuery({
 *   variables: {
 *      case_id: // value for 'case_id'
 *   },
 * });
 */
export function useGetCpUpdatesQuery(baseOptions: Apollo.QueryHookOptions<GetCpUpdatesQuery, GetCpUpdatesQueryVariables> & ({ variables: GetCpUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>(GetCpUpdatesDocument, options);
      }
export function useGetCpUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>(GetCpUpdatesDocument, options);
        }
// @ts-ignore
export function useGetCpUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>;
export function useGetCpUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCpUpdatesQuery | undefined, GetCpUpdatesQueryVariables>;
export function useGetCpUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>(GetCpUpdatesDocument, options);
        }
export type GetCpUpdatesQueryHookResult = ReturnType<typeof useGetCpUpdatesQuery>;
export type GetCpUpdatesLazyQueryHookResult = ReturnType<typeof useGetCpUpdatesLazyQuery>;
export type GetCpUpdatesSuspenseQueryHookResult = ReturnType<typeof useGetCpUpdatesSuspenseQuery>;
export type GetCpUpdatesQueryResult = Apollo.QueryResult<GetCpUpdatesQuery, GetCpUpdatesQueryVariables>;
export const GetCreditRefreshAvailabilityDocument = gql`
    query getCreditRefreshAvailability($clientId: ID!) {
  creditRefreshAvailability(clientId: $clientId) {
    status
    reason {
      code
      description
    }
  }
}
    `;

/**
 * __useGetCreditRefreshAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetCreditRefreshAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditRefreshAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditRefreshAvailabilityQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetCreditRefreshAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables> & ({ variables: GetCreditRefreshAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>(GetCreditRefreshAvailabilityDocument, options);
      }
export function useGetCreditRefreshAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>(GetCreditRefreshAvailabilityDocument, options);
        }
// @ts-ignore
export function useGetCreditRefreshAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>;
export function useGetCreditRefreshAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreditRefreshAvailabilityQuery | undefined, GetCreditRefreshAvailabilityQueryVariables>;
export function useGetCreditRefreshAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>(GetCreditRefreshAvailabilityDocument, options);
        }
export type GetCreditRefreshAvailabilityQueryHookResult = ReturnType<typeof useGetCreditRefreshAvailabilityQuery>;
export type GetCreditRefreshAvailabilityLazyQueryHookResult = ReturnType<typeof useGetCreditRefreshAvailabilityLazyQuery>;
export type GetCreditRefreshAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetCreditRefreshAvailabilitySuspenseQuery>;
export type GetCreditRefreshAvailabilityQueryResult = Apollo.QueryResult<GetCreditRefreshAvailabilityQuery, GetCreditRefreshAvailabilityQueryVariables>;
export const GetCreditReportDocument = gql`
    query getCreditReport($useClientApi: Boolean, $clientId: String, $showSearches: Boolean = true, $documentId: String, $requests: [CreditReportRequestInput!]) {
  creditReport(
    useClientApi: $useClientApi
    clientId: $clientId
    showSearches: $showSearches
    documentId: $documentId
    requests: $requests
  ) {
    reports {
      client_id
      score
      max_score
      retrieval_timestamp
      personal_information {
        name {
          forename
          surname
        }
        dob
        address {
          address_1
          address_2
          address_3
          posttown
          postcode
          country
          county
        }
      }
      public_information {
        electoral_rolls {
          address {
            address_1
            address_2
            address_3
            posttown
            postcode
            country
            county
            is_current_correspondence
          }
          from_year
          name {
            forename
            surname
          }
          to_year
        }
        ivas {
          completed
          registered
        }
        ccjs {
          amount
          court_name
          date_registered
          date_satisfied
        }
        bankruptcies {
          bankruptcy
          court
          discharge
        }
        corrections {
          date
          name {
            forename
            surname
          }
          text
        }
      }
      accounts {
        account_number
        balance
        credit_limit
        creditor
        end_date
        monthly_repayment
        payment_status
        remaining_term
        start_date
        status
        type
        payment_history {
          age_in_months
          date
          status
        }
      }
      searches @include(if: $showSearches) {
        company_name
        search_date
        type
      }
      accounts_aggregation {
        key
        account_creditor
        account_type
        monthly_repayment
        status
      }
      warnings {
        warning
        identifiers
      }
      changes {
        change
        identifiers
      }
    }
  }
}
    `;

/**
 * __useGetCreditReportQuery__
 *
 * To run a query within a React component, call `useGetCreditReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditReportQuery({
 *   variables: {
 *      useClientApi: // value for 'useClientApi'
 *      clientId: // value for 'clientId'
 *      showSearches: // value for 'showSearches'
 *      documentId: // value for 'documentId'
 *      requests: // value for 'requests'
 *   },
 * });
 */
export function useGetCreditReportQuery(baseOptions?: Apollo.QueryHookOptions<GetCreditReportQuery, GetCreditReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditReportQuery, GetCreditReportQueryVariables>(GetCreditReportDocument, options);
      }
export function useGetCreditReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditReportQuery, GetCreditReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditReportQuery, GetCreditReportQueryVariables>(GetCreditReportDocument, options);
        }
// @ts-ignore
export function useGetCreditReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreditReportQuery, GetCreditReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreditReportQuery, GetCreditReportQueryVariables>;
export function useGetCreditReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditReportQuery, GetCreditReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetCreditReportQuery | undefined, GetCreditReportQueryVariables>;
export function useGetCreditReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditReportQuery, GetCreditReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditReportQuery, GetCreditReportQueryVariables>(GetCreditReportDocument, options);
        }
export type GetCreditReportQueryHookResult = ReturnType<typeof useGetCreditReportQuery>;
export type GetCreditReportLazyQueryHookResult = ReturnType<typeof useGetCreditReportLazyQuery>;
export type GetCreditReportSuspenseQueryHookResult = ReturnType<typeof useGetCreditReportSuspenseQuery>;
export type GetCreditReportQueryResult = Apollo.QueryResult<GetCreditReportQuery, GetCreditReportQueryVariables>;
export const GetCurrentUserDocument = gql`
    query getCurrentUser {
  currentUser {
    id
    organisation_id
    email_address
    first_name
    last_name
    primary_role_id
    first_time_access {
      complete
      features {
        feature
        complete
      }
    }
    role_name
    credentials {
      provider
      metadata {
        IRESS_USER_CODE
      }
      password
      username
    }
    group_ids
    metadata {
      name
      string_value
      bool_value
      int_value
      user_editable
    }
    agency_codes {
      provider_id
      agency_code
    }
    ...Authentications
    organisation {
      id
      organisation_id
      name
      type
      logo
      first_time_access {
        complete
      }
      administered_by {
        id
        external_id
      }
      representative_of
      representative_of_org {
        ...BasicOrganisationDetails
        metadata {
          name
          bool_value
          string_value
        }
        process_settings {
          protection_disclaimer {
            generated_by
            signed_by
          }
        }
      }
      metadata {
        name
        string_value
        bool_value
      }
      ...PanelManagement
      verification_class {
        enhanced
        optional
        beta
      }
      process_settings {
        use_exchange_case_status
        case_board {
          name
          statuses
        }
        protection_disclaimer {
          generated_by
          signed_by
        }
      }
      lender_metadata {
        porting_pay_on_full_loan_amount
      }
      standard_fee_options {
        fee_option_title
        fees {
          fee_type
          value
        }
        default
      }
      ...OrganisationRmarSettings
      ...NoteTemplates
    }
    ...UserPermissions
  }
}
    ${AuthenticationsFragmentDoc}
${BasicOrganisationDetailsFragmentDoc}
${PanelManagementFragmentDoc}
${OrganisationRmarSettingsFragmentDoc}
${NoteTemplatesFragmentDoc}
${UserPermissionsFragmentDoc}`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCurrentUserQuery | undefined, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetDipStatusDocument = gql`
    query getDipStatus($input: DipStatusInput!) {
  getDipStatus(input: $input) {
    approved_amount
    id
    lender
    provider
    provider_id
    reason
    status
    available_next_steps
    details {
      decisionExpiryDate
      overallDecision
      reprocessInd
      decisionDetails {
        ...dipDetailsFragment
      }
      decisions {
        provider
        resultType
        errorMessages {
          name
          result
        }
      }
    }
  }
}
    ${DipDetailsFragmentFragmentDoc}`;

/**
 * __useGetDipStatusQuery__
 *
 * To run a query within a React component, call `useGetDipStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDipStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDipStatusQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDipStatusQuery(baseOptions: Apollo.QueryHookOptions<GetDipStatusQuery, GetDipStatusQueryVariables> & ({ variables: GetDipStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDipStatusQuery, GetDipStatusQueryVariables>(GetDipStatusDocument, options);
      }
export function useGetDipStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDipStatusQuery, GetDipStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDipStatusQuery, GetDipStatusQueryVariables>(GetDipStatusDocument, options);
        }
// @ts-ignore
export function useGetDipStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDipStatusQuery, GetDipStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetDipStatusQuery, GetDipStatusQueryVariables>;
export function useGetDipStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDipStatusQuery, GetDipStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetDipStatusQuery | undefined, GetDipStatusQueryVariables>;
export function useGetDipStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDipStatusQuery, GetDipStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDipStatusQuery, GetDipStatusQueryVariables>(GetDipStatusDocument, options);
        }
export type GetDipStatusQueryHookResult = ReturnType<typeof useGetDipStatusQuery>;
export type GetDipStatusLazyQueryHookResult = ReturnType<typeof useGetDipStatusLazyQuery>;
export type GetDipStatusSuspenseQueryHookResult = ReturnType<typeof useGetDipStatusSuspenseQuery>;
export type GetDipStatusQueryResult = Apollo.QueryResult<GetDipStatusQuery, GetDipStatusQueryVariables>;
export const GetDirectorCaseListDocument = gql`
    query getDirectorCaseList($clientId: ID!, $fromClientPortal: Boolean, $includeClientNames: Boolean = true, $deniedAccess: Boolean, $includeProperty: Boolean = false, $includeMortgageProduct: Boolean = false) {
  directorClientCases(
    clientId: $clientId
    fromClientPortal: $fromClientPortal
    deniedAccess: $deniedAccess
  ) {
    id
    created_at
    version
    version_created_at
    details {
      id
      status
      owner_user_id
      preference_mortgage_reason
      regulated_by
      ...ClientNames @include(if: $includeClientNames)
      new_property_cp @include(if: $includeProperty) {
        id
        property_id
        details {
          ...PropertyDetailsCp
        }
      }
    }
  }
}
    ${ClientNamesFragmentDoc}
${PropertyDetailsCpFragmentDoc}`;

/**
 * __useGetDirectorCaseListQuery__
 *
 * To run a query within a React component, call `useGetDirectorCaseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectorCaseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectorCaseListQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      fromClientPortal: // value for 'fromClientPortal'
 *      includeClientNames: // value for 'includeClientNames'
 *      deniedAccess: // value for 'deniedAccess'
 *      includeProperty: // value for 'includeProperty'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetDirectorCaseListQuery(baseOptions: Apollo.QueryHookOptions<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables> & ({ variables: GetDirectorCaseListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>(GetDirectorCaseListDocument, options);
      }
export function useGetDirectorCaseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>(GetDirectorCaseListDocument, options);
        }
// @ts-ignore
export function useGetDirectorCaseListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>;
export function useGetDirectorCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectorCaseListQuery | undefined, GetDirectorCaseListQueryVariables>;
export function useGetDirectorCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>(GetDirectorCaseListDocument, options);
        }
export type GetDirectorCaseListQueryHookResult = ReturnType<typeof useGetDirectorCaseListQuery>;
export type GetDirectorCaseListLazyQueryHookResult = ReturnType<typeof useGetDirectorCaseListLazyQuery>;
export type GetDirectorCaseListSuspenseQueryHookResult = ReturnType<typeof useGetDirectorCaseListSuspenseQuery>;
export type GetDirectorCaseListQueryResult = Apollo.QueryResult<GetDirectorCaseListQuery, GetDirectorCaseListQueryVariables>;
export const GetDirectorsFromChCompanyDocument = gql`
    query getDirectorsFromCHCompany($company: CHCompanyInput!, $organisation_id: String!) {
  getDirectorsFromCHCompany(company: $company, organisation_id: $organisation_id) {
    existingClients {
      id
      version
      details {
        id
        ...ClientDetails
        miDocuments {
          documents {
            ...MIDocuments
          }
        }
      }
    }
    newClients {
      is_natural_person
      client_type
      first_name
      last_name
      nationalities
      date_of_birth
      addresses {
        address {
          address1
          address2
          address3
          posttown
          postcode
          country
          county
        }
        is_current_correspondence
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}
${MiDocumentsFragmentDoc}`;

/**
 * __useGetDirectorsFromChCompanyQuery__
 *
 * To run a query within a React component, call `useGetDirectorsFromChCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDirectorsFromChCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDirectorsFromChCompanyQuery({
 *   variables: {
 *      company: // value for 'company'
 *      organisation_id: // value for 'organisation_id'
 *   },
 * });
 */
export function useGetDirectorsFromChCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables> & ({ variables: GetDirectorsFromChCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>(GetDirectorsFromChCompanyDocument, options);
      }
export function useGetDirectorsFromChCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>(GetDirectorsFromChCompanyDocument, options);
        }
// @ts-ignore
export function useGetDirectorsFromChCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>;
export function useGetDirectorsFromChCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<GetDirectorsFromChCompanyQuery | undefined, GetDirectorsFromChCompanyQueryVariables>;
export function useGetDirectorsFromChCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>(GetDirectorsFromChCompanyDocument, options);
        }
export type GetDirectorsFromChCompanyQueryHookResult = ReturnType<typeof useGetDirectorsFromChCompanyQuery>;
export type GetDirectorsFromChCompanyLazyQueryHookResult = ReturnType<typeof useGetDirectorsFromChCompanyLazyQuery>;
export type GetDirectorsFromChCompanySuspenseQueryHookResult = ReturnType<typeof useGetDirectorsFromChCompanySuspenseQuery>;
export type GetDirectorsFromChCompanyQueryResult = Apollo.QueryResult<GetDirectorsFromChCompanyQuery, GetDirectorsFromChCompanyQueryVariables>;
export const GetDocumentDetailsDocument = gql`
    query getDocumentDetails($docId: ID!, $params: GetDocumentParams) {
  documentDetails(docId: $docId, params: $params) {
    document_id
    internalHash
    document_name
    archived
    type
    other_type
    date_stored
    uploaded_by
    verification_count
    data_base64
    source
    source_client_id
    file_type
    document_signature
    case_ids
    owning_client_ids
    rendered_mortgage_ids
    template_id
    tags
    general_insurance_product_id
    signed_copy {
      data_base64
      file_type
    }
    origination_fingerprint {
      call_length
      call_recipient_type
      call_recipient_id
      call_recipient_no
      call_originator_type
      call_originator_id
      call_originator_no
      call_start
    }
    template {
      id
      name
    }
    cases {
      id
      details {
        id
        status
      }
    }
  }
}
    `;

/**
 * __useGetDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables> & ({ variables: GetDocumentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
      }
export function useGetDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
// @ts-ignore
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>;
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentDetailsQuery | undefined, GetDocumentDetailsQueryVariables>;
export function useGetDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>(GetDocumentDetailsDocument, options);
        }
export type GetDocumentDetailsQueryHookResult = ReturnType<typeof useGetDocumentDetailsQuery>;
export type GetDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetDocumentDetailsLazyQuery>;
export type GetDocumentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDetailsSuspenseQuery>;
export type GetDocumentDetailsQueryResult = Apollo.QueryResult<GetDocumentDetailsQuery, GetDocumentDetailsQueryVariables>;
export const GetDocumentRequirementsDocument = gql`
    query getDocumentRequirements($filter_organisation_ids: [ID!]!, $requirement_details: Boolean = true) {
  documentRequirements(
    filter_organisation_ids: $filter_organisation_ids
    requirement_details: $requirement_details
  ) {
    requirement_id
    created_at
    created_by
    modified_at
    disabled_at
    details {
      ...DocumentRequirementDetails
    }
  }
}
    ${DocumentRequirementDetailsFragmentDoc}`;

/**
 * __useGetDocumentRequirementsQuery__
 *
 * To run a query within a React component, call `useGetDocumentRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentRequirementsQuery({
 *   variables: {
 *      filter_organisation_ids: // value for 'filter_organisation_ids'
 *      requirement_details: // value for 'requirement_details'
 *   },
 * });
 */
export function useGetDocumentRequirementsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables> & ({ variables: GetDocumentRequirementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>(GetDocumentRequirementsDocument, options);
      }
export function useGetDocumentRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>(GetDocumentRequirementsDocument, options);
        }
// @ts-ignore
export function useGetDocumentRequirementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>;
export function useGetDocumentRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentRequirementsQuery | undefined, GetDocumentRequirementsQueryVariables>;
export function useGetDocumentRequirementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>(GetDocumentRequirementsDocument, options);
        }
export type GetDocumentRequirementsQueryHookResult = ReturnType<typeof useGetDocumentRequirementsQuery>;
export type GetDocumentRequirementsLazyQueryHookResult = ReturnType<typeof useGetDocumentRequirementsLazyQuery>;
export type GetDocumentRequirementsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentRequirementsSuspenseQuery>;
export type GetDocumentRequirementsQueryResult = Apollo.QueryResult<GetDocumentRequirementsQuery, GetDocumentRequirementsQueryVariables>;
export const GetDocumentSummariesDocument = gql`
    query getDocumentSummaries($filter_owning_client_id: String, $filter_case_id: ID, $filter_archived: Boolean) {
  documentSummaries(
    filter_owning_client_id: $filter_owning_client_id
    filter_case_id: $filter_case_id
    filter_archived: $filter_archived
  ) {
    document_id
    internalHash
    case_ids
    date_stored
    document_name
    file_type
    source
    source_user_id
    type
    template_type
    rendered_mortgage_ids
    archived
    verification_count
    uploaded_by
  }
}
    `;

/**
 * __useGetDocumentSummariesQuery__
 *
 * To run a query within a React component, call `useGetDocumentSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentSummariesQuery({
 *   variables: {
 *      filter_owning_client_id: // value for 'filter_owning_client_id'
 *      filter_case_id: // value for 'filter_case_id'
 *      filter_archived: // value for 'filter_archived'
 *   },
 * });
 */
export function useGetDocumentSummariesQuery(baseOptions?: Apollo.QueryHookOptions<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>(GetDocumentSummariesDocument, options);
      }
export function useGetDocumentSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>(GetDocumentSummariesDocument, options);
        }
// @ts-ignore
export function useGetDocumentSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>;
export function useGetDocumentSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentSummariesQuery | undefined, GetDocumentSummariesQueryVariables>;
export function useGetDocumentSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>(GetDocumentSummariesDocument, options);
        }
export type GetDocumentSummariesQueryHookResult = ReturnType<typeof useGetDocumentSummariesQuery>;
export type GetDocumentSummariesLazyQueryHookResult = ReturnType<typeof useGetDocumentSummariesLazyQuery>;
export type GetDocumentSummariesSuspenseQueryHookResult = ReturnType<typeof useGetDocumentSummariesSuspenseQuery>;
export type GetDocumentSummariesQueryResult = Apollo.QueryResult<GetDocumentSummariesQuery, GetDocumentSummariesQueryVariables>;
export const GetDocumentVerificationsDocument = gql`
    query getDocumentVerifications($documentId: ID!, $params: DocumentVerificationQueryParams, $includeUser: Boolean = false) {
  documentVerifications(
    documentId: $documentId
    params: $params
    includeUser: $includeUser
  ) {
    verification_id
    client_id
    document_id
    document_signature
    signature_key_id
    source
    source_user_id
    verification_type
    verification_date
    result
    result_justification
    fingerprint {
      browser_id
      ip
      referer
      user_agent
    }
    source_user @include(if: $includeUser) {
      id
      first_name
      last_name
    }
    source_client @include(if: $includeUser) {
      id
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useGetDocumentVerificationsQuery__
 *
 * To run a query within a React component, call `useGetDocumentVerificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVerificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVerificationsQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      params: // value for 'params'
 *      includeUser: // value for 'includeUser'
 *   },
 * });
 */
export function useGetDocumentVerificationsQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables> & ({ variables: GetDocumentVerificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>(GetDocumentVerificationsDocument, options);
      }
export function useGetDocumentVerificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>(GetDocumentVerificationsDocument, options);
        }
// @ts-ignore
export function useGetDocumentVerificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>;
export function useGetDocumentVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentVerificationsQuery | undefined, GetDocumentVerificationsQueryVariables>;
export function useGetDocumentVerificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>(GetDocumentVerificationsDocument, options);
        }
export type GetDocumentVerificationsQueryHookResult = ReturnType<typeof useGetDocumentVerificationsQuery>;
export type GetDocumentVerificationsLazyQueryHookResult = ReturnType<typeof useGetDocumentVerificationsLazyQuery>;
export type GetDocumentVerificationsSuspenseQueryHookResult = ReturnType<typeof useGetDocumentVerificationsSuspenseQuery>;
export type GetDocumentVerificationsQueryResult = Apollo.QueryResult<GetDocumentVerificationsQuery, GetDocumentVerificationsQueryVariables>;
export const GetFeesForCaseDocument = gql`
    query getFeesForCase($caseId: ID!, $mortgageId: ID!) {
  case(id: $caseId) {
    ...CaseMortgageFees
  }
}
    ${CaseMortgageFeesFragmentDoc}`;

/**
 * __useGetFeesForCaseQuery__
 *
 * To run a query within a React component, call `useGetFeesForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeesForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeesForCaseQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      mortgageId: // value for 'mortgageId'
 *   },
 * });
 */
export function useGetFeesForCaseQuery(baseOptions: Apollo.QueryHookOptions<GetFeesForCaseQuery, GetFeesForCaseQueryVariables> & ({ variables: GetFeesForCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>(GetFeesForCaseDocument, options);
      }
export function useGetFeesForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>(GetFeesForCaseDocument, options);
        }
// @ts-ignore
export function useGetFeesForCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>;
export function useGetFeesForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeesForCaseQuery | undefined, GetFeesForCaseQueryVariables>;
export function useGetFeesForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>(GetFeesForCaseDocument, options);
        }
export type GetFeesForCaseQueryHookResult = ReturnType<typeof useGetFeesForCaseQuery>;
export type GetFeesForCaseLazyQueryHookResult = ReturnType<typeof useGetFeesForCaseLazyQuery>;
export type GetFeesForCaseSuspenseQueryHookResult = ReturnType<typeof useGetFeesForCaseSuspenseQuery>;
export type GetFeesForCaseQueryResult = Apollo.QueryResult<GetFeesForCaseQuery, GetFeesForCaseQueryVariables>;
export const GetFilteredNotesDocument = gql`
    query getFilteredNotes($params: GetFilteredNoteRequestInput, $useClientApi: Boolean) {
  getFilteredNotes(params: $params, useClientApi: $useClientApi) {
    notes {
      ...filteredNotes
    }
    next_page {
      bookmark
    }
  }
  getActiveNotes(params: $params) @client {
    ...filteredNotes
  }
}
    ${FilteredNotesFragmentDoc}`;

/**
 * __useGetFilteredNotesQuery__
 *
 * To run a query within a React component, call `useGetFilteredNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredNotesQuery({
 *   variables: {
 *      params: // value for 'params'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useGetFilteredNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>(GetFilteredNotesDocument, options);
      }
export function useGetFilteredNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>(GetFilteredNotesDocument, options);
        }
// @ts-ignore
export function useGetFilteredNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>;
export function useGetFilteredNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFilteredNotesQuery | undefined, GetFilteredNotesQueryVariables>;
export function useGetFilteredNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>(GetFilteredNotesDocument, options);
        }
export type GetFilteredNotesQueryHookResult = ReturnType<typeof useGetFilteredNotesQuery>;
export type GetFilteredNotesLazyQueryHookResult = ReturnType<typeof useGetFilteredNotesLazyQuery>;
export type GetFilteredNotesSuspenseQueryHookResult = ReturnType<typeof useGetFilteredNotesSuspenseQuery>;
export type GetFilteredNotesQueryResult = Apollo.QueryResult<GetFilteredNotesQuery, GetFilteredNotesQueryVariables>;
export const GetFreeBusyTimesDocument = gql`
    query getFreeBusyTimes($start: Int!, $end: Int!, $emails: [String!]!) {
  getFreeBusyTimes(start: $start, end: $end, emails: $emails) {
    email
    time_slots {
      start_time
      end_time
      status
    }
  }
}
    `;

/**
 * __useGetFreeBusyTimesQuery__
 *
 * To run a query within a React component, call `useGetFreeBusyTimesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreeBusyTimesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreeBusyTimesQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useGetFreeBusyTimesQuery(baseOptions: Apollo.QueryHookOptions<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables> & ({ variables: GetFreeBusyTimesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>(GetFreeBusyTimesDocument, options);
      }
export function useGetFreeBusyTimesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>(GetFreeBusyTimesDocument, options);
        }
// @ts-ignore
export function useGetFreeBusyTimesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>;
export function useGetFreeBusyTimesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFreeBusyTimesQuery | undefined, GetFreeBusyTimesQueryVariables>;
export function useGetFreeBusyTimesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>(GetFreeBusyTimesDocument, options);
        }
export type GetFreeBusyTimesQueryHookResult = ReturnType<typeof useGetFreeBusyTimesQuery>;
export type GetFreeBusyTimesLazyQueryHookResult = ReturnType<typeof useGetFreeBusyTimesLazyQuery>;
export type GetFreeBusyTimesSuspenseQueryHookResult = ReturnType<typeof useGetFreeBusyTimesSuspenseQuery>;
export type GetFreeBusyTimesQueryResult = Apollo.QueryResult<GetFreeBusyTimesQuery, GetFreeBusyTimesQueryVariables>;
export const GetGoCardlessAccountStatusDocument = gql`
    query getGoCardlessAccountStatus {
  getGoCardlessAccountStatus {
    status
  }
}
    `;

/**
 * __useGetGoCardlessAccountStatusQuery__
 *
 * To run a query within a React component, call `useGetGoCardlessAccountStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoCardlessAccountStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoCardlessAccountStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoCardlessAccountStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>(GetGoCardlessAccountStatusDocument, options);
      }
export function useGetGoCardlessAccountStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>(GetGoCardlessAccountStatusDocument, options);
        }
// @ts-ignore
export function useGetGoCardlessAccountStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>;
export function useGetGoCardlessAccountStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetGoCardlessAccountStatusQuery | undefined, GetGoCardlessAccountStatusQueryVariables>;
export function useGetGoCardlessAccountStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>(GetGoCardlessAccountStatusDocument, options);
        }
export type GetGoCardlessAccountStatusQueryHookResult = ReturnType<typeof useGetGoCardlessAccountStatusQuery>;
export type GetGoCardlessAccountStatusLazyQueryHookResult = ReturnType<typeof useGetGoCardlessAccountStatusLazyQuery>;
export type GetGoCardlessAccountStatusSuspenseQueryHookResult = ReturnType<typeof useGetGoCardlessAccountStatusSuspenseQuery>;
export type GetGoCardlessAccountStatusQueryResult = Apollo.QueryResult<GetGoCardlessAccountStatusQuery, GetGoCardlessAccountStatusQueryVariables>;
export const GetGoCardlessAuthUrlDocument = gql`
    query getGoCardlessAuthURL {
  getGoCardlessAuthURL {
    url
  }
}
    `;

/**
 * __useGetGoCardlessAuthUrlQuery__
 *
 * To run a query within a React component, call `useGetGoCardlessAuthUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoCardlessAuthUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoCardlessAuthUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoCardlessAuthUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>(GetGoCardlessAuthUrlDocument, options);
      }
export function useGetGoCardlessAuthUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>(GetGoCardlessAuthUrlDocument, options);
        }
// @ts-ignore
export function useGetGoCardlessAuthUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>;
export function useGetGoCardlessAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GetGoCardlessAuthUrlQuery | undefined, GetGoCardlessAuthUrlQueryVariables>;
export function useGetGoCardlessAuthUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>(GetGoCardlessAuthUrlDocument, options);
        }
export type GetGoCardlessAuthUrlQueryHookResult = ReturnType<typeof useGetGoCardlessAuthUrlQuery>;
export type GetGoCardlessAuthUrlLazyQueryHookResult = ReturnType<typeof useGetGoCardlessAuthUrlLazyQuery>;
export type GetGoCardlessAuthUrlSuspenseQueryHookResult = ReturnType<typeof useGetGoCardlessAuthUrlSuspenseQuery>;
export type GetGoCardlessAuthUrlQueryResult = Apollo.QueryResult<GetGoCardlessAuthUrlQuery, GetGoCardlessAuthUrlQueryVariables>;
export const GetGroupsDocument = gql`
    query getGroups($ids: [ID!]!, $fetchUsers: Boolean = true) {
  getGroups(ids: $ids, fetchUsers: $fetchUsers) {
    group_id
    group_name
    organisation_id
    disabled
    accept_reminders
    users @include(if: $fetchUsers) {
      id
      first_name
      last_name
      email_address
      phone_number
      role_name
    }
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      fetchUsers: // value for 'fetchUsers'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables> & ({ variables: GetGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
// @ts-ignore
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsQuery | undefined, GetGroupsQueryVariables>;
export function useGetGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsSuspenseQueryHookResult = ReturnType<typeof useGetGroupsSuspenseQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetGroupsByDocument = gql`
    query getGroupsBy($input: GetGroupInput) {
  getGroupsBy(input: $input) {
    group_id
    group_name
    organisation_id
    disabled
    accept_reminders
    users {
      id
      first_name
      last_name
      email_address
      phone_number
      role_name
    }
  }
}
    `;

/**
 * __useGetGroupsByQuery__
 *
 * To run a query within a React component, call `useGetGroupsByQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsByQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsByQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGroupsByQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsByQuery, GetGroupsByQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsByQuery, GetGroupsByQueryVariables>(GetGroupsByDocument, options);
      }
export function useGetGroupsByLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsByQuery, GetGroupsByQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsByQuery, GetGroupsByQueryVariables>(GetGroupsByDocument, options);
        }
// @ts-ignore
export function useGetGroupsBySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsByQuery, GetGroupsByQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsByQuery, GetGroupsByQueryVariables>;
export function useGetGroupsBySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsByQuery, GetGroupsByQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsByQuery | undefined, GetGroupsByQueryVariables>;
export function useGetGroupsBySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsByQuery, GetGroupsByQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsByQuery, GetGroupsByQueryVariables>(GetGroupsByDocument, options);
        }
export type GetGroupsByQueryHookResult = ReturnType<typeof useGetGroupsByQuery>;
export type GetGroupsByLazyQueryHookResult = ReturnType<typeof useGetGroupsByLazyQuery>;
export type GetGroupsBySuspenseQueryHookResult = ReturnType<typeof useGetGroupsBySuspenseQuery>;
export type GetGroupsByQueryResult = Apollo.QueryResult<GetGroupsByQuery, GetGroupsByQueryVariables>;
export const GetGroupsByOrgForRemindersDocument = gql`
    query getGroupsByOrgForReminders($filter_organisation_id: String, $show_disabled: Boolean) {
  getGroupsForOrg(
    filter_organisation_id: $filter_organisation_id
    show_disabled: $show_disabled
  ) {
    group_id
    group_name
    accept_reminders
  }
}
    `;

/**
 * __useGetGroupsByOrgForRemindersQuery__
 *
 * To run a query within a React component, call `useGetGroupsByOrgForRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsByOrgForRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsByOrgForRemindersQuery({
 *   variables: {
 *      filter_organisation_id: // value for 'filter_organisation_id'
 *      show_disabled: // value for 'show_disabled'
 *   },
 * });
 */
export function useGetGroupsByOrgForRemindersQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>(GetGroupsByOrgForRemindersDocument, options);
      }
export function useGetGroupsByOrgForRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>(GetGroupsByOrgForRemindersDocument, options);
        }
// @ts-ignore
export function useGetGroupsByOrgForRemindersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>;
export function useGetGroupsByOrgForRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsByOrgForRemindersQuery | undefined, GetGroupsByOrgForRemindersQueryVariables>;
export function useGetGroupsByOrgForRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>(GetGroupsByOrgForRemindersDocument, options);
        }
export type GetGroupsByOrgForRemindersQueryHookResult = ReturnType<typeof useGetGroupsByOrgForRemindersQuery>;
export type GetGroupsByOrgForRemindersLazyQueryHookResult = ReturnType<typeof useGetGroupsByOrgForRemindersLazyQuery>;
export type GetGroupsByOrgForRemindersSuspenseQueryHookResult = ReturnType<typeof useGetGroupsByOrgForRemindersSuspenseQuery>;
export type GetGroupsByOrgForRemindersQueryResult = Apollo.QueryResult<GetGroupsByOrgForRemindersQuery, GetGroupsByOrgForRemindersQueryVariables>;
export const GetGroupsForOrgDocument = gql`
    query getGroupsForOrg($filter_organisation_id: String, $show_disabled: Boolean, $fetchUsers: Boolean = true) {
  getGroupsForOrg(
    filter_organisation_id: $filter_organisation_id
    show_disabled: $show_disabled
    fetchUsers: $fetchUsers
  ) {
    group_id
    group_name
    organisation_id
    disabled
    accept_reminders
    users @include(if: $fetchUsers) {
      id
      first_name
      last_name
      email_address
      phone_number
      role_name
    }
  }
}
    `;

/**
 * __useGetGroupsForOrgQuery__
 *
 * To run a query within a React component, call `useGetGroupsForOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsForOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsForOrgQuery({
 *   variables: {
 *      filter_organisation_id: // value for 'filter_organisation_id'
 *      show_disabled: // value for 'show_disabled'
 *      fetchUsers: // value for 'fetchUsers'
 *   },
 * });
 */
export function useGetGroupsForOrgQuery(baseOptions?: Apollo.QueryHookOptions<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>(GetGroupsForOrgDocument, options);
      }
export function useGetGroupsForOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>(GetGroupsForOrgDocument, options);
        }
// @ts-ignore
export function useGetGroupsForOrgSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>;
export function useGetGroupsForOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>): Apollo.UseSuspenseQueryResult<GetGroupsForOrgQuery | undefined, GetGroupsForOrgQueryVariables>;
export function useGetGroupsForOrgSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>(GetGroupsForOrgDocument, options);
        }
export type GetGroupsForOrgQueryHookResult = ReturnType<typeof useGetGroupsForOrgQuery>;
export type GetGroupsForOrgLazyQueryHookResult = ReturnType<typeof useGetGroupsForOrgLazyQuery>;
export type GetGroupsForOrgSuspenseQueryHookResult = ReturnType<typeof useGetGroupsForOrgSuspenseQuery>;
export type GetGroupsForOrgQueryResult = Apollo.QueryResult<GetGroupsForOrgQuery, GetGroupsForOrgQueryVariables>;
export const GetIntroducersDocument = gql`
    query getIntroducers($input: IntroducerCommissionsRequestInput!, $includePayingOrg: Boolean = false) {
  introducers(input: $input) {
    organisations {
      organisation_id
      name
      status
    }
  }
}
    `;

/**
 * __useGetIntroducersQuery__
 *
 * To run a query within a React component, call `useGetIntroducersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntroducersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntroducersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      includePayingOrg: // value for 'includePayingOrg'
 *   },
 * });
 */
export function useGetIntroducersQuery(baseOptions: Apollo.QueryHookOptions<GetIntroducersQuery, GetIntroducersQueryVariables> & ({ variables: GetIntroducersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntroducersQuery, GetIntroducersQueryVariables>(GetIntroducersDocument, options);
      }
export function useGetIntroducersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntroducersQuery, GetIntroducersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntroducersQuery, GetIntroducersQueryVariables>(GetIntroducersDocument, options);
        }
// @ts-ignore
export function useGetIntroducersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntroducersQuery, GetIntroducersQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntroducersQuery, GetIntroducersQueryVariables>;
export function useGetIntroducersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntroducersQuery, GetIntroducersQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntroducersQuery | undefined, GetIntroducersQueryVariables>;
export function useGetIntroducersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntroducersQuery, GetIntroducersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntroducersQuery, GetIntroducersQueryVariables>(GetIntroducersDocument, options);
        }
export type GetIntroducersQueryHookResult = ReturnType<typeof useGetIntroducersQuery>;
export type GetIntroducersLazyQueryHookResult = ReturnType<typeof useGetIntroducersLazyQuery>;
export type GetIntroducersSuspenseQueryHookResult = ReturnType<typeof useGetIntroducersSuspenseQuery>;
export type GetIntroducersQueryResult = Apollo.QueryResult<GetIntroducersQuery, GetIntroducersQueryVariables>;
export const GetIntroducersCommissionsListDocument = gql`
    query getIntroducersCommissionsList($input: IntroducerCommissionsRequestInput!) {
  introducers(input: $input) {
    organisations {
      commission_structure_id
      general_email
      joined_acre
      name
      organisation_id
      primary_address
      primary_phone
      status
      users {
        user_id
        first_name
        last_name
      }
    }
    next_page {
      bookmark
    }
  }
}
    `;

/**
 * __useGetIntroducersCommissionsListQuery__
 *
 * To run a query within a React component, call `useGetIntroducersCommissionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntroducersCommissionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntroducersCommissionsListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetIntroducersCommissionsListQuery(baseOptions: Apollo.QueryHookOptions<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables> & ({ variables: GetIntroducersCommissionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>(GetIntroducersCommissionsListDocument, options);
      }
export function useGetIntroducersCommissionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>(GetIntroducersCommissionsListDocument, options);
        }
// @ts-ignore
export function useGetIntroducersCommissionsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>;
export function useGetIntroducersCommissionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntroducersCommissionsListQuery | undefined, GetIntroducersCommissionsListQueryVariables>;
export function useGetIntroducersCommissionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>(GetIntroducersCommissionsListDocument, options);
        }
export type GetIntroducersCommissionsListQueryHookResult = ReturnType<typeof useGetIntroducersCommissionsListQuery>;
export type GetIntroducersCommissionsListLazyQueryHookResult = ReturnType<typeof useGetIntroducersCommissionsListLazyQuery>;
export type GetIntroducersCommissionsListSuspenseQueryHookResult = ReturnType<typeof useGetIntroducersCommissionsListSuspenseQuery>;
export type GetIntroducersCommissionsListQueryResult = Apollo.QueryResult<GetIntroducersCommissionsListQuery, GetIntroducersCommissionsListQueryVariables>;
export const GetKbaQuestionnaireDocument = gql`
    query getKbaQuestionnaire($id: ID!, $useClientApi: Boolean) {
  kbaQuestionnaire(userId: $id, useClientApi: $useClientApi) {
    attempt_id
    status
    questions {
      id
      text
      header
      choices {
        id
        text
      }
    }
  }
}
    `;

/**
 * __useGetKbaQuestionnaireQuery__
 *
 * To run a query within a React component, call `useGetKbaQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKbaQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKbaQuestionnaireQuery({
 *   variables: {
 *      id: // value for 'id'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useGetKbaQuestionnaireQuery(baseOptions: Apollo.QueryHookOptions<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables> & ({ variables: GetKbaQuestionnaireQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>(GetKbaQuestionnaireDocument, options);
      }
export function useGetKbaQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>(GetKbaQuestionnaireDocument, options);
        }
// @ts-ignore
export function useGetKbaQuestionnaireSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>): Apollo.UseSuspenseQueryResult<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>;
export function useGetKbaQuestionnaireSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>): Apollo.UseSuspenseQueryResult<GetKbaQuestionnaireQuery | undefined, GetKbaQuestionnaireQueryVariables>;
export function useGetKbaQuestionnaireSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>(GetKbaQuestionnaireDocument, options);
        }
export type GetKbaQuestionnaireQueryHookResult = ReturnType<typeof useGetKbaQuestionnaireQuery>;
export type GetKbaQuestionnaireLazyQueryHookResult = ReturnType<typeof useGetKbaQuestionnaireLazyQuery>;
export type GetKbaQuestionnaireSuspenseQueryHookResult = ReturnType<typeof useGetKbaQuestionnaireSuspenseQuery>;
export type GetKbaQuestionnaireQueryResult = Apollo.QueryResult<GetKbaQuestionnaireQuery, GetKbaQuestionnaireQueryVariables>;
export const GetLedgerFiltersDocument = gql`
    query getLedgerFilters($input: GetLedgerFiltersInput, $includeDetails: Boolean = true, $includeSources: Boolean = true) {
  getLedgerFilters(input: $input) {
    periodIds
    advisorIds {
      id
      hydrationType
      sourceType
    }
    advisors {
      id
      first_name
      last_name
    }
    clubIds @include(if: $includeDetails) {
      id
      hydrationType
      sourceType
    }
    clubs @include(if: $includeDetails) {
      id
      name
    }
    sourceIds @include(if: $includeSources) {
      id
      hydrationType
      sourceType
      details {
        ... on ClientVersion {
          id
          version
          details {
            id
            first_name
            last_name
            organisation_name
            is_natural_person
          }
        }
        ... on Organisation {
          id
          organisation_id
          name
        }
        ... on User {
          id
          first_name
          last_name
          role_name
          primary_role_id
        }
      }
    }
  }
}
    `;

/**
 * __useGetLedgerFiltersQuery__
 *
 * To run a query within a React component, call `useGetLedgerFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerFiltersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      includeDetails: // value for 'includeDetails'
 *      includeSources: // value for 'includeSources'
 *   },
 * });
 */
export function useGetLedgerFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>(GetLedgerFiltersDocument, options);
      }
export function useGetLedgerFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>(GetLedgerFiltersDocument, options);
        }
// @ts-ignore
export function useGetLedgerFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>;
export function useGetLedgerFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerFiltersQuery | undefined, GetLedgerFiltersQueryVariables>;
export function useGetLedgerFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>(GetLedgerFiltersDocument, options);
        }
export type GetLedgerFiltersQueryHookResult = ReturnType<typeof useGetLedgerFiltersQuery>;
export type GetLedgerFiltersLazyQueryHookResult = ReturnType<typeof useGetLedgerFiltersLazyQuery>;
export type GetLedgerFiltersSuspenseQueryHookResult = ReturnType<typeof useGetLedgerFiltersSuspenseQuery>;
export type GetLedgerFiltersQueryResult = Apollo.QueryResult<GetLedgerFiltersQuery, GetLedgerFiltersQueryVariables>;
export const GetLedgerFiltersClubsDocument = gql`
    query getLedgerFiltersClubs($org_ids: [String!]) {
  getLedgerFilters(input: {org_ids: $org_ids}) {
    periodIds
    clubs {
      id
      name
    }
  }
}
    `;

/**
 * __useGetLedgerFiltersClubsQuery__
 *
 * To run a query within a React component, call `useGetLedgerFiltersClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerFiltersClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerFiltersClubsQuery({
 *   variables: {
 *      org_ids: // value for 'org_ids'
 *   },
 * });
 */
export function useGetLedgerFiltersClubsQuery(baseOptions?: Apollo.QueryHookOptions<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>(GetLedgerFiltersClubsDocument, options);
      }
export function useGetLedgerFiltersClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>(GetLedgerFiltersClubsDocument, options);
        }
// @ts-ignore
export function useGetLedgerFiltersClubsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>;
export function useGetLedgerFiltersClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerFiltersClubsQuery | undefined, GetLedgerFiltersClubsQueryVariables>;
export function useGetLedgerFiltersClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>(GetLedgerFiltersClubsDocument, options);
        }
export type GetLedgerFiltersClubsQueryHookResult = ReturnType<typeof useGetLedgerFiltersClubsQuery>;
export type GetLedgerFiltersClubsLazyQueryHookResult = ReturnType<typeof useGetLedgerFiltersClubsLazyQuery>;
export type GetLedgerFiltersClubsSuspenseQueryHookResult = ReturnType<typeof useGetLedgerFiltersClubsSuspenseQuery>;
export type GetLedgerFiltersClubsQueryResult = Apollo.QueryResult<GetLedgerFiltersClubsQuery, GetLedgerFiltersClubsQueryVariables>;
export const GetLedgerSummaryDocument = gql`
    query getLedgerSummary($input: GetLedgerSummaryInput!) {
  getLedgerSummary(input: $input) {
    ledgers_summary {
      advisor_id
      payee
      role
      period_id
      period_name
      period_start
      period_end
      commissions_total
      gross_revenue_total
      net_commission_total
      paid_commissions_total
      paid_gross_revenue_total
      paid_net_commission_total
      commission_ledger_ids_cache_key
      clawbacks
      clawback_total
      paid_clawback_total
      conveyancing_summary {
        clawback
        commissions
        gross_revenue
        net_commission
        paid_commissions
        paid_gross_revenue
        paid_net_commission
      }
      gi_summary {
        clawback
        commissions
        gross_revenue
        net_commission
        paid_commissions
        paid_gross_revenue
        paid_net_commission
      }
      mortgage_summary {
        clawback
        commissions
        gross_revenue
        net_commission
        paid_commissions
        paid_gross_revenue
        paid_net_commission
      }
      protection_summary {
        clawback
        commissions
        gross_revenue
        net_commission
        paid_commissions
        paid_gross_revenue
        paid_net_commission
      }
      tier_summary {
        mortgage {
          commissions
          net_commission
          paid_net_commission
          tier_from
          tier_to
        }
        protection {
          commissions
          net_commission
          paid_net_commission
          tier_from
          tier_to
        }
      }
    }
    filter {
      club_ids
      due_date_start
      due_date_end
      order_by_commissions
      order_by_gross_revenue
      order_by_net_commission
      order_by_payee
      period_ids
      period_end_date
      period_start_date
      settled_date_start
      settled_date_end
      source_ids
    }
    nextPage {
      bookmark
      page_size
    }
    totals {
      commissions
      gross_fee
      net_commission
      paid_commissions
      paid_gross_fee
      paid_net_commission
    }
  }
}
    `;

/**
 * __useGetLedgerSummaryQuery__
 *
 * To run a query within a React component, call `useGetLedgerSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgerSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgerSummaryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLedgerSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables> & ({ variables: GetLedgerSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>(GetLedgerSummaryDocument, options);
      }
export function useGetLedgerSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>(GetLedgerSummaryDocument, options);
        }
// @ts-ignore
export function useGetLedgerSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>;
export function useGetLedgerSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgerSummaryQuery | undefined, GetLedgerSummaryQueryVariables>;
export function useGetLedgerSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>(GetLedgerSummaryDocument, options);
        }
export type GetLedgerSummaryQueryHookResult = ReturnType<typeof useGetLedgerSummaryQuery>;
export type GetLedgerSummaryLazyQueryHookResult = ReturnType<typeof useGetLedgerSummaryLazyQuery>;
export type GetLedgerSummarySuspenseQueryHookResult = ReturnType<typeof useGetLedgerSummarySuspenseQuery>;
export type GetLedgerSummaryQueryResult = Apollo.QueryResult<GetLedgerSummaryQuery, GetLedgerSummaryQueryVariables>;
export const GetLedgersDocument = gql`
    query getLedgers($input: GetLedgersInput!) {
  getLedgers(input: $input) {
    filter {
      periodIds
      advisorIds
      clubIds
      dueDateEnd
      dueDateStart
      isOverdue
      orderByAmountDue
      orderByDueDate
      orderBySettledDate
      sourceIds
      statuses
      settledDateStart
      settledDateEnd
    }
    ledgers {
      ...ledgerDetails
    }
    nextPage {
      bookmark
      pageSize
      page_size
    }
    totals {
      amount_due
      amount_paid
      number_of_payments
      number_of_ledgers
    }
  }
}
    ${LedgerDetailsFragmentDoc}`;

/**
 * __useGetLedgersQuery__
 *
 * To run a query within a React component, call `useGetLedgersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLedgersQuery(baseOptions: Apollo.QueryHookOptions<GetLedgersQuery, GetLedgersQueryVariables> & ({ variables: GetLedgersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgersQuery, GetLedgersQueryVariables>(GetLedgersDocument, options);
      }
export function useGetLedgersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgersQuery, GetLedgersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgersQuery, GetLedgersQueryVariables>(GetLedgersDocument, options);
        }
// @ts-ignore
export function useGetLedgersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLedgersQuery, GetLedgersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgersQuery, GetLedgersQueryVariables>;
export function useGetLedgersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgersQuery, GetLedgersQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgersQuery | undefined, GetLedgersQueryVariables>;
export function useGetLedgersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgersQuery, GetLedgersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLedgersQuery, GetLedgersQueryVariables>(GetLedgersDocument, options);
        }
export type GetLedgersQueryHookResult = ReturnType<typeof useGetLedgersQuery>;
export type GetLedgersLazyQueryHookResult = ReturnType<typeof useGetLedgersLazyQuery>;
export type GetLedgersSuspenseQueryHookResult = ReturnType<typeof useGetLedgersSuspenseQuery>;
export type GetLedgersQueryResult = Apollo.QueryResult<GetLedgersQuery, GetLedgersQueryVariables>;
export const GetLedgersByCaseIdDocument = gql`
    query getLedgersByCaseId($caseId: ID!) {
  getLedgersByCaseId(caseId: $caseId) {
    oneOffLedgers {
      id
      amountDue
      grossFee
      dueDate
      settledDate
      isOverdue
      type
      paymentDirection
      clubId
      caseId
      payerName @client
      advisorId
      clientIds
      orgId
      isTier
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          organisation_name
        }
      }
      product_source_id
      originLedgerId
      sourceId {
        id
        sourceType
        hydrationType
        details {
          ... on ClientVersion {
            version
            id
          }
          ... on User {
            id
            first_name
            last_name
          }
          ... on Organisation {
            id
            organisation_id
            name
          }
        }
      }
      status
      protection_policy_number
      protection_quote_reference
      payments {
        id
        status
        external_id
        amount
        provider
        date
      }
    }
    recurringLedgers {
      id
      endDate
      startDate
      isOverdue
      amount
      recurringAmount
      type
      nextPayment
      clubId
      caseId
      advisorId
      orgId
      payerName @client
      advisor {
        id
        first_name
        last_name
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          organisation_name
        }
      }
      sourceId {
        id
        sourceType
        hydrationType
        details {
          ... on ClientVersion {
            id
            version
          }
          ... on User {
            id
            first_name
            last_name
          }
          ... on Organisation {
            id
            organisation_id
            name
          }
        }
      }
      status
    }
  }
}
    `;

/**
 * __useGetLedgersByCaseIdQuery__
 *
 * To run a query within a React component, call `useGetLedgersByCaseIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLedgersByCaseIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLedgersByCaseIdQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetLedgersByCaseIdQuery(baseOptions: Apollo.QueryHookOptions<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables> & ({ variables: GetLedgersByCaseIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>(GetLedgersByCaseIdDocument, options);
      }
export function useGetLedgersByCaseIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>(GetLedgersByCaseIdDocument, options);
        }
// @ts-ignore
export function useGetLedgersByCaseIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>;
export function useGetLedgersByCaseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetLedgersByCaseIdQuery | undefined, GetLedgersByCaseIdQueryVariables>;
export function useGetLedgersByCaseIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>(GetLedgersByCaseIdDocument, options);
        }
export type GetLedgersByCaseIdQueryHookResult = ReturnType<typeof useGetLedgersByCaseIdQuery>;
export type GetLedgersByCaseIdLazyQueryHookResult = ReturnType<typeof useGetLedgersByCaseIdLazyQuery>;
export type GetLedgersByCaseIdSuspenseQueryHookResult = ReturnType<typeof useGetLedgersByCaseIdSuspenseQuery>;
export type GetLedgersByCaseIdQueryResult = Apollo.QueryResult<GetLedgersByCaseIdQuery, GetLedgersByCaseIdQueryVariables>;
export const GetLenderNamesDocument = gql`
    query getLenderNames {
  lenderNames {
    id
    name
  }
}
    `;

/**
 * __useGetLenderNamesQuery__
 *
 * To run a query within a React component, call `useGetLenderNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLenderNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLenderNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLenderNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetLenderNamesQuery, GetLenderNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLenderNamesQuery, GetLenderNamesQueryVariables>(GetLenderNamesDocument, options);
      }
export function useGetLenderNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLenderNamesQuery, GetLenderNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLenderNamesQuery, GetLenderNamesQueryVariables>(GetLenderNamesDocument, options);
        }
// @ts-ignore
export function useGetLenderNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLenderNamesQuery, GetLenderNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLenderNamesQuery, GetLenderNamesQueryVariables>;
export function useGetLenderNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLenderNamesQuery, GetLenderNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLenderNamesQuery | undefined, GetLenderNamesQueryVariables>;
export function useGetLenderNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLenderNamesQuery, GetLenderNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLenderNamesQuery, GetLenderNamesQueryVariables>(GetLenderNamesDocument, options);
        }
export type GetLenderNamesQueryHookResult = ReturnType<typeof useGetLenderNamesQuery>;
export type GetLenderNamesLazyQueryHookResult = ReturnType<typeof useGetLenderNamesLazyQuery>;
export type GetLenderNamesSuspenseQueryHookResult = ReturnType<typeof useGetLenderNamesSuspenseQuery>;
export type GetLenderNamesQueryResult = Apollo.QueryResult<GetLenderNamesQuery, GetLenderNamesQueryVariables>;
export const GetMessageUsersByIdDocument = gql`
    query getMessageUsersById($userIds: [ID!], $useClientApi: Boolean) {
  users(ids: $userIds, useClientApi: $useClientApi) {
    id
    organisation_id
    first_name
    last_name
    status
    email_address
    phone_number
    group_ids
    photo
    organisation_id
    organisation(useClientApi: $useClientApi) {
      id
      name
      logo
      representative_of
      type
    }
  }
}
    `;

/**
 * __useGetMessageUsersByIdQuery__
 *
 * To run a query within a React component, call `useGetMessageUsersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMessageUsersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMessageUsersByIdQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useGetMessageUsersByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>(GetMessageUsersByIdDocument, options);
      }
export function useGetMessageUsersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>(GetMessageUsersByIdDocument, options);
        }
// @ts-ignore
export function useGetMessageUsersByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>;
export function useGetMessageUsersByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetMessageUsersByIdQuery | undefined, GetMessageUsersByIdQueryVariables>;
export function useGetMessageUsersByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>(GetMessageUsersByIdDocument, options);
        }
export type GetMessageUsersByIdQueryHookResult = ReturnType<typeof useGetMessageUsersByIdQuery>;
export type GetMessageUsersByIdLazyQueryHookResult = ReturnType<typeof useGetMessageUsersByIdLazyQuery>;
export type GetMessageUsersByIdSuspenseQueryHookResult = ReturnType<typeof useGetMessageUsersByIdSuspenseQuery>;
export type GetMessageUsersByIdQueryResult = Apollo.QueryResult<GetMessageUsersByIdQuery, GetMessageUsersByIdQueryVariables>;
export const GetDashboardCaseListDocument = gql`
    query getDashboardCaseList($input: GetMiCaseListFilterInput!, $fetchIntroducerUser: Boolean!) {
  getDashboardCaseList(input: $input) {
    stats {
      predicted_revenue
      count
    }
    cases {
      advisor_id
      case_id
      lender_id
      case_status
      case_type
      last_editor_type
      recent_client_doc
      client_ids
      created_at
      introducer_id
      related_users {
        id
        user_id
        relationship_type
      }
      modified_at
      mortgage_amount
      flags
      organisation_name
      transition_at
      offer_date
      exchange_date
      recommendation_date
      review_date
      submitted_date
      completed_date
      first_offer_date
      first_exchange_date
      first_recommendation_date
      first_review_date
      first_submitted_date
      first_completed_date
      regulated_by_name
      logged_in_to_client_portal
      credit_report_done
      meeting_booked
      org_id
      org_ids
      predicted_revenue
      property_id
      address {
        address1
        address2
        address3
        postcode
        posttown
        county
        country
      }
      advisor_name
      lender {
        name
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          is_natural_person
          organisation_name
        }
      }
      introducer {
        id
        name
      }
      introducer_user @include(if: $fetchIntroducerUser) {
        id
        first_name
        last_name
      }
      related_cases {
        id
        case_id
        relationship_type
        firm
        advisor
      }
      notes {
        assignee_id
        communication_type
        deadline
        primary_type
        priority
        status
        title
        template_id
      }
    }
    next_page {
      bookmark
    }
  }
}
    `;

/**
 * __useGetDashboardCaseListQuery__
 *
 * To run a query within a React component, call `useGetDashboardCaseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardCaseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardCaseListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      fetchIntroducerUser: // value for 'fetchIntroducerUser'
 *   },
 * });
 */
export function useGetDashboardCaseListQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables> & ({ variables: GetDashboardCaseListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>(GetDashboardCaseListDocument, options);
      }
export function useGetDashboardCaseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>(GetDashboardCaseListDocument, options);
        }
// @ts-ignore
export function useGetDashboardCaseListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>;
export function useGetDashboardCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardCaseListQuery | undefined, GetDashboardCaseListQueryVariables>;
export function useGetDashboardCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>(GetDashboardCaseListDocument, options);
        }
export type GetDashboardCaseListQueryHookResult = ReturnType<typeof useGetDashboardCaseListQuery>;
export type GetDashboardCaseListLazyQueryHookResult = ReturnType<typeof useGetDashboardCaseListLazyQuery>;
export type GetDashboardCaseListSuspenseQueryHookResult = ReturnType<typeof useGetDashboardCaseListSuspenseQuery>;
export type GetDashboardCaseListQueryResult = Apollo.QueryResult<GetDashboardCaseListQuery, GetDashboardCaseListQueryVariables>;
export const GetMiOrganisationsDocument = gql`
    query getMiOrganisations($filters: MiOrganisationInput, $includeUsers: Boolean = false) {
  miOrganisations(filters: $filters) {
    organisations {
      organisation_id
      name
      users @include(if: $includeUsers) {
        user_id
        first_name
        last_name
        primary_role_id
      }
    }
    next_page {
      bookmark
    }
    filters {
      all_users
      bookmark
      include_disabled_orgs
      include_disabled_users
      org_id
      page_size
      primary_role_ids
      representative_of
    }
  }
}
    `;

/**
 * __useGetMiOrganisationsQuery__
 *
 * To run a query within a React component, call `useGetMiOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMiOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMiOrganisationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      includeUsers: // value for 'includeUsers'
 *   },
 * });
 */
export function useGetMiOrganisationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>(GetMiOrganisationsDocument, options);
      }
export function useGetMiOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>(GetMiOrganisationsDocument, options);
        }
// @ts-ignore
export function useGetMiOrganisationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>;
export function useGetMiOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMiOrganisationsQuery | undefined, GetMiOrganisationsQueryVariables>;
export function useGetMiOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>(GetMiOrganisationsDocument, options);
        }
export type GetMiOrganisationsQueryHookResult = ReturnType<typeof useGetMiOrganisationsQuery>;
export type GetMiOrganisationsLazyQueryHookResult = ReturnType<typeof useGetMiOrganisationsLazyQuery>;
export type GetMiOrganisationsSuspenseQueryHookResult = ReturnType<typeof useGetMiOrganisationsSuspenseQuery>;
export type GetMiOrganisationsQueryResult = Apollo.QueryResult<GetMiOrganisationsQuery, GetMiOrganisationsQueryVariables>;
export const GetMortgageByVersionDocument = gql`
    query getMortgageByVersion($id: ID!, $version: Int!, $show_history: Int) {
  mortgageVersion(id: $id, version: $version, show_history: $show_history) {
    ...CaseMortgagesAndMortgageProducts
    versions {
      ...VersionWithChangedFields
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}
${VersionWithChangedFieldsFragmentDoc}`;

/**
 * __useGetMortgageByVersionQuery__
 *
 * To run a query within a React component, call `useGetMortgageByVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgageByVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgageByVersionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *      show_history: // value for 'show_history'
 *   },
 * });
 */
export function useGetMortgageByVersionQuery(baseOptions: Apollo.QueryHookOptions<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables> & ({ variables: GetMortgageByVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>(GetMortgageByVersionDocument, options);
      }
export function useGetMortgageByVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>(GetMortgageByVersionDocument, options);
        }
// @ts-ignore
export function useGetMortgageByVersionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>;
export function useGetMortgageByVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>): Apollo.UseSuspenseQueryResult<GetMortgageByVersionQuery | undefined, GetMortgageByVersionQueryVariables>;
export function useGetMortgageByVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>(GetMortgageByVersionDocument, options);
        }
export type GetMortgageByVersionQueryHookResult = ReturnType<typeof useGetMortgageByVersionQuery>;
export type GetMortgageByVersionLazyQueryHookResult = ReturnType<typeof useGetMortgageByVersionLazyQuery>;
export type GetMortgageByVersionSuspenseQueryHookResult = ReturnType<typeof useGetMortgageByVersionSuspenseQuery>;
export type GetMortgageByVersionQueryResult = Apollo.QueryResult<GetMortgageByVersionQuery, GetMortgageByVersionQueryVariables>;
export const GetMortgageProductDocument = gql`
    query getMortgageProduct($id: ID!) {
  case(id: $id, include_source_response: true) {
    id
    details {
      id
      lender_has_proposed_new_product
      mortgages {
        ...CaseMortgagesAndMortgageProducts
      }
    }
  }
}
    ${CaseMortgagesAndMortgageProductsFragmentDoc}`;

/**
 * __useGetMortgageProductQuery__
 *
 * To run a query within a React component, call `useGetMortgageProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgageProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgageProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMortgageProductQuery(baseOptions: Apollo.QueryHookOptions<GetMortgageProductQuery, GetMortgageProductQueryVariables> & ({ variables: GetMortgageProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgageProductQuery, GetMortgageProductQueryVariables>(GetMortgageProductDocument, options);
      }
export function useGetMortgageProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgageProductQuery, GetMortgageProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgageProductQuery, GetMortgageProductQueryVariables>(GetMortgageProductDocument, options);
        }
// @ts-ignore
export function useGetMortgageProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMortgageProductQuery, GetMortgageProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetMortgageProductQuery, GetMortgageProductQueryVariables>;
export function useGetMortgageProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMortgageProductQuery, GetMortgageProductQueryVariables>): Apollo.UseSuspenseQueryResult<GetMortgageProductQuery | undefined, GetMortgageProductQueryVariables>;
export function useGetMortgageProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMortgageProductQuery, GetMortgageProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMortgageProductQuery, GetMortgageProductQueryVariables>(GetMortgageProductDocument, options);
        }
export type GetMortgageProductQueryHookResult = ReturnType<typeof useGetMortgageProductQuery>;
export type GetMortgageProductLazyQueryHookResult = ReturnType<typeof useGetMortgageProductLazyQuery>;
export type GetMortgageProductSuspenseQueryHookResult = ReturnType<typeof useGetMortgageProductSuspenseQuery>;
export type GetMortgageProductQueryResult = Apollo.QueryResult<GetMortgageProductQuery, GetMortgageProductQueryVariables>;
export const GetMortgageProductBySourcingProductIdDocument = gql`
    query getMortgageProductBySourcingProductId($input: MortgageProductBySourcingIdInput!) {
  getMortgageProductBySourcingProductId(input: $input) {
    product_name
    lender_name
    fees_total
    fees {
      amount
      fee_type
      timing
      can_be_added_to_loan
    }
    incentives {
      amount
      type
      maxAmount
      method
    }
    is_porting
    early_repayment_charge_applies
    early_repayment_charge_periods {
      erc_charge
      period_fixed_end_date
      period_fixed_length_months
    }
    rate_tiers {
      rate
      rate_type
      period_fixed_length_months
      period_fixed_end_date
      rate_tracked
      until_end_of_term
    }
    mortgage_club_proc_fees {
      mortgage_club_code
      mortgage_club_name
      net_proc_fee_percentage
      proc_fee_percentage
    }
  }
}
    `;

/**
 * __useGetMortgageProductBySourcingProductIdQuery__
 *
 * To run a query within a React component, call `useGetMortgageProductBySourcingProductIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgageProductBySourcingProductIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgageProductBySourcingProductIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMortgageProductBySourcingProductIdQuery(baseOptions: Apollo.QueryHookOptions<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables> & ({ variables: GetMortgageProductBySourcingProductIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>(GetMortgageProductBySourcingProductIdDocument, options);
      }
export function useGetMortgageProductBySourcingProductIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>(GetMortgageProductBySourcingProductIdDocument, options);
        }
// @ts-ignore
export function useGetMortgageProductBySourcingProductIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>;
export function useGetMortgageProductBySourcingProductIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetMortgageProductBySourcingProductIdQuery | undefined, GetMortgageProductBySourcingProductIdQueryVariables>;
export function useGetMortgageProductBySourcingProductIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>(GetMortgageProductBySourcingProductIdDocument, options);
        }
export type GetMortgageProductBySourcingProductIdQueryHookResult = ReturnType<typeof useGetMortgageProductBySourcingProductIdQuery>;
export type GetMortgageProductBySourcingProductIdLazyQueryHookResult = ReturnType<typeof useGetMortgageProductBySourcingProductIdLazyQuery>;
export type GetMortgageProductBySourcingProductIdSuspenseQueryHookResult = ReturnType<typeof useGetMortgageProductBySourcingProductIdSuspenseQuery>;
export type GetMortgageProductBySourcingProductIdQueryResult = Apollo.QueryResult<GetMortgageProductBySourcingProductIdQuery, GetMortgageProductBySourcingProductIdQueryVariables>;
export const GetMortgageProductCodesDocument = gql`
    query getMortgageProductCodes($isBtl: Boolean!, $productCode: String, $lender: String) {
  getMortgageProductCodes(
    isBtl: $isBtl
    productCode: $productCode
    lender: $lender
  ) {
    productCode
    name
    id
    lender
  }
}
    `;

/**
 * __useGetMortgageProductCodesQuery__
 *
 * To run a query within a React component, call `useGetMortgageProductCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMortgageProductCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMortgageProductCodesQuery({
 *   variables: {
 *      isBtl: // value for 'isBtl'
 *      productCode: // value for 'productCode'
 *      lender: // value for 'lender'
 *   },
 * });
 */
export function useGetMortgageProductCodesQuery(baseOptions: Apollo.QueryHookOptions<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables> & ({ variables: GetMortgageProductCodesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>(GetMortgageProductCodesDocument, options);
      }
export function useGetMortgageProductCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>(GetMortgageProductCodesDocument, options);
        }
// @ts-ignore
export function useGetMortgageProductCodesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>;
export function useGetMortgageProductCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>): Apollo.UseSuspenseQueryResult<GetMortgageProductCodesQuery | undefined, GetMortgageProductCodesQueryVariables>;
export function useGetMortgageProductCodesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>(GetMortgageProductCodesDocument, options);
        }
export type GetMortgageProductCodesQueryHookResult = ReturnType<typeof useGetMortgageProductCodesQuery>;
export type GetMortgageProductCodesLazyQueryHookResult = ReturnType<typeof useGetMortgageProductCodesLazyQuery>;
export type GetMortgageProductCodesSuspenseQueryHookResult = ReturnType<typeof useGetMortgageProductCodesSuspenseQuery>;
export type GetMortgageProductCodesQueryResult = Apollo.QueryResult<GetMortgageProductCodesQuery, GetMortgageProductCodesQueryVariables>;
export const GetNoteDocument = gql`
    query GetNote($params: GetNoteRequestInput, $useClientApi: Boolean) {
  getNote(params: $params, useClientApi: $useClientApi) {
    notes {
      note_id
      created_at
      modified_at
      title
      priority
      status
      body
      primary_type
      deadline
      assignee_id
      assignee_type
      case_id
      client_id
      property_id
      mortgage_id
      verification_id
      organisation_ids
      created_by
      communication_type
      template_id
      event_note {
        event_id
        user_ids
        event_type
        start_time
        end_time
      }
      ui_reference {
        section
        entity_id
      }
    }
  }
}
    `;

/**
 * __useGetNoteQuery__
 *
 * To run a query within a React component, call `useGetNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteQuery({
 *   variables: {
 *      params: // value for 'params'
 *      useClientApi: // value for 'useClientApi'
 *   },
 * });
 */
export function useGetNoteQuery(baseOptions?: Apollo.QueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
      }
export function useGetNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
        }
// @ts-ignore
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>): Apollo.UseSuspenseQueryResult<GetNoteQuery, GetNoteQueryVariables>;
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>): Apollo.UseSuspenseQueryResult<GetNoteQuery | undefined, GetNoteQueryVariables>;
export function useGetNoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNoteQuery, GetNoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNoteQuery, GetNoteQueryVariables>(GetNoteDocument, options);
        }
export type GetNoteQueryHookResult = ReturnType<typeof useGetNoteQuery>;
export type GetNoteLazyQueryHookResult = ReturnType<typeof useGetNoteLazyQuery>;
export type GetNoteSuspenseQueryHookResult = ReturnType<typeof useGetNoteSuspenseQuery>;
export type GetNoteQueryResult = Apollo.QueryResult<GetNoteQuery, GetNoteQueryVariables>;
export const GetNotesDocument = gql`
    query GetNotes($params: GetNoteRequestInput, $useClientApi: Boolean = false, $hydrateCreator: Boolean = false) {
  getNotes(
    params: $params
    useClientApi: $useClientApi
    hydrateCreator: $hydrateCreator
  ) {
    notes {
      note_id
      created_at
      modified_at
      title
      priority
      status
      body
      primary_type
      deadline
      assignee_id
      assignee_type
      case_id
      client_id
      property_id
      mortgage_id
      verification_id
      organisation_ids
      created_by
      communication_type
      template_id
      created_by_user(useClientApi: $useClientApi) @include(if: $useClientApi) {
        id
        first_name
        last_name
        organisation_id
        photo
      }
      creator @include(if: $hydrateCreator) {
        user_id
        first_name
        last_name
      }
      event_note {
        event_id
        user_ids
        event_type
        start_time
        end_time
      }
      ui_reference {
        section
        entity_id
      }
    }
    next_page {
      note_ids
      organisation_id
      filter_case_id
      filter_client_id
      filter_property_id
      filter_mortgage_id
      filter_assignee_id
      bookmark
      page_size
    }
  }
}
    `;

/**
 * __useGetNotesQuery__
 *
 * To run a query within a React component, call `useGetNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotesQuery({
 *   variables: {
 *      params: // value for 'params'
 *      useClientApi: // value for 'useClientApi'
 *      hydrateCreator: // value for 'hydrateCreator'
 *   },
 * });
 */
export function useGetNotesQuery(baseOptions?: Apollo.QueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
      }
export function useGetNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
// @ts-ignore
export function useGetNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotesQuery, GetNotesQueryVariables>;
export function useGetNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotesQuery | undefined, GetNotesQueryVariables>;
export function useGetNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotesQuery, GetNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotesQuery, GetNotesQueryVariables>(GetNotesDocument, options);
        }
export type GetNotesQueryHookResult = ReturnType<typeof useGetNotesQuery>;
export type GetNotesLazyQueryHookResult = ReturnType<typeof useGetNotesLazyQuery>;
export type GetNotesSuspenseQueryHookResult = ReturnType<typeof useGetNotesSuspenseQuery>;
export type GetNotesQueryResult = Apollo.QueryResult<GetNotesQuery, GetNotesQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($userId: ID!) {
  notifications(userId: $userId) {
    notification_id
    notification_type
    message
    subtext
    url
    created_at
    document_type
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables> & ({ variables: GetNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
// @ts-ignore
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetNotificationsTokenDocument = gql`
    query getNotificationsToken {
  getNotificationsToken {
    token
  }
}
    `;

/**
 * __useGetNotificationsTokenQuery__
 *
 * To run a query within a React component, call `useGetNotificationsTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>(GetNotificationsTokenDocument, options);
      }
export function useGetNotificationsTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>(GetNotificationsTokenDocument, options);
        }
// @ts-ignore
export function useGetNotificationsTokenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>;
export function useGetNotificationsTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>): Apollo.UseSuspenseQueryResult<GetNotificationsTokenQuery | undefined, GetNotificationsTokenQueryVariables>;
export function useGetNotificationsTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>(GetNotificationsTokenDocument, options);
        }
export type GetNotificationsTokenQueryHookResult = ReturnType<typeof useGetNotificationsTokenQuery>;
export type GetNotificationsTokenLazyQueryHookResult = ReturnType<typeof useGetNotificationsTokenLazyQuery>;
export type GetNotificationsTokenSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsTokenSuspenseQuery>;
export type GetNotificationsTokenQueryResult = Apollo.QueryResult<GetNotificationsTokenQuery, GetNotificationsTokenQueryVariables>;
export const GetOauthCheckDocument = gql`
    query getOauthCheck {
  getOauthCheck {
    credentials {
      id
      scopes
      username
      is_active
      provider
    }
  }
}
    `;

/**
 * __useGetOauthCheckQuery__
 *
 * To run a query within a React component, call `useGetOauthCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOauthCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOauthCheckQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOauthCheckQuery(baseOptions?: Apollo.QueryHookOptions<GetOauthCheckQuery, GetOauthCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOauthCheckQuery, GetOauthCheckQueryVariables>(GetOauthCheckDocument, options);
      }
export function useGetOauthCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOauthCheckQuery, GetOauthCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOauthCheckQuery, GetOauthCheckQueryVariables>(GetOauthCheckDocument, options);
        }
// @ts-ignore
export function useGetOauthCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOauthCheckQuery, GetOauthCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GetOauthCheckQuery, GetOauthCheckQueryVariables>;
export function useGetOauthCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOauthCheckQuery, GetOauthCheckQueryVariables>): Apollo.UseSuspenseQueryResult<GetOauthCheckQuery | undefined, GetOauthCheckQueryVariables>;
export function useGetOauthCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOauthCheckQuery, GetOauthCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOauthCheckQuery, GetOauthCheckQueryVariables>(GetOauthCheckDocument, options);
        }
export type GetOauthCheckQueryHookResult = ReturnType<typeof useGetOauthCheckQuery>;
export type GetOauthCheckLazyQueryHookResult = ReturnType<typeof useGetOauthCheckLazyQuery>;
export type GetOauthCheckSuspenseQueryHookResult = ReturnType<typeof useGetOauthCheckSuspenseQuery>;
export type GetOauthCheckQueryResult = Apollo.QueryResult<GetOauthCheckQuery, GetOauthCheckQueryVariables>;
export const GetOauthCheckForUsersDocument = gql`
    query getOauthCheckForUsers($ids: [ID!]) {
  getOauthCheckForUsers(ids: $ids) {
    authenticated {
      credential_id
      scopes
      username
      user_id
    }
  }
}
    `;

/**
 * __useGetOauthCheckForUsersQuery__
 *
 * To run a query within a React component, call `useGetOauthCheckForUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOauthCheckForUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOauthCheckForUsersQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetOauthCheckForUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>(GetOauthCheckForUsersDocument, options);
      }
export function useGetOauthCheckForUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>(GetOauthCheckForUsersDocument, options);
        }
// @ts-ignore
export function useGetOauthCheckForUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>;
export function useGetOauthCheckForUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOauthCheckForUsersQuery | undefined, GetOauthCheckForUsersQueryVariables>;
export function useGetOauthCheckForUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>(GetOauthCheckForUsersDocument, options);
        }
export type GetOauthCheckForUsersQueryHookResult = ReturnType<typeof useGetOauthCheckForUsersQuery>;
export type GetOauthCheckForUsersLazyQueryHookResult = ReturnType<typeof useGetOauthCheckForUsersLazyQuery>;
export type GetOauthCheckForUsersSuspenseQueryHookResult = ReturnType<typeof useGetOauthCheckForUsersSuspenseQuery>;
export type GetOauthCheckForUsersQueryResult = Apollo.QueryResult<GetOauthCheckForUsersQuery, GetOauthCheckForUsersQueryVariables>;
export const GetOrganisationDocument = gql`
    query getOrganisation($id: ID!, $useClientApi: Boolean = false, $includeFinancialConfigFields: Boolean = false) {
  organisation(
    id: $id
    useClientApi: $useClientApi
    includeFinancialConfigFields: $includeFinancialConfigFields
  ) {
    ...BasicOrganisationDetails
    organisation_legal_form
    organisation_ext_identifier
    joined_acre
    logo
    client_portal_url
    client_portal_settings {
      primary_colour
    }
    fca_reg_no
    type
    administered_by {
      id
      external_id
    }
    paid_by {
      id
    }
    bank_account {
      sort_code
      number
    }
    ...OrganisationRmarSettings
    ...OrganisationSourcingSettings
    standard_fee_options {
      fee_option_title
      fees {
        fee_type
        value
      }
      default
    }
    representative_of
    representative_of_org(useClientApi: $useClientApi) {
      ...BasicOrganisationDetails
      metadata {
        name
        string_value
        bool_value
        user_editable
      }
      process_settings {
        protection_disclaimer {
          generated_by
          signed_by
        }
        template_styles {
          protection_advice_disclaimer
        }
      }
      protection_settings {
        commission {
          indemnity_required
        }
      }
    }
    status
    website
    primary_phone
    general_email
    metadata {
      name
      string_value
      bool_value
      user_editable
    }
    ...NoteTemplates
    periods_settings {
      periods {
        id
        name
        start_date
        end_date
        disabled
      }
    }
    verification_class {
      enhanced
      optional
      beta
    }
    process_settings {
      use_exchange_case_status
      case_board {
        name
        statuses
      }
      protection_disclaimer {
        generated_by
        signed_by
      }
      template_styles {
        protection_advice_disclaimer
      }
      risk_flagging {
        right_to_buy
        vulnerable
        second_job
        gifted_deposit
        lending_into_retirement
        redemption_penalty
        residential_interest_only
        equity_release
        debt_consolidation
        high_risk_debt_consolidation
        high_commission
        cheapest_product_not_recommended
        advisor_under_review
      }
    }
    lender_metadata {
      porting_pay_on_full_loan_amount
    }
    protection_settings {
      decreasing_term_policy_rate_default_type
      decreasing_term_policy_rate_default_rate
      commission {
        indemnity_required
      }
    }
    referral_settings {
      excluded_referral_partners {
        id
        organisation_id
      }
    }
    bank_details_account_no
    bank_details_sort_code
    accounting @include(if: $includeFinancialConfigFields) {
      vat_registered
      vat_number
      bank_details_sort_code
      bank_details_account_no
    }
  }
}
    ${BasicOrganisationDetailsFragmentDoc}
${OrganisationRmarSettingsFragmentDoc}
${OrganisationSourcingSettingsFragmentDoc}
${NoteTemplatesFragmentDoc}`;

/**
 * __useGetOrganisationQuery__
 *
 * To run a query within a React component, call `useGetOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      useClientApi: // value for 'useClientApi'
 *      includeFinancialConfigFields: // value for 'includeFinancialConfigFields'
 *   },
 * });
 */
export function useGetOrganisationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables> & ({ variables: GetOrganisationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, options);
      }
export function useGetOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, options);
        }
// @ts-ignore
export function useGetOrganisationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationQuery, GetOrganisationQueryVariables>;
export function useGetOrganisationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationQuery | undefined, GetOrganisationQueryVariables>;
export function useGetOrganisationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationQuery, GetOrganisationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationQuery, GetOrganisationQueryVariables>(GetOrganisationDocument, options);
        }
export type GetOrganisationQueryHookResult = ReturnType<typeof useGetOrganisationQuery>;
export type GetOrganisationLazyQueryHookResult = ReturnType<typeof useGetOrganisationLazyQuery>;
export type GetOrganisationSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationSuspenseQuery>;
export type GetOrganisationQueryResult = Apollo.QueryResult<GetOrganisationQuery, GetOrganisationQueryVariables>;
export const GetOrganisationCommissionIndemnityRequiredDocument = gql`
    query getOrganisationCommissionIndemnityRequired($id: ID!) {
  organisation(id: $id) {
    id
    protection_settings {
      commission {
        indemnity_required
      }
    }
  }
}
    `;

/**
 * __useGetOrganisationCommissionIndemnityRequiredQuery__
 *
 * To run a query within a React component, call `useGetOrganisationCommissionIndemnityRequiredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationCommissionIndemnityRequiredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationCommissionIndemnityRequiredQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganisationCommissionIndemnityRequiredQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables> & ({ variables: GetOrganisationCommissionIndemnityRequiredQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>(GetOrganisationCommissionIndemnityRequiredDocument, options);
      }
export function useGetOrganisationCommissionIndemnityRequiredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>(GetOrganisationCommissionIndemnityRequiredDocument, options);
        }
// @ts-ignore
export function useGetOrganisationCommissionIndemnityRequiredSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>;
export function useGetOrganisationCommissionIndemnityRequiredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationCommissionIndemnityRequiredQuery | undefined, GetOrganisationCommissionIndemnityRequiredQueryVariables>;
export function useGetOrganisationCommissionIndemnityRequiredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>(GetOrganisationCommissionIndemnityRequiredDocument, options);
        }
export type GetOrganisationCommissionIndemnityRequiredQueryHookResult = ReturnType<typeof useGetOrganisationCommissionIndemnityRequiredQuery>;
export type GetOrganisationCommissionIndemnityRequiredLazyQueryHookResult = ReturnType<typeof useGetOrganisationCommissionIndemnityRequiredLazyQuery>;
export type GetOrganisationCommissionIndemnityRequiredSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationCommissionIndemnityRequiredSuspenseQuery>;
export type GetOrganisationCommissionIndemnityRequiredQueryResult = Apollo.QueryResult<GetOrganisationCommissionIndemnityRequiredQuery, GetOrganisationCommissionIndemnityRequiredQueryVariables>;
export const GetOrganisationFeesDocument = gql`
    query getOrganisationFees($organisationId: ID!) {
  organisation(id: $organisationId) {
    id
    standard_fee_options {
      fee_option_title
      fees {
        fee_type
        value
      }
      default
    }
  }
}
    `;

/**
 * __useGetOrganisationFeesQuery__
 *
 * To run a query within a React component, call `useGetOrganisationFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationFeesQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGetOrganisationFeesQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables> & ({ variables: GetOrganisationFeesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>(GetOrganisationFeesDocument, options);
      }
export function useGetOrganisationFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>(GetOrganisationFeesDocument, options);
        }
// @ts-ignore
export function useGetOrganisationFeesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>;
export function useGetOrganisationFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationFeesQuery | undefined, GetOrganisationFeesQueryVariables>;
export function useGetOrganisationFeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>(GetOrganisationFeesDocument, options);
        }
export type GetOrganisationFeesQueryHookResult = ReturnType<typeof useGetOrganisationFeesQuery>;
export type GetOrganisationFeesLazyQueryHookResult = ReturnType<typeof useGetOrganisationFeesLazyQuery>;
export type GetOrganisationFeesSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationFeesSuspenseQuery>;
export type GetOrganisationFeesQueryResult = Apollo.QueryResult<GetOrganisationFeesQuery, GetOrganisationFeesQueryVariables>;
export const GetOrganisationUsersDocument = gql`
    query getOrganisationUsers($id: ID!) {
  organisation(id: $id, includeUsers: true) {
    organisation_id
    name
    users {
      id
      first_name
      last_name
    }
  }
}
    `;

/**
 * __useGetOrganisationUsersQuery__
 *
 * To run a query within a React component, call `useGetOrganisationUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganisationUsersQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables> & ({ variables: GetOrganisationUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>(GetOrganisationUsersDocument, options);
      }
export function useGetOrganisationUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>(GetOrganisationUsersDocument, options);
        }
// @ts-ignore
export function useGetOrganisationUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>;
export function useGetOrganisationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationUsersQuery | undefined, GetOrganisationUsersQueryVariables>;
export function useGetOrganisationUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>(GetOrganisationUsersDocument, options);
        }
export type GetOrganisationUsersQueryHookResult = ReturnType<typeof useGetOrganisationUsersQuery>;
export type GetOrganisationUsersLazyQueryHookResult = ReturnType<typeof useGetOrganisationUsersLazyQuery>;
export type GetOrganisationUsersSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationUsersSuspenseQuery>;
export type GetOrganisationUsersQueryResult = Apollo.QueryResult<GetOrganisationUsersQuery, GetOrganisationUsersQueryVariables>;
export const GetOrganisationsDocument = gql`
    query getOrganisations($ids: [ID!]!) {
  organisations(ids: $ids) {
    ...BasicOrganisationDetails
    organisation_legal_form
    joined_acre
    client_portal_url
    fca_reg_no
    administered_by {
      id
      external_id
    }
    bank_account {
      sort_code
      number
    }
    standard_fee_options {
      fee_option_title
      fees {
        fee_type
        value
      }
      default
    }
    representative_of_org {
      ...BasicOrganisationDetails
      metadata {
        string_value
        bool_value
        name
      }
    }
    status
    website
    primary_phone
    general_email
    metadata {
      name
      string_value
      bool_value
      user_editable
    }
  }
}
    ${BasicOrganisationDetailsFragmentDoc}`;

/**
 * __useGetOrganisationsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetOrganisationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationsQuery, GetOrganisationsQueryVariables> & ({ variables: GetOrganisationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationsQuery, GetOrganisationsQueryVariables>(GetOrganisationsDocument, options);
      }
export function useGetOrganisationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationsQuery, GetOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationsQuery, GetOrganisationsQueryVariables>(GetOrganisationsDocument, options);
        }
// @ts-ignore
export function useGetOrganisationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationsQuery, GetOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationsQuery, GetOrganisationsQueryVariables>;
export function useGetOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationsQuery, GetOrganisationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationsQuery | undefined, GetOrganisationsQueryVariables>;
export function useGetOrganisationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationsQuery, GetOrganisationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationsQuery, GetOrganisationsQueryVariables>(GetOrganisationsDocument, options);
        }
export type GetOrganisationsQueryHookResult = ReturnType<typeof useGetOrganisationsQuery>;
export type GetOrganisationsLazyQueryHookResult = ReturnType<typeof useGetOrganisationsLazyQuery>;
export type GetOrganisationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationsSuspenseQuery>;
export type GetOrganisationsQueryResult = Apollo.QueryResult<GetOrganisationsQuery, GetOrganisationsQueryVariables>;
export const GetOrganisationsRepresentativeOfDocument = gql`
    query getOrganisationsRepresentativeOf($filter_representative_of_org_id: ID!) {
  organisationsRepresentativeOf(
    filter_representative_of_org_id: $filter_representative_of_org_id
  ) {
    ...BasicOrganisationDetails
    joined_acre
    client_portal_url
    fca_reg_no
    administered_by {
      id
      external_id
    }
    bank_account {
      sort_code
      number
    }
    standard_fee_options {
      fee_option_title
      fees {
        fee_type
        value
      }
      default
    }
    representative_of_org {
      ...BasicOrganisationDetails
    }
    status
    website
    primary_phone
    general_email
    metadata {
      name
      string_value
      bool_value
      user_editable
    }
  }
}
    ${BasicOrganisationDetailsFragmentDoc}`;

/**
 * __useGetOrganisationsRepresentativeOfQuery__
 *
 * To run a query within a React component, call `useGetOrganisationsRepresentativeOfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationsRepresentativeOfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationsRepresentativeOfQuery({
 *   variables: {
 *      filter_representative_of_org_id: // value for 'filter_representative_of_org_id'
 *   },
 * });
 */
export function useGetOrganisationsRepresentativeOfQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables> & ({ variables: GetOrganisationsRepresentativeOfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>(GetOrganisationsRepresentativeOfDocument, options);
      }
export function useGetOrganisationsRepresentativeOfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>(GetOrganisationsRepresentativeOfDocument, options);
        }
// @ts-ignore
export function useGetOrganisationsRepresentativeOfSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>;
export function useGetOrganisationsRepresentativeOfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrganisationsRepresentativeOfQuery | undefined, GetOrganisationsRepresentativeOfQueryVariables>;
export function useGetOrganisationsRepresentativeOfSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>(GetOrganisationsRepresentativeOfDocument, options);
        }
export type GetOrganisationsRepresentativeOfQueryHookResult = ReturnType<typeof useGetOrganisationsRepresentativeOfQuery>;
export type GetOrganisationsRepresentativeOfLazyQueryHookResult = ReturnType<typeof useGetOrganisationsRepresentativeOfLazyQuery>;
export type GetOrganisationsRepresentativeOfSuspenseQueryHookResult = ReturnType<typeof useGetOrganisationsRepresentativeOfSuspenseQuery>;
export type GetOrganisationsRepresentativeOfQueryResult = Apollo.QueryResult<GetOrganisationsRepresentativeOfQuery, GetOrganisationsRepresentativeOfQueryVariables>;
export const GetPermissionAssignmentsDocument = gql`
    query getPermissionAssignments($userId: ID, $groupId: ID) {
  permissionAssignments(userId: $userId, groupId: $groupId) {
    permission_assignments {
      permission_assignment_id
      permission_id
      disabled
      user_id
      group_id
      role_id
      organisation_id
      client_id
      case_id
      user_scope_id
    }
  }
}
    `;

/**
 * __useGetPermissionAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetPermissionAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionAssignmentsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetPermissionAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>(GetPermissionAssignmentsDocument, options);
      }
export function useGetPermissionAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>(GetPermissionAssignmentsDocument, options);
        }
// @ts-ignore
export function useGetPermissionAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>;
export function useGetPermissionAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionAssignmentsQuery | undefined, GetPermissionAssignmentsQueryVariables>;
export function useGetPermissionAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>(GetPermissionAssignmentsDocument, options);
        }
export type GetPermissionAssignmentsQueryHookResult = ReturnType<typeof useGetPermissionAssignmentsQuery>;
export type GetPermissionAssignmentsLazyQueryHookResult = ReturnType<typeof useGetPermissionAssignmentsLazyQuery>;
export type GetPermissionAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionAssignmentsSuspenseQuery>;
export type GetPermissionAssignmentsQueryResult = Apollo.QueryResult<GetPermissionAssignmentsQuery, GetPermissionAssignmentsQueryVariables>;
export const GetPermissionResolutionDocument = gql`
    query getPermissionResolution($input: PermissionResolutionInput!) {
  permissionResolution(input: $input) {
    permission_name
    scope {
      id
      type
    }
    has_permission
    assignee {
      id
    }
  }
}
    `;

/**
 * __useGetPermissionResolutionQuery__
 *
 * To run a query within a React component, call `useGetPermissionResolutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionResolutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionResolutionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPermissionResolutionQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables> & ({ variables: GetPermissionResolutionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>(GetPermissionResolutionDocument, options);
      }
export function useGetPermissionResolutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>(GetPermissionResolutionDocument, options);
        }
// @ts-ignore
export function useGetPermissionResolutionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>;
export function useGetPermissionResolutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionResolutionQuery | undefined, GetPermissionResolutionQueryVariables>;
export function useGetPermissionResolutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>(GetPermissionResolutionDocument, options);
        }
export type GetPermissionResolutionQueryHookResult = ReturnType<typeof useGetPermissionResolutionQuery>;
export type GetPermissionResolutionLazyQueryHookResult = ReturnType<typeof useGetPermissionResolutionLazyQuery>;
export type GetPermissionResolutionSuspenseQueryHookResult = ReturnType<typeof useGetPermissionResolutionSuspenseQuery>;
export type GetPermissionResolutionQueryResult = Apollo.QueryResult<GetPermissionResolutionQuery, GetPermissionResolutionQueryVariables>;
export const GetPermissionsDocument = gql`
    query getPermissions($names: [String!], $ids: [ID!], $show_allowlist: Boolean) {
  permission(names: $names, ids: $ids, show_allowlist: $show_allowlist) {
    permissions {
      permission_name
      permission_id
      permission_type
      description
      scopes
    }
  }
}
    `;

/**
 * __useGetPermissionsQuery__
 *
 * To run a query within a React component, call `useGetPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsQuery({
 *   variables: {
 *      names: // value for 'names'
 *      ids: // value for 'ids'
 *      show_allowlist: // value for 'show_allowlist'
 *   },
 * });
 */
export function useGetPermissionsQuery(baseOptions?: Apollo.QueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
      }
export function useGetPermissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
// @ts-ignore
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionsQuery | undefined, GetPermissionsQueryVariables>;
export function useGetPermissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsQuery, GetPermissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionsQuery, GetPermissionsQueryVariables>(GetPermissionsDocument, options);
        }
export type GetPermissionsQueryHookResult = ReturnType<typeof useGetPermissionsQuery>;
export type GetPermissionsLazyQueryHookResult = ReturnType<typeof useGetPermissionsLazyQuery>;
export type GetPermissionsSuspenseQueryHookResult = ReturnType<typeof useGetPermissionsSuspenseQuery>;
export type GetPermissionsQueryResult = Apollo.QueryResult<GetPermissionsQuery, GetPermissionsQueryVariables>;
export const GetPermissionsListDocument = gql`
    query getPermissionsList($show_allowlist: Boolean, $userId: ID, $groupId: ID, $orgId: ID!, $userScope: Boolean) {
  permission(show_allowlist: $show_allowlist) {
    permissions {
      permission_name
      permission_id
      permission_type
      description
      scopes
    }
  }
  permissionAssignments(userId: $userId, groupId: $groupId) {
    permission_assignments {
      permission_assignment_id
      permission_id
      user_scope_id
      user_id
      organisation_id
      disabled
    }
  }
  getPermissionsAllowList(
    show_allowlist: $show_allowlist
    userId: $userId
    groupId: $groupId
    orgId: $orgId
    userScope: $userScope
  ) @client {
    permission_name
    permission_assignment_id
    permission_id
    permission_type
    description
    scopes
    disabled
  }
}
    `;

/**
 * __useGetPermissionsListQuery__
 *
 * To run a query within a React component, call `useGetPermissionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPermissionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPermissionsListQuery({
 *   variables: {
 *      show_allowlist: // value for 'show_allowlist'
 *      userId: // value for 'userId'
 *      groupId: // value for 'groupId'
 *      orgId: // value for 'orgId'
 *      userScope: // value for 'userScope'
 *   },
 * });
 */
export function useGetPermissionsListQuery(baseOptions: Apollo.QueryHookOptions<GetPermissionsListQuery, GetPermissionsListQueryVariables> & ({ variables: GetPermissionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPermissionsListQuery, GetPermissionsListQueryVariables>(GetPermissionsListDocument, options);
      }
export function useGetPermissionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPermissionsListQuery, GetPermissionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPermissionsListQuery, GetPermissionsListQueryVariables>(GetPermissionsListDocument, options);
        }
// @ts-ignore
export function useGetPermissionsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPermissionsListQuery, GetPermissionsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionsListQuery, GetPermissionsListQueryVariables>;
export function useGetPermissionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsListQuery, GetPermissionsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetPermissionsListQuery | undefined, GetPermissionsListQueryVariables>;
export function useGetPermissionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPermissionsListQuery, GetPermissionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPermissionsListQuery, GetPermissionsListQueryVariables>(GetPermissionsListDocument, options);
        }
export type GetPermissionsListQueryHookResult = ReturnType<typeof useGetPermissionsListQuery>;
export type GetPermissionsListLazyQueryHookResult = ReturnType<typeof useGetPermissionsListLazyQuery>;
export type GetPermissionsListSuspenseQueryHookResult = ReturnType<typeof useGetPermissionsListSuspenseQuery>;
export type GetPermissionsListQueryResult = Apollo.QueryResult<GetPermissionsListQuery, GetPermissionsListQueryVariables>;
export const GetPredictedRevenueDocument = gql`
    query getPredictedRevenue($caseId: ID!) {
  predictedRevenue @client {
    id
    value
    fee_type
    payer
    commission
    commission_period
    frequency
  }
  predictedRevenueTotal @client
  case(id: $caseId) {
    id
    details {
      id
      fee_option_title
      fees {
        value
        fee_type
      }
      mortgages {
        id
        version
        status
        mortgage_amount
        calculated_values {
          calculated_net_proc_fee
        }
        mortgage_product {
          id
          lender_name
        }
      }
    }
  }
  protectionProducts(protectionProductDetails: true, filterCaseIds: [$caseId]) {
    protection_id
    version
    details {
      status
      product_name
      provider_name
      start_date
      commission {
        initial_commission
        commission_frequency
        initial_commission_end_date
      }
    }
  }
  generalInsuranceProducts(input: {filter_case_ids: [$caseId]}) {
    general_insurance_products {
      general_insurance_product_id
      client_ids
      case_ids
      property_ids
      details {
        provider
        status
        commission
      }
    }
  }
}
    `;

/**
 * __useGetPredictedRevenueQuery__
 *
 * To run a query within a React component, call `useGetPredictedRevenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPredictedRevenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPredictedRevenueQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetPredictedRevenueQuery(baseOptions: Apollo.QueryHookOptions<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables> & ({ variables: GetPredictedRevenueQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>(GetPredictedRevenueDocument, options);
      }
export function useGetPredictedRevenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>(GetPredictedRevenueDocument, options);
        }
// @ts-ignore
export function useGetPredictedRevenueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>): Apollo.UseSuspenseQueryResult<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>;
export function useGetPredictedRevenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>): Apollo.UseSuspenseQueryResult<GetPredictedRevenueQuery | undefined, GetPredictedRevenueQueryVariables>;
export function useGetPredictedRevenueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>(GetPredictedRevenueDocument, options);
        }
export type GetPredictedRevenueQueryHookResult = ReturnType<typeof useGetPredictedRevenueQuery>;
export type GetPredictedRevenueLazyQueryHookResult = ReturnType<typeof useGetPredictedRevenueLazyQuery>;
export type GetPredictedRevenueSuspenseQueryHookResult = ReturnType<typeof useGetPredictedRevenueSuspenseQuery>;
export type GetPredictedRevenueQueryResult = Apollo.QueryResult<GetPredictedRevenueQuery, GetPredictedRevenueQueryVariables>;
export const GetPropertyDocument = gql`
    query getProperty($id: ID!, $includeCaseDetailsInProperty: Boolean = false, $version: Int, $show_history: Int) {
  property(id: $id, version: $version, show_history: $show_history) {
    ...PropertyDetails
    versions {
      ...VersionWithChangedFields
    }
  }
}
    ${PropertyDetailsFragmentDoc}
${VersionWithChangedFieldsFragmentDoc}`;

/**
 * __useGetPropertyQuery__
 *
 * To run a query within a React component, call `useGetPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *      version: // value for 'version'
 *      show_history: // value for 'show_history'
 *   },
 * });
 */
export function useGetPropertyQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables> & ({ variables: GetPropertyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
      }
export function useGetPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
        }
// @ts-ignore
export function useGetPropertySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>): Apollo.UseSuspenseQueryResult<GetPropertyQuery, GetPropertyQueryVariables>;
export function useGetPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>): Apollo.UseSuspenseQueryResult<GetPropertyQuery | undefined, GetPropertyQueryVariables>;
export function useGetPropertySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyQuery, GetPropertyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyQuery, GetPropertyQueryVariables>(GetPropertyDocument, options);
        }
export type GetPropertyQueryHookResult = ReturnType<typeof useGetPropertyQuery>;
export type GetPropertyLazyQueryHookResult = ReturnType<typeof useGetPropertyLazyQuery>;
export type GetPropertySuspenseQueryHookResult = ReturnType<typeof useGetPropertySuspenseQuery>;
export type GetPropertyQueryResult = Apollo.QueryResult<GetPropertyQuery, GetPropertyQueryVariables>;
export const GetPropertyPortfolioDocument = gql`
    query getPropertyPortfolio($caseId: ID!, $includeCaseDetailsInProperty: Boolean = true, $includeDirectorsProperties: Boolean = false) {
  case(id: $caseId) {
    id
    details {
      id
      property_portfolio(includeDirectorsProperties: $includeDirectorsProperties) {
        ...PropertyDetails
      }
    }
  }
}
    ${PropertyDetailsFragmentDoc}`;

/**
 * __useGetPropertyPortfolioQuery__
 *
 * To run a query within a React component, call `useGetPropertyPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyPortfolioQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *      includeDirectorsProperties: // value for 'includeDirectorsProperties'
 *   },
 * });
 */
export function useGetPropertyPortfolioQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables> & ({ variables: GetPropertyPortfolioQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>(GetPropertyPortfolioDocument, options);
      }
export function useGetPropertyPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>(GetPropertyPortfolioDocument, options);
        }
// @ts-ignore
export function useGetPropertyPortfolioSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>): Apollo.UseSuspenseQueryResult<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>;
export function useGetPropertyPortfolioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>): Apollo.UseSuspenseQueryResult<GetPropertyPortfolioQuery | undefined, GetPropertyPortfolioQueryVariables>;
export function useGetPropertyPortfolioSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>(GetPropertyPortfolioDocument, options);
        }
export type GetPropertyPortfolioQueryHookResult = ReturnType<typeof useGetPropertyPortfolioQuery>;
export type GetPropertyPortfolioLazyQueryHookResult = ReturnType<typeof useGetPropertyPortfolioLazyQuery>;
export type GetPropertyPortfolioSuspenseQueryHookResult = ReturnType<typeof useGetPropertyPortfolioSuspenseQuery>;
export type GetPropertyPortfolioQueryResult = Apollo.QueryResult<GetPropertyPortfolioQuery, GetPropertyPortfolioQueryVariables>;
export const GetProtectionInfoDocument = gql`
    query getProtectionInfo($caseId: ID!) {
  case(id: $caseId) {
    id
    details {
      id
      preference_loan_amount
      preference_term
      mortgages {
        id
        version
        mortgage_id
        mortgage_amount
        monthly_payment
        revert_monthly_payment
        calculated_values {
          monthly_payment
          revert_monthly_payment
        }
        status
        term
        term_unit
        mortgage_product {
          id
          initial_pay_rate
          standard_variable_rate
        }
      }
      protection {
        ...ProtectionDetails
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          gender
          is_natural_person
          organisation_name
          organisation_sic
          retirement_age
          net_monthly_income
          total_guaranteed_annual
          smoker_status
          non_natural {
            number_of_employees
          }
          contact_details_email
          contact_details_work_phone
          contact_details_mobile_phone
          income_and_employment {
            id
            internalHash
            standardised_occupation_code
            occupation_title
            ...ClientEmploymentIncome
            ...ClientSelfEmployedIncome
          }
        }
      }
    }
  }
}
    ${ProtectionDetailsFragmentDoc}
${ClientEmploymentIncomeFragmentDoc}
${ClientSelfEmployedIncomeFragmentDoc}`;

/**
 * __useGetProtectionInfoQuery__
 *
 * To run a query within a React component, call `useGetProtectionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtectionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtectionInfoQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetProtectionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetProtectionInfoQuery, GetProtectionInfoQueryVariables> & ({ variables: GetProtectionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>(GetProtectionInfoDocument, options);
      }
export function useGetProtectionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>(GetProtectionInfoDocument, options);
        }
// @ts-ignore
export function useGetProtectionInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>;
export function useGetProtectionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtectionInfoQuery | undefined, GetProtectionInfoQueryVariables>;
export function useGetProtectionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>(GetProtectionInfoDocument, options);
        }
export type GetProtectionInfoQueryHookResult = ReturnType<typeof useGetProtectionInfoQuery>;
export type GetProtectionInfoLazyQueryHookResult = ReturnType<typeof useGetProtectionInfoLazyQuery>;
export type GetProtectionInfoSuspenseQueryHookResult = ReturnType<typeof useGetProtectionInfoSuspenseQuery>;
export type GetProtectionInfoQueryResult = Apollo.QueryResult<GetProtectionInfoQuery, GetProtectionInfoQueryVariables>;
export const GetProviderNamesDocument = gql`
    query getProviderNames {
  providerNames {
    id
    name
  }
}
    `;

/**
 * __useGetProviderNamesQuery__
 *
 * To run a query within a React component, call `useGetProviderNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProviderNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderNamesQuery, GetProviderNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderNamesQuery, GetProviderNamesQueryVariables>(GetProviderNamesDocument, options);
      }
export function useGetProviderNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderNamesQuery, GetProviderNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderNamesQuery, GetProviderNamesQueryVariables>(GetProviderNamesDocument, options);
        }
// @ts-ignore
export function useGetProviderNamesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderNamesQuery, GetProviderNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderNamesQuery, GetProviderNamesQueryVariables>;
export function useGetProviderNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderNamesQuery, GetProviderNamesQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderNamesQuery | undefined, GetProviderNamesQueryVariables>;
export function useGetProviderNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderNamesQuery, GetProviderNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderNamesQuery, GetProviderNamesQueryVariables>(GetProviderNamesDocument, options);
        }
export type GetProviderNamesQueryHookResult = ReturnType<typeof useGetProviderNamesQuery>;
export type GetProviderNamesLazyQueryHookResult = ReturnType<typeof useGetProviderNamesLazyQuery>;
export type GetProviderNamesSuspenseQueryHookResult = ReturnType<typeof useGetProviderNamesSuspenseQuery>;
export type GetProviderNamesQueryResult = Apollo.QueryResult<GetProviderNamesQuery, GetProviderNamesQueryVariables>;
export const GetProviderStatementFiltersDocument = gql`
    query getProviderStatementFilters($input: GetProviderStatementFiltersInput) {
  getProviderStatementFilters(input: $input) {
    providers {
      id
      name
    }
    clubs {
      id
      name
    }
  }
}
    `;

/**
 * __useGetProviderStatementFiltersQuery__
 *
 * To run a query within a React component, call `useGetProviderStatementFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderStatementFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderStatementFiltersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProviderStatementFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>(GetProviderStatementFiltersDocument, options);
      }
export function useGetProviderStatementFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>(GetProviderStatementFiltersDocument, options);
        }
// @ts-ignore
export function useGetProviderStatementFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>;
export function useGetProviderStatementFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderStatementFiltersQuery | undefined, GetProviderStatementFiltersQueryVariables>;
export function useGetProviderStatementFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>(GetProviderStatementFiltersDocument, options);
        }
export type GetProviderStatementFiltersQueryHookResult = ReturnType<typeof useGetProviderStatementFiltersQuery>;
export type GetProviderStatementFiltersLazyQueryHookResult = ReturnType<typeof useGetProviderStatementFiltersLazyQuery>;
export type GetProviderStatementFiltersSuspenseQueryHookResult = ReturnType<typeof useGetProviderStatementFiltersSuspenseQuery>;
export type GetProviderStatementFiltersQueryResult = Apollo.QueryResult<GetProviderStatementFiltersQuery, GetProviderStatementFiltersQueryVariables>;
export const GetProviderStatementsDocument = gql`
    query getProviderStatements($input: GetProviderStatementsInput!) {
  getProviderStatements(input: $input) {
    statements {
      id
      provider_id
      provider_name
      club_name
      period_id
      total_amount
      num_transactions
      items_to_match
      status
    }
    nextPage {
      bookmark
      pageSize
      page_size
    }
  }
}
    `;

/**
 * __useGetProviderStatementsQuery__
 *
 * To run a query within a React component, call `useGetProviderStatementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderStatementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderStatementsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProviderStatementsQuery(baseOptions: Apollo.QueryHookOptions<GetProviderStatementsQuery, GetProviderStatementsQueryVariables> & ({ variables: GetProviderStatementsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>(GetProviderStatementsDocument, options);
      }
export function useGetProviderStatementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>(GetProviderStatementsDocument, options);
        }
// @ts-ignore
export function useGetProviderStatementsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>;
export function useGetProviderStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProviderStatementsQuery | undefined, GetProviderStatementsQueryVariables>;
export function useGetProviderStatementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>(GetProviderStatementsDocument, options);
        }
export type GetProviderStatementsQueryHookResult = ReturnType<typeof useGetProviderStatementsQuery>;
export type GetProviderStatementsLazyQueryHookResult = ReturnType<typeof useGetProviderStatementsLazyQuery>;
export type GetProviderStatementsSuspenseQueryHookResult = ReturnType<typeof useGetProviderStatementsSuspenseQuery>;
export type GetProviderStatementsQueryResult = Apollo.QueryResult<GetProviderStatementsQuery, GetProviderStatementsQueryVariables>;
export const GetReferralPartnersDocument = gql`
    query getReferralPartners($input: GetReferralPartnersInput!, $includeUsers: Boolean = false) {
  getReferralPartners(input: $input) {
    referral_partners {
      case_types
      commission_structure_id
      paying_organisation_id
      paying_organisation_name
      receiving_organisation_id
      receiving_organisation_name
      regulating_organisation_id
      regulating_organisation_name
      users @include(if: $includeUsers) {
        user_id
        first_name
        last_name
        primary_role_id
      }
      blacklisted
      acre_referral_club
    }
    filters {
      bookmark
      page_size
      case_types
      receiving_organisations
      regulating_organisation
      all_users
    }
    next_page {
      bookmark
    }
  }
}
    `;

/**
 * __useGetReferralPartnersQuery__
 *
 * To run a query within a React component, call `useGetReferralPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReferralPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReferralPartnersQuery({
 *   variables: {
 *      input: // value for 'input'
 *      includeUsers: // value for 'includeUsers'
 *   },
 * });
 */
export function useGetReferralPartnersQuery(baseOptions: Apollo.QueryHookOptions<GetReferralPartnersQuery, GetReferralPartnersQueryVariables> & ({ variables: GetReferralPartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>(GetReferralPartnersDocument, options);
      }
export function useGetReferralPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>(GetReferralPartnersDocument, options);
        }
// @ts-ignore
export function useGetReferralPartnersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>): Apollo.UseSuspenseQueryResult<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>;
export function useGetReferralPartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>): Apollo.UseSuspenseQueryResult<GetReferralPartnersQuery | undefined, GetReferralPartnersQueryVariables>;
export function useGetReferralPartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>(GetReferralPartnersDocument, options);
        }
export type GetReferralPartnersQueryHookResult = ReturnType<typeof useGetReferralPartnersQuery>;
export type GetReferralPartnersLazyQueryHookResult = ReturnType<typeof useGetReferralPartnersLazyQuery>;
export type GetReferralPartnersSuspenseQueryHookResult = ReturnType<typeof useGetReferralPartnersSuspenseQuery>;
export type GetReferralPartnersQueryResult = Apollo.QueryResult<GetReferralPartnersQuery, GetReferralPartnersQueryVariables>;
export const ReferredCaseListDocument = gql`
    query referredCaseList($input: GetReferredCaseListFilterInput!) {
  referredCaseList(input: $input) {
    cases {
      case_id
      created_at
      case_type
      case_status
      mortgage_amount
      org_id
      address {
        ...FullAddress
      }
      offer_expiry_date
      introducerClients {
        client_id
        first_name
        last_name
      }
      organisation {
        name
      }
    }
    next_page {
      bookmark
    }
  }
}
    ${FullAddressFragmentDoc}`;

/**
 * __useReferredCaseListQuery__
 *
 * To run a query within a React component, call `useReferredCaseListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferredCaseListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferredCaseListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReferredCaseListQuery(baseOptions: Apollo.QueryHookOptions<ReferredCaseListQuery, ReferredCaseListQueryVariables> & ({ variables: ReferredCaseListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferredCaseListQuery, ReferredCaseListQueryVariables>(ReferredCaseListDocument, options);
      }
export function useReferredCaseListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferredCaseListQuery, ReferredCaseListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferredCaseListQuery, ReferredCaseListQueryVariables>(ReferredCaseListDocument, options);
        }
// @ts-ignore
export function useReferredCaseListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReferredCaseListQuery, ReferredCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<ReferredCaseListQuery, ReferredCaseListQueryVariables>;
export function useReferredCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferredCaseListQuery, ReferredCaseListQueryVariables>): Apollo.UseSuspenseQueryResult<ReferredCaseListQuery | undefined, ReferredCaseListQueryVariables>;
export function useReferredCaseListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReferredCaseListQuery, ReferredCaseListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReferredCaseListQuery, ReferredCaseListQueryVariables>(ReferredCaseListDocument, options);
        }
export type ReferredCaseListQueryHookResult = ReturnType<typeof useReferredCaseListQuery>;
export type ReferredCaseListLazyQueryHookResult = ReturnType<typeof useReferredCaseListLazyQuery>;
export type ReferredCaseListSuspenseQueryHookResult = ReturnType<typeof useReferredCaseListSuspenseQuery>;
export type ReferredCaseListQueryResult = Apollo.QueryResult<ReferredCaseListQuery, ReferredCaseListQueryVariables>;
export const GetReportsCommissionsDocument = gql`
    query getReportsCommissions($body: ReportsCommissionsInput!) {
  reportsCommissions(body: $body) {
    summaries {
      fees
      from
      percentage
      period_id
      period_name
      to
      total_commission
      internalHash
    }
  }
}
    `;

/**
 * __useGetReportsCommissionsQuery__
 *
 * To run a query within a React component, call `useGetReportsCommissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsCommissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsCommissionsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useGetReportsCommissionsQuery(baseOptions: Apollo.QueryHookOptions<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables> & ({ variables: GetReportsCommissionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>(GetReportsCommissionsDocument, options);
      }
export function useGetReportsCommissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>(GetReportsCommissionsDocument, options);
        }
// @ts-ignore
export function useGetReportsCommissionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>;
export function useGetReportsCommissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsCommissionsQuery | undefined, GetReportsCommissionsQueryVariables>;
export function useGetReportsCommissionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>(GetReportsCommissionsDocument, options);
        }
export type GetReportsCommissionsQueryHookResult = ReturnType<typeof useGetReportsCommissionsQuery>;
export type GetReportsCommissionsLazyQueryHookResult = ReturnType<typeof useGetReportsCommissionsLazyQuery>;
export type GetReportsCommissionsSuspenseQueryHookResult = ReturnType<typeof useGetReportsCommissionsSuspenseQuery>;
export type GetReportsCommissionsQueryResult = Apollo.QueryResult<GetReportsCommissionsQuery, GetReportsCommissionsQueryVariables>;
export const GetReportsDiscoveryDocument = gql`
    query getReportsDiscovery {
  reportsDiscovery {
    reports {
      id
      description
      title
      is_xls
      category
      endpoint
      filters {
        display_name
        param_name
        type
        values_discovery
        values {
          default
          display
          value
        }
      }
      columns {
        name
        display_name
      }
    }
  }
}
    `;

/**
 * __useGetReportsDiscoveryQuery__
 *
 * To run a query within a React component, call `useGetReportsDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsDiscoveryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetReportsDiscoveryQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>(GetReportsDiscoveryDocument, options);
      }
export function useGetReportsDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>(GetReportsDiscoveryDocument, options);
        }
// @ts-ignore
export function useGetReportsDiscoverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>;
export function useGetReportsDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsDiscoveryQuery | undefined, GetReportsDiscoveryQueryVariables>;
export function useGetReportsDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>(GetReportsDiscoveryDocument, options);
        }
export type GetReportsDiscoveryQueryHookResult = ReturnType<typeof useGetReportsDiscoveryQuery>;
export type GetReportsDiscoveryLazyQueryHookResult = ReturnType<typeof useGetReportsDiscoveryLazyQuery>;
export type GetReportsDiscoverySuspenseQueryHookResult = ReturnType<typeof useGetReportsDiscoverySuspenseQuery>;
export type GetReportsDiscoveryQueryResult = Apollo.QueryResult<GetReportsDiscoveryQuery, GetReportsDiscoveryQueryVariables>;
export const GetReportsFilterOptionsDocument = gql`
    query getReportsFilterOptions($body: ReportsFilterInput!) {
  reportsFilterOptions(body: $body) {
    values {
      default
      display
      value
      organisationId
      organisationName
    }
    filters {
      error
      name
      values {
        default
        display
        value
        organisationId
        organisationName
      }
    }
  }
}
    `;

/**
 * __useGetReportsFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetReportsFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsFilterOptionsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useGetReportsFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables> & ({ variables: GetReportsFilterOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>(GetReportsFilterOptionsDocument, options);
      }
export function useGetReportsFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>(GetReportsFilterOptionsDocument, options);
        }
// @ts-ignore
export function useGetReportsFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>;
export function useGetReportsFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsFilterOptionsQuery | undefined, GetReportsFilterOptionsQueryVariables>;
export function useGetReportsFilterOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>(GetReportsFilterOptionsDocument, options);
        }
export type GetReportsFilterOptionsQueryHookResult = ReturnType<typeof useGetReportsFilterOptionsQuery>;
export type GetReportsFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetReportsFilterOptionsLazyQuery>;
export type GetReportsFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetReportsFilterOptionsSuspenseQuery>;
export type GetReportsFilterOptionsQueryResult = Apollo.QueryResult<GetReportsFilterOptionsQuery, GetReportsFilterOptionsQueryVariables>;
export const GetReportsReportQueueDocument = gql`
    query getReportsReportQueue($targetUserId: ID) {
  reportsReportQueue(targetUserId: $targetUserId) {
    reports {
      report_id
      name
      description
      created_at
      key
      status
      error
    }
  }
}
    `;

/**
 * __useGetReportsReportQueueQuery__
 *
 * To run a query within a React component, call `useGetReportsReportQueueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsReportQueueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsReportQueueQuery({
 *   variables: {
 *      targetUserId: // value for 'targetUserId'
 *   },
 * });
 */
export function useGetReportsReportQueueQuery(baseOptions?: Apollo.QueryHookOptions<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>(GetReportsReportQueueDocument, options);
      }
export function useGetReportsReportQueueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>(GetReportsReportQueueDocument, options);
        }
// @ts-ignore
export function useGetReportsReportQueueSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>;
export function useGetReportsReportQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>): Apollo.UseSuspenseQueryResult<GetReportsReportQueueQuery | undefined, GetReportsReportQueueQueryVariables>;
export function useGetReportsReportQueueSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>(GetReportsReportQueueDocument, options);
        }
export type GetReportsReportQueueQueryHookResult = ReturnType<typeof useGetReportsReportQueueQuery>;
export type GetReportsReportQueueLazyQueryHookResult = ReturnType<typeof useGetReportsReportQueueLazyQuery>;
export type GetReportsReportQueueSuspenseQueryHookResult = ReturnType<typeof useGetReportsReportQueueSuspenseQuery>;
export type GetReportsReportQueueQueryResult = Apollo.QueryResult<GetReportsReportQueueQuery, GetReportsReportQueueQueryVariables>;
export const GetRolesByNameDocument = gql`
    query getRolesByName($roleNames: [String!]!) {
  getRolesByName(roleNames: $roleNames) {
    role_id
    role_name
  }
}
    `;

/**
 * __useGetRolesByNameQuery__
 *
 * To run a query within a React component, call `useGetRolesByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesByNameQuery({
 *   variables: {
 *      roleNames: // value for 'roleNames'
 *   },
 * });
 */
export function useGetRolesByNameQuery(baseOptions: Apollo.QueryHookOptions<GetRolesByNameQuery, GetRolesByNameQueryVariables> & ({ variables: GetRolesByNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesByNameQuery, GetRolesByNameQueryVariables>(GetRolesByNameDocument, options);
      }
export function useGetRolesByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesByNameQuery, GetRolesByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesByNameQuery, GetRolesByNameQueryVariables>(GetRolesByNameDocument, options);
        }
// @ts-ignore
export function useGetRolesByNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRolesByNameQuery, GetRolesByNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesByNameQuery, GetRolesByNameQueryVariables>;
export function useGetRolesByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesByNameQuery, GetRolesByNameQueryVariables>): Apollo.UseSuspenseQueryResult<GetRolesByNameQuery | undefined, GetRolesByNameQueryVariables>;
export function useGetRolesByNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRolesByNameQuery, GetRolesByNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRolesByNameQuery, GetRolesByNameQueryVariables>(GetRolesByNameDocument, options);
        }
export type GetRolesByNameQueryHookResult = ReturnType<typeof useGetRolesByNameQuery>;
export type GetRolesByNameLazyQueryHookResult = ReturnType<typeof useGetRolesByNameLazyQuery>;
export type GetRolesByNameSuspenseQueryHookResult = ReturnType<typeof useGetRolesByNameSuspenseQuery>;
export type GetRolesByNameQueryResult = Apollo.QueryResult<GetRolesByNameQuery, GetRolesByNameQueryVariables>;
export const GetSearchResultsDocument = gql`
    query getSearchResults($searchFragment: String!, $owning_org_id: String, $show_client: Boolean, $bookmark: Int) {
  search(
    searchFragment: $searchFragment
    owning_org_id: $owning_org_id
    show_client: $show_client
    bookmark: $bookmark
  ) {
    total_results
    link
    bookmark
    results {
      id
      doctype
      owning_org_id
      regulating_org_id
      owning_user_id
      owning_org_name
      created_at
      modified_at
      first_name
      last_name
      organisation_name
      address1
      address2
      address3
      town
      postcode
      phone_number
      email
      Cases {
        id
        doctype
        modified_at
        case_reason
        case_status
        mortgage_status
        term_months
        address1
        address2
        address3
        town
        postcode
      }
      Properties {
        id
        modified_at
        address1
        address2
        address3
        town
        postcode
      }
    }
  }
}
    `;

/**
 * __useGetSearchResultsQuery__
 *
 * To run a query within a React component, call `useGetSearchResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultsQuery({
 *   variables: {
 *      searchFragment: // value for 'searchFragment'
 *      owning_org_id: // value for 'owning_org_id'
 *      show_client: // value for 'show_client'
 *      bookmark: // value for 'bookmark'
 *   },
 * });
 */
export function useGetSearchResultsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables> & ({ variables: GetSearchResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
      }
export function useGetSearchResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
        }
// @ts-ignore
export function useGetSearchResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchResultsQuery, GetSearchResultsQueryVariables>;
export function useGetSearchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSearchResultsQuery | undefined, GetSearchResultsQueryVariables>;
export function useGetSearchResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchResultsQuery, GetSearchResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchResultsQuery, GetSearchResultsQueryVariables>(GetSearchResultsDocument, options);
        }
export type GetSearchResultsQueryHookResult = ReturnType<typeof useGetSearchResultsQuery>;
export type GetSearchResultsLazyQueryHookResult = ReturnType<typeof useGetSearchResultsLazyQuery>;
export type GetSearchResultsSuspenseQueryHookResult = ReturnType<typeof useGetSearchResultsSuspenseQuery>;
export type GetSearchResultsQueryResult = Apollo.QueryResult<GetSearchResultsQuery, GetSearchResultsQueryVariables>;
export const GetSourcingCaseDocument = gql`
    query getSourcingCase($id: ID!) {
  case(id: $id) {
    id
    created_at
    version_created_at
    details {
      id
      client_ids
      owner_user_id
      preference_mortgage_reason
      preference_related_property_sale
      preference_details
      preference_target_property
      preference_target_deposit
      preference_target_property_value
      preference_loan_amount
      preference_term
      preference_cashback
      preference_overpayment
      preference_fixed_rate
      preference_free_valuations
      preference_tracker
      preference_target_property_value
      calculated_values {
        total_required_loan_amount
      }
      clients {
        id
        version
        details {
          id
          first_name
          last_name
          is_natural_person
        }
      }
      new_property {
        id
        version
        details {
          id
          shared_ownership_type
        }
      }
      remortgage_property {
        id
        version
        details {
          id
          shared_ownership_type
        }
      }
    }
  }
}
    `;

/**
 * __useGetSourcingCaseQuery__
 *
 * To run a query within a React component, call `useGetSourcingCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSourcingCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSourcingCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSourcingCaseQuery(baseOptions: Apollo.QueryHookOptions<GetSourcingCaseQuery, GetSourcingCaseQueryVariables> & ({ variables: GetSourcingCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>(GetSourcingCaseDocument, options);
      }
export function useGetSourcingCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>(GetSourcingCaseDocument, options);
        }
// @ts-ignore
export function useGetSourcingCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>;
export function useGetSourcingCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetSourcingCaseQuery | undefined, GetSourcingCaseQueryVariables>;
export function useGetSourcingCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>(GetSourcingCaseDocument, options);
        }
export type GetSourcingCaseQueryHookResult = ReturnType<typeof useGetSourcingCaseQuery>;
export type GetSourcingCaseLazyQueryHookResult = ReturnType<typeof useGetSourcingCaseLazyQuery>;
export type GetSourcingCaseSuspenseQueryHookResult = ReturnType<typeof useGetSourcingCaseSuspenseQuery>;
export type GetSourcingCaseQueryResult = Apollo.QueryResult<GetSourcingCaseQuery, GetSourcingCaseQueryVariables>;
export const GetCaseSummaryDocument = gql`
    query getCaseSummary($id: ID!, $include_calculated_values: Boolean, $include_source_response: Boolean, $includeCaseDetailsInProperty: Boolean = false) {
  summary(
    id: $id
    include_calculated_values: $include_calculated_values
    include_source_response: $include_source_response
  ) {
    case {
      case_id
    }
    calculated_values {
      mortgage_debt
      mortgage_monthly_payments
      remaining_mortgage_term_months
    }
    properties {
      ...PropertyDetails
    }
    mortgages {
      mortgage_id
      product_id
      mortgage {
        ...CaseMortgagesAndMortgageProducts
      }
      product_details {
        ...CaseMortgageProduct
      }
    }
    clients {
      id
      version
      details {
        ...ClientDetails
      }
    }
  }
}
    ${PropertyDetailsFragmentDoc}
${CaseMortgagesAndMortgageProductsFragmentDoc}
${CaseMortgageProductFragmentDoc}
${ClientDetailsFragmentDoc}`;

/**
 * __useGetCaseSummaryQuery__
 *
 * To run a query within a React component, call `useGetCaseSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseSummaryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      include_calculated_values: // value for 'include_calculated_values'
 *      include_source_response: // value for 'include_source_response'
 *      includeCaseDetailsInProperty: // value for 'includeCaseDetailsInProperty'
 *   },
 * });
 */
export function useGetCaseSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetCaseSummaryQuery, GetCaseSummaryQueryVariables> & ({ variables: GetCaseSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>(GetCaseSummaryDocument, options);
      }
export function useGetCaseSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>(GetCaseSummaryDocument, options);
        }
// @ts-ignore
export function useGetCaseSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>;
export function useGetCaseSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseSummaryQuery | undefined, GetCaseSummaryQueryVariables>;
export function useGetCaseSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>(GetCaseSummaryDocument, options);
        }
export type GetCaseSummaryQueryHookResult = ReturnType<typeof useGetCaseSummaryQuery>;
export type GetCaseSummaryLazyQueryHookResult = ReturnType<typeof useGetCaseSummaryLazyQuery>;
export type GetCaseSummarySuspenseQueryHookResult = ReturnType<typeof useGetCaseSummarySuspenseQuery>;
export type GetCaseSummaryQueryResult = Apollo.QueryResult<GetCaseSummaryQuery, GetCaseSummaryQueryVariables>;
export const GetSurveyDocument = gql`
    query getSurvey($id: ID!) {
  survey(id: $id) {
    questions {
      id
      question
      version
      type
      event_trigger {
        type
        gt
        lt
        choice_trigger
      }
      choices
      order
      required
      topic
      answer {
        question_id
        question_version
        five_scale_answer
        ten_scale_answer
        free_text_answer
        bool_answer
        single_choice_answer
        multiple_choice_answer
      }
      answered
    }
  }
}
    `;

/**
 * __useGetSurveyQuery__
 *
 * To run a query within a React component, call `useGetSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSurveyQuery(baseOptions: Apollo.QueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables> & ({ variables: GetSurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
      }
export function useGetSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
        }
// @ts-ignore
export function useGetSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyQuery, GetSurveyQueryVariables>;
export function useGetSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>): Apollo.UseSuspenseQueryResult<GetSurveyQuery | undefined, GetSurveyQueryVariables>;
export function useGetSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSurveyQuery, GetSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSurveyQuery, GetSurveyQueryVariables>(GetSurveyDocument, options);
        }
export type GetSurveyQueryHookResult = ReturnType<typeof useGetSurveyQuery>;
export type GetSurveyLazyQueryHookResult = ReturnType<typeof useGetSurveyLazyQuery>;
export type GetSurveySuspenseQueryHookResult = ReturnType<typeof useGetSurveySuspenseQuery>;
export type GetSurveyQueryResult = Apollo.QueryResult<GetSurveyQuery, GetSurveyQueryVariables>;
export const GetTemplatesDocument = gql`
    query getTemplates($organisationId: ID!, $isAr: Boolean = false, $includeDATemplates: Boolean = false) {
  organisation(
    id: $organisationId
    isAr: $isAr
    includeDATemplates: $includeDATemplates
  ) {
    id
    logo
    templates {
      id
      name
      friendly_name
      date_stored
      template
      file_type
      sub_type
      owning_organisation_id
      enforce_for_representative
      allow_child_access
      styles
      default_style
    }
    representative_of_org @include(if: $isAr) {
      id
      name
      templates @include(if: $includeDATemplates) {
        id
        name
        friendly_name
        date_stored
        template
        file_type
        sub_type
        owning_organisation_id
        enforce_for_representative
        allow_child_access
        styles
        default_style
      }
      metadata {
        name
        bool_value
        string_value
        user_editable
      }
    }
    metadata {
      name
      bool_value
      string_value
      user_editable
    }
  }
}
    `;

/**
 * __useGetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplatesQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      isAr: // value for 'isAr'
 *      includeDATemplates: // value for 'includeDATemplates'
 *   },
 * });
 */
export function useGetTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables> & ({ variables: GetTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
      }
export function useGetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
// @ts-ignore
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetTemplatesQuery | undefined, GetTemplatesQueryVariables>;
export function useGetTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplatesQuery, GetTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplatesQuery, GetTemplatesQueryVariables>(GetTemplatesDocument, options);
        }
export type GetTemplatesQueryHookResult = ReturnType<typeof useGetTemplatesQuery>;
export type GetTemplatesLazyQueryHookResult = ReturnType<typeof useGetTemplatesLazyQuery>;
export type GetTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetTemplatesSuspenseQuery>;
export type GetTemplatesQueryResult = Apollo.QueryResult<GetTemplatesQuery, GetTemplatesQueryVariables>;
export const GetUserDocument = gql`
    query getUser($id: ID!, $useClientApi: Boolean!, $includeDAOrg: Boolean = false, $includeFinancialConfigFields: Boolean = false) {
  user(id: $id, useClientApi: $useClientApi) {
    id
    first_name
    last_name
    email_address
    mobile_number
    phone_number
    status
    user_firm_identifier
    primary_role_id
    photo
    employment_basis
    part_time_percentage
    training_and_competency {
      mortgage_qualifications
      protection_qualifications
      equity_release_qualifications
    }
    first_time_access {
      complete
      features {
        feature
        complete
      }
    }
    role_name @skip(if: $useClientApi)
    group_ids
    organisation_id
    organisation(
      useClientApi: $useClientApi
      includeFinancialConfigFields: $includeFinancialConfigFields
    ) {
      id
      name
      logo
      representative_of
      representative_of_org(useClientApi: $useClientApi) @include(if: $includeDAOrg) {
        id
        organisation_id
        metadata {
          name
          string_value
          bool_value
          user_editable
        }
      }
      type
      client_portal_settings {
        primary_colour
      }
      metadata {
        name
        string_value
        bool_value
        user_editable
      }
    }
    metadata {
      name
      string_value
      bool_value
      int_value
      user_editable
    }
    credentials {
      username
      password
      provider
      metadata {
        IRESS_USER_CODE
      }
    }
    agency_codes {
      provider_id
      agency_code
    }
    ...Authentications @skip(if: $useClientApi)
  }
}
    ${AuthenticationsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      useClientApi: // value for 'useClientApi'
 *      includeDAOrg: // value for 'includeDAOrg'
 *      includeFinancialConfigFields: // value for 'includeFinancialConfigFields'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
// @ts-ignore
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserQuery | undefined, GetUserQueryVariables>;
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers($id: ID!, $orderBy: OrderBy, $order: Order) {
  organisation(id: $id, orderUsersBy: $orderBy, order: $order) {
    id
    type
    users {
      id
      organisation_id
      first_name
      last_name
      primary_role_id
      role_name
      status
      email_address
      phone_number
      mobile_number
      user_firm_identifier
      group_ids
      employment_basis
      part_time_percentage
      training_and_competency {
        mortgage_qualifications
        protection_qualifications
        equity_release_qualifications
      }
      first_time_access {
        complete
        features {
          feature
          complete
        }
      }
      credentials {
        provider
      }
      agency_codes {
        provider_id
        agency_code
      }
      ...Authentications
    }
  }
}
    ${AuthenticationsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orderBy: // value for 'orderBy'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables> & ({ variables: GetUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetUsersByIdDocument = gql`
    query getUsersById($userIds: [ID!], $useClientApi: Boolean = false, $includeOrganisation: Boolean = false) {
  users(ids: $userIds, useClientApi: $useClientApi) {
    id
    organisation_id
    first_name
    last_name
    primary_role_id
    role_name @skip(if: $useClientApi)
    status
    email_address
    phone_number
    group_ids
    photo
    organisation(useClientApi: $useClientApi) @include(if: $includeOrganisation) {
      id
      name
      logo
    }
  }
}
    `;

/**
 * __useGetUsersByIdQuery__
 *
 * To run a query within a React component, call `useGetUsersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByIdQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      useClientApi: // value for 'useClientApi'
 *      includeOrganisation: // value for 'includeOrganisation'
 *   },
 * });
 */
export function useGetUsersByIdQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersByIdQuery, GetUsersByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByIdQuery, GetUsersByIdQueryVariables>(GetUsersByIdDocument, options);
      }
export function useGetUsersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByIdQuery, GetUsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByIdQuery, GetUsersByIdQueryVariables>(GetUsersByIdDocument, options);
        }
// @ts-ignore
export function useGetUsersByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsersByIdQuery, GetUsersByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersByIdQuery, GetUsersByIdQueryVariables>;
export function useGetUsersByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByIdQuery, GetUsersByIdQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsersByIdQuery | undefined, GetUsersByIdQueryVariables>;
export function useGetUsersByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByIdQuery, GetUsersByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByIdQuery, GetUsersByIdQueryVariables>(GetUsersByIdDocument, options);
        }
export type GetUsersByIdQueryHookResult = ReturnType<typeof useGetUsersByIdQuery>;
export type GetUsersByIdLazyQueryHookResult = ReturnType<typeof useGetUsersByIdLazyQuery>;
export type GetUsersByIdSuspenseQueryHookResult = ReturnType<typeof useGetUsersByIdSuspenseQuery>;
export type GetUsersByIdQueryResult = Apollo.QueryResult<GetUsersByIdQuery, GetUsersByIdQueryVariables>;
export const GetValuationDocument = gql`
    query getValuation($acrePropertyID: Int!) {
  getValuation(acrePropertyID: $acrePropertyID) {
    valuation
    breakdown {
      estimate
      note
      weight
      method
    }
    range {
      from
      to
    }
  }
}
    `;

/**
 * __useGetValuationQuery__
 *
 * To run a query within a React component, call `useGetValuationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetValuationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetValuationQuery({
 *   variables: {
 *      acrePropertyID: // value for 'acrePropertyID'
 *   },
 * });
 */
export function useGetValuationQuery(baseOptions: Apollo.QueryHookOptions<GetValuationQuery, GetValuationQueryVariables> & ({ variables: GetValuationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetValuationQuery, GetValuationQueryVariables>(GetValuationDocument, options);
      }
export function useGetValuationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetValuationQuery, GetValuationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetValuationQuery, GetValuationQueryVariables>(GetValuationDocument, options);
        }
// @ts-ignore
export function useGetValuationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetValuationQuery, GetValuationQueryVariables>): Apollo.UseSuspenseQueryResult<GetValuationQuery, GetValuationQueryVariables>;
export function useGetValuationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetValuationQuery, GetValuationQueryVariables>): Apollo.UseSuspenseQueryResult<GetValuationQuery | undefined, GetValuationQueryVariables>;
export function useGetValuationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetValuationQuery, GetValuationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetValuationQuery, GetValuationQueryVariables>(GetValuationDocument, options);
        }
export type GetValuationQueryHookResult = ReturnType<typeof useGetValuationQuery>;
export type GetValuationLazyQueryHookResult = ReturnType<typeof useGetValuationLazyQuery>;
export type GetValuationSuspenseQueryHookResult = ReturnType<typeof useGetValuationSuspenseQuery>;
export type GetValuationQueryResult = Apollo.QueryResult<GetValuationQuery, GetValuationQueryVariables>;
export const HasGoCardlessMandateDocument = gql`
    query hasGoCardlessMandate($client_id: String!) {
  hasGoCardlessMandate(client_id: $client_id) {
    status
  }
}
    `;

/**
 * __useHasGoCardlessMandateQuery__
 *
 * To run a query within a React component, call `useHasGoCardlessMandateQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasGoCardlessMandateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasGoCardlessMandateQuery({
 *   variables: {
 *      client_id: // value for 'client_id'
 *   },
 * });
 */
export function useHasGoCardlessMandateQuery(baseOptions: Apollo.QueryHookOptions<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables> & ({ variables: HasGoCardlessMandateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>(HasGoCardlessMandateDocument, options);
      }
export function useHasGoCardlessMandateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>(HasGoCardlessMandateDocument, options);
        }
// @ts-ignore
export function useHasGoCardlessMandateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>): Apollo.UseSuspenseQueryResult<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>;
export function useHasGoCardlessMandateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>): Apollo.UseSuspenseQueryResult<HasGoCardlessMandateQuery | undefined, HasGoCardlessMandateQueryVariables>;
export function useHasGoCardlessMandateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>(HasGoCardlessMandateDocument, options);
        }
export type HasGoCardlessMandateQueryHookResult = ReturnType<typeof useHasGoCardlessMandateQuery>;
export type HasGoCardlessMandateLazyQueryHookResult = ReturnType<typeof useHasGoCardlessMandateLazyQuery>;
export type HasGoCardlessMandateSuspenseQueryHookResult = ReturnType<typeof useHasGoCardlessMandateSuspenseQuery>;
export type HasGoCardlessMandateQueryResult = Apollo.QueryResult<HasGoCardlessMandateQuery, HasGoCardlessMandateQueryVariables>;
export const IsLbgAuthValidDocument = gql`
    query isLbgAuthValid($input: LbgAuthCreds!) {
  isLbgAuthValid(input: $input)
}
    `;

/**
 * __useIsLbgAuthValidQuery__
 *
 * To run a query within a React component, call `useIsLbgAuthValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLbgAuthValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLbgAuthValidQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsLbgAuthValidQuery(baseOptions: Apollo.QueryHookOptions<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables> & ({ variables: IsLbgAuthValidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>(IsLbgAuthValidDocument, options);
      }
export function useIsLbgAuthValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>(IsLbgAuthValidDocument, options);
        }
// @ts-ignore
export function useIsLbgAuthValidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>): Apollo.UseSuspenseQueryResult<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>;
export function useIsLbgAuthValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>): Apollo.UseSuspenseQueryResult<IsLbgAuthValidQuery | undefined, IsLbgAuthValidQueryVariables>;
export function useIsLbgAuthValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>(IsLbgAuthValidDocument, options);
        }
export type IsLbgAuthValidQueryHookResult = ReturnType<typeof useIsLbgAuthValidQuery>;
export type IsLbgAuthValidLazyQueryHookResult = ReturnType<typeof useIsLbgAuthValidLazyQuery>;
export type IsLbgAuthValidSuspenseQueryHookResult = ReturnType<typeof useIsLbgAuthValidSuspenseQuery>;
export type IsLbgAuthValidQueryResult = Apollo.QueryResult<IsLbgAuthValidQuery, IsLbgAuthValidQueryVariables>;
export const GetLbgSharedOwnershipCompaniesDocument = gql`
    query getLbgSharedOwnershipCompanies {
  lbgSharedOwnershipCompanies {
    label
    value
  }
}
    `;

/**
 * __useGetLbgSharedOwnershipCompaniesQuery__
 *
 * To run a query within a React component, call `useGetLbgSharedOwnershipCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLbgSharedOwnershipCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLbgSharedOwnershipCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLbgSharedOwnershipCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>(GetLbgSharedOwnershipCompaniesDocument, options);
      }
export function useGetLbgSharedOwnershipCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>(GetLbgSharedOwnershipCompaniesDocument, options);
        }
// @ts-ignore
export function useGetLbgSharedOwnershipCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>;
export function useGetLbgSharedOwnershipCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>): Apollo.UseSuspenseQueryResult<GetLbgSharedOwnershipCompaniesQuery | undefined, GetLbgSharedOwnershipCompaniesQueryVariables>;
export function useGetLbgSharedOwnershipCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>(GetLbgSharedOwnershipCompaniesDocument, options);
        }
export type GetLbgSharedOwnershipCompaniesQueryHookResult = ReturnType<typeof useGetLbgSharedOwnershipCompaniesQuery>;
export type GetLbgSharedOwnershipCompaniesLazyQueryHookResult = ReturnType<typeof useGetLbgSharedOwnershipCompaniesLazyQuery>;
export type GetLbgSharedOwnershipCompaniesSuspenseQueryHookResult = ReturnType<typeof useGetLbgSharedOwnershipCompaniesSuspenseQuery>;
export type GetLbgSharedOwnershipCompaniesQueryResult = Apollo.QueryResult<GetLbgSharedOwnershipCompaniesQuery, GetLbgSharedOwnershipCompaniesQueryVariables>;
export const LoginAsSupportUserDocument = gql`
    query loginAsSupportUser($id: ID!) {
  loginAsSupportUser(id: $id) {
    email
    org_id
    name
  }
}
    `;

/**
 * __useLoginAsSupportUserQuery__
 *
 * To run a query within a React component, call `useLoginAsSupportUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoginAsSupportUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoginAsSupportUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoginAsSupportUserQuery(baseOptions: Apollo.QueryHookOptions<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables> & ({ variables: LoginAsSupportUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>(LoginAsSupportUserDocument, options);
      }
export function useLoginAsSupportUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>(LoginAsSupportUserDocument, options);
        }
// @ts-ignore
export function useLoginAsSupportUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>): Apollo.UseSuspenseQueryResult<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>;
export function useLoginAsSupportUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>): Apollo.UseSuspenseQueryResult<LoginAsSupportUserQuery | undefined, LoginAsSupportUserQueryVariables>;
export function useLoginAsSupportUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>(LoginAsSupportUserDocument, options);
        }
export type LoginAsSupportUserQueryHookResult = ReturnType<typeof useLoginAsSupportUserQuery>;
export type LoginAsSupportUserLazyQueryHookResult = ReturnType<typeof useLoginAsSupportUserLazyQuery>;
export type LoginAsSupportUserSuspenseQueryHookResult = ReturnType<typeof useLoginAsSupportUserSuspenseQuery>;
export type LoginAsSupportUserQueryResult = Apollo.QueryResult<LoginAsSupportUserQuery, LoginAsSupportUserQueryVariables>;
export const OrgAndIntroducerAndAdvisorFiltersDiscoveryDocument = gql`
    query orgAndIntroducerAndAdvisorFiltersDiscovery($input: GetMiCaseListFilterInput) {
  orgAndIntroducerAndAdvisorFiltersDiscovery(input: $input) {
    filters {
      display_name
      param_name
      relationship_type
      type
      values {
        count
        default
        display
        value
      }
    }
  }
}
    `;

/**
 * __useOrgAndIntroducerAndAdvisorFiltersDiscoveryQuery__
 *
 * To run a query within a React component, call `useOrgAndIntroducerAndAdvisorFiltersDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgAndIntroducerAndAdvisorFiltersDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgAndIntroducerAndAdvisorFiltersDiscoveryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrgAndIntroducerAndAdvisorFiltersDiscoveryQuery(baseOptions?: Apollo.QueryHookOptions<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>(OrgAndIntroducerAndAdvisorFiltersDiscoveryDocument, options);
      }
export function useOrgAndIntroducerAndAdvisorFiltersDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>(OrgAndIntroducerAndAdvisorFiltersDiscoveryDocument, options);
        }
// @ts-ignore
export function useOrgAndIntroducerAndAdvisorFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>;
export function useOrgAndIntroducerAndAdvisorFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery | undefined, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>;
export function useOrgAndIntroducerAndAdvisorFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>(OrgAndIntroducerAndAdvisorFiltersDiscoveryDocument, options);
        }
export type OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryHookResult = ReturnType<typeof useOrgAndIntroducerAndAdvisorFiltersDiscoveryQuery>;
export type OrgAndIntroducerAndAdvisorFiltersDiscoveryLazyQueryHookResult = ReturnType<typeof useOrgAndIntroducerAndAdvisorFiltersDiscoveryLazyQuery>;
export type OrgAndIntroducerAndAdvisorFiltersDiscoverySuspenseQueryHookResult = ReturnType<typeof useOrgAndIntroducerAndAdvisorFiltersDiscoverySuspenseQuery>;
export type OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryResult = Apollo.QueryResult<OrgAndIntroducerAndAdvisorFiltersDiscoveryQuery, OrgAndIntroducerAndAdvisorFiltersDiscoveryQueryVariables>;
export const OrgRegulatingFiltersDiscoveryDocument = gql`
    query orgRegulatingFiltersDiscovery {
  orgRegulatingFiltersDiscovery {
    filters {
      display_name
      param_name
      type
      values {
        count
        default
        display
        value
      }
    }
  }
}
    `;

/**
 * __useOrgRegulatingFiltersDiscoveryQuery__
 *
 * To run a query within a React component, call `useOrgRegulatingFiltersDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgRegulatingFiltersDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgRegulatingFiltersDiscoveryQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgRegulatingFiltersDiscoveryQuery(baseOptions?: Apollo.QueryHookOptions<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>(OrgRegulatingFiltersDiscoveryDocument, options);
      }
export function useOrgRegulatingFiltersDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>(OrgRegulatingFiltersDiscoveryDocument, options);
        }
// @ts-ignore
export function useOrgRegulatingFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>;
export function useOrgRegulatingFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<OrgRegulatingFiltersDiscoveryQuery | undefined, OrgRegulatingFiltersDiscoveryQueryVariables>;
export function useOrgRegulatingFiltersDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>(OrgRegulatingFiltersDiscoveryDocument, options);
        }
export type OrgRegulatingFiltersDiscoveryQueryHookResult = ReturnType<typeof useOrgRegulatingFiltersDiscoveryQuery>;
export type OrgRegulatingFiltersDiscoveryLazyQueryHookResult = ReturnType<typeof useOrgRegulatingFiltersDiscoveryLazyQuery>;
export type OrgRegulatingFiltersDiscoverySuspenseQueryHookResult = ReturnType<typeof useOrgRegulatingFiltersDiscoverySuspenseQuery>;
export type OrgRegulatingFiltersDiscoveryQueryResult = Apollo.QueryResult<OrgRegulatingFiltersDiscoveryQuery, OrgRegulatingFiltersDiscoveryQueryVariables>;
export const PredictedRevenueReportDocument = gql`
    query predictedRevenueReport($body: ReportsCaseStatsFilterInput!) {
  reportsPredictedRevenue(body: $body) {
    grouped_results {
      group_id
      results {
        case_status
        count
        value
      }
    }
    totals {
      case_status
      count
      value
    }
  }
  getPredictedRevenueReport @client {
    id
    view_by
    LEAD {
      value
      count
    }
    PRE_RECOMMENDATION {
      value
      count
    }
    PRE_APPLICATION {
      value
      count
    }
    APPLICATION_SUBMITTED {
      value
      count
    }
    AWAITING_VALUATION {
      value
      count
    }
    AWAITING_OFFER {
      value
      count
    }
    OFFER_RECEIVED {
      value
      count
    }
    EXCHANGE {
      value
      count
    }
  }
}
    `;

/**
 * __usePredictedRevenueReportQuery__
 *
 * To run a query within a React component, call `usePredictedRevenueReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictedRevenueReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictedRevenueReportQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function usePredictedRevenueReportQuery(baseOptions: Apollo.QueryHookOptions<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables> & ({ variables: PredictedRevenueReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>(PredictedRevenueReportDocument, options);
      }
export function usePredictedRevenueReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>(PredictedRevenueReportDocument, options);
        }
// @ts-ignore
export function usePredictedRevenueReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>): Apollo.UseSuspenseQueryResult<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>;
export function usePredictedRevenueReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>): Apollo.UseSuspenseQueryResult<PredictedRevenueReportQuery | undefined, PredictedRevenueReportQueryVariables>;
export function usePredictedRevenueReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>(PredictedRevenueReportDocument, options);
        }
export type PredictedRevenueReportQueryHookResult = ReturnType<typeof usePredictedRevenueReportQuery>;
export type PredictedRevenueReportLazyQueryHookResult = ReturnType<typeof usePredictedRevenueReportLazyQuery>;
export type PredictedRevenueReportSuspenseQueryHookResult = ReturnType<typeof usePredictedRevenueReportSuspenseQuery>;
export type PredictedRevenueReportQueryResult = Apollo.QueryResult<PredictedRevenueReportQuery, PredictedRevenueReportQueryVariables>;
export const PredictedRevenueTotalsDocument = gql`
    query predictedRevenueTotals($body: ReportsCaseStatsFilterInput!) {
  getPredictedRevenueTotals(body: $body) @client {
    LEAD {
      value
      count
    }
    PRE_RECOMMENDATION {
      value
      count
    }
    PRE_APPLICATION {
      value
      count
    }
    APPLICATION_SUBMITTED {
      value
      count
    }
    AWAITING_VALUATION {
      value
      count
    }
    AWAITING_OFFER {
      value
      count
    }
    OFFER_RECEIVED {
      value
      count
    }
    EXCHANGE {
      value
      count
    }
  }
}
    `;

/**
 * __usePredictedRevenueTotalsQuery__
 *
 * To run a query within a React component, call `usePredictedRevenueTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePredictedRevenueTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePredictedRevenueTotalsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function usePredictedRevenueTotalsQuery(baseOptions: Apollo.QueryHookOptions<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables> & ({ variables: PredictedRevenueTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>(PredictedRevenueTotalsDocument, options);
      }
export function usePredictedRevenueTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>(PredictedRevenueTotalsDocument, options);
        }
// @ts-ignore
export function usePredictedRevenueTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>;
export function usePredictedRevenueTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<PredictedRevenueTotalsQuery | undefined, PredictedRevenueTotalsQueryVariables>;
export function usePredictedRevenueTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>(PredictedRevenueTotalsDocument, options);
        }
export type PredictedRevenueTotalsQueryHookResult = ReturnType<typeof usePredictedRevenueTotalsQuery>;
export type PredictedRevenueTotalsLazyQueryHookResult = ReturnType<typeof usePredictedRevenueTotalsLazyQuery>;
export type PredictedRevenueTotalsSuspenseQueryHookResult = ReturnType<typeof usePredictedRevenueTotalsSuspenseQuery>;
export type PredictedRevenueTotalsQueryResult = Apollo.QueryResult<PredictedRevenueTotalsQuery, PredictedRevenueTotalsQueryVariables>;
export const GetProductEstimateDocument = gql`
    query getProductEstimate($input: ProductEstimateInput!) {
  productEstimate(input: $input) {
    product_price
    product_price_frequency
  }
}
    `;

/**
 * __useGetProductEstimateQuery__
 *
 * To run a query within a React component, call `useGetProductEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductEstimateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetProductEstimateQuery(baseOptions: Apollo.QueryHookOptions<GetProductEstimateQuery, GetProductEstimateQueryVariables> & ({ variables: GetProductEstimateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductEstimateQuery, GetProductEstimateQueryVariables>(GetProductEstimateDocument, options);
      }
export function useGetProductEstimateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductEstimateQuery, GetProductEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductEstimateQuery, GetProductEstimateQueryVariables>(GetProductEstimateDocument, options);
        }
// @ts-ignore
export function useGetProductEstimateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductEstimateQuery, GetProductEstimateQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductEstimateQuery, GetProductEstimateQueryVariables>;
export function useGetProductEstimateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductEstimateQuery, GetProductEstimateQueryVariables>): Apollo.UseSuspenseQueryResult<GetProductEstimateQuery | undefined, GetProductEstimateQueryVariables>;
export function useGetProductEstimateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductEstimateQuery, GetProductEstimateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductEstimateQuery, GetProductEstimateQueryVariables>(GetProductEstimateDocument, options);
        }
export type GetProductEstimateQueryHookResult = ReturnType<typeof useGetProductEstimateQuery>;
export type GetProductEstimateLazyQueryHookResult = ReturnType<typeof useGetProductEstimateLazyQuery>;
export type GetProductEstimateSuspenseQueryHookResult = ReturnType<typeof useGetProductEstimateSuspenseQuery>;
export type GetProductEstimateQueryResult = Apollo.QueryResult<GetProductEstimateQuery, GetProductEstimateQueryVariables>;
export const GetProtectionProductsDocument = gql`
    query getProtectionProducts($protectionProductDetails: Boolean, $filterCaseIds: [ID!]) {
  protectionProducts(
    protectionProductDetails: $protectionProductDetails
    filterCaseIds: $filterCaseIds
  ) {
    protection_id
    created_at
    version
    version_created_at
    details {
      ...ProductsForProtection
    }
  }
}
    ${ProductsForProtectionFragmentDoc}`;

/**
 * __useGetProtectionProductsQuery__
 *
 * To run a query within a React component, call `useGetProtectionProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtectionProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtectionProductsQuery({
 *   variables: {
 *      protectionProductDetails: // value for 'protectionProductDetails'
 *      filterCaseIds: // value for 'filterCaseIds'
 *   },
 * });
 */
export function useGetProtectionProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>(GetProtectionProductsDocument, options);
      }
export function useGetProtectionProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>(GetProtectionProductsDocument, options);
        }
// @ts-ignore
export function useGetProtectionProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>;
export function useGetProtectionProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtectionProductsQuery | undefined, GetProtectionProductsQueryVariables>;
export function useGetProtectionProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>(GetProtectionProductsDocument, options);
        }
export type GetProtectionProductsQueryHookResult = ReturnType<typeof useGetProtectionProductsQuery>;
export type GetProtectionProductsLazyQueryHookResult = ReturnType<typeof useGetProtectionProductsLazyQuery>;
export type GetProtectionProductsSuspenseQueryHookResult = ReturnType<typeof useGetProtectionProductsSuspenseQuery>;
export type GetProtectionProductsQueryResult = Apollo.QueryResult<GetProtectionProductsQuery, GetProtectionProductsQueryVariables>;
export const GetProtectionProductsForCaseDocument = gql`
    query getProtectionProductsForCase($id: ID!) {
  case(id: $id) {
    id
    created_at
    version
    version_created_at
    details {
      id
      protection_products {
        protection_id
        created_at
        version
        version_created_at
        details {
          ...ProductsForProtection
        }
      }
    }
  }
}
    ${ProductsForProtectionFragmentDoc}`;

/**
 * __useGetProtectionProductsForCaseQuery__
 *
 * To run a query within a React component, call `useGetProtectionProductsForCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtectionProductsForCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtectionProductsForCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProtectionProductsForCaseQuery(baseOptions: Apollo.QueryHookOptions<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables> & ({ variables: GetProtectionProductsForCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>(GetProtectionProductsForCaseDocument, options);
      }
export function useGetProtectionProductsForCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>(GetProtectionProductsForCaseDocument, options);
        }
// @ts-ignore
export function useGetProtectionProductsForCaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>;
export function useGetProtectionProductsForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtectionProductsForCaseQuery | undefined, GetProtectionProductsForCaseQueryVariables>;
export function useGetProtectionProductsForCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>(GetProtectionProductsForCaseDocument, options);
        }
export type GetProtectionProductsForCaseQueryHookResult = ReturnType<typeof useGetProtectionProductsForCaseQuery>;
export type GetProtectionProductsForCaseLazyQueryHookResult = ReturnType<typeof useGetProtectionProductsForCaseLazyQuery>;
export type GetProtectionProductsForCaseSuspenseQueryHookResult = ReturnType<typeof useGetProtectionProductsForCaseSuspenseQuery>;
export type GetProtectionProductsForCaseQueryResult = Apollo.QueryResult<GetProtectionProductsForCaseQuery, GetProtectionProductsForCaseQueryVariables>;
export const GetProtectionProductsForClientsDocument = gql`
    query getProtectionProductsForClients($protectionProductDetails: Boolean, $filterClientIds: [ID!]!) {
  protectionProductsForClients(
    protectionProductDetails: $protectionProductDetails
    filterClientIds: $filterClientIds
  ) {
    protection_id
    created_at
    version
    version_created_at
    details {
      ...ProductsForProtection
    }
  }
}
    ${ProductsForProtectionFragmentDoc}`;

/**
 * __useGetProtectionProductsForClientsQuery__
 *
 * To run a query within a React component, call `useGetProtectionProductsForClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProtectionProductsForClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProtectionProductsForClientsQuery({
 *   variables: {
 *      protectionProductDetails: // value for 'protectionProductDetails'
 *      filterClientIds: // value for 'filterClientIds'
 *   },
 * });
 */
export function useGetProtectionProductsForClientsQuery(baseOptions: Apollo.QueryHookOptions<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables> & ({ variables: GetProtectionProductsForClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>(GetProtectionProductsForClientsDocument, options);
      }
export function useGetProtectionProductsForClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>(GetProtectionProductsForClientsDocument, options);
        }
// @ts-ignore
export function useGetProtectionProductsForClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>;
export function useGetProtectionProductsForClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetProtectionProductsForClientsQuery | undefined, GetProtectionProductsForClientsQueryVariables>;
export function useGetProtectionProductsForClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>(GetProtectionProductsForClientsDocument, options);
        }
export type GetProtectionProductsForClientsQueryHookResult = ReturnType<typeof useGetProtectionProductsForClientsQuery>;
export type GetProtectionProductsForClientsLazyQueryHookResult = ReturnType<typeof useGetProtectionProductsForClientsLazyQuery>;
export type GetProtectionProductsForClientsSuspenseQueryHookResult = ReturnType<typeof useGetProtectionProductsForClientsSuspenseQuery>;
export type GetProtectionProductsForClientsQueryResult = Apollo.QueryResult<GetProtectionProductsForClientsQuery, GetProtectionProductsForClientsQueryVariables>;
export const GetQuotesDocument = gql`
    query getQuotes($input: SplitCoverBenefitsInput!) {
  quoteSource(input: $input) {
    id
    status
    errors
    premium
  }
}
    `;

/**
 * __useGetQuotesQuery__
 *
 * To run a query within a React component, call `useGetQuotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuotesQuery(baseOptions: Apollo.QueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables> & ({ variables: GetQuotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
      }
export function useGetQuotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
        }
// @ts-ignore
export function useGetQuotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuotesQuery, GetQuotesQueryVariables>;
export function useGetQuotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetQuotesQuery | undefined, GetQuotesQueryVariables>;
export function useGetQuotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotesQuery, GetQuotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotesQuery, GetQuotesQueryVariables>(GetQuotesDocument, options);
        }
export type GetQuotesQueryHookResult = ReturnType<typeof useGetQuotesQuery>;
export type GetQuotesLazyQueryHookResult = ReturnType<typeof useGetQuotesLazyQuery>;
export type GetQuotesSuspenseQueryHookResult = ReturnType<typeof useGetQuotesSuspenseQuery>;
export type GetQuotesQueryResult = Apollo.QueryResult<GetQuotesQuery, GetQuotesQueryVariables>;
export const GetQuotesV2Document = gql`
    query getQuotesV2($input: SplitCoverBenefitsInput!) {
  quoteSourceV2(input: $input) {
    id
    status
    errors
    premium
  }
}
    `;

/**
 * __useGetQuotesV2Query__
 *
 * To run a query within a React component, call `useGetQuotesV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetQuotesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuotesV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetQuotesV2Query(baseOptions: Apollo.QueryHookOptions<GetQuotesV2Query, GetQuotesV2QueryVariables> & ({ variables: GetQuotesV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuotesV2Query, GetQuotesV2QueryVariables>(GetQuotesV2Document, options);
      }
export function useGetQuotesV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuotesV2Query, GetQuotesV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuotesV2Query, GetQuotesV2QueryVariables>(GetQuotesV2Document, options);
        }
// @ts-ignore
export function useGetQuotesV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetQuotesV2Query, GetQuotesV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetQuotesV2Query, GetQuotesV2QueryVariables>;
export function useGetQuotesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotesV2Query, GetQuotesV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetQuotesV2Query | undefined, GetQuotesV2QueryVariables>;
export function useGetQuotesV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuotesV2Query, GetQuotesV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuotesV2Query, GetQuotesV2QueryVariables>(GetQuotesV2Document, options);
        }
export type GetQuotesV2QueryHookResult = ReturnType<typeof useGetQuotesV2Query>;
export type GetQuotesV2LazyQueryHookResult = ReturnType<typeof useGetQuotesV2LazyQuery>;
export type GetQuotesV2SuspenseQueryHookResult = ReturnType<typeof useGetQuotesV2SuspenseQuery>;
export type GetQuotesV2QueryResult = Apollo.QueryResult<GetQuotesV2Query, GetQuotesV2QueryVariables>;
export const GetSolutionSourcingResultsDocument = gql`
    query getSolutionSourcingResults($location: String!) {
  getSolutionSourcingResults(location: $location) {
    id
    product_benefits {
      ...ProtectionBenefitsFragment
    }
    solutions {
      solution_type
      product_benefit_groups {
        product_benefit_group_id
        product_benefit_ids
        status
      }
      products {
        status
        expires_at
        product_price_monthly
        benefits {
          ...ProtectionBenefitsFragment
        }
        provider_name
        product_name
        can_apply_at_provider_extranet
        product_benefit_group_id
        org_provider_reference
        sourced_with_bmi
        warnings
        errors
        integrator_metadata {
          integrator_name
          integrator_product_reference
          integrator_quote_reference
          integrator_provider_reference
        }
      }
    }
  }
}
    ${ProtectionBenefitsFragmentFragmentDoc}`;

/**
 * __useGetSolutionSourcingResultsQuery__
 *
 * To run a query within a React component, call `useGetSolutionSourcingResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSolutionSourcingResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSolutionSourcingResultsQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetSolutionSourcingResultsQuery(baseOptions: Apollo.QueryHookOptions<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables> & ({ variables: GetSolutionSourcingResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>(GetSolutionSourcingResultsDocument, options);
      }
export function useGetSolutionSourcingResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>(GetSolutionSourcingResultsDocument, options);
        }
// @ts-ignore
export function useGetSolutionSourcingResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>;
export function useGetSolutionSourcingResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSolutionSourcingResultsQuery | undefined, GetSolutionSourcingResultsQueryVariables>;
export function useGetSolutionSourcingResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>(GetSolutionSourcingResultsDocument, options);
        }
export type GetSolutionSourcingResultsQueryHookResult = ReturnType<typeof useGetSolutionSourcingResultsQuery>;
export type GetSolutionSourcingResultsLazyQueryHookResult = ReturnType<typeof useGetSolutionSourcingResultsLazyQuery>;
export type GetSolutionSourcingResultsSuspenseQueryHookResult = ReturnType<typeof useGetSolutionSourcingResultsSuspenseQuery>;
export type GetSolutionSourcingResultsQueryResult = Apollo.QueryResult<GetSolutionSourcingResultsQuery, GetSolutionSourcingResultsQueryVariables>;
export const GetSolutionSourcingResultsV2Document = gql`
    query getSolutionSourcingResultsV2($location: String!) {
  getSolutionSourcingResultsV2(location: $location) {
    id
    product_benefits {
      ...ProtectionBenefitsFragment
    }
    solutions {
      solution_type
      product_benefit_groups {
        product_benefit_group_id
        product_benefit_ids
        status
      }
      products {
        status
        expires_at
        product_price_monthly
        benefits {
          ...ProtectionBenefitsFragment
        }
        provider_name
        product_name
        can_apply_at_provider_extranet
        product_benefit_group_id
        org_provider_reference
        sourced_with_bmi
        warnings
        errors
        integrator_metadata {
          integrator_name
          integrator_product_reference
          integrator_quote_reference
          integrator_provider_reference
        }
      }
    }
  }
}
    ${ProtectionBenefitsFragmentFragmentDoc}`;

/**
 * __useGetSolutionSourcingResultsV2Query__
 *
 * To run a query within a React component, call `useGetSolutionSourcingResultsV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetSolutionSourcingResultsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSolutionSourcingResultsV2Query({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetSolutionSourcingResultsV2Query(baseOptions: Apollo.QueryHookOptions<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables> & ({ variables: GetSolutionSourcingResultsV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>(GetSolutionSourcingResultsV2Document, options);
      }
export function useGetSolutionSourcingResultsV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>(GetSolutionSourcingResultsV2Document, options);
        }
// @ts-ignore
export function useGetSolutionSourcingResultsV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>;
export function useGetSolutionSourcingResultsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>): Apollo.UseSuspenseQueryResult<GetSolutionSourcingResultsV2Query | undefined, GetSolutionSourcingResultsV2QueryVariables>;
export function useGetSolutionSourcingResultsV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>(GetSolutionSourcingResultsV2Document, options);
        }
export type GetSolutionSourcingResultsV2QueryHookResult = ReturnType<typeof useGetSolutionSourcingResultsV2Query>;
export type GetSolutionSourcingResultsV2LazyQueryHookResult = ReturnType<typeof useGetSolutionSourcingResultsV2LazyQuery>;
export type GetSolutionSourcingResultsV2SuspenseQueryHookResult = ReturnType<typeof useGetSolutionSourcingResultsV2SuspenseQuery>;
export type GetSolutionSourcingResultsV2QueryResult = Apollo.QueryResult<GetSolutionSourcingResultsV2Query, GetSolutionSourcingResultsV2QueryVariables>;
export const IsProtectionAuthValidDocument = gql`
    query isProtectionAuthValid($input: ProtectionAuth!) {
  isProtectionAuthValid(input: $input)
}
    `;

/**
 * __useIsProtectionAuthValidQuery__
 *
 * To run a query within a React component, call `useIsProtectionAuthValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsProtectionAuthValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsProtectionAuthValidQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsProtectionAuthValidQuery(baseOptions: Apollo.QueryHookOptions<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables> & ({ variables: IsProtectionAuthValidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>(IsProtectionAuthValidDocument, options);
      }
export function useIsProtectionAuthValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>(IsProtectionAuthValidDocument, options);
        }
// @ts-ignore
export function useIsProtectionAuthValidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>): Apollo.UseSuspenseQueryResult<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>;
export function useIsProtectionAuthValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>): Apollo.UseSuspenseQueryResult<IsProtectionAuthValidQuery | undefined, IsProtectionAuthValidQueryVariables>;
export function useIsProtectionAuthValidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>(IsProtectionAuthValidDocument, options);
        }
export type IsProtectionAuthValidQueryHookResult = ReturnType<typeof useIsProtectionAuthValidQuery>;
export type IsProtectionAuthValidLazyQueryHookResult = ReturnType<typeof useIsProtectionAuthValidLazyQuery>;
export type IsProtectionAuthValidSuspenseQueryHookResult = ReturnType<typeof useIsProtectionAuthValidSuspenseQuery>;
export type IsProtectionAuthValidQueryResult = Apollo.QueryResult<IsProtectionAuthValidQuery, IsProtectionAuthValidQueryVariables>;
export const IsProtectionAuthValidV2Document = gql`
    query isProtectionAuthValidV2($input: IressCredentialsPair!) {
  isProtectionAuthValid: isProtectionAuthValidV2(input: $input)
}
    `;

/**
 * __useIsProtectionAuthValidV2Query__
 *
 * To run a query within a React component, call `useIsProtectionAuthValidV2Query` and pass it any options that fit your needs.
 * When your component renders, `useIsProtectionAuthValidV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsProtectionAuthValidV2Query({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIsProtectionAuthValidV2Query(baseOptions: Apollo.QueryHookOptions<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables> & ({ variables: IsProtectionAuthValidV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>(IsProtectionAuthValidV2Document, options);
      }
export function useIsProtectionAuthValidV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>(IsProtectionAuthValidV2Document, options);
        }
// @ts-ignore
export function useIsProtectionAuthValidV2SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>): Apollo.UseSuspenseQueryResult<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>;
export function useIsProtectionAuthValidV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>): Apollo.UseSuspenseQueryResult<IsProtectionAuthValidV2Query | undefined, IsProtectionAuthValidV2QueryVariables>;
export function useIsProtectionAuthValidV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>(IsProtectionAuthValidV2Document, options);
        }
export type IsProtectionAuthValidV2QueryHookResult = ReturnType<typeof useIsProtectionAuthValidV2Query>;
export type IsProtectionAuthValidV2LazyQueryHookResult = ReturnType<typeof useIsProtectionAuthValidV2LazyQuery>;
export type IsProtectionAuthValidV2SuspenseQueryHookResult = ReturnType<typeof useIsProtectionAuthValidV2SuspenseQuery>;
export type IsProtectionAuthValidV2QueryResult = Apollo.QueryResult<IsProtectionAuthValidV2Query, IsProtectionAuthValidV2QueryVariables>;
export const RunSolutionSourcingDocument = gql`
    mutation runSolutionSourcing($input: RunSolutionSourcingInput!) {
  runSolutionSourcing(input: $input) {
    location
    product_benefits {
      product_type_term {
        client_ids
        cover_amount
        cover_amount_depreciation_rate
        cover_amount_life
        cover_amount_cic
        cover_amount_life_or_earlier_cic
        include_low_start
        indexation_percentage
        indexation_type
        payout_type
        premium_frequency
        premium_type
        product_benefit_id
        product_type
        term_years
        term_age
        product_add_ons {
          fracture_cover_client_ids
          waiver_of_premium_client_ids
          include_total_permanent_disability
        }
      }
      product_type_family_income_benefit {
        client_ids
        cover_amount
        cover_amount_depreciation_rate
        cover_amount_life
        cover_amount_cic
        cover_amount_life_or_earlier_cic
        include_low_start
        indexation_percentage
        indexation_type
        payout_type
        premium_frequency
        premium_type
        product_benefit_id
        product_type
        term_years
        term_age
        product_add_ons {
          fracture_cover_client_ids
          waiver_of_premium_client_ids
          include_total_permanent_disability
        }
      }
      product_type_whole_of_life {
        product_benefit_id
        client_ids
        product_type
        indexation_type
        indexation_percentage
        cover_amount
        premium_type
        product_add_ons {
          waiver_of_premium_client_ids
        }
      }
      product_type_income_protection {
        product_benefit_id
        client_ids
        product_type
        indexation_type
        indexation_percentage
        term_years
        term_age
        age_banded
        limited_payment_plan
        limited_payment_plan_term
        premium_frequency
        cover_amount
        premium_type
        additional_cover_amount
        deferral_period_days
        additional_deferral_period_days
        include_limited_benefit_payment_period
      }
    }
    source_response {
      solution_type
      sourced_solution_products {
        source_id
        product_benefit_ids
      }
    }
  }
}
    `;
export type RunSolutionSourcingMutationFn = Apollo.MutationFunction<RunSolutionSourcingMutation, RunSolutionSourcingMutationVariables>;

/**
 * __useRunSolutionSourcingMutation__
 *
 * To run a mutation, you first call `useRunSolutionSourcingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunSolutionSourcingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runSolutionSourcingMutation, { data, loading, error }] = useRunSolutionSourcingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunSolutionSourcingMutation(baseOptions?: Apollo.MutationHookOptions<RunSolutionSourcingMutation, RunSolutionSourcingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunSolutionSourcingMutation, RunSolutionSourcingMutationVariables>(RunSolutionSourcingDocument, options);
      }
export type RunSolutionSourcingMutationHookResult = ReturnType<typeof useRunSolutionSourcingMutation>;
export type RunSolutionSourcingMutationResult = Apollo.MutationResult<RunSolutionSourcingMutation>;
export type RunSolutionSourcingMutationOptions = Apollo.BaseMutationOptions<RunSolutionSourcingMutation, RunSolutionSourcingMutationVariables>;
export const RunSolutionSourcingV2Document = gql`
    mutation runSolutionSourcingV2($input: RunSolutionSourcingInput!) {
  runSolutionSourcingV2(input: $input) {
    location
    product_benefits {
      product_type_term {
        client_ids
        cover_amount
        cover_amount_depreciation_rate
        cover_amount_life
        cover_amount_cic
        cover_amount_life_or_earlier_cic
        include_low_start
        indexation_percentage
        indexation_type
        payout_type
        premium_frequency
        premium_type
        product_benefit_id
        product_type
        term_years
        term_age
        product_add_ons {
          fracture_cover_client_ids
          waiver_of_premium_client_ids
          include_total_permanent_disability
        }
      }
      product_type_family_income_benefit {
        client_ids
        cover_amount
        cover_amount_depreciation_rate
        cover_amount_life
        cover_amount_cic
        cover_amount_life_or_earlier_cic
        include_low_start
        indexation_percentage
        indexation_type
        payout_type
        premium_frequency
        premium_type
        product_benefit_id
        product_type
        term_years
        term_age
        product_add_ons {
          fracture_cover_client_ids
          waiver_of_premium_client_ids
          include_total_permanent_disability
        }
      }
      product_type_whole_of_life {
        product_benefit_id
        client_ids
        product_type
        indexation_type
        indexation_percentage
        cover_amount
        premium_type
        product_add_ons {
          waiver_of_premium_client_ids
        }
      }
      product_type_income_protection {
        product_benefit_id
        client_ids
        product_type
        indexation_type
        indexation_percentage
        term_years
        term_age
        age_banded
        limited_payment_plan
        limited_payment_plan_term
        premium_frequency
        cover_amount
        premium_type
        additional_cover_amount
        deferral_period_days
        additional_deferral_period_days
        include_limited_benefit_payment_period
      }
    }
    source_response {
      solution_type
      sourced_solution_products {
        source_id
        product_benefit_ids
      }
    }
  }
}
    `;
export type RunSolutionSourcingV2MutationFn = Apollo.MutationFunction<RunSolutionSourcingV2Mutation, RunSolutionSourcingV2MutationVariables>;

/**
 * __useRunSolutionSourcingV2Mutation__
 *
 * To run a mutation, you first call `useRunSolutionSourcingV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunSolutionSourcingV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runSolutionSourcingV2Mutation, { data, loading, error }] = useRunSolutionSourcingV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunSolutionSourcingV2Mutation(baseOptions?: Apollo.MutationHookOptions<RunSolutionSourcingV2Mutation, RunSolutionSourcingV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunSolutionSourcingV2Mutation, RunSolutionSourcingV2MutationVariables>(RunSolutionSourcingV2Document, options);
      }
export type RunSolutionSourcingV2MutationHookResult = ReturnType<typeof useRunSolutionSourcingV2Mutation>;
export type RunSolutionSourcingV2MutationResult = Apollo.MutationResult<RunSolutionSourcingV2Mutation>;
export type RunSolutionSourcingV2MutationOptions = Apollo.BaseMutationOptions<RunSolutionSourcingV2Mutation, RunSolutionSourcingV2MutationVariables>;
export const RenderDocumentDocument = gql`
    query renderDocument($template_name: TemplateType, $template_id: ID, $client_ids: [String!], $mortgage_ids: [String!], $organisation_ids: [String!], $user_ids: [String!], $case_ids: [String!], $product_ids: [String!], $store_document: Boolean!, $preview: Boolean, $template_style: TemplateStyleVariant) {
  renderedDocument(
    template_name: $template_name
    template_id: $template_id
    client_ids: $client_ids
    mortgage_ids: $mortgage_ids
    organisation_ids: $organisation_ids
    user_ids: $user_ids
    case_ids: $case_ids
    product_ids: $product_ids
    store_document: $store_document
    preview: $preview
    template_style: $template_style
  ) {
    internalHash
    document_id
    document_signature @include(if: $store_document)
    document_id @include(if: $store_document)
    date_stored @include(if: $store_document)
    data_base64
    file_type
    template_type
  }
}
    `;

/**
 * __useRenderDocumentQuery__
 *
 * To run a query within a React component, call `useRenderDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderDocumentQuery({
 *   variables: {
 *      template_name: // value for 'template_name'
 *      template_id: // value for 'template_id'
 *      client_ids: // value for 'client_ids'
 *      mortgage_ids: // value for 'mortgage_ids'
 *      organisation_ids: // value for 'organisation_ids'
 *      user_ids: // value for 'user_ids'
 *      case_ids: // value for 'case_ids'
 *      product_ids: // value for 'product_ids'
 *      store_document: // value for 'store_document'
 *      preview: // value for 'preview'
 *      template_style: // value for 'template_style'
 *   },
 * });
 */
export function useRenderDocumentQuery(baseOptions: Apollo.QueryHookOptions<RenderDocumentQuery, RenderDocumentQueryVariables> & ({ variables: RenderDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderDocumentQuery, RenderDocumentQueryVariables>(RenderDocumentDocument, options);
      }
export function useRenderDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderDocumentQuery, RenderDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderDocumentQuery, RenderDocumentQueryVariables>(RenderDocumentDocument, options);
        }
// @ts-ignore
export function useRenderDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenderDocumentQuery, RenderDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<RenderDocumentQuery, RenderDocumentQueryVariables>;
export function useRenderDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderDocumentQuery, RenderDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<RenderDocumentQuery | undefined, RenderDocumentQueryVariables>;
export function useRenderDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderDocumentQuery, RenderDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenderDocumentQuery, RenderDocumentQueryVariables>(RenderDocumentDocument, options);
        }
export type RenderDocumentQueryHookResult = ReturnType<typeof useRenderDocumentQuery>;
export type RenderDocumentLazyQueryHookResult = ReturnType<typeof useRenderDocumentLazyQuery>;
export type RenderDocumentSuspenseQueryHookResult = ReturnType<typeof useRenderDocumentSuspenseQuery>;
export type RenderDocumentQueryResult = Apollo.QueryResult<RenderDocumentQuery, RenderDocumentQueryVariables>;
export const RenderTestTemplateDocument = gql`
    query renderTestTemplate($template_name: TemplateType!, $template_code: String!, $organisation_ids: [String!], $user_ids: [String!], $client_ids: [String!], $case_ids: [String!], $mortgage_ids: [String!], $product_ids: [String!], $note_ids: [String!]) {
  renderedTestTemplate(
    template_name: $template_name
    template_code: $template_code
    organisation_ids: $organisation_ids
    user_ids: $user_ids
    client_ids: $client_ids
    case_ids: $case_ids
    mortgage_ids: $mortgage_ids
    product_ids: $product_ids
    note_ids: $note_ids
  ) {
    document_id
    internalHash
    data_base64
    file_type
    document_name
    template_type
  }
}
    `;

/**
 * __useRenderTestTemplateQuery__
 *
 * To run a query within a React component, call `useRenderTestTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useRenderTestTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRenderTestTemplateQuery({
 *   variables: {
 *      template_name: // value for 'template_name'
 *      template_code: // value for 'template_code'
 *      organisation_ids: // value for 'organisation_ids'
 *      user_ids: // value for 'user_ids'
 *      client_ids: // value for 'client_ids'
 *      case_ids: // value for 'case_ids'
 *      mortgage_ids: // value for 'mortgage_ids'
 *      product_ids: // value for 'product_ids'
 *      note_ids: // value for 'note_ids'
 *   },
 * });
 */
export function useRenderTestTemplateQuery(baseOptions: Apollo.QueryHookOptions<RenderTestTemplateQuery, RenderTestTemplateQueryVariables> & ({ variables: RenderTestTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>(RenderTestTemplateDocument, options);
      }
export function useRenderTestTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>(RenderTestTemplateDocument, options);
        }
// @ts-ignore
export function useRenderTestTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>;
export function useRenderTestTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<RenderTestTemplateQuery | undefined, RenderTestTemplateQueryVariables>;
export function useRenderTestTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>(RenderTestTemplateDocument, options);
        }
export type RenderTestTemplateQueryHookResult = ReturnType<typeof useRenderTestTemplateQuery>;
export type RenderTestTemplateLazyQueryHookResult = ReturnType<typeof useRenderTestTemplateLazyQuery>;
export type RenderTestTemplateSuspenseQueryHookResult = ReturnType<typeof useRenderTestTemplateSuspenseQuery>;
export type RenderTestTemplateQueryResult = Apollo.QueryResult<RenderTestTemplateQuery, RenderTestTemplateQueryVariables>;
export const ResolveLenderPanelDataDocument = gql`
    query resolveLenderPanelData {
  mortgageClubs {
    id
    name
    external_id
    metadata {
      name
      string_value
    }
  }
  lenderNames {
    id
    name
  }
}
    `;

/**
 * __useResolveLenderPanelDataQuery__
 *
 * To run a query within a React component, call `useResolveLenderPanelDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveLenderPanelDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveLenderPanelDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useResolveLenderPanelDataQuery(baseOptions?: Apollo.QueryHookOptions<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>(ResolveLenderPanelDataDocument, options);
      }
export function useResolveLenderPanelDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>(ResolveLenderPanelDataDocument, options);
        }
// @ts-ignore
export function useResolveLenderPanelDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>;
export function useResolveLenderPanelDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveLenderPanelDataQuery | undefined, ResolveLenderPanelDataQueryVariables>;
export function useResolveLenderPanelDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>(ResolveLenderPanelDataDocument, options);
        }
export type ResolveLenderPanelDataQueryHookResult = ReturnType<typeof useResolveLenderPanelDataQuery>;
export type ResolveLenderPanelDataLazyQueryHookResult = ReturnType<typeof useResolveLenderPanelDataLazyQuery>;
export type ResolveLenderPanelDataSuspenseQueryHookResult = ReturnType<typeof useResolveLenderPanelDataSuspenseQuery>;
export type ResolveLenderPanelDataQueryResult = Apollo.QueryResult<ResolveLenderPanelDataQuery, ResolveLenderPanelDataQueryVariables>;
export const ResolveNotificationDetailsDocument = gql`
    query resolveNotificationDetails($userIds: [ID!], $clientIds: [ID!], $caseIds: [ID!]) {
  clients(ids: $clientIds) {
    id
    version
    details {
      id
      first_name
      last_name
    }
  }
  cases(ids: $caseIds) {
    id
    version
    details {
      id
      preference_mortgage_reason
    }
  }
  users(ids: $userIds) {
    id
    first_name
    last_name
  }
}
    `;

/**
 * __useResolveNotificationDetailsQuery__
 *
 * To run a query within a React component, call `useResolveNotificationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveNotificationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveNotificationDetailsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      clientIds: // value for 'clientIds'
 *      caseIds: // value for 'caseIds'
 *   },
 * });
 */
export function useResolveNotificationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>(ResolveNotificationDetailsDocument, options);
      }
export function useResolveNotificationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>(ResolveNotificationDetailsDocument, options);
        }
// @ts-ignore
export function useResolveNotificationDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>;
export function useResolveNotificationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveNotificationDetailsQuery | undefined, ResolveNotificationDetailsQueryVariables>;
export function useResolveNotificationDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>(ResolveNotificationDetailsDocument, options);
        }
export type ResolveNotificationDetailsQueryHookResult = ReturnType<typeof useResolveNotificationDetailsQuery>;
export type ResolveNotificationDetailsLazyQueryHookResult = ReturnType<typeof useResolveNotificationDetailsLazyQuery>;
export type ResolveNotificationDetailsSuspenseQueryHookResult = ReturnType<typeof useResolveNotificationDetailsSuspenseQuery>;
export type ResolveNotificationDetailsQueryResult = Apollo.QueryResult<ResolveNotificationDetailsQuery, ResolveNotificationDetailsQueryVariables>;
export const RevenueReportDocument = gql`
    query revenueReport($body: ReportsRevenueInput!) {
  reportsRevenue(body: $body) {
    results {
      group_id
      value
      year_month
    }
    totals {
      by_group_id {
        id
        value
      }
      by_year_month {
        id
        value
      }
    }
  }
  getRevenueReport(body: $body) @client {
    revenues
  }
}
    `;

/**
 * __useRevenueReportQuery__
 *
 * To run a query within a React component, call `useRevenueReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevenueReportQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useRevenueReportQuery(baseOptions: Apollo.QueryHookOptions<RevenueReportQuery, RevenueReportQueryVariables> & ({ variables: RevenueReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevenueReportQuery, RevenueReportQueryVariables>(RevenueReportDocument, options);
      }
export function useRevenueReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevenueReportQuery, RevenueReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevenueReportQuery, RevenueReportQueryVariables>(RevenueReportDocument, options);
        }
// @ts-ignore
export function useRevenueReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RevenueReportQuery, RevenueReportQueryVariables>): Apollo.UseSuspenseQueryResult<RevenueReportQuery, RevenueReportQueryVariables>;
export function useRevenueReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RevenueReportQuery, RevenueReportQueryVariables>): Apollo.UseSuspenseQueryResult<RevenueReportQuery | undefined, RevenueReportQueryVariables>;
export function useRevenueReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RevenueReportQuery, RevenueReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RevenueReportQuery, RevenueReportQueryVariables>(RevenueReportDocument, options);
        }
export type RevenueReportQueryHookResult = ReturnType<typeof useRevenueReportQuery>;
export type RevenueReportLazyQueryHookResult = ReturnType<typeof useRevenueReportLazyQuery>;
export type RevenueReportSuspenseQueryHookResult = ReturnType<typeof useRevenueReportSuspenseQuery>;
export type RevenueReportQueryResult = Apollo.QueryResult<RevenueReportQuery, RevenueReportQueryVariables>;
export const RevenueTotalsDocument = gql`
    query revenueTotals($body: ReportsRevenueInput!) {
  getRevenueTotals(body: $body) @client {
    totals
  }
}
    `;

/**
 * __useRevenueTotalsQuery__
 *
 * To run a query within a React component, call `useRevenueTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRevenueTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRevenueTotalsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useRevenueTotalsQuery(baseOptions: Apollo.QueryHookOptions<RevenueTotalsQuery, RevenueTotalsQueryVariables> & ({ variables: RevenueTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RevenueTotalsQuery, RevenueTotalsQueryVariables>(RevenueTotalsDocument, options);
      }
export function useRevenueTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RevenueTotalsQuery, RevenueTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RevenueTotalsQuery, RevenueTotalsQueryVariables>(RevenueTotalsDocument, options);
        }
// @ts-ignore
export function useRevenueTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<RevenueTotalsQuery, RevenueTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<RevenueTotalsQuery, RevenueTotalsQueryVariables>;
export function useRevenueTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RevenueTotalsQuery, RevenueTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<RevenueTotalsQuery | undefined, RevenueTotalsQueryVariables>;
export function useRevenueTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RevenueTotalsQuery, RevenueTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RevenueTotalsQuery, RevenueTotalsQueryVariables>(RevenueTotalsDocument, options);
        }
export type RevenueTotalsQueryHookResult = ReturnType<typeof useRevenueTotalsQuery>;
export type RevenueTotalsLazyQueryHookResult = ReturnType<typeof useRevenueTotalsLazyQuery>;
export type RevenueTotalsSuspenseQueryHookResult = ReturnType<typeof useRevenueTotalsSuspenseQuery>;
export type RevenueTotalsQueryResult = Apollo.QueryResult<RevenueTotalsQuery, RevenueTotalsQueryVariables>;
export const SolicitorSearchDocument = gql`
    query solicitorSearch($q: ID!) {
  solicitorSearch(q: $q) {
    name
    address
    reference
  }
}
    `;

/**
 * __useSolicitorSearchQuery__
 *
 * To run a query within a React component, call `useSolicitorSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSolicitorSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSolicitorSearchQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useSolicitorSearchQuery(baseOptions: Apollo.QueryHookOptions<SolicitorSearchQuery, SolicitorSearchQueryVariables> & ({ variables: SolicitorSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SolicitorSearchQuery, SolicitorSearchQueryVariables>(SolicitorSearchDocument, options);
      }
export function useSolicitorSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SolicitorSearchQuery, SolicitorSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SolicitorSearchQuery, SolicitorSearchQueryVariables>(SolicitorSearchDocument, options);
        }
// @ts-ignore
export function useSolicitorSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SolicitorSearchQuery, SolicitorSearchQueryVariables>): Apollo.UseSuspenseQueryResult<SolicitorSearchQuery, SolicitorSearchQueryVariables>;
export function useSolicitorSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SolicitorSearchQuery, SolicitorSearchQueryVariables>): Apollo.UseSuspenseQueryResult<SolicitorSearchQuery | undefined, SolicitorSearchQueryVariables>;
export function useSolicitorSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SolicitorSearchQuery, SolicitorSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SolicitorSearchQuery, SolicitorSearchQueryVariables>(SolicitorSearchDocument, options);
        }
export type SolicitorSearchQueryHookResult = ReturnType<typeof useSolicitorSearchQuery>;
export type SolicitorSearchLazyQueryHookResult = ReturnType<typeof useSolicitorSearchLazyQuery>;
export type SolicitorSearchSuspenseQueryHookResult = ReturnType<typeof useSolicitorSearchSuspenseQuery>;
export type SolicitorSearchQueryResult = Apollo.QueryResult<SolicitorSearchQuery, SolicitorSearchQueryVariables>;
export const TagsDiscoveryDocument = gql`
    query tagsDiscovery {
  tagsDiscovery {
    id
    name
    description
  }
}
    `;

/**
 * __useTagsDiscoveryQuery__
 *
 * To run a query within a React component, call `useTagsDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsDiscoveryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsDiscoveryQuery(baseOptions?: Apollo.QueryHookOptions<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>(TagsDiscoveryDocument, options);
      }
export function useTagsDiscoveryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>(TagsDiscoveryDocument, options);
        }
// @ts-ignore
export function useTagsDiscoverySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>;
export function useTagsDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>): Apollo.UseSuspenseQueryResult<TagsDiscoveryQuery | undefined, TagsDiscoveryQueryVariables>;
export function useTagsDiscoverySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>(TagsDiscoveryDocument, options);
        }
export type TagsDiscoveryQueryHookResult = ReturnType<typeof useTagsDiscoveryQuery>;
export type TagsDiscoveryLazyQueryHookResult = ReturnType<typeof useTagsDiscoveryLazyQuery>;
export type TagsDiscoverySuspenseQueryHookResult = ReturnType<typeof useTagsDiscoverySuspenseQuery>;
export type TagsDiscoveryQueryResult = Apollo.QueryResult<TagsDiscoveryQuery, TagsDiscoveryQueryVariables>;
export const GetVulnerabilityTemplatesDocument = gql`
    query getVulnerabilityTemplates($provider: ID!) {
  vulnerabilityTemplates(provider: $provider) {
    templates {
      provider
      name
      id
    }
  }
}
    `;

/**
 * __useGetVulnerabilityTemplatesQuery__
 *
 * To run a query within a React component, call `useGetVulnerabilityTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVulnerabilityTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVulnerabilityTemplatesQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *   },
 * });
 */
export function useGetVulnerabilityTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables> & ({ variables: GetVulnerabilityTemplatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>(GetVulnerabilityTemplatesDocument, options);
      }
export function useGetVulnerabilityTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>(GetVulnerabilityTemplatesDocument, options);
        }
// @ts-ignore
export function useGetVulnerabilityTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>;
export function useGetVulnerabilityTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetVulnerabilityTemplatesQuery | undefined, GetVulnerabilityTemplatesQueryVariables>;
export function useGetVulnerabilityTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>(GetVulnerabilityTemplatesDocument, options);
        }
export type GetVulnerabilityTemplatesQueryHookResult = ReturnType<typeof useGetVulnerabilityTemplatesQuery>;
export type GetVulnerabilityTemplatesLazyQueryHookResult = ReturnType<typeof useGetVulnerabilityTemplatesLazyQuery>;
export type GetVulnerabilityTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetVulnerabilityTemplatesSuspenseQuery>;
export type GetVulnerabilityTemplatesQueryResult = Apollo.QueryResult<GetVulnerabilityTemplatesQuery, GetVulnerabilityTemplatesQueryVariables>;
export const VulnerabilityReportDocument = gql`
    query vulnerabilityReport($client: ID!, $assessment: ID!) {
  vulnerabilityReport(client: $client, assessment_uuid: $assessment) {
    assessment_id
    external_url
    generated_at
    raw_categories
    raw_vulnerabilities
    report_detail {
      indications
      linked_vulnerability {
        ...vulnerability
      }
      risk_factor
    }
    report_id
    template_id
    title
    vulnerabilities {
      ...vulnerability
    }
  }
}
    ${VulnerabilityFragmentDoc}`;

/**
 * __useVulnerabilityReportQuery__
 *
 * To run a query within a React component, call `useVulnerabilityReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useVulnerabilityReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVulnerabilityReportQuery({
 *   variables: {
 *      client: // value for 'client'
 *      assessment: // value for 'assessment'
 *   },
 * });
 */
export function useVulnerabilityReportQuery(baseOptions: Apollo.QueryHookOptions<VulnerabilityReportQuery, VulnerabilityReportQueryVariables> & ({ variables: VulnerabilityReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>(VulnerabilityReportDocument, options);
      }
export function useVulnerabilityReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>(VulnerabilityReportDocument, options);
        }
// @ts-ignore
export function useVulnerabilityReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>): Apollo.UseSuspenseQueryResult<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>;
export function useVulnerabilityReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>): Apollo.UseSuspenseQueryResult<VulnerabilityReportQuery | undefined, VulnerabilityReportQueryVariables>;
export function useVulnerabilityReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>(VulnerabilityReportDocument, options);
        }
export type VulnerabilityReportQueryHookResult = ReturnType<typeof useVulnerabilityReportQuery>;
export type VulnerabilityReportLazyQueryHookResult = ReturnType<typeof useVulnerabilityReportLazyQuery>;
export type VulnerabilityReportSuspenseQueryHookResult = ReturnType<typeof useVulnerabilityReportSuspenseQuery>;
export type VulnerabilityReportQueryResult = Apollo.QueryResult<VulnerabilityReportQuery, VulnerabilityReportQueryVariables>;
export const CreateVulnerabilityAssessmentsDocument = gql`
    mutation createVulnerabilityAssessments($caseID: ID!) {
  createVulnerabilityAssessments(caseID: $caseID) {
    message
    error
    statusCode
  }
}
    `;
export type CreateVulnerabilityAssessmentsMutationFn = Apollo.MutationFunction<CreateVulnerabilityAssessmentsMutation, CreateVulnerabilityAssessmentsMutationVariables>;

/**
 * __useCreateVulnerabilityAssessmentsMutation__
 *
 * To run a mutation, you first call `useCreateVulnerabilityAssessmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVulnerabilityAssessmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVulnerabilityAssessmentsMutation, { data, loading, error }] = useCreateVulnerabilityAssessmentsMutation({
 *   variables: {
 *      caseID: // value for 'caseID'
 *   },
 * });
 */
export function useCreateVulnerabilityAssessmentsMutation(baseOptions?: Apollo.MutationHookOptions<CreateVulnerabilityAssessmentsMutation, CreateVulnerabilityAssessmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVulnerabilityAssessmentsMutation, CreateVulnerabilityAssessmentsMutationVariables>(CreateVulnerabilityAssessmentsDocument, options);
      }
export type CreateVulnerabilityAssessmentsMutationHookResult = ReturnType<typeof useCreateVulnerabilityAssessmentsMutation>;
export type CreateVulnerabilityAssessmentsMutationResult = Apollo.MutationResult<CreateVulnerabilityAssessmentsMutation>;
export type CreateVulnerabilityAssessmentsMutationOptions = Apollo.BaseMutationOptions<CreateVulnerabilityAssessmentsMutation, CreateVulnerabilityAssessmentsMutationVariables>;
export const AddCasePropertyCpDocument = gql`
    mutation addCasePropertyCp($input: PropertyInput!, $caseId: ID!, $propertyType: String!, $includeMortgageProduct: Boolean = false) {
  addCasePropertyCp(input: $input, caseId: $caseId, propertyType: $propertyType) {
    id
    created_at
    version
    version_created_at
    details {
      id
      owner_user_id
      status
      preference_mortgage_reason
      preference_related_property_sale
      preference_target_property
      new_property_cp {
        id
        property_id
        details {
          ...PropertyDetailsCp
        }
      }
      remortgage_property_cp {
        id
        property_id
        details {
          ...PropertyDetailsCp
        }
      }
      clientsUser {
        id
        details {
          ...ClientUserDetails
        }
      }
    }
  }
}
    ${PropertyDetailsCpFragmentDoc}
${ClientUserDetailsFragmentDoc}`;
export type AddCasePropertyCpMutationFn = Apollo.MutationFunction<AddCasePropertyCpMutation, AddCasePropertyCpMutationVariables>;

/**
 * __useAddCasePropertyCpMutation__
 *
 * To run a mutation, you first call `useAddCasePropertyCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCasePropertyCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCasePropertyCpMutation, { data, loading, error }] = useAddCasePropertyCpMutation({
 *   variables: {
 *      input: // value for 'input'
 *      caseId: // value for 'caseId'
 *      propertyType: // value for 'propertyType'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useAddCasePropertyCpMutation(baseOptions?: Apollo.MutationHookOptions<AddCasePropertyCpMutation, AddCasePropertyCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCasePropertyCpMutation, AddCasePropertyCpMutationVariables>(AddCasePropertyCpDocument, options);
      }
export type AddCasePropertyCpMutationHookResult = ReturnType<typeof useAddCasePropertyCpMutation>;
export type AddCasePropertyCpMutationResult = Apollo.MutationResult<AddCasePropertyCpMutation>;
export type AddCasePropertyCpMutationOptions = Apollo.BaseMutationOptions<AddCasePropertyCpMutation, AddCasePropertyCpMutationVariables>;
export const AddClientCpDocument = gql`
    mutation addClientCp($input: ClientInput!, $includeMortgageProduct: Boolean = false) {
  addClientCp(input: $input) {
    id
    version
    details {
      ...ClientUserDetails
    }
  }
}
    ${ClientUserDetailsFragmentDoc}`;
export type AddClientCpMutationFn = Apollo.MutationFunction<AddClientCpMutation, AddClientCpMutationVariables>;

/**
 * __useAddClientCpMutation__
 *
 * To run a mutation, you first call `useAddClientCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientCpMutation, { data, loading, error }] = useAddClientCpMutation({
 *   variables: {
 *      input: // value for 'input'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useAddClientCpMutation(baseOptions?: Apollo.MutationHookOptions<AddClientCpMutation, AddClientCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientCpMutation, AddClientCpMutationVariables>(AddClientCpDocument, options);
      }
export type AddClientCpMutationHookResult = ReturnType<typeof useAddClientCpMutation>;
export type AddClientCpMutationResult = Apollo.MutationResult<AddClientCpMutation>;
export type AddClientCpMutationOptions = Apollo.BaseMutationOptions<AddClientCpMutation, AddClientCpMutationVariables>;
export const AddDocumentRequirementDocument = gql`
    mutation addDocumentRequirement($input: DocumentRequirementInput!) {
  addDocumentRequirement(input: $input) {
    requirement_id
    created_at
    created_by
    modified_at
    disabled_at
    details {
      organisation_id
      name
      description
      status
      gi
      protection_types
      exclude_product_transfer
      exclude_no_contact_renewal
      exclude_renewal
      case_types
      document_types
      auto_satisfy {
        document_types
        count
        broker_verification_required
      }
      default_overdue
      per_client
      can_share_with_client
      required_from
      required_by
      apply_to_existing
    }
  }
}
    `;
export type AddDocumentRequirementMutationFn = Apollo.MutationFunction<AddDocumentRequirementMutation, AddDocumentRequirementMutationVariables>;

/**
 * __useAddDocumentRequirementMutation__
 *
 * To run a mutation, you first call `useAddDocumentRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDocumentRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDocumentRequirementMutation, { data, loading, error }] = useAddDocumentRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDocumentRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AddDocumentRequirementMutation, AddDocumentRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDocumentRequirementMutation, AddDocumentRequirementMutationVariables>(AddDocumentRequirementDocument, options);
      }
export type AddDocumentRequirementMutationHookResult = ReturnType<typeof useAddDocumentRequirementMutation>;
export type AddDocumentRequirementMutationResult = Apollo.MutationResult<AddDocumentRequirementMutation>;
export type AddDocumentRequirementMutationOptions = Apollo.BaseMutationOptions<AddDocumentRequirementMutation, AddDocumentRequirementMutationVariables>;
export const AddMortgageAndProductCpDocument = gql`
    mutation addMortgageAndProductCp($mortgageInput: MortgageInput!, $mortgageProductInput: MortgageProductActualInput!) {
  addMortgageAndProductCp(
    mortgageInput: $mortgageInput
    mortgageProductInput: $mortgageProductInput
  ) {
    id
    version
    term
    term_unit
    outstanding_balance
    monthly_payment
    property_secured_ids
    client_ids
    mortgage_productCp {
      id
      product_name
      lender_reference
      lender_name
      rate_tiers {
        rate
        rate_type
        period_fixed_length_months
        period_fixed_end_date
      }
    }
  }
}
    `;
export type AddMortgageAndProductCpMutationFn = Apollo.MutationFunction<AddMortgageAndProductCpMutation, AddMortgageAndProductCpMutationVariables>;

/**
 * __useAddMortgageAndProductCpMutation__
 *
 * To run a mutation, you first call `useAddMortgageAndProductCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMortgageAndProductCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMortgageAndProductCpMutation, { data, loading, error }] = useAddMortgageAndProductCpMutation({
 *   variables: {
 *      mortgageInput: // value for 'mortgageInput'
 *      mortgageProductInput: // value for 'mortgageProductInput'
 *   },
 * });
 */
export function useAddMortgageAndProductCpMutation(baseOptions?: Apollo.MutationHookOptions<AddMortgageAndProductCpMutation, AddMortgageAndProductCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMortgageAndProductCpMutation, AddMortgageAndProductCpMutationVariables>(AddMortgageAndProductCpDocument, options);
      }
export type AddMortgageAndProductCpMutationHookResult = ReturnType<typeof useAddMortgageAndProductCpMutation>;
export type AddMortgageAndProductCpMutationResult = Apollo.MutationResult<AddMortgageAndProductCpMutation>;
export type AddMortgageAndProductCpMutationOptions = Apollo.BaseMutationOptions<AddMortgageAndProductCpMutation, AddMortgageAndProductCpMutationVariables>;
export const AddPropertyCpDocument = gql`
    mutation addPropertyCp($input: PropertyInput!, $caseId: ID, $reasons: [String!], $propertyType: String, $includeMortgageProduct: Boolean = false) {
  addPropertyCp(
    input: $input
    caseId: $caseId
    reasons: $reasons
    propertyType: $propertyType
  ) {
    id
    property_id
    details {
      ...PropertyDetailsCp
    }
  }
}
    ${PropertyDetailsCpFragmentDoc}`;
export type AddPropertyCpMutationFn = Apollo.MutationFunction<AddPropertyCpMutation, AddPropertyCpMutationVariables>;

/**
 * __useAddPropertyCpMutation__
 *
 * To run a mutation, you first call `useAddPropertyCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPropertyCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPropertyCpMutation, { data, loading, error }] = useAddPropertyCpMutation({
 *   variables: {
 *      input: // value for 'input'
 *      caseId: // value for 'caseId'
 *      reasons: // value for 'reasons'
 *      propertyType: // value for 'propertyType'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useAddPropertyCpMutation(baseOptions?: Apollo.MutationHookOptions<AddPropertyCpMutation, AddPropertyCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPropertyCpMutation, AddPropertyCpMutationVariables>(AddPropertyCpDocument, options);
      }
export type AddPropertyCpMutationHookResult = ReturnType<typeof useAddPropertyCpMutation>;
export type AddPropertyCpMutationResult = Apollo.MutationResult<AddPropertyCpMutation>;
export type AddPropertyCpMutationOptions = Apollo.BaseMutationOptions<AddPropertyCpMutation, AddPropertyCpMutationVariables>;
export const ClientAnswerVulnerabilityQuestionDocument = gql`
    mutation clientAnswerVulnerabilityQuestion($answer: ClientVulnerabilityAnswerInput!) {
  clientAnswerVulnerabilityQuestion(answer: $answer) {
    assessment_uuid
    progress
    question {
      ...Question
    }
  }
}
    ${QuestionFragmentDoc}`;
export type ClientAnswerVulnerabilityQuestionMutationFn = Apollo.MutationFunction<ClientAnswerVulnerabilityQuestionMutation, ClientAnswerVulnerabilityQuestionMutationVariables>;

/**
 * __useClientAnswerVulnerabilityQuestionMutation__
 *
 * To run a mutation, you first call `useClientAnswerVulnerabilityQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientAnswerVulnerabilityQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientAnswerVulnerabilityQuestionMutation, { data, loading, error }] = useClientAnswerVulnerabilityQuestionMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useClientAnswerVulnerabilityQuestionMutation(baseOptions?: Apollo.MutationHookOptions<ClientAnswerVulnerabilityQuestionMutation, ClientAnswerVulnerabilityQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientAnswerVulnerabilityQuestionMutation, ClientAnswerVulnerabilityQuestionMutationVariables>(ClientAnswerVulnerabilityQuestionDocument, options);
      }
export type ClientAnswerVulnerabilityQuestionMutationHookResult = ReturnType<typeof useClientAnswerVulnerabilityQuestionMutation>;
export type ClientAnswerVulnerabilityQuestionMutationResult = Apollo.MutationResult<ClientAnswerVulnerabilityQuestionMutation>;
export type ClientAnswerVulnerabilityQuestionMutationOptions = Apollo.BaseMutationOptions<ClientAnswerVulnerabilityQuestionMutation, ClientAnswerVulnerabilityQuestionMutationVariables>;
export const CreateGoCardlessMandateDocument = gql`
    mutation createGoCardlessMandate {
  createMandate {
    status
    url
  }
}
    `;
export type CreateGoCardlessMandateMutationFn = Apollo.MutationFunction<CreateGoCardlessMandateMutation, CreateGoCardlessMandateMutationVariables>;

/**
 * __useCreateGoCardlessMandateMutation__
 *
 * To run a mutation, you first call `useCreateGoCardlessMandateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoCardlessMandateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoCardlessMandateMutation, { data, loading, error }] = useCreateGoCardlessMandateMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateGoCardlessMandateMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoCardlessMandateMutation, CreateGoCardlessMandateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoCardlessMandateMutation, CreateGoCardlessMandateMutationVariables>(CreateGoCardlessMandateDocument, options);
      }
export type CreateGoCardlessMandateMutationHookResult = ReturnType<typeof useCreateGoCardlessMandateMutation>;
export type CreateGoCardlessMandateMutationResult = Apollo.MutationResult<CreateGoCardlessMandateMutation>;
export type CreateGoCardlessMandateMutationOptions = Apollo.BaseMutationOptions<CreateGoCardlessMandateMutation, CreateGoCardlessMandateMutationVariables>;
export const CreateLeadCaseReferralDocument = gql`
    mutation createLeadCaseReferral($case_id: ID!, $client_ids: [ID!]!, $preference_mortgage_reason: String!, $target_user_id: ID!, $client_generated_lead: Boolean!) {
  createLeadCaseReferral(
    case_id: $case_id
    client_ids: $client_ids
    preference_mortgage_reason: $preference_mortgage_reason
    target_user_id: $target_user_id
    client_generated_lead: $client_generated_lead
  ) {
    case {
      case_id
    }
  }
}
    `;
export type CreateLeadCaseReferralMutationFn = Apollo.MutationFunction<CreateLeadCaseReferralMutation, CreateLeadCaseReferralMutationVariables>;

/**
 * __useCreateLeadCaseReferralMutation__
 *
 * To run a mutation, you first call `useCreateLeadCaseReferralMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadCaseReferralMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadCaseReferralMutation, { data, loading, error }] = useCreateLeadCaseReferralMutation({
 *   variables: {
 *      case_id: // value for 'case_id'
 *      client_ids: // value for 'client_ids'
 *      preference_mortgage_reason: // value for 'preference_mortgage_reason'
 *      target_user_id: // value for 'target_user_id'
 *      client_generated_lead: // value for 'client_generated_lead'
 *   },
 * });
 */
export function useCreateLeadCaseReferralMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadCaseReferralMutation, CreateLeadCaseReferralMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadCaseReferralMutation, CreateLeadCaseReferralMutationVariables>(CreateLeadCaseReferralDocument, options);
      }
export type CreateLeadCaseReferralMutationHookResult = ReturnType<typeof useCreateLeadCaseReferralMutation>;
export type CreateLeadCaseReferralMutationResult = Apollo.MutationResult<CreateLeadCaseReferralMutation>;
export type CreateLeadCaseReferralMutationOptions = Apollo.BaseMutationOptions<CreateLeadCaseReferralMutation, CreateLeadCaseReferralMutationVariables>;
export const CreateSchedulerEventDocument = gql`
    mutation createSchedulerEvent($start_time: Int!, $key: String!) {
  createSchedulerEvent(start_time: $start_time, key: $key) {
    end_time
    event_id
    start_time
    title
  }
}
    `;
export type CreateSchedulerEventMutationFn = Apollo.MutationFunction<CreateSchedulerEventMutation, CreateSchedulerEventMutationVariables>;

/**
 * __useCreateSchedulerEventMutation__
 *
 * To run a mutation, you first call `useCreateSchedulerEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchedulerEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchedulerEventMutation, { data, loading, error }] = useCreateSchedulerEventMutation({
 *   variables: {
 *      start_time: // value for 'start_time'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useCreateSchedulerEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchedulerEventMutation, CreateSchedulerEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchedulerEventMutation, CreateSchedulerEventMutationVariables>(CreateSchedulerEventDocument, options);
      }
export type CreateSchedulerEventMutationHookResult = ReturnType<typeof useCreateSchedulerEventMutation>;
export type CreateSchedulerEventMutationResult = Apollo.MutationResult<CreateSchedulerEventMutation>;
export type CreateSchedulerEventMutationOptions = Apollo.BaseMutationOptions<CreateSchedulerEventMutation, CreateSchedulerEventMutationVariables>;
export const CreateSchedulerEventDirectDocument = gql`
    mutation createSchedulerEventDirect($start_time: Int!, $caseId: String!, $title: String) {
  createSchedulerEventDirect(
    start_time: $start_time
    caseId: $caseId
    title: $title
  ) {
    end_time
    event_id
    start_time
    title
  }
}
    `;
export type CreateSchedulerEventDirectMutationFn = Apollo.MutationFunction<CreateSchedulerEventDirectMutation, CreateSchedulerEventDirectMutationVariables>;

/**
 * __useCreateSchedulerEventDirectMutation__
 *
 * To run a mutation, you first call `useCreateSchedulerEventDirectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSchedulerEventDirectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSchedulerEventDirectMutation, { data, loading, error }] = useCreateSchedulerEventDirectMutation({
 *   variables: {
 *      start_time: // value for 'start_time'
 *      caseId: // value for 'caseId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateSchedulerEventDirectMutation(baseOptions?: Apollo.MutationHookOptions<CreateSchedulerEventDirectMutation, CreateSchedulerEventDirectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSchedulerEventDirectMutation, CreateSchedulerEventDirectMutationVariables>(CreateSchedulerEventDirectDocument, options);
      }
export type CreateSchedulerEventDirectMutationHookResult = ReturnType<typeof useCreateSchedulerEventDirectMutation>;
export type CreateSchedulerEventDirectMutationResult = Apollo.MutationResult<CreateSchedulerEventDirectMutation>;
export type CreateSchedulerEventDirectMutationOptions = Apollo.BaseMutationOptions<CreateSchedulerEventDirectMutation, CreateSchedulerEventDirectMutationVariables>;
export const DeleteCasePropertyCpDocument = gql`
    mutation deleteCasePropertyCp($caseId: ID!, $reasons: [String!]!, $propertyId: ID!, $propertyType: String!, $deleteFromClient: Boolean!) {
  deleteCasePropertyCp(
    caseId: $caseId
    reasons: $reasons
    propertyId: $propertyId
    propertyType: $propertyType
    deleteFromClient: $deleteFromClient
  ) {
    id
  }
}
    `;
export type DeleteCasePropertyCpMutationFn = Apollo.MutationFunction<DeleteCasePropertyCpMutation, DeleteCasePropertyCpMutationVariables>;

/**
 * __useDeleteCasePropertyCpMutation__
 *
 * To run a mutation, you first call `useDeleteCasePropertyCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCasePropertyCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCasePropertyCpMutation, { data, loading, error }] = useDeleteCasePropertyCpMutation({
 *   variables: {
 *      caseId: // value for 'caseId'
 *      reasons: // value for 'reasons'
 *      propertyId: // value for 'propertyId'
 *      propertyType: // value for 'propertyType'
 *      deleteFromClient: // value for 'deleteFromClient'
 *   },
 * });
 */
export function useDeleteCasePropertyCpMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCasePropertyCpMutation, DeleteCasePropertyCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCasePropertyCpMutation, DeleteCasePropertyCpMutationVariables>(DeleteCasePropertyCpDocument, options);
      }
export type DeleteCasePropertyCpMutationHookResult = ReturnType<typeof useDeleteCasePropertyCpMutation>;
export type DeleteCasePropertyCpMutationResult = Apollo.MutationResult<DeleteCasePropertyCpMutation>;
export type DeleteCasePropertyCpMutationOptions = Apollo.BaseMutationOptions<DeleteCasePropertyCpMutation, DeleteCasePropertyCpMutationVariables>;
export const FetchOnfidoTokenDocument = gql`
    mutation fetchOnfidoToken($id: ID) {
  onfidoToken(id: $id)
}
    `;
export type FetchOnfidoTokenMutationFn = Apollo.MutationFunction<FetchOnfidoTokenMutation, FetchOnfidoTokenMutationVariables>;

/**
 * __useFetchOnfidoTokenMutation__
 *
 * To run a mutation, you first call `useFetchOnfidoTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchOnfidoTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchOnfidoTokenMutation, { data, loading, error }] = useFetchOnfidoTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFetchOnfidoTokenMutation(baseOptions?: Apollo.MutationHookOptions<FetchOnfidoTokenMutation, FetchOnfidoTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchOnfidoTokenMutation, FetchOnfidoTokenMutationVariables>(FetchOnfidoTokenDocument, options);
      }
export type FetchOnfidoTokenMutationHookResult = ReturnType<typeof useFetchOnfidoTokenMutation>;
export type FetchOnfidoTokenMutationResult = Apollo.MutationResult<FetchOnfidoTokenMutation>;
export type FetchOnfidoTokenMutationOptions = Apollo.BaseMutationOptions<FetchOnfidoTokenMutation, FetchOnfidoTokenMutationVariables>;
export const LoginKratosPasskeyDocument = gql`
    mutation loginKratosPasskey($flow_id: ID!, $csrf_token: String!, $passkey_login: String!) {
  loginKratosPasskey(
    flow_id: $flow_id
    csrf_token: $csrf_token
    passkey_login: $passkey_login
  ) {
    email
  }
}
    `;
export type LoginKratosPasskeyMutationFn = Apollo.MutationFunction<LoginKratosPasskeyMutation, LoginKratosPasskeyMutationVariables>;

/**
 * __useLoginKratosPasskeyMutation__
 *
 * To run a mutation, you first call `useLoginKratosPasskeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginKratosPasskeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginKratosPasskeyMutation, { data, loading, error }] = useLoginKratosPasskeyMutation({
 *   variables: {
 *      flow_id: // value for 'flow_id'
 *      csrf_token: // value for 'csrf_token'
 *      passkey_login: // value for 'passkey_login'
 *   },
 * });
 */
export function useLoginKratosPasskeyMutation(baseOptions?: Apollo.MutationHookOptions<LoginKratosPasskeyMutation, LoginKratosPasskeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginKratosPasskeyMutation, LoginKratosPasskeyMutationVariables>(LoginKratosPasskeyDocument, options);
      }
export type LoginKratosPasskeyMutationHookResult = ReturnType<typeof useLoginKratosPasskeyMutation>;
export type LoginKratosPasskeyMutationResult = Apollo.MutationResult<LoginKratosPasskeyMutation>;
export type LoginKratosPasskeyMutationOptions = Apollo.BaseMutationOptions<LoginKratosPasskeyMutation, LoginKratosPasskeyMutationVariables>;
export const PostAuthMagicLinkDocument = gql`
    mutation postAuthMagicLink($email: String!) {
  authenticationClientUser(email: $email) {
    hasError
  }
}
    `;
export type PostAuthMagicLinkMutationFn = Apollo.MutationFunction<PostAuthMagicLinkMutation, PostAuthMagicLinkMutationVariables>;

/**
 * __usePostAuthMagicLinkMutation__
 *
 * To run a mutation, you first call `usePostAuthMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostAuthMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postAuthMagicLinkMutation, { data, loading, error }] = usePostAuthMagicLinkMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function usePostAuthMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<PostAuthMagicLinkMutation, PostAuthMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostAuthMagicLinkMutation, PostAuthMagicLinkMutationVariables>(PostAuthMagicLinkDocument, options);
      }
export type PostAuthMagicLinkMutationHookResult = ReturnType<typeof usePostAuthMagicLinkMutation>;
export type PostAuthMagicLinkMutationResult = Apollo.MutationResult<PostAuthMagicLinkMutation>;
export type PostAuthMagicLinkMutationOptions = Apollo.BaseMutationOptions<PostAuthMagicLinkMutation, PostAuthMagicLinkMutationVariables>;
export const PostCreditCheckCallbackDocument = gql`
    mutation postCreditCheckCallback($id: ID) {
  creditCheckCallback(id: $id)
}
    `;
export type PostCreditCheckCallbackMutationFn = Apollo.MutationFunction<PostCreditCheckCallbackMutation, PostCreditCheckCallbackMutationVariables>;

/**
 * __usePostCreditCheckCallbackMutation__
 *
 * To run a mutation, you first call `usePostCreditCheckCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostCreditCheckCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postCreditCheckCallbackMutation, { data, loading, error }] = usePostCreditCheckCallbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostCreditCheckCallbackMutation(baseOptions?: Apollo.MutationHookOptions<PostCreditCheckCallbackMutation, PostCreditCheckCallbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostCreditCheckCallbackMutation, PostCreditCheckCallbackMutationVariables>(PostCreditCheckCallbackDocument, options);
      }
export type PostCreditCheckCallbackMutationHookResult = ReturnType<typeof usePostCreditCheckCallbackMutation>;
export type PostCreditCheckCallbackMutationResult = Apollo.MutationResult<PostCreditCheckCallbackMutation>;
export type PostCreditCheckCallbackMutationOptions = Apollo.BaseMutationOptions<PostCreditCheckCallbackMutation, PostCreditCheckCallbackMutationVariables>;
export const PostMagicLinkCookieDocument = gql`
    mutation postMagicLinkCookie($token: String!, $clientId: String) {
  magicLinkCookie(token: $token, clientId: $clientId) {
    hasError
    loginOptions {
      client_id
      first_name
      last_name
      organisation_name
    }
  }
}
    `;
export type PostMagicLinkCookieMutationFn = Apollo.MutationFunction<PostMagicLinkCookieMutation, PostMagicLinkCookieMutationVariables>;

/**
 * __usePostMagicLinkCookieMutation__
 *
 * To run a mutation, you first call `usePostMagicLinkCookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostMagicLinkCookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postMagicLinkCookieMutation, { data, loading, error }] = usePostMagicLinkCookieMutation({
 *   variables: {
 *      token: // value for 'token'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function usePostMagicLinkCookieMutation(baseOptions?: Apollo.MutationHookOptions<PostMagicLinkCookieMutation, PostMagicLinkCookieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostMagicLinkCookieMutation, PostMagicLinkCookieMutationVariables>(PostMagicLinkCookieDocument, options);
      }
export type PostMagicLinkCookieMutationHookResult = ReturnType<typeof usePostMagicLinkCookieMutation>;
export type PostMagicLinkCookieMutationResult = Apollo.MutationResult<PostMagicLinkCookieMutation>;
export type PostMagicLinkCookieMutationOptions = Apollo.BaseMutationOptions<PostMagicLinkCookieMutation, PostMagicLinkCookieMutationVariables>;
export const PostOnfidoCallbackDocument = gql`
    mutation postOnfidoCallback($input: OnfidoCallbackInput!) {
  onfidoCallback(input: $input)
}
    `;
export type PostOnfidoCallbackMutationFn = Apollo.MutationFunction<PostOnfidoCallbackMutation, PostOnfidoCallbackMutationVariables>;

/**
 * __usePostOnfidoCallbackMutation__
 *
 * To run a mutation, you first call `usePostOnfidoCallbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostOnfidoCallbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postOnfidoCallbackMutation, { data, loading, error }] = usePostOnfidoCallbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostOnfidoCallbackMutation(baseOptions?: Apollo.MutationHookOptions<PostOnfidoCallbackMutation, PostOnfidoCallbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostOnfidoCallbackMutation, PostOnfidoCallbackMutationVariables>(PostOnfidoCallbackDocument, options);
      }
export type PostOnfidoCallbackMutationHookResult = ReturnType<typeof usePostOnfidoCallbackMutation>;
export type PostOnfidoCallbackMutationResult = Apollo.MutationResult<PostOnfidoCallbackMutation>;
export type PostOnfidoCallbackMutationOptions = Apollo.BaseMutationOptions<PostOnfidoCallbackMutation, PostOnfidoCallbackMutationVariables>;
export const RegisterKratosPasskeyDocument = gql`
    mutation registerKratosPasskey($flow_id: ID!, $csrf_token: String!, $passkey_settings_register: String!) {
  registerKratosPasskey(
    flow_id: $flow_id
    csrf_token: $csrf_token
    passkey_settings_register: $passkey_settings_register
  )
}
    `;
export type RegisterKratosPasskeyMutationFn = Apollo.MutationFunction<RegisterKratosPasskeyMutation, RegisterKratosPasskeyMutationVariables>;

/**
 * __useRegisterKratosPasskeyMutation__
 *
 * To run a mutation, you first call `useRegisterKratosPasskeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterKratosPasskeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerKratosPasskeyMutation, { data, loading, error }] = useRegisterKratosPasskeyMutation({
 *   variables: {
 *      flow_id: // value for 'flow_id'
 *      csrf_token: // value for 'csrf_token'
 *      passkey_settings_register: // value for 'passkey_settings_register'
 *   },
 * });
 */
export function useRegisterKratosPasskeyMutation(baseOptions?: Apollo.MutationHookOptions<RegisterKratosPasskeyMutation, RegisterKratosPasskeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterKratosPasskeyMutation, RegisterKratosPasskeyMutationVariables>(RegisterKratosPasskeyDocument, options);
      }
export type RegisterKratosPasskeyMutationHookResult = ReturnType<typeof useRegisterKratosPasskeyMutation>;
export type RegisterKratosPasskeyMutationResult = Apollo.MutationResult<RegisterKratosPasskeyMutation>;
export type RegisterKratosPasskeyMutationOptions = Apollo.BaseMutationOptions<RegisterKratosPasskeyMutation, RegisterKratosPasskeyMutationVariables>;
export const RemoveKratosPasskeyDocument = gql`
    mutation removeKratosPasskey($flow_id: ID!, $csrf_token: String!, $passkey_remove: String!) {
  removeKratosPasskey(
    flow_id: $flow_id
    csrf_token: $csrf_token
    passkey_remove: $passkey_remove
  )
}
    `;
export type RemoveKratosPasskeyMutationFn = Apollo.MutationFunction<RemoveKratosPasskeyMutation, RemoveKratosPasskeyMutationVariables>;

/**
 * __useRemoveKratosPasskeyMutation__
 *
 * To run a mutation, you first call `useRemoveKratosPasskeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveKratosPasskeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeKratosPasskeyMutation, { data, loading, error }] = useRemoveKratosPasskeyMutation({
 *   variables: {
 *      flow_id: // value for 'flow_id'
 *      csrf_token: // value for 'csrf_token'
 *      passkey_remove: // value for 'passkey_remove'
 *   },
 * });
 */
export function useRemoveKratosPasskeyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveKratosPasskeyMutation, RemoveKratosPasskeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveKratosPasskeyMutation, RemoveKratosPasskeyMutationVariables>(RemoveKratosPasskeyDocument, options);
      }
export type RemoveKratosPasskeyMutationHookResult = ReturnType<typeof useRemoveKratosPasskeyMutation>;
export type RemoveKratosPasskeyMutationResult = Apollo.MutationResult<RemoveKratosPasskeyMutation>;
export type RemoveKratosPasskeyMutationOptions = Apollo.BaseMutationOptions<RemoveKratosPasskeyMutation, RemoveKratosPasskeyMutationVariables>;
export const RenderAndStoreClientUserDocumentDocument = gql`
    mutation renderAndStoreClientUserDocument($input: RenderAndStoreDocumentInput!) {
  renderAndStoreClientUserDocument(input: $input) {
    document_id
    data_base64
    document_signature
    document_name
    source
    type
    file_type
    template_type
    other_type
    uploaded_by
    owning_client_ids
    rendered_case_ids
  }
}
    `;
export type RenderAndStoreClientUserDocumentMutationFn = Apollo.MutationFunction<RenderAndStoreClientUserDocumentMutation, RenderAndStoreClientUserDocumentMutationVariables>;

/**
 * __useRenderAndStoreClientUserDocumentMutation__
 *
 * To run a mutation, you first call `useRenderAndStoreClientUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenderAndStoreClientUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renderAndStoreClientUserDocumentMutation, { data, loading, error }] = useRenderAndStoreClientUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenderAndStoreClientUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RenderAndStoreClientUserDocumentMutation, RenderAndStoreClientUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenderAndStoreClientUserDocumentMutation, RenderAndStoreClientUserDocumentMutationVariables>(RenderAndStoreClientUserDocumentDocument, options);
      }
export type RenderAndStoreClientUserDocumentMutationHookResult = ReturnType<typeof useRenderAndStoreClientUserDocumentMutation>;
export type RenderAndStoreClientUserDocumentMutationResult = Apollo.MutationResult<RenderAndStoreClientUserDocumentMutation>;
export type RenderAndStoreClientUserDocumentMutationOptions = Apollo.BaseMutationOptions<RenderAndStoreClientUserDocumentMutation, RenderAndStoreClientUserDocumentMutationVariables>;
export const SubscribeWebPushDocument = gql`
    mutation subscribeWebPush($input: WebPushSubscriptionInput!) {
  subscribeWebPush(input: $input) {
    id
    client_id
    endpoint
    keys {
      p256dh
      auth
    }
    status
    user_agent
    created
    updated
  }
}
    `;
export type SubscribeWebPushMutationFn = Apollo.MutationFunction<SubscribeWebPushMutation, SubscribeWebPushMutationVariables>;

/**
 * __useSubscribeWebPushMutation__
 *
 * To run a mutation, you first call `useSubscribeWebPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeWebPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeWebPushMutation, { data, loading, error }] = useSubscribeWebPushMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubscribeWebPushMutation(baseOptions?: Apollo.MutationHookOptions<SubscribeWebPushMutation, SubscribeWebPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubscribeWebPushMutation, SubscribeWebPushMutationVariables>(SubscribeWebPushDocument, options);
      }
export type SubscribeWebPushMutationHookResult = ReturnType<typeof useSubscribeWebPushMutation>;
export type SubscribeWebPushMutationResult = Apollo.MutationResult<SubscribeWebPushMutation>;
export type SubscribeWebPushMutationOptions = Apollo.BaseMutationOptions<SubscribeWebPushMutation, SubscribeWebPushMutationVariables>;
export const UnsubscribeWebPushDocument = gql`
    mutation unsubscribeWebPush($id: String!) {
  unsubscribeWebPush(id: $id)
}
    `;
export type UnsubscribeWebPushMutationFn = Apollo.MutationFunction<UnsubscribeWebPushMutation, UnsubscribeWebPushMutationVariables>;

/**
 * __useUnsubscribeWebPushMutation__
 *
 * To run a mutation, you first call `useUnsubscribeWebPushMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeWebPushMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeWebPushMutation, { data, loading, error }] = useUnsubscribeWebPushMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnsubscribeWebPushMutation(baseOptions?: Apollo.MutationHookOptions<UnsubscribeWebPushMutation, UnsubscribeWebPushMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsubscribeWebPushMutation, UnsubscribeWebPushMutationVariables>(UnsubscribeWebPushDocument, options);
      }
export type UnsubscribeWebPushMutationHookResult = ReturnType<typeof useUnsubscribeWebPushMutation>;
export type UnsubscribeWebPushMutationResult = Apollo.MutationResult<UnsubscribeWebPushMutation>;
export type UnsubscribeWebPushMutationOptions = Apollo.BaseMutationOptions<UnsubscribeWebPushMutation, UnsubscribeWebPushMutationVariables>;
export const UpdateCaseCpDocument = gql`
    mutation updateCaseCp($id: ID!, $input: CaseInput!, $includeMortgageProduct: Boolean = false) {
  updateCaseCp(id: $id, input: $input) {
    id
    created_at
    version
    version_created_at
    details {
      id
      owner_user_id
      status
      regulated_by
      has_previously_owned_property
      has_seen_face_to_face
      impersonation_check_performed
      impersonation_check_details
      is_debt_consolidation
      btl_has_lived
      btl_will_lived
      btl_is_operating_a_business
      btl_through_company
      client_ids
      is_introduced
      introducer_id
      introducer_details
      lender_has_proposed_new_product
      reason_for_further_advance
      shared_budget
      preference_mortgage_reason
      preference_loan_amount
      preference_target_property_value
      preference_term
      preference_fixed_rate
      preference_initial_period_months
      preference_repayment_percentage
      preference_early_year_discount
      preference_tracker
      additional_loan_required
      calculated_values {
        total_required_loan_amount
        total_additional_borrowing
        current_totals {
          total_outstanding_balances
        }
      }
      transition_mortgage_versions {
        entity_versions {
          mortgage_id
          version
        }
        transition_to
        created_at
      }
      additional_loans {
        loan_amount
        loan_purpose
      }
      clientsUser {
        id
        details {
          ...ClientUserDetails
        }
      }
      protection {
        has_client_accepted_protection_advice
        has_client_accepted_protection_needs
        client_declined_protection_needs_reason
        requirements {
          life_and_critical_illness {
            id
          }
          family_income_benefits {
            id
          }
          income_protection {
            id
          }
          whole_of_life {
            id
          }
          private_medical_insurance {
            id
          }
        }
      }
      additional_metadata {
        name
        string_value
      }
      survey_answers {
        client_id
        answers {
          question_id
          question_version
          five_scale_answer
          ten_scale_answer
          zero_ten_scale_answer
          free_text_answer
          bool_answer
          single_choice_answer
          multiple_choice_answer
        }
      }
    }
  }
}
    ${ClientUserDetailsFragmentDoc}`;
export type UpdateCaseCpMutationFn = Apollo.MutationFunction<UpdateCaseCpMutation, UpdateCaseCpMutationVariables>;

/**
 * __useUpdateCaseCpMutation__
 *
 * To run a mutation, you first call `useUpdateCaseCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseCpMutation, { data, loading, error }] = useUpdateCaseCpMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useUpdateCaseCpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseCpMutation, UpdateCaseCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseCpMutation, UpdateCaseCpMutationVariables>(UpdateCaseCpDocument, options);
      }
export type UpdateCaseCpMutationHookResult = ReturnType<typeof useUpdateCaseCpMutation>;
export type UpdateCaseCpMutationResult = Apollo.MutationResult<UpdateCaseCpMutation>;
export type UpdateCaseCpMutationOptions = Apollo.BaseMutationOptions<UpdateCaseCpMutation, UpdateCaseCpMutationVariables>;
export const UpdateCaseCpSurveyDocument = gql`
    mutation updateCaseCpSurvey($id: ID!, $input: AnswerInput!) {
  updateCaseCpSurvey(id: $id, input: $input) {
    answers {
      question_id
      question_version
      five_scale_answer
      ten_scale_answer
      zero_ten_scale_answer
      free_text_answer
      bool_answer
      single_choice_answer
      multiple_choice_answer
    }
  }
}
    `;
export type UpdateCaseCpSurveyMutationFn = Apollo.MutationFunction<UpdateCaseCpSurveyMutation, UpdateCaseCpSurveyMutationVariables>;

/**
 * __useUpdateCaseCpSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateCaseCpSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaseCpSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaseCpSurveyMutation, { data, loading, error }] = useUpdateCaseCpSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaseCpSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaseCpSurveyMutation, UpdateCaseCpSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaseCpSurveyMutation, UpdateCaseCpSurveyMutationVariables>(UpdateCaseCpSurveyDocument, options);
      }
export type UpdateCaseCpSurveyMutationHookResult = ReturnType<typeof useUpdateCaseCpSurveyMutation>;
export type UpdateCaseCpSurveyMutationResult = Apollo.MutationResult<UpdateCaseCpSurveyMutation>;
export type UpdateCaseCpSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateCaseCpSurveyMutation, UpdateCaseCpSurveyMutationVariables>;
export const UpdateClientUserDocument = gql`
    mutation updateClientUser($id: ID!, $input: ClientInput!, $includeMortgageProduct: Boolean = false) {
  updateClientUser(id: $id, input: $input) {
    id
    version
    details {
      ...ClientUserDetails
    }
  }
}
    ${ClientUserDetailsFragmentDoc}`;
export type UpdateClientUserMutationFn = Apollo.MutationFunction<UpdateClientUserMutation, UpdateClientUserMutationVariables>;

/**
 * __useUpdateClientUserMutation__
 *
 * To run a mutation, you first call `useUpdateClientUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientUserMutation, { data, loading, error }] = useUpdateClientUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useUpdateClientUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientUserMutation, UpdateClientUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientUserMutation, UpdateClientUserMutationVariables>(UpdateClientUserDocument, options);
      }
export type UpdateClientUserMutationHookResult = ReturnType<typeof useUpdateClientUserMutation>;
export type UpdateClientUserMutationResult = Apollo.MutationResult<UpdateClientUserMutation>;
export type UpdateClientUserMutationOptions = Apollo.BaseMutationOptions<UpdateClientUserMutation, UpdateClientUserMutationVariables>;
export const UpdateDocumentCpDocument = gql`
    mutation updateDocumentCp($id: ID!, $input: DocumentInput!) {
  updateDocumentCp(id: $id, input: $input) {
    document_id
    type
    other_type
    document_name
    archived
    case_ids
    owning_client_ids
  }
}
    `;
export type UpdateDocumentCpMutationFn = Apollo.MutationFunction<UpdateDocumentCpMutation, UpdateDocumentCpMutationVariables>;

/**
 * __useUpdateDocumentCpMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentCpMutation, { data, loading, error }] = useUpdateDocumentCpMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentCpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentCpMutation, UpdateDocumentCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentCpMutation, UpdateDocumentCpMutationVariables>(UpdateDocumentCpDocument, options);
      }
export type UpdateDocumentCpMutationHookResult = ReturnType<typeof useUpdateDocumentCpMutation>;
export type UpdateDocumentCpMutationResult = Apollo.MutationResult<UpdateDocumentCpMutation>;
export type UpdateDocumentCpMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentCpMutation, UpdateDocumentCpMutationVariables>;
export const UpdateDocumentRequirementDocument = gql`
    mutation updateDocumentRequirement($input: DocumentRequirementInput!) {
  updateDocumentRequirement(input: $input) {
    requirement_id
    created_at
    created_by
    modified_at
    disabled_at
    details {
      organisation_id
      name
      description
      status
      gi
      protection_types
      exclude_product_transfer
      exclude_no_contact_renewal
      exclude_renewal
      case_types
      document_types
      auto_satisfy {
        document_types
        count
        broker_verification_required
      }
      default_overdue
      per_client
      can_share_with_client
      required_from
      required_by
      apply_to_existing
    }
  }
}
    `;
export type UpdateDocumentRequirementMutationFn = Apollo.MutationFunction<UpdateDocumentRequirementMutation, UpdateDocumentRequirementMutationVariables>;

/**
 * __useUpdateDocumentRequirementMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentRequirementMutation, { data, loading, error }] = useUpdateDocumentRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentRequirementMutation, UpdateDocumentRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentRequirementMutation, UpdateDocumentRequirementMutationVariables>(UpdateDocumentRequirementDocument, options);
      }
export type UpdateDocumentRequirementMutationHookResult = ReturnType<typeof useUpdateDocumentRequirementMutation>;
export type UpdateDocumentRequirementMutationResult = Apollo.MutationResult<UpdateDocumentRequirementMutation>;
export type UpdateDocumentRequirementMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentRequirementMutation, UpdateDocumentRequirementMutationVariables>;
export const UpdateMortgageProductCpDocument = gql`
    mutation updateMortgageProductCp($mortgageId: ID!, $mortgageProductId: ID!, $mortgageProductInput: MortgageProductActualInput!) {
  updateMortgageProductCp(
    mortgageId: $mortgageId
    mortgageProductId: $mortgageProductId
    mortgageProductInput: $mortgageProductInput
  ) {
    id
    product_name
    lender_reference
    lender_name
    rate_tiers {
      rate
      rate_type
      period_fixed_length_months
      period_fixed_end_date
    }
  }
}
    `;
export type UpdateMortgageProductCpMutationFn = Apollo.MutationFunction<UpdateMortgageProductCpMutation, UpdateMortgageProductCpMutationVariables>;

/**
 * __useUpdateMortgageProductCpMutation__
 *
 * To run a mutation, you first call `useUpdateMortgageProductCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgageProductCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgageProductCpMutation, { data, loading, error }] = useUpdateMortgageProductCpMutation({
 *   variables: {
 *      mortgageId: // value for 'mortgageId'
 *      mortgageProductId: // value for 'mortgageProductId'
 *      mortgageProductInput: // value for 'mortgageProductInput'
 *   },
 * });
 */
export function useUpdateMortgageProductCpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgageProductCpMutation, UpdateMortgageProductCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgageProductCpMutation, UpdateMortgageProductCpMutationVariables>(UpdateMortgageProductCpDocument, options);
      }
export type UpdateMortgageProductCpMutationHookResult = ReturnType<typeof useUpdateMortgageProductCpMutation>;
export type UpdateMortgageProductCpMutationResult = Apollo.MutationResult<UpdateMortgageProductCpMutation>;
export type UpdateMortgageProductCpMutationOptions = Apollo.BaseMutationOptions<UpdateMortgageProductCpMutation, UpdateMortgageProductCpMutationVariables>;
export const UpdatePropertyCpDocument = gql`
    mutation updatePropertyCp($propertyId: ID!, $input: PropertyInput!, $includeMortgageProduct: Boolean = false) {
  updatePropertyCp(propertyId: $propertyId, input: $input) {
    id
    property_id
    details {
      ...PropertyDetailsCp
    }
  }
}
    ${PropertyDetailsCpFragmentDoc}`;
export type UpdatePropertyCpMutationFn = Apollo.MutationFunction<UpdatePropertyCpMutation, UpdatePropertyCpMutationVariables>;

/**
 * __useUpdatePropertyCpMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyCpMutation, { data, loading, error }] = useUpdatePropertyCpMutation({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      input: // value for 'input'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useUpdatePropertyCpMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePropertyCpMutation, UpdatePropertyCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePropertyCpMutation, UpdatePropertyCpMutationVariables>(UpdatePropertyCpDocument, options);
      }
export type UpdatePropertyCpMutationHookResult = ReturnType<typeof useUpdatePropertyCpMutation>;
export type UpdatePropertyCpMutationResult = Apollo.MutationResult<UpdatePropertyCpMutation>;
export type UpdatePropertyCpMutationOptions = Apollo.BaseMutationOptions<UpdatePropertyCpMutation, UpdatePropertyCpMutationVariables>;
export const UpdateMortgageCpDocument = gql`
    mutation updateMortgageCp($id: ID!, $input: MortgageInput!, $includeMortgageProduct: Boolean = false) {
  updateMortgageCp(id: $id, input: $input) {
    ...MortgageAndProduct
  }
}
    ${MortgageAndProductFragmentDoc}`;
export type UpdateMortgageCpMutationFn = Apollo.MutationFunction<UpdateMortgageCpMutation, UpdateMortgageCpMutationVariables>;

/**
 * __useUpdateMortgageCpMutation__
 *
 * To run a mutation, you first call `useUpdateMortgageCpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMortgageCpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMortgageCpMutation, { data, loading, error }] = useUpdateMortgageCpMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useUpdateMortgageCpMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMortgageCpMutation, UpdateMortgageCpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMortgageCpMutation, UpdateMortgageCpMutationVariables>(UpdateMortgageCpDocument, options);
      }
export type UpdateMortgageCpMutationHookResult = ReturnType<typeof useUpdateMortgageCpMutation>;
export type UpdateMortgageCpMutationResult = Apollo.MutationResult<UpdateMortgageCpMutation>;
export type UpdateMortgageCpMutationOptions = Apollo.BaseMutationOptions<UpdateMortgageCpMutation, UpdateMortgageCpMutationVariables>;
export const UploadClientUserDocumentDocument = gql`
    mutation uploadClientUserDocument($document: DocumentUploadInput!, $mortgage_id: String) {
  uploadClientUserDocument(document: $document, mortgage_id: $mortgage_id) {
    template_type
    document_id
    date_stored
    document_name
    file_type
    source
    source_user_id
    type
    other_type
    verification_count
    data_base64
    source_client_id
    owning_client_ids
    case_ids
    archived
  }
}
    `;
export type UploadClientUserDocumentMutationFn = Apollo.MutationFunction<UploadClientUserDocumentMutation, UploadClientUserDocumentMutationVariables>;

/**
 * __useUploadClientUserDocumentMutation__
 *
 * To run a mutation, you first call `useUploadClientUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadClientUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadClientUserDocumentMutation, { data, loading, error }] = useUploadClientUserDocumentMutation({
 *   variables: {
 *      document: // value for 'document'
 *      mortgage_id: // value for 'mortgage_id'
 *   },
 * });
 */
export function useUploadClientUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadClientUserDocumentMutation, UploadClientUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadClientUserDocumentMutation, UploadClientUserDocumentMutationVariables>(UploadClientUserDocumentDocument, options);
      }
export type UploadClientUserDocumentMutationHookResult = ReturnType<typeof useUploadClientUserDocumentMutation>;
export type UploadClientUserDocumentMutationResult = Apollo.MutationResult<UploadClientUserDocumentMutation>;
export type UploadClientUserDocumentMutationOptions = Apollo.BaseMutationOptions<UploadClientUserDocumentMutation, UploadClientUserDocumentMutationVariables>;
export const VerifyClientUserDocumentDocument = gql`
    mutation verifyClientUserDocument($input: DocumentVerificationInput!) {
  verifyClientUserDocument(input: $input) {
    id
  }
}
    `;
export type VerifyClientUserDocumentMutationFn = Apollo.MutationFunction<VerifyClientUserDocumentMutation, VerifyClientUserDocumentMutationVariables>;

/**
 * __useVerifyClientUserDocumentMutation__
 *
 * To run a mutation, you first call `useVerifyClientUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyClientUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyClientUserDocumentMutation, { data, loading, error }] = useVerifyClientUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyClientUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<VerifyClientUserDocumentMutation, VerifyClientUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyClientUserDocumentMutation, VerifyClientUserDocumentMutationVariables>(VerifyClientUserDocumentDocument, options);
      }
export type VerifyClientUserDocumentMutationHookResult = ReturnType<typeof useVerifyClientUserDocumentMutation>;
export type VerifyClientUserDocumentMutationResult = Apollo.MutationResult<VerifyClientUserDocumentMutation>;
export type VerifyClientUserDocumentMutationOptions = Apollo.BaseMutationOptions<VerifyClientUserDocumentMutation, VerifyClientUserDocumentMutationVariables>;
export const ClientGetVulnerabilityQuestionDocument = gql`
    query clientGetVulnerabilityQuestion($assessment_uuid: ID!, $case: ID!) {
  clientGetVulnerabilityQuestion(assessment_uuid: $assessment_uuid, case: $case) {
    assessment_uuid
    title
    intro
    progress
    question {
      ...Question
    }
  }
}
    ${QuestionFragmentDoc}`;

/**
 * __useClientGetVulnerabilityQuestionQuery__
 *
 * To run a query within a React component, call `useClientGetVulnerabilityQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientGetVulnerabilityQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientGetVulnerabilityQuestionQuery({
 *   variables: {
 *      assessment_uuid: // value for 'assessment_uuid'
 *      case: // value for 'case'
 *   },
 * });
 */
export function useClientGetVulnerabilityQuestionQuery(baseOptions: Apollo.QueryHookOptions<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables> & ({ variables: ClientGetVulnerabilityQuestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>(ClientGetVulnerabilityQuestionDocument, options);
      }
export function useClientGetVulnerabilityQuestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>(ClientGetVulnerabilityQuestionDocument, options);
        }
// @ts-ignore
export function useClientGetVulnerabilityQuestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>;
export function useClientGetVulnerabilityQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>): Apollo.UseSuspenseQueryResult<ClientGetVulnerabilityQuestionQuery | undefined, ClientGetVulnerabilityQuestionQueryVariables>;
export function useClientGetVulnerabilityQuestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>(ClientGetVulnerabilityQuestionDocument, options);
        }
export type ClientGetVulnerabilityQuestionQueryHookResult = ReturnType<typeof useClientGetVulnerabilityQuestionQuery>;
export type ClientGetVulnerabilityQuestionLazyQueryHookResult = ReturnType<typeof useClientGetVulnerabilityQuestionLazyQuery>;
export type ClientGetVulnerabilityQuestionSuspenseQueryHookResult = ReturnType<typeof useClientGetVulnerabilityQuestionSuspenseQuery>;
export type ClientGetVulnerabilityQuestionQueryResult = Apollo.QueryResult<ClientGetVulnerabilityQuestionQuery, ClientGetVulnerabilityQuestionQueryVariables>;
export const GetCaseClientsUserBasicInfoDocument = gql`
    query getCaseClientsUserBasicInfo($id: ID!) {
  caseUser(id: $id) {
    id
    version
    details {
      id
      clientsUser(showBasicInfo: true) {
        id
        details {
          id
          first_name
          last_name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCaseClientsUserBasicInfoQuery__
 *
 * To run a query within a React component, call `useGetCaseClientsUserBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseClientsUserBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseClientsUserBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseClientsUserBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables> & ({ variables: GetCaseClientsUserBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>(GetCaseClientsUserBasicInfoDocument, options);
      }
export function useGetCaseClientsUserBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>(GetCaseClientsUserBasicInfoDocument, options);
        }
// @ts-ignore
export function useGetCaseClientsUserBasicInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>;
export function useGetCaseClientsUserBasicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseClientsUserBasicInfoQuery | undefined, GetCaseClientsUserBasicInfoQueryVariables>;
export function useGetCaseClientsUserBasicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>(GetCaseClientsUserBasicInfoDocument, options);
        }
export type GetCaseClientsUserBasicInfoQueryHookResult = ReturnType<typeof useGetCaseClientsUserBasicInfoQuery>;
export type GetCaseClientsUserBasicInfoLazyQueryHookResult = ReturnType<typeof useGetCaseClientsUserBasicInfoLazyQuery>;
export type GetCaseClientsUserBasicInfoSuspenseQueryHookResult = ReturnType<typeof useGetCaseClientsUserBasicInfoSuspenseQuery>;
export type GetCaseClientsUserBasicInfoQueryResult = Apollo.QueryResult<GetCaseClientsUserBasicInfoQuery, GetCaseClientsUserBasicInfoQueryVariables>;
export const GetCaseUserDocument = gql`
    query getCaseUser($id: ID!, $fromClientPortal: Boolean = true, $includeDocuments: Boolean = false, $includeMortgageProduct: Boolean = true) {
  caseUser(id: $id, fromClientPortal: $fromClientPortal) {
    id
    created_at
    version
    version_created_at
    details {
      id
      owner_user_id
      owner_organisation_id
      client_ids
      status
      regulated_by
      has_previously_owned_property
      has_seen_face_to_face
      impersonation_check_performed
      impersonation_check_details
      is_debt_consolidation
      btl_has_lived
      btl_will_lived
      btl_is_operating_a_business
      btl_through_company
      client_ids
      is_introduced
      introducer_id
      introducer_details
      lender_has_proposed_new_product
      reason_for_further_advance
      shared_budget
      preference_mortgage_reason
      preference_loan_amount
      preference_target_property
      preference_target_property_value
      preference_term
      preference_fixed_rate
      preference_initial_period_months
      preference_repayment_percentage
      preference_early_year_discount
      preference_tracker
      additional_loan_required
      change_of_preference_reason
      preference_related_property_sale
      conveyancing_type
      conveyancing_status
      calculated_values {
        total_required_loan_amount
        total_additional_borrowing
        current_totals {
          total_outstanding_balances
        }
      }
      transition_mortgage_versions {
        entity_versions {
          mortgage_id
          version
        }
      }
      protection {
        has_client_accepted_protection_advice
        has_client_accepted_protection_needs
        client_declined_protection_needs_reason
        requirements {
          life_and_critical_illness {
            id
          }
          family_income_benefits {
            id
          }
          income_protection {
            id
          }
          whole_of_life {
            id
          }
          private_medical_insurance {
            id
          }
        }
      }
      additional_loans {
        loan_amount
        loan_purpose
        id
      }
      own_solicitor_details {
        firm_name
        contact_name
        email_address
        phone_number
        dx_number
        dx_town
        case_reference
      }
      referrals {
        partner
        referral_type
        status
        third_party_id
        contact_history {
          third_party_id
          clicked_at
          clicks
          contact_type
          created_at
          delivered
          identifier
          opened_at
        }
      }
      additional_metadata {
        name
        string_value
      }
      survey_answers {
        client_id
        modified_at
        completed_at
        answers {
          question_id
          question_version
          five_scale_answer
          ten_scale_answer
          free_text_answer
          bool_answer
          single_choice_answer
          multiple_choice_answer
          zero_ten_scale_answer
        }
      }
      mortgages_cp {
        ...MortgageAndProduct
      }
      new_property_cp {
        id
        property_id
        details {
          ...PropertyDetailsCp
        }
      }
      remortgage_property_cp {
        id
        property_id
        details {
          ...PropertyDetailsCp
        }
      }
      clientsUser {
        id
        details {
          ...ClientUserDetails
        }
      }
      miDocuments(fromClientPortal: $fromClientPortal) @include(if: $includeDocuments) {
        documents {
          ...MIDocuments
        }
      }
      document_requirements {
        requirement_id
        details {
          status
          name
          auto_satisfy {
            document_types
            count
          }
        }
      }
    }
  }
}
    ${MortgageAndProductFragmentDoc}
${PropertyDetailsCpFragmentDoc}
${ClientUserDetailsFragmentDoc}
${MiDocumentsFragmentDoc}`;

/**
 * __useGetCaseUserQuery__
 *
 * To run a query within a React component, call `useGetCaseUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fromClientPortal: // value for 'fromClientPortal'
 *      includeDocuments: // value for 'includeDocuments'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetCaseUserQuery(baseOptions: Apollo.QueryHookOptions<GetCaseUserQuery, GetCaseUserQueryVariables> & ({ variables: GetCaseUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseUserQuery, GetCaseUserQueryVariables>(GetCaseUserDocument, options);
      }
export function useGetCaseUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseUserQuery, GetCaseUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseUserQuery, GetCaseUserQueryVariables>(GetCaseUserDocument, options);
        }
// @ts-ignore
export function useGetCaseUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseUserQuery, GetCaseUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseUserQuery, GetCaseUserQueryVariables>;
export function useGetCaseUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseUserQuery, GetCaseUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseUserQuery | undefined, GetCaseUserQueryVariables>;
export function useGetCaseUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseUserQuery, GetCaseUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseUserQuery, GetCaseUserQueryVariables>(GetCaseUserDocument, options);
        }
export type GetCaseUserQueryHookResult = ReturnType<typeof useGetCaseUserQuery>;
export type GetCaseUserLazyQueryHookResult = ReturnType<typeof useGetCaseUserLazyQuery>;
export type GetCaseUserSuspenseQueryHookResult = ReturnType<typeof useGetCaseUserSuspenseQuery>;
export type GetCaseUserQueryResult = Apollo.QueryResult<GetCaseUserQuery, GetCaseUserQueryVariables>;
export const GetCaseUserSurveyDocument = gql`
    query getCaseUserSurvey($id: ID!) {
  caseUser(id: $id) {
    id
    details {
      id
      owner_user_id
    }
  }
}
    `;

/**
 * __useGetCaseUserSurveyQuery__
 *
 * To run a query within a React component, call `useGetCaseUserSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseUserSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseUserSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaseUserSurveyQuery(baseOptions: Apollo.QueryHookOptions<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables> & ({ variables: GetCaseUserSurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>(GetCaseUserSurveyDocument, options);
      }
export function useGetCaseUserSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>(GetCaseUserSurveyDocument, options);
        }
// @ts-ignore
export function useGetCaseUserSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>;
export function useGetCaseUserSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseUserSurveyQuery | undefined, GetCaseUserSurveyQueryVariables>;
export function useGetCaseUserSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>(GetCaseUserSurveyDocument, options);
        }
export type GetCaseUserSurveyQueryHookResult = ReturnType<typeof useGetCaseUserSurveyQuery>;
export type GetCaseUserSurveyLazyQueryHookResult = ReturnType<typeof useGetCaseUserSurveyLazyQuery>;
export type GetCaseUserSurveySuspenseQueryHookResult = ReturnType<typeof useGetCaseUserSurveySuspenseQuery>;
export type GetCaseUserSurveyQueryResult = Apollo.QueryResult<GetCaseUserSurveyQuery, GetCaseUserSurveyQueryVariables>;
export const GetCaseVerificationsCpDocument = gql`
    query getCaseVerificationsCp($id: ID!, $show_pass: Boolean) {
  caseVerificationsCp(id: $id, show_pass: $show_pass, show_documents: true) {
    verification_collections {
      collection_id
      name
      passed
      verifications {
        verification_id
        name
        passed
        explanation
        case_id
        client_id
        mortgage_id
        optional
        entities {
          id
          type
        }
        auto_satisfy {
          document_types
          count
          satisfied_document_ids
        }
      }
    }
  }
}
    `;

/**
 * __useGetCaseVerificationsCpQuery__
 *
 * To run a query within a React component, call `useGetCaseVerificationsCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaseVerificationsCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaseVerificationsCpQuery({
 *   variables: {
 *      id: // value for 'id'
 *      show_pass: // value for 'show_pass'
 *   },
 * });
 */
export function useGetCaseVerificationsCpQuery(baseOptions: Apollo.QueryHookOptions<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables> & ({ variables: GetCaseVerificationsCpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>(GetCaseVerificationsCpDocument, options);
      }
export function useGetCaseVerificationsCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>(GetCaseVerificationsCpDocument, options);
        }
// @ts-ignore
export function useGetCaseVerificationsCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>;
export function useGetCaseVerificationsCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaseVerificationsCpQuery | undefined, GetCaseVerificationsCpQueryVariables>;
export function useGetCaseVerificationsCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>(GetCaseVerificationsCpDocument, options);
        }
export type GetCaseVerificationsCpQueryHookResult = ReturnType<typeof useGetCaseVerificationsCpQuery>;
export type GetCaseVerificationsCpLazyQueryHookResult = ReturnType<typeof useGetCaseVerificationsCpLazyQuery>;
export type GetCaseVerificationsCpSuspenseQueryHookResult = ReturnType<typeof useGetCaseVerificationsCpSuspenseQuery>;
export type GetCaseVerificationsCpQueryResult = Apollo.QueryResult<GetCaseVerificationsCpQuery, GetCaseVerificationsCpQueryVariables>;
export const GetClientPropertiesCpDocument = gql`
    query getClientPropertiesCp($id: ID!, $includeMortgageProduct: Boolean = false) {
  propertiesCp(id: $id) {
    id
    property_id
    details {
      ...PropertyDetailsCp
    }
  }
}
    ${PropertyDetailsCpFragmentDoc}`;

/**
 * __useGetClientPropertiesCpQuery__
 *
 * To run a query within a React component, call `useGetClientPropertiesCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPropertiesCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPropertiesCpQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetClientPropertiesCpQuery(baseOptions: Apollo.QueryHookOptions<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables> & ({ variables: GetClientPropertiesCpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>(GetClientPropertiesCpDocument, options);
      }
export function useGetClientPropertiesCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>(GetClientPropertiesCpDocument, options);
        }
// @ts-ignore
export function useGetClientPropertiesCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>;
export function useGetClientPropertiesCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientPropertiesCpQuery | undefined, GetClientPropertiesCpQueryVariables>;
export function useGetClientPropertiesCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>(GetClientPropertiesCpDocument, options);
        }
export type GetClientPropertiesCpQueryHookResult = ReturnType<typeof useGetClientPropertiesCpQuery>;
export type GetClientPropertiesCpLazyQueryHookResult = ReturnType<typeof useGetClientPropertiesCpLazyQuery>;
export type GetClientPropertiesCpSuspenseQueryHookResult = ReturnType<typeof useGetClientPropertiesCpSuspenseQuery>;
export type GetClientPropertiesCpQueryResult = Apollo.QueryResult<GetClientPropertiesCpQuery, GetClientPropertiesCpQueryVariables>;
export const GetClientUserDocument = gql`
    query getClientUser($includeMortgageProduct: Boolean = false) {
  clientUser {
    id
    version
    details {
      ...ClientUserDetails
      clientUserIdd {
        document_id
        date_stored
        document_name
        document_signature
        file_type
        source
        source_user_id
        type
        verification_count
        data_base64
      }
    }
  }
}
    ${ClientUserDetailsFragmentDoc}`;

/**
 * __useGetClientUserQuery__
 *
 * To run a query within a React component, call `useGetClientUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientUserQuery({
 *   variables: {
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetClientUserQuery(baseOptions?: Apollo.QueryHookOptions<GetClientUserQuery, GetClientUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientUserQuery, GetClientUserQueryVariables>(GetClientUserDocument, options);
      }
export function useGetClientUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientUserQuery, GetClientUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientUserQuery, GetClientUserQueryVariables>(GetClientUserDocument, options);
        }
// @ts-ignore
export function useGetClientUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientUserQuery, GetClientUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserQuery, GetClientUserQueryVariables>;
export function useGetClientUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserQuery, GetClientUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserQuery | undefined, GetClientUserQueryVariables>;
export function useGetClientUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserQuery, GetClientUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientUserQuery, GetClientUserQueryVariables>(GetClientUserDocument, options);
        }
export type GetClientUserQueryHookResult = ReturnType<typeof useGetClientUserQuery>;
export type GetClientUserLazyQueryHookResult = ReturnType<typeof useGetClientUserLazyQuery>;
export type GetClientUserSuspenseQueryHookResult = ReturnType<typeof useGetClientUserSuspenseQuery>;
export type GetClientUserQueryResult = Apollo.QueryResult<GetClientUserQuery, GetClientUserQueryVariables>;
export const GetClientUserDocumentDetailsDocument = gql`
    query getClientUserDocumentDetails($docId: ID!, $params: GetDocumentParams) {
  clientUserDocumentDetails(docId: $docId, params: $params) {
    template_type
    document_id
    date_stored
    document_name
    file_type
    source
    source_user_id
    type
    other_type
    verification_count
    data_base64
    document_signature
    rendered_organisation_ids
  }
}
    `;

/**
 * __useGetClientUserDocumentDetailsQuery__
 *
 * To run a query within a React component, call `useGetClientUserDocumentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientUserDocumentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientUserDocumentDetailsQuery({
 *   variables: {
 *      docId: // value for 'docId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetClientUserDocumentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables> & ({ variables: GetClientUserDocumentDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>(GetClientUserDocumentDetailsDocument, options);
      }
export function useGetClientUserDocumentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>(GetClientUserDocumentDetailsDocument, options);
        }
// @ts-ignore
export function useGetClientUserDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>;
export function useGetClientUserDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserDocumentDetailsQuery | undefined, GetClientUserDocumentDetailsQueryVariables>;
export function useGetClientUserDocumentDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>(GetClientUserDocumentDetailsDocument, options);
        }
export type GetClientUserDocumentDetailsQueryHookResult = ReturnType<typeof useGetClientUserDocumentDetailsQuery>;
export type GetClientUserDocumentDetailsLazyQueryHookResult = ReturnType<typeof useGetClientUserDocumentDetailsLazyQuery>;
export type GetClientUserDocumentDetailsSuspenseQueryHookResult = ReturnType<typeof useGetClientUserDocumentDetailsSuspenseQuery>;
export type GetClientUserDocumentDetailsQueryResult = Apollo.QueryResult<GetClientUserDocumentDetailsQuery, GetClientUserDocumentDetailsQueryVariables>;
export const GetClientUserHealthDocument = gql`
    query getClientUserHealth {
  clientUser {
    id
    version
    details {
      id
      ...ClientHealth
    }
  }
}
    ${ClientHealthFragmentDoc}`;

/**
 * __useGetClientUserHealthQuery__
 *
 * To run a query within a React component, call `useGetClientUserHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientUserHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientUserHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientUserHealthQuery(baseOptions?: Apollo.QueryHookOptions<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>(GetClientUserHealthDocument, options);
      }
export function useGetClientUserHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>(GetClientUserHealthDocument, options);
        }
// @ts-ignore
export function useGetClientUserHealthSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>;
export function useGetClientUserHealthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserHealthQuery | undefined, GetClientUserHealthQueryVariables>;
export function useGetClientUserHealthSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>(GetClientUserHealthDocument, options);
        }
export type GetClientUserHealthQueryHookResult = ReturnType<typeof useGetClientUserHealthQuery>;
export type GetClientUserHealthLazyQueryHookResult = ReturnType<typeof useGetClientUserHealthLazyQuery>;
export type GetClientUserHealthSuspenseQueryHookResult = ReturnType<typeof useGetClientUserHealthSuspenseQuery>;
export type GetClientUserHealthQueryResult = Apollo.QueryResult<GetClientUserHealthQuery, GetClientUserHealthQueryVariables>;
export const GetClientUserIddDocumentsDocument = gql`
    query getClientUserIddDocuments($filter_owning_client_id: String, $filter_case_id: ID, $filter_archived: Boolean) {
  clientUserIddDocuments(
    filter_owning_client_id: $filter_owning_client_id
    filter_case_id: $filter_case_id
    filter_archived: $filter_archived
  ) {
    template_type
    document_id
    date_stored
    document_name
    file_type
    source
    source_user_id
    type
    other_type
    verification_count
    data_base64
    document_signature
    rendered_organisation_ids
  }
}
    `;

/**
 * __useGetClientUserIddDocumentsQuery__
 *
 * To run a query within a React component, call `useGetClientUserIddDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientUserIddDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientUserIddDocumentsQuery({
 *   variables: {
 *      filter_owning_client_id: // value for 'filter_owning_client_id'
 *      filter_case_id: // value for 'filter_case_id'
 *      filter_archived: // value for 'filter_archived'
 *   },
 * });
 */
export function useGetClientUserIddDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>(GetClientUserIddDocumentsDocument, options);
      }
export function useGetClientUserIddDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>(GetClientUserIddDocumentsDocument, options);
        }
// @ts-ignore
export function useGetClientUserIddDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>;
export function useGetClientUserIddDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserIddDocumentsQuery | undefined, GetClientUserIddDocumentsQueryVariables>;
export function useGetClientUserIddDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>(GetClientUserIddDocumentsDocument, options);
        }
export type GetClientUserIddDocumentsQueryHookResult = ReturnType<typeof useGetClientUserIddDocumentsQuery>;
export type GetClientUserIddDocumentsLazyQueryHookResult = ReturnType<typeof useGetClientUserIddDocumentsLazyQuery>;
export type GetClientUserIddDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetClientUserIddDocumentsSuspenseQuery>;
export type GetClientUserIddDocumentsQueryResult = Apollo.QueryResult<GetClientUserIddDocumentsQuery, GetClientUserIddDocumentsQueryVariables>;
export const GetClientUserMiDocumentSummariesDocument = gql`
    query getClientUserMiDocumentSummaries($entity: String, $id: String!, $filters: MIDocumentSummaryFiltersInput) {
  clientUserMiDocumentsSummaries(entity: $entity, id: $id, filters: $filters) {
    documents {
      document_id
      case_ids
      client_ids
      date_stored
      document_name
      file_type
      type
      other_type
      template_type
      rendered_mortgage_ids
      archived
      verification_count
      source {
        type
        id
      }
    }
  }
}
    `;

/**
 * __useGetClientUserMiDocumentSummariesQuery__
 *
 * To run a query within a React component, call `useGetClientUserMiDocumentSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientUserMiDocumentSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientUserMiDocumentSummariesQuery({
 *   variables: {
 *      entity: // value for 'entity'
 *      id: // value for 'id'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetClientUserMiDocumentSummariesQuery(baseOptions: Apollo.QueryHookOptions<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables> & ({ variables: GetClientUserMiDocumentSummariesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>(GetClientUserMiDocumentSummariesDocument, options);
      }
export function useGetClientUserMiDocumentSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>(GetClientUserMiDocumentSummariesDocument, options);
        }
// @ts-ignore
export function useGetClientUserMiDocumentSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>;
export function useGetClientUserMiDocumentSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserMiDocumentSummariesQuery | undefined, GetClientUserMiDocumentSummariesQueryVariables>;
export function useGetClientUserMiDocumentSummariesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>(GetClientUserMiDocumentSummariesDocument, options);
        }
export type GetClientUserMiDocumentSummariesQueryHookResult = ReturnType<typeof useGetClientUserMiDocumentSummariesQuery>;
export type GetClientUserMiDocumentSummariesLazyQueryHookResult = ReturnType<typeof useGetClientUserMiDocumentSummariesLazyQuery>;
export type GetClientUserMiDocumentSummariesSuspenseQueryHookResult = ReturnType<typeof useGetClientUserMiDocumentSummariesSuspenseQuery>;
export type GetClientUserMiDocumentSummariesQueryResult = Apollo.QueryResult<GetClientUserMiDocumentSummariesQuery, GetClientUserMiDocumentSummariesQueryVariables>;
export const GetClientUserProtectedFieldsDocument = gql`
    query getClientUserProtectedFields($id: ID!, $protectedFields: [String!], $date_of_birth: Boolean = false, $maiden_or_previous_name: Boolean = false, $accounts: Boolean = false, $sort_code: Boolean = false, $number: Boolean = false, $previous_names: Boolean = false, $previous_first_name: Boolean = false, $previous_surname: Boolean = false) {
  clientUserProtectedFields(
    id: $id
    protectedFields: $protectedFields
    date_of_birth: $date_of_birth
    maiden_or_previous_name: $maiden_or_previous_name
    accounts: $accounts
    sort_code: $sort_code
    number: $number
    previous_names: $previous_names
    previous_first_name: $previous_first_name
    previous_surname: $previous_surname
  ) {
    id
    version
    details {
      id
      maiden_or_previous_name @include(if: $maiden_or_previous_name)
      date_of_birth @include(if: $date_of_birth)
      accounts @include(if: $accounts) {
        sort_code @include(if: $sort_code)
        number @include(if: $number)
      }
      previous_names {
        id
        previous_first_name
        previous_surname
        date_of_name_change
        reason_for_name_change
      }
    }
  }
}
    `;

/**
 * __useGetClientUserProtectedFieldsQuery__
 *
 * To run a query within a React component, call `useGetClientUserProtectedFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientUserProtectedFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientUserProtectedFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      protectedFields: // value for 'protectedFields'
 *      date_of_birth: // value for 'date_of_birth'
 *      maiden_or_previous_name: // value for 'maiden_or_previous_name'
 *      accounts: // value for 'accounts'
 *      sort_code: // value for 'sort_code'
 *      number: // value for 'number'
 *      previous_names: // value for 'previous_names'
 *      previous_first_name: // value for 'previous_first_name'
 *      previous_surname: // value for 'previous_surname'
 *   },
 * });
 */
export function useGetClientUserProtectedFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables> & ({ variables: GetClientUserProtectedFieldsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>(GetClientUserProtectedFieldsDocument, options);
      }
export function useGetClientUserProtectedFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>(GetClientUserProtectedFieldsDocument, options);
        }
// @ts-ignore
export function useGetClientUserProtectedFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>;
export function useGetClientUserProtectedFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientUserProtectedFieldsQuery | undefined, GetClientUserProtectedFieldsQueryVariables>;
export function useGetClientUserProtectedFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>(GetClientUserProtectedFieldsDocument, options);
        }
export type GetClientUserProtectedFieldsQueryHookResult = ReturnType<typeof useGetClientUserProtectedFieldsQuery>;
export type GetClientUserProtectedFieldsLazyQueryHookResult = ReturnType<typeof useGetClientUserProtectedFieldsLazyQuery>;
export type GetClientUserProtectedFieldsSuspenseQueryHookResult = ReturnType<typeof useGetClientUserProtectedFieldsSuspenseQuery>;
export type GetClientUserProtectedFieldsQueryResult = Apollo.QueryResult<GetClientUserProtectedFieldsQuery, GetClientUserProtectedFieldsQueryVariables>;
export const GetClientsUserDocument = gql`
    query getClientsUser($ids: [ID!], $organisationId: ID, $includeMortgageProduct: Boolean = false) {
  clientsUser(ids: $ids, organisationId: $organisationId) {
    id
    details {
      id
      ...ClientUserDetails
    }
  }
}
    ${ClientUserDetailsFragmentDoc}`;

/**
 * __useGetClientsUserQuery__
 *
 * To run a query within a React component, call `useGetClientsUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsUserQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      organisationId: // value for 'organisationId'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetClientsUserQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsUserQuery, GetClientsUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsUserQuery, GetClientsUserQueryVariables>(GetClientsUserDocument, options);
      }
export function useGetClientsUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsUserQuery, GetClientsUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsUserQuery, GetClientsUserQueryVariables>(GetClientsUserDocument, options);
        }
// @ts-ignore
export function useGetClientsUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsUserQuery, GetClientsUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsUserQuery, GetClientsUserQueryVariables>;
export function useGetClientsUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsUserQuery, GetClientsUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsUserQuery | undefined, GetClientsUserQueryVariables>;
export function useGetClientsUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsUserQuery, GetClientsUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsUserQuery, GetClientsUserQueryVariables>(GetClientsUserDocument, options);
        }
export type GetClientsUserQueryHookResult = ReturnType<typeof useGetClientsUserQuery>;
export type GetClientsUserLazyQueryHookResult = ReturnType<typeof useGetClientsUserLazyQuery>;
export type GetClientsUserSuspenseQueryHookResult = ReturnType<typeof useGetClientsUserSuspenseQuery>;
export type GetClientsUserQueryResult = Apollo.QueryResult<GetClientsUserQuery, GetClientsUserQueryVariables>;
export const GetClientsUserDetailDocument = gql`
    query getClientsUserDetail($ids: [ID!], $organisationId: ID, $includeMortgageProduct: Boolean = false) {
  clientsUserDetails(ids: $ids, organisationId: $organisationId) {
    id
    details {
      id
      ...ClientUserDetails
    }
  }
}
    ${ClientUserDetailsFragmentDoc}`;

/**
 * __useGetClientsUserDetailQuery__
 *
 * To run a query within a React component, call `useGetClientsUserDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsUserDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsUserDetailQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      organisationId: // value for 'organisationId'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetClientsUserDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>(GetClientsUserDetailDocument, options);
      }
export function useGetClientsUserDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>(GetClientsUserDetailDocument, options);
        }
// @ts-ignore
export function useGetClientsUserDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>;
export function useGetClientsUserDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsUserDetailQuery | undefined, GetClientsUserDetailQueryVariables>;
export function useGetClientsUserDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>(GetClientsUserDetailDocument, options);
        }
export type GetClientsUserDetailQueryHookResult = ReturnType<typeof useGetClientsUserDetailQuery>;
export type GetClientsUserDetailLazyQueryHookResult = ReturnType<typeof useGetClientsUserDetailLazyQuery>;
export type GetClientsUserDetailSuspenseQueryHookResult = ReturnType<typeof useGetClientsUserDetailSuspenseQuery>;
export type GetClientsUserDetailQueryResult = Apollo.QueryResult<GetClientsUserDetailQuery, GetClientsUserDetailQueryVariables>;
export const GetClientsUserRelatedClientsDocument = gql`
    query getClientsUserRelatedClients($ids: [ID!], $relationshipTypes: [ClientRelationship!], $fromClientPortal: Boolean = true) {
  clientsUser(ids: $ids) {
    id
    details {
      id
      relatedClients(
        relationshipTypes: $relationshipTypes
        fromClientPortal: $fromClientPortal
      ) {
        id
        details {
          id
          first_name
          last_name
        }
      }
    }
  }
}
    `;

/**
 * __useGetClientsUserRelatedClientsQuery__
 *
 * To run a query within a React component, call `useGetClientsUserRelatedClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsUserRelatedClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsUserRelatedClientsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      relationshipTypes: // value for 'relationshipTypes'
 *      fromClientPortal: // value for 'fromClientPortal'
 *   },
 * });
 */
export function useGetClientsUserRelatedClientsQuery(baseOptions?: Apollo.QueryHookOptions<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>(GetClientsUserRelatedClientsDocument, options);
      }
export function useGetClientsUserRelatedClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>(GetClientsUserRelatedClientsDocument, options);
        }
// @ts-ignore
export function useGetClientsUserRelatedClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>;
export function useGetClientsUserRelatedClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientsUserRelatedClientsQuery | undefined, GetClientsUserRelatedClientsQueryVariables>;
export function useGetClientsUserRelatedClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>(GetClientsUserRelatedClientsDocument, options);
        }
export type GetClientsUserRelatedClientsQueryHookResult = ReturnType<typeof useGetClientsUserRelatedClientsQuery>;
export type GetClientsUserRelatedClientsLazyQueryHookResult = ReturnType<typeof useGetClientsUserRelatedClientsLazyQuery>;
export type GetClientsUserRelatedClientsSuspenseQueryHookResult = ReturnType<typeof useGetClientsUserRelatedClientsSuspenseQuery>;
export type GetClientsUserRelatedClientsQueryResult = Apollo.QueryResult<GetClientsUserRelatedClientsQuery, GetClientsUserRelatedClientsQueryVariables>;
export const GetDashboardDocumentsCpDocument = gql`
    query getDashboardDocumentsCp($id: ID!, $entity: String, $filters: MIDocumentSummaryFiltersInput) {
  dashboardDocumentsCp(id: $id, entity: $entity, filters: $filters) {
    documentSummaries {
      template_type
      document_id
      date_stored
      document_name
      file_type
      source {
        first_name
        id
        last_name
        type
      }
      type
      other_type
      verification_count
      data_base64
      client_ids
      case_ids
      archived
    }
    iddDocumentsDetails {
      template_type
      document_id
      date_stored
      document_name
      file_type
      source
      source_user_id
      type
      other_type
      verification_count
      data_base64
      document_signature
      rendered_organisation_ids
    }
  }
}
    `;

/**
 * __useGetDashboardDocumentsCpQuery__
 *
 * To run a query within a React component, call `useGetDashboardDocumentsCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardDocumentsCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardDocumentsCpQuery({
 *   variables: {
 *      id: // value for 'id'
 *      entity: // value for 'entity'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetDashboardDocumentsCpQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables> & ({ variables: GetDashboardDocumentsCpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>(GetDashboardDocumentsCpDocument, options);
      }
export function useGetDashboardDocumentsCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>(GetDashboardDocumentsCpDocument, options);
        }
// @ts-ignore
export function useGetDashboardDocumentsCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>;
export function useGetDashboardDocumentsCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetDashboardDocumentsCpQuery | undefined, GetDashboardDocumentsCpQueryVariables>;
export function useGetDashboardDocumentsCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>(GetDashboardDocumentsCpDocument, options);
        }
export type GetDashboardDocumentsCpQueryHookResult = ReturnType<typeof useGetDashboardDocumentsCpQuery>;
export type GetDashboardDocumentsCpLazyQueryHookResult = ReturnType<typeof useGetDashboardDocumentsCpLazyQuery>;
export type GetDashboardDocumentsCpSuspenseQueryHookResult = ReturnType<typeof useGetDashboardDocumentsCpSuspenseQuery>;
export type GetDashboardDocumentsCpQueryResult = Apollo.QueryResult<GetDashboardDocumentsCpQuery, GetDashboardDocumentsCpQueryVariables>;
export const GetDocumentVerificationsCpDocument = gql`
    query getDocumentVerificationsCp($documentId: ID!, $params: DocumentVerificationQueryParams) {
  documentVerificationsCp(documentId: $documentId, params: $params) {
    client_id
    document_id
    result_justification
    verification_date
    verification_type
  }
}
    `;

/**
 * __useGetDocumentVerificationsCpQuery__
 *
 * To run a query within a React component, call `useGetDocumentVerificationsCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVerificationsCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVerificationsCpQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetDocumentVerificationsCpQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables> & ({ variables: GetDocumentVerificationsCpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>(GetDocumentVerificationsCpDocument, options);
      }
export function useGetDocumentVerificationsCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>(GetDocumentVerificationsCpDocument, options);
        }
// @ts-ignore
export function useGetDocumentVerificationsCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>;
export function useGetDocumentVerificationsCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentVerificationsCpQuery | undefined, GetDocumentVerificationsCpQueryVariables>;
export function useGetDocumentVerificationsCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>(GetDocumentVerificationsCpDocument, options);
        }
export type GetDocumentVerificationsCpQueryHookResult = ReturnType<typeof useGetDocumentVerificationsCpQuery>;
export type GetDocumentVerificationsCpLazyQueryHookResult = ReturnType<typeof useGetDocumentVerificationsCpLazyQuery>;
export type GetDocumentVerificationsCpSuspenseQueryHookResult = ReturnType<typeof useGetDocumentVerificationsCpSuspenseQuery>;
export type GetDocumentVerificationsCpQueryResult = Apollo.QueryResult<GetDocumentVerificationsCpQuery, GetDocumentVerificationsCpQueryVariables>;
export const GetIsDirectSchedulingAllowedDocument = gql`
    query getIsDirectSchedulingAllowed($caseId: String!) {
  getIsDirectSchedulingAllowed(caseId: $caseId)
}
    `;

/**
 * __useGetIsDirectSchedulingAllowedQuery__
 *
 * To run a query within a React component, call `useGetIsDirectSchedulingAllowedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsDirectSchedulingAllowedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsDirectSchedulingAllowedQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetIsDirectSchedulingAllowedQuery(baseOptions: Apollo.QueryHookOptions<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables> & ({ variables: GetIsDirectSchedulingAllowedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>(GetIsDirectSchedulingAllowedDocument, options);
      }
export function useGetIsDirectSchedulingAllowedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>(GetIsDirectSchedulingAllowedDocument, options);
        }
// @ts-ignore
export function useGetIsDirectSchedulingAllowedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>): Apollo.UseSuspenseQueryResult<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>;
export function useGetIsDirectSchedulingAllowedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>): Apollo.UseSuspenseQueryResult<GetIsDirectSchedulingAllowedQuery | undefined, GetIsDirectSchedulingAllowedQueryVariables>;
export function useGetIsDirectSchedulingAllowedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>(GetIsDirectSchedulingAllowedDocument, options);
        }
export type GetIsDirectSchedulingAllowedQueryHookResult = ReturnType<typeof useGetIsDirectSchedulingAllowedQuery>;
export type GetIsDirectSchedulingAllowedLazyQueryHookResult = ReturnType<typeof useGetIsDirectSchedulingAllowedLazyQuery>;
export type GetIsDirectSchedulingAllowedSuspenseQueryHookResult = ReturnType<typeof useGetIsDirectSchedulingAllowedSuspenseQuery>;
export type GetIsDirectSchedulingAllowedQueryResult = Apollo.QueryResult<GetIsDirectSchedulingAllowedQuery, GetIsDirectSchedulingAllowedQueryVariables>;
export const GetKratosLoginFlowDocument = gql`
    query getKratosLoginFlow {
  kratosLoginFlow {
    id
    csrf_token
    passkey_challenge
  }
}
    `;

/**
 * __useGetKratosLoginFlowQuery__
 *
 * To run a query within a React component, call `useGetKratosLoginFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKratosLoginFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKratosLoginFlowQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKratosLoginFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>(GetKratosLoginFlowDocument, options);
      }
export function useGetKratosLoginFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>(GetKratosLoginFlowDocument, options);
        }
// @ts-ignore
export function useGetKratosLoginFlowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>): Apollo.UseSuspenseQueryResult<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>;
export function useGetKratosLoginFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>): Apollo.UseSuspenseQueryResult<GetKratosLoginFlowQuery | undefined, GetKratosLoginFlowQueryVariables>;
export function useGetKratosLoginFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>(GetKratosLoginFlowDocument, options);
        }
export type GetKratosLoginFlowQueryHookResult = ReturnType<typeof useGetKratosLoginFlowQuery>;
export type GetKratosLoginFlowLazyQueryHookResult = ReturnType<typeof useGetKratosLoginFlowLazyQuery>;
export type GetKratosLoginFlowSuspenseQueryHookResult = ReturnType<typeof useGetKratosLoginFlowSuspenseQuery>;
export type GetKratosLoginFlowQueryResult = Apollo.QueryResult<GetKratosLoginFlowQuery, GetKratosLoginFlowQueryVariables>;
export const GetKratosSettingsFlowDocument = gql`
    query getKratosSettingsFlow($flow_id: String) {
  kratosSettingsFlow(flow_id: $flow_id) {
    id
    csrf_token
    passkey_create_data
    passkeys {
      token
      display_name
      added_at
    }
  }
}
    `;

/**
 * __useGetKratosSettingsFlowQuery__
 *
 * To run a query within a React component, call `useGetKratosSettingsFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKratosSettingsFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKratosSettingsFlowQuery({
 *   variables: {
 *      flow_id: // value for 'flow_id'
 *   },
 * });
 */
export function useGetKratosSettingsFlowQuery(baseOptions?: Apollo.QueryHookOptions<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>(GetKratosSettingsFlowDocument, options);
      }
export function useGetKratosSettingsFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>(GetKratosSettingsFlowDocument, options);
        }
// @ts-ignore
export function useGetKratosSettingsFlowSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>): Apollo.UseSuspenseQueryResult<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>;
export function useGetKratosSettingsFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>): Apollo.UseSuspenseQueryResult<GetKratosSettingsFlowQuery | undefined, GetKratosSettingsFlowQueryVariables>;
export function useGetKratosSettingsFlowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>(GetKratosSettingsFlowDocument, options);
        }
export type GetKratosSettingsFlowQueryHookResult = ReturnType<typeof useGetKratosSettingsFlowQuery>;
export type GetKratosSettingsFlowLazyQueryHookResult = ReturnType<typeof useGetKratosSettingsFlowLazyQuery>;
export type GetKratosSettingsFlowSuspenseQueryHookResult = ReturnType<typeof useGetKratosSettingsFlowSuspenseQuery>;
export type GetKratosSettingsFlowQueryResult = Apollo.QueryResult<GetKratosSettingsFlowQuery, GetKratosSettingsFlowQueryVariables>;
export const GetLenderNamesCpDocument = gql`
    query getLenderNamesCp {
  lenderNamesCp {
    id
    name
  }
}
    `;

/**
 * __useGetLenderNamesCpQuery__
 *
 * To run a query within a React component, call `useGetLenderNamesCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLenderNamesCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLenderNamesCpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLenderNamesCpQuery(baseOptions?: Apollo.QueryHookOptions<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>(GetLenderNamesCpDocument, options);
      }
export function useGetLenderNamesCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>(GetLenderNamesCpDocument, options);
        }
// @ts-ignore
export function useGetLenderNamesCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>;
export function useGetLenderNamesCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetLenderNamesCpQuery | undefined, GetLenderNamesCpQueryVariables>;
export function useGetLenderNamesCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>(GetLenderNamesCpDocument, options);
        }
export type GetLenderNamesCpQueryHookResult = ReturnType<typeof useGetLenderNamesCpQuery>;
export type GetLenderNamesCpLazyQueryHookResult = ReturnType<typeof useGetLenderNamesCpLazyQuery>;
export type GetLenderNamesCpSuspenseQueryHookResult = ReturnType<typeof useGetLenderNamesCpSuspenseQuery>;
export type GetLenderNamesCpQueryResult = Apollo.QueryResult<GetLenderNamesCpQuery, GetLenderNamesCpQueryVariables>;
export const GetNeedsGoCardlessMandateDocument = gql`
    query getNeedsGoCardlessMandate {
  getNeedsMandate {
    status
  }
}
    `;

/**
 * __useGetNeedsGoCardlessMandateQuery__
 *
 * To run a query within a React component, call `useGetNeedsGoCardlessMandateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNeedsGoCardlessMandateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNeedsGoCardlessMandateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNeedsGoCardlessMandateQuery(baseOptions?: Apollo.QueryHookOptions<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>(GetNeedsGoCardlessMandateDocument, options);
      }
export function useGetNeedsGoCardlessMandateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>(GetNeedsGoCardlessMandateDocument, options);
        }
// @ts-ignore
export function useGetNeedsGoCardlessMandateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>): Apollo.UseSuspenseQueryResult<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>;
export function useGetNeedsGoCardlessMandateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>): Apollo.UseSuspenseQueryResult<GetNeedsGoCardlessMandateQuery | undefined, GetNeedsGoCardlessMandateQueryVariables>;
export function useGetNeedsGoCardlessMandateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>(GetNeedsGoCardlessMandateDocument, options);
        }
export type GetNeedsGoCardlessMandateQueryHookResult = ReturnType<typeof useGetNeedsGoCardlessMandateQuery>;
export type GetNeedsGoCardlessMandateLazyQueryHookResult = ReturnType<typeof useGetNeedsGoCardlessMandateLazyQuery>;
export type GetNeedsGoCardlessMandateSuspenseQueryHookResult = ReturnType<typeof useGetNeedsGoCardlessMandateSuspenseQuery>;
export type GetNeedsGoCardlessMandateQueryResult = Apollo.QueryResult<GetNeedsGoCardlessMandateQuery, GetNeedsGoCardlessMandateQueryVariables>;
export const GetPaymentsDocument = gql`
    query getPayments($useClientApi: Boolean = false, $includeOrganisation: Boolean = false) {
  getPayments(
    includeOrganisation: $includeOrganisation
    useClientApi: $useClientApi
  ) {
    payments {
      id
      amount
      url
      case_id
      org_id
      organisation(useClientApi: $useClientApi) @include(if: $includeOrganisation) {
        id
        organisation_id
        name
      }
    }
  }
}
    `;

/**
 * __useGetPaymentsQuery__
 *
 * To run a query within a React component, call `useGetPaymentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentsQuery({
 *   variables: {
 *      useClientApi: // value for 'useClientApi'
 *      includeOrganisation: // value for 'includeOrganisation'
 *   },
 * });
 */
export function useGetPaymentsQuery(baseOptions?: Apollo.QueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentsQuery, GetPaymentsQueryVariables>(GetPaymentsDocument, options);
      }
export function useGetPaymentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentsQuery, GetPaymentsQueryVariables>(GetPaymentsDocument, options);
        }
// @ts-ignore
export function useGetPaymentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentsQuery, GetPaymentsQueryVariables>;
export function useGetPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetPaymentsQuery | undefined, GetPaymentsQueryVariables>;
export function useGetPaymentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaymentsQuery, GetPaymentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaymentsQuery, GetPaymentsQueryVariables>(GetPaymentsDocument, options);
        }
export type GetPaymentsQueryHookResult = ReturnType<typeof useGetPaymentsQuery>;
export type GetPaymentsLazyQueryHookResult = ReturnType<typeof useGetPaymentsLazyQuery>;
export type GetPaymentsSuspenseQueryHookResult = ReturnType<typeof useGetPaymentsSuspenseQuery>;
export type GetPaymentsQueryResult = Apollo.QueryResult<GetPaymentsQuery, GetPaymentsQueryVariables>;
export const GetPropertyCpDocument = gql`
    query getPropertyCp($id: ID!, $includeMortgageProduct: Boolean = false) {
  propertyCp(id: $id) {
    id
    property_id
    details {
      ...PropertyDetailsCp
    }
  }
}
    ${PropertyDetailsCpFragmentDoc}`;

/**
 * __useGetPropertyCpQuery__
 *
 * To run a query within a React component, call `useGetPropertyCpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyCpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyCpQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeMortgageProduct: // value for 'includeMortgageProduct'
 *   },
 * });
 */
export function useGetPropertyCpQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyCpQuery, GetPropertyCpQueryVariables> & ({ variables: GetPropertyCpQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyCpQuery, GetPropertyCpQueryVariables>(GetPropertyCpDocument, options);
      }
export function useGetPropertyCpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyCpQuery, GetPropertyCpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyCpQuery, GetPropertyCpQueryVariables>(GetPropertyCpDocument, options);
        }
// @ts-ignore
export function useGetPropertyCpSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPropertyCpQuery, GetPropertyCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetPropertyCpQuery, GetPropertyCpQueryVariables>;
export function useGetPropertyCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyCpQuery, GetPropertyCpQueryVariables>): Apollo.UseSuspenseQueryResult<GetPropertyCpQuery | undefined, GetPropertyCpQueryVariables>;
export function useGetPropertyCpSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyCpQuery, GetPropertyCpQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyCpQuery, GetPropertyCpQueryVariables>(GetPropertyCpDocument, options);
        }
export type GetPropertyCpQueryHookResult = ReturnType<typeof useGetPropertyCpQuery>;
export type GetPropertyCpLazyQueryHookResult = ReturnType<typeof useGetPropertyCpLazyQuery>;
export type GetPropertyCpSuspenseQueryHookResult = ReturnType<typeof useGetPropertyCpSuspenseQuery>;
export type GetPropertyCpQueryResult = Apollo.QueryResult<GetPropertyCpQuery, GetPropertyCpQueryVariables>;
export const GetSchedulerAvailabilityDocument = gql`
    query getSchedulerAvailability($startTime: Float!, $endTime: Float!, $key: String!) {
  getSchedulerAvailability(startTime: $startTime, endTime: $endTime, key: $key) {
    time_slots {
      start_time
      end_time
    }
  }
}
    `;

/**
 * __useGetSchedulerAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetSchedulerAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulerAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulerAvailabilityQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSchedulerAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables> & ({ variables: GetSchedulerAvailabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>(GetSchedulerAvailabilityDocument, options);
      }
export function useGetSchedulerAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>(GetSchedulerAvailabilityDocument, options);
        }
// @ts-ignore
export function useGetSchedulerAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>;
export function useGetSchedulerAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetSchedulerAvailabilityQuery | undefined, GetSchedulerAvailabilityQueryVariables>;
export function useGetSchedulerAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>(GetSchedulerAvailabilityDocument, options);
        }
export type GetSchedulerAvailabilityQueryHookResult = ReturnType<typeof useGetSchedulerAvailabilityQuery>;
export type GetSchedulerAvailabilityLazyQueryHookResult = ReturnType<typeof useGetSchedulerAvailabilityLazyQuery>;
export type GetSchedulerAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetSchedulerAvailabilitySuspenseQuery>;
export type GetSchedulerAvailabilityQueryResult = Apollo.QueryResult<GetSchedulerAvailabilityQuery, GetSchedulerAvailabilityQueryVariables>;
export const GetSchedulerAvailabilityDirectDocument = gql`
    query getSchedulerAvailabilityDirect($startTime: Float!, $endTime: Float!, $caseId: String!) {
  getSchedulerAvailabilityDirect(
    startTime: $startTime
    endTime: $endTime
    caseId: $caseId
  ) {
    time_slots {
      start_time
      end_time
    }
  }
}
    `;

/**
 * __useGetSchedulerAvailabilityDirectQuery__
 *
 * To run a query within a React component, call `useGetSchedulerAvailabilityDirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulerAvailabilityDirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulerAvailabilityDirectQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetSchedulerAvailabilityDirectQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables> & ({ variables: GetSchedulerAvailabilityDirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>(GetSchedulerAvailabilityDirectDocument, options);
      }
export function useGetSchedulerAvailabilityDirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>(GetSchedulerAvailabilityDirectDocument, options);
        }
// @ts-ignore
export function useGetSchedulerAvailabilityDirectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>): Apollo.UseSuspenseQueryResult<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>;
export function useGetSchedulerAvailabilityDirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>): Apollo.UseSuspenseQueryResult<GetSchedulerAvailabilityDirectQuery | undefined, GetSchedulerAvailabilityDirectQueryVariables>;
export function useGetSchedulerAvailabilityDirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>(GetSchedulerAvailabilityDirectDocument, options);
        }
export type GetSchedulerAvailabilityDirectQueryHookResult = ReturnType<typeof useGetSchedulerAvailabilityDirectQuery>;
export type GetSchedulerAvailabilityDirectLazyQueryHookResult = ReturnType<typeof useGetSchedulerAvailabilityDirectLazyQuery>;
export type GetSchedulerAvailabilityDirectSuspenseQueryHookResult = ReturnType<typeof useGetSchedulerAvailabilityDirectSuspenseQuery>;
export type GetSchedulerAvailabilityDirectQueryResult = Apollo.QueryResult<GetSchedulerAvailabilityDirectQuery, GetSchedulerAvailabilityDirectQueryVariables>;
export const GetSchedulerEventInfoDocument = gql`
    query getSchedulerEventInfo($key: String!) {
  getSchedulerEventInfo(key: $key) {
    client {
      first_name
      last_name
    }
    event {
      title
      start_time
      end_time
      event_id
    }
    duration_minutes
    organisation_logo
  }
}
    `;

/**
 * __useGetSchedulerEventInfoQuery__
 *
 * To run a query within a React component, call `useGetSchedulerEventInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulerEventInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulerEventInfoQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSchedulerEventInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables> & ({ variables: GetSchedulerEventInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>(GetSchedulerEventInfoDocument, options);
      }
export function useGetSchedulerEventInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>(GetSchedulerEventInfoDocument, options);
        }
// @ts-ignore
export function useGetSchedulerEventInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>;
export function useGetSchedulerEventInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetSchedulerEventInfoQuery | undefined, GetSchedulerEventInfoQueryVariables>;
export function useGetSchedulerEventInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>(GetSchedulerEventInfoDocument, options);
        }
export type GetSchedulerEventInfoQueryHookResult = ReturnType<typeof useGetSchedulerEventInfoQuery>;
export type GetSchedulerEventInfoLazyQueryHookResult = ReturnType<typeof useGetSchedulerEventInfoLazyQuery>;
export type GetSchedulerEventInfoSuspenseQueryHookResult = ReturnType<typeof useGetSchedulerEventInfoSuspenseQuery>;
export type GetSchedulerEventInfoQueryResult = Apollo.QueryResult<GetSchedulerEventInfoQuery, GetSchedulerEventInfoQueryVariables>;
export const GetSchedulerEventInfoDirectDocument = gql`
    query getSchedulerEventInfoDirect($caseId: String!) {
  getSchedulerEventInfoDirect(caseId: $caseId) {
    duration_minutes
    organisation_logo
  }
  getSchedulerEventsDirect(caseId: $caseId) {
    end_time
    start_time
    event_id
    title
  }
}
    `;

/**
 * __useGetSchedulerEventInfoDirectQuery__
 *
 * To run a query within a React component, call `useGetSchedulerEventInfoDirectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSchedulerEventInfoDirectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchedulerEventInfoDirectQuery({
 *   variables: {
 *      caseId: // value for 'caseId'
 *   },
 * });
 */
export function useGetSchedulerEventInfoDirectQuery(baseOptions: Apollo.QueryHookOptions<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables> & ({ variables: GetSchedulerEventInfoDirectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>(GetSchedulerEventInfoDirectDocument, options);
      }
export function useGetSchedulerEventInfoDirectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>(GetSchedulerEventInfoDirectDocument, options);
        }
// @ts-ignore
export function useGetSchedulerEventInfoDirectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>): Apollo.UseSuspenseQueryResult<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>;
export function useGetSchedulerEventInfoDirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>): Apollo.UseSuspenseQueryResult<GetSchedulerEventInfoDirectQuery | undefined, GetSchedulerEventInfoDirectQueryVariables>;
export function useGetSchedulerEventInfoDirectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>(GetSchedulerEventInfoDirectDocument, options);
        }
export type GetSchedulerEventInfoDirectQueryHookResult = ReturnType<typeof useGetSchedulerEventInfoDirectQuery>;
export type GetSchedulerEventInfoDirectLazyQueryHookResult = ReturnType<typeof useGetSchedulerEventInfoDirectLazyQuery>;
export type GetSchedulerEventInfoDirectSuspenseQueryHookResult = ReturnType<typeof useGetSchedulerEventInfoDirectSuspenseQuery>;
export type GetSchedulerEventInfoDirectQueryResult = Apollo.QueryResult<GetSchedulerEventInfoDirectQuery, GetSchedulerEventInfoDirectQueryVariables>;
export const GetWebPushPublicKeyDocument = gql`
    query getWebPushPublicKey {
  getWebPushPublicKey {
    publicKey
  }
}
    `;

/**
 * __useGetWebPushPublicKeyQuery__
 *
 * To run a query within a React component, call `useGetWebPushPublicKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebPushPublicKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebPushPublicKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebPushPublicKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>(GetWebPushPublicKeyDocument, options);
      }
export function useGetWebPushPublicKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>(GetWebPushPublicKeyDocument, options);
        }
// @ts-ignore
export function useGetWebPushPublicKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>;
export function useGetWebPushPublicKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebPushPublicKeyQuery | undefined, GetWebPushPublicKeyQueryVariables>;
export function useGetWebPushPublicKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>(GetWebPushPublicKeyDocument, options);
        }
export type GetWebPushPublicKeyQueryHookResult = ReturnType<typeof useGetWebPushPublicKeyQuery>;
export type GetWebPushPublicKeyLazyQueryHookResult = ReturnType<typeof useGetWebPushPublicKeyLazyQuery>;
export type GetWebPushPublicKeySuspenseQueryHookResult = ReturnType<typeof useGetWebPushPublicKeySuspenseQuery>;
export type GetWebPushPublicKeyQueryResult = Apollo.QueryResult<GetWebPushPublicKeyQuery, GetWebPushPublicKeyQueryVariables>;
export const GetWebPushSubscriptionsDocument = gql`
    query getWebPushSubscriptions {
  getWebPushSubscriptions {
    id
    client_id
    endpoint
    keys {
      p256dh
      auth
    }
    status
    user_agent
    created
    updated
  }
}
    `;

/**
 * __useGetWebPushSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetWebPushSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebPushSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebPushSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWebPushSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>(GetWebPushSubscriptionsDocument, options);
      }
export function useGetWebPushSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>(GetWebPushSubscriptionsDocument, options);
        }
// @ts-ignore
export function useGetWebPushSubscriptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>;
export function useGetWebPushSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWebPushSubscriptionsQuery | undefined, GetWebPushSubscriptionsQueryVariables>;
export function useGetWebPushSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>(GetWebPushSubscriptionsDocument, options);
        }
export type GetWebPushSubscriptionsQueryHookResult = ReturnType<typeof useGetWebPushSubscriptionsQuery>;
export type GetWebPushSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetWebPushSubscriptionsLazyQuery>;
export type GetWebPushSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useGetWebPushSubscriptionsSuspenseQuery>;
export type GetWebPushSubscriptionsQueryResult = Apollo.QueryResult<GetWebPushSubscriptionsQuery, GetWebPushSubscriptionsQueryVariables>;
export const SurveyDocument = gql`
    query survey($id: ID!) {
  survey(id: $id) {
    questions {
      id
      question
      version
      type
      event_trigger {
        type
        gt
        lt
        choice_trigger
      }
      choices
      order
      required
      topic
      answer {
        question_id
        question_version
        five_scale_answer
        ten_scale_answer
        free_text_answer
        bool_answer
        single_choice_answer
        multiple_choice_answer
        zero_ten_scale_answer
      }
      answered
      show_if {
        conditions {
          dependent_question_id
          equals_bool
          equals_choice
          greater_than
          less_than
        }
      }
    }
  }
}
    `;

/**
 * __useSurveyQuery__
 *
 * To run a query within a React component, call `useSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyQuery(baseOptions: Apollo.QueryHookOptions<SurveyQuery, SurveyQueryVariables> & ({ variables: SurveyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
      }
export function useSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
        }
// @ts-ignore
export function useSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyQuery, SurveyQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyQuery, SurveyQueryVariables>;
export function useSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyQuery, SurveyQueryVariables>): Apollo.UseSuspenseQueryResult<SurveyQuery | undefined, SurveyQueryVariables>;
export function useSurveySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
        }
export type SurveyQueryHookResult = ReturnType<typeof useSurveyQuery>;
export type SurveyLazyQueryHookResult = ReturnType<typeof useSurveyLazyQuery>;
export type SurveySuspenseQueryHookResult = ReturnType<typeof useSurveySuspenseQuery>;
export type SurveyQueryResult = Apollo.QueryResult<SurveyQuery, SurveyQueryVariables>;
export const CaseWaterfallIntroducerTotalsDocument = gql`
    query caseWaterfallIntroducerTotals($body: ReportsCaseStatsFilterInput!) {
  getCaseWaterfallIntroducerTotals(body: $body) @client {
    LEAD {
      value
      count
    }
    PRE_RECOMMENDATION {
      value
      count
    }
    PRE_APPLICATION {
      value
      count
    }
    APPLICATION_SUBMITTED {
      value
      count
    }
    AWAITING_VALUATION {
      value
      count
    }
    AWAITING_OFFER {
      value
      count
    }
    OFFER_RECEIVED {
      value
      count
    }
    EXCHANGE {
      value
      count
    }
    COMPLETE {
      value
      count
    }
  }
}
    `;

/**
 * __useCaseWaterfallIntroducerTotalsQuery__
 *
 * To run a query within a React component, call `useCaseWaterfallIntroducerTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseWaterfallIntroducerTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseWaterfallIntroducerTotalsQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCaseWaterfallIntroducerTotalsQuery(baseOptions: Apollo.QueryHookOptions<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables> & ({ variables: CaseWaterfallIntroducerTotalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>(CaseWaterfallIntroducerTotalsDocument, options);
      }
export function useCaseWaterfallIntroducerTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>(CaseWaterfallIntroducerTotalsDocument, options);
        }
// @ts-ignore
export function useCaseWaterfallIntroducerTotalsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>;
export function useCaseWaterfallIntroducerTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>): Apollo.UseSuspenseQueryResult<CaseWaterfallIntroducerTotalsQuery | undefined, CaseWaterfallIntroducerTotalsQueryVariables>;
export function useCaseWaterfallIntroducerTotalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>(CaseWaterfallIntroducerTotalsDocument, options);
        }
export type CaseWaterfallIntroducerTotalsQueryHookResult = ReturnType<typeof useCaseWaterfallIntroducerTotalsQuery>;
export type CaseWaterfallIntroducerTotalsLazyQueryHookResult = ReturnType<typeof useCaseWaterfallIntroducerTotalsLazyQuery>;
export type CaseWaterfallIntroducerTotalsSuspenseQueryHookResult = ReturnType<typeof useCaseWaterfallIntroducerTotalsSuspenseQuery>;
export type CaseWaterfallIntroducerTotalsQueryResult = Apollo.QueryResult<CaseWaterfallIntroducerTotalsQuery, CaseWaterfallIntroducerTotalsQueryVariables>;
export const CaseWaterfallIntroducerDocument = gql`
    query caseWaterfallIntroducer($body: ReportsIntroducerCaseStatsFilterInput!) {
  reportsCaseWaterfallIntroducer(body: $body) {
    grouped_results {
      group_id
      results {
        case_status
        count
        value
      }
    }
    totals {
      case_status
      count
      value
    }
  }
  getCaseWaterfallIntroducerReport @client {
    id
    view_by
    LEAD {
      value
      count
    }
    PRE_RECOMMENDATION {
      value
      count
    }
    PRE_APPLICATION {
      value
      count
    }
    APPLICATION_SUBMITTED {
      value
      count
    }
    AWAITING_VALUATION {
      value
      count
    }
    AWAITING_OFFER {
      value
      count
    }
    OFFER_RECEIVED {
      value
      count
    }
    EXCHANGE {
      value
      count
    }
    COMPLETE {
      value
      count
    }
  }
}
    `;

/**
 * __useCaseWaterfallIntroducerQuery__
 *
 * To run a query within a React component, call `useCaseWaterfallIntroducerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCaseWaterfallIntroducerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCaseWaterfallIntroducerQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCaseWaterfallIntroducerQuery(baseOptions: Apollo.QueryHookOptions<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables> & ({ variables: CaseWaterfallIntroducerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>(CaseWaterfallIntroducerDocument, options);
      }
export function useCaseWaterfallIntroducerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>(CaseWaterfallIntroducerDocument, options);
        }
// @ts-ignore
export function useCaseWaterfallIntroducerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>): Apollo.UseSuspenseQueryResult<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>;
export function useCaseWaterfallIntroducerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>): Apollo.UseSuspenseQueryResult<CaseWaterfallIntroducerQuery | undefined, CaseWaterfallIntroducerQueryVariables>;
export function useCaseWaterfallIntroducerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>(CaseWaterfallIntroducerDocument, options);
        }
export type CaseWaterfallIntroducerQueryHookResult = ReturnType<typeof useCaseWaterfallIntroducerQuery>;
export type CaseWaterfallIntroducerLazyQueryHookResult = ReturnType<typeof useCaseWaterfallIntroducerLazyQuery>;
export type CaseWaterfallIntroducerSuspenseQueryHookResult = ReturnType<typeof useCaseWaterfallIntroducerSuspenseQuery>;
export type CaseWaterfallIntroducerQueryResult = Apollo.QueryResult<CaseWaterfallIntroducerQuery, CaseWaterfallIntroducerQueryVariables>;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($id: ID!, $input: DocumentInput!, $isArchiving: Boolean, $mortgageStatus: MortgageStatus) {
  updateDocument(
    id: $id
    input: $input
    isArchiving: $isArchiving
    mortgageStatus: $mortgageStatus
  ) {
    document_id
    internalHash
    type
    document_name
    archived
    case_ids
    owning_client_ids
    template {
      id
      name
      template
    }
  }
}
    `;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      isArchiving: // value for 'isArchiving'
 *      mortgageStatus: // value for 'mortgageStatus'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const UploadDocumentListDocument = gql`
    mutation uploadDocumentList($input: [DocumentUploadInput!]!) {
  uploadDocumentList(input: $input) {
    document_id
    internalHash
    document_name
    type
    date_stored
    data_base64
    uploaded_by
    verification_count
    source
    file_type
    document_signature
  }
}
    `;
export type UploadDocumentListMutationFn = Apollo.MutationFunction<UploadDocumentListMutation, UploadDocumentListMutationVariables>;

/**
 * __useUploadDocumentListMutation__
 *
 * To run a mutation, you first call `useUploadDocumentListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadDocumentListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadDocumentListMutation, { data, loading, error }] = useUploadDocumentListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadDocumentListMutation(baseOptions?: Apollo.MutationHookOptions<UploadDocumentListMutation, UploadDocumentListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadDocumentListMutation, UploadDocumentListMutationVariables>(UploadDocumentListDocument, options);
      }
export type UploadDocumentListMutationHookResult = ReturnType<typeof useUploadDocumentListMutation>;
export type UploadDocumentListMutationResult = Apollo.MutationResult<UploadDocumentListMutation>;
export type UploadDocumentListMutationOptions = Apollo.BaseMutationOptions<UploadDocumentListMutation, UploadDocumentListMutationVariables>;
export const GetClientDocument = gql`
    query getClient($id: ID!, $version: Int) {
  client(id: $id, version: $version) {
    id
    version
    details {
      id
      ...ClientDetails
      cases {
        id
        created_at
        details {
          id
          status
          preference_mortgage_reason
          regulated_by
          owner_organisation_id
          owner_user_id
          client_ids
        }
      }
    }
  }
}
    ${ClientDetailsFragmentDoc}`;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables> & ({ variables: GetClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
// @ts-ignore
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientQuery, GetClientQueryVariables>;
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientQuery | undefined, GetClientQueryVariables>;
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetDocumentDetailsListDocument = gql`
    query getDocumentDetailsList($docIds: [ID!]!, $documentTypes: [DocumentKind!], $isCp: Boolean) {
  documentDetailsList(docIds: $docIds, documentTypes: $documentTypes, isCp: $isCp) {
    document_id
    internalHash
    data_base64
    date_stored
    rendered_organisation_ids
    document_name
    type
    template_type
    uploaded_by
    verification_count
    source
    file_type
    document_signature
  }
}
    `;

/**
 * __useGetDocumentDetailsListQuery__
 *
 * To run a query within a React component, call `useGetDocumentDetailsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentDetailsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentDetailsListQuery({
 *   variables: {
 *      docIds: // value for 'docIds'
 *      documentTypes: // value for 'documentTypes'
 *      isCp: // value for 'isCp'
 *   },
 * });
 */
export function useGetDocumentDetailsListQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables> & ({ variables: GetDocumentDetailsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>(GetDocumentDetailsListDocument, options);
      }
export function useGetDocumentDetailsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>(GetDocumentDetailsListDocument, options);
        }
// @ts-ignore
export function useGetDocumentDetailsListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>;
export function useGetDocumentDetailsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>): Apollo.UseSuspenseQueryResult<GetDocumentDetailsListQuery | undefined, GetDocumentDetailsListQueryVariables>;
export function useGetDocumentDetailsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>(GetDocumentDetailsListDocument, options);
        }
export type GetDocumentDetailsListQueryHookResult = ReturnType<typeof useGetDocumentDetailsListQuery>;
export type GetDocumentDetailsListLazyQueryHookResult = ReturnType<typeof useGetDocumentDetailsListLazyQuery>;
export type GetDocumentDetailsListSuspenseQueryHookResult = ReturnType<typeof useGetDocumentDetailsListSuspenseQuery>;
export type GetDocumentDetailsListQueryResult = Apollo.QueryResult<GetDocumentDetailsListQuery, GetDocumentDetailsListQueryVariables>;
export const GetMetaStateDocument = gql`
    query getMetaState {
  redirectToLogin @client
}
    `;

/**
 * __useGetMetaStateQuery__
 *
 * To run a query within a React component, call `useGetMetaStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetaStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetaStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMetaStateQuery(baseOptions?: Apollo.QueryHookOptions<GetMetaStateQuery, GetMetaStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetaStateQuery, GetMetaStateQueryVariables>(GetMetaStateDocument, options);
      }
export function useGetMetaStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetaStateQuery, GetMetaStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetaStateQuery, GetMetaStateQueryVariables>(GetMetaStateDocument, options);
        }
// @ts-ignore
export function useGetMetaStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMetaStateQuery, GetMetaStateQueryVariables>): Apollo.UseSuspenseQueryResult<GetMetaStateQuery, GetMetaStateQueryVariables>;
export function useGetMetaStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetaStateQuery, GetMetaStateQueryVariables>): Apollo.UseSuspenseQueryResult<GetMetaStateQuery | undefined, GetMetaStateQueryVariables>;
export function useGetMetaStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetaStateQuery, GetMetaStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetaStateQuery, GetMetaStateQueryVariables>(GetMetaStateDocument, options);
        }
export type GetMetaStateQueryHookResult = ReturnType<typeof useGetMetaStateQuery>;
export type GetMetaStateLazyQueryHookResult = ReturnType<typeof useGetMetaStateLazyQuery>;
export type GetMetaStateSuspenseQueryHookResult = ReturnType<typeof useGetMetaStateSuspenseQuery>;
export type GetMetaStateQueryResult = Apollo.QueryResult<GetMetaStateQuery, GetMetaStateQueryVariables>;